/*
MAVLink protocol implementation for node.js (auto-generated by mavgen_javascript.py)

Generated from: common.xml,standard.xml,minimal.xml

Note: this file has been auto-generated. DO NOT EDIT
*/

// Detect environment
const isNode = typeof process !== 'undefined' &&
               process.versions &&
               process.versions.node;

// Handle jspack dependency
let jspack;
if (isNode) {
    jspack = (global && global.jspack) || require("jspack").jspack;
} else {
    // Webpack resolves the package from node_modules in browser builds too.
    jspack = require("jspack").jspack;
}

// Handle Node.js specific modules
let events, util;
if (isNode) {
    events = require("events");
    util = require("util");
} else {
    // Browser polyfills for Node.js modules
    util = { 
        inherits: function(constructor, superConstructor) {
            constructor.prototype = Object.create(superConstructor.prototype);
            constructor.prototype.constructor = constructor;
        }
    };
    
    // Simple EventEmitter polyfill for browsers
    events = { 
        EventEmitter: function() {
            this._events = {};
            
            this.on = function(event, listener) {
                if (!this._events[event]) {
                    this._events[event] = [];
                }
                this._events[event].push(listener);
            };
            
            this.emit = function(event, ...args) {
                if (this._events[event]) {
                    this._events[event].forEach(listener => {
                        try {
                            listener.apply(this, args);
                        } catch (e) {
                            console.error('Error in event listener:', e);
                        }
                    });
                }
            };
            
            this.removeListener = function(event, listener) {
                if (this._events[event]) {
                    const index = this._events[event].indexOf(listener);
                    if (index > -1) {
                        this._events[event].splice(index, 1);
                    }
                }
            };
        }
    };
}


mavlink20 = function(){};

// Implement the CRC-16/MCRF4XX function (present in the Python version through the mavutil.py package)
mavlink20.x25Crc = function(buffer, crcIN) {

    var bytes = buffer;
    var crcOUT = crcIN ===  undefined ? 0xffff : crcIN;
    bytes.forEach(function(e) {
        var tmp = e ^ (crcOUT & 0xff);
        tmp = (tmp ^ (tmp << 4)) & 0xff;
        crcOUT = (crcOUT >> 8) ^ (tmp << 8) ^ (tmp << 3) ^ (tmp >> 4);
        crcOUT = crcOUT & 0xffff;
    });
    return crcOUT;

}

mavlink20.WIRE_PROTOCOL_VERSION = "2.0";
mavlink20.PROTOCOL_MARKER_V1 = 0xFE 
mavlink20.PROTOCOL_MARKER_V2 = 0xFD 
mavlink20.HEADER_LEN_V1 = 6 
mavlink20.HEADER_LEN_V2 = 10 
mavlink20.HEADER_LEN = 10;

mavlink20.MAVLINK_TYPE_CHAR     = 0
mavlink20.MAVLINK_TYPE_UINT8_T  = 1
mavlink20.MAVLINK_TYPE_INT8_T   = 2
mavlink20.MAVLINK_TYPE_UINT16_T = 3
mavlink20.MAVLINK_TYPE_INT16_T  = 4
mavlink20.MAVLINK_TYPE_UINT32_T = 5
mavlink20.MAVLINK_TYPE_INT32_T  = 6
mavlink20.MAVLINK_TYPE_UINT64_T = 7
mavlink20.MAVLINK_TYPE_INT64_T  = 8
mavlink20.MAVLINK_TYPE_FLOAT    = 9
mavlink20.MAVLINK_TYPE_DOUBLE   = 10

mavlink20.MAVLINK_IFLAG_SIGNED = 0x01
mavlink20.MAVLINK_SIGNATURE_BLOCK_LEN = 13

// Mavlink headers incorporate sequence, source system (platform) and source component. 
mavlink20.header = function(msgId, mlen, seq, srcSystem, srcComponent, incompat_flags=0, compat_flags=0) {

    this.mlen = ( typeof mlen === 'undefined' ) ? 0 : mlen;
    this.seq = ( typeof seq === 'undefined' ) ? 0 : seq;
    this.srcSystem = ( typeof srcSystem === 'undefined' ) ? 0 : srcSystem;
    this.srcComponent = ( typeof srcComponent === 'undefined' ) ? 0 : srcComponent;
    this.msgId = msgId
    this.incompat_flags = incompat_flags
    this.compat_flags = compat_flags

}
mavlink20.header.prototype.pack = function() {
    return jspack.Pack('BBBBBBBHB', [253, this.mlen, this.incompat_flags, this.compat_flags, this.seq, this.srcSystem, this.srcComponent, ((this.msgId & 0xFF) << 8) | ((this.msgId >> 8) & 0xFF), this.msgId>>16]);
}

// Base class declaration: mavlink.message will be the parent class for each
// concrete implementation in mavlink.messages.
mavlink20.message = function() {};

// Convenience setter to facilitate turning the unpacked array of data into member properties
mavlink20.message.prototype.set = function(args,verbose) {
    // inspect
    this.fieldnames.forEach(function(e, i) {
        var num = parseInt(i,10);
        if (this.hasOwnProperty(e) && isNaN(num)  ){ // asking for an attribute that's non-numeric is ok unless its already an attribute we have
            if ( verbose >= 1) { console.log("WARNING, overwriting an existing property is DANGEROUS:"+e+" ==>"+i+"==>"+args[i]+" -> "+JSON.stringify(this)); }
        }
    }, this);

    // then modify
    this.fieldnames.forEach(function(e, i) {
        this[e] = args[i];
    }, this);
};

/*
  sha256 implementation
  embedded to avoid async issues in web browsers with crypto library
  with thanks to https://geraintluff.github.io/sha256/
*/
mavlink20.sha256 = function(inputBytes) {
    const K = new Uint32Array([
        0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
        0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
        0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
        0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
        0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
        0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
        0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
        0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
        0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
        0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
        0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
        0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
        0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
    ]);

    function ROTR(n, x) { return (x >>> n) | (x << (32 - n)); }

    function Σ0(x) { return ROTR(2, x) ^ ROTR(13, x) ^ ROTR(22, x); }
    function Σ1(x) { return ROTR(6, x) ^ ROTR(11, x) ^ ROTR(25, x); }
    function σ0(x) { return ROTR(7, x) ^ ROTR(18, x) ^ (x >>> 3); }
    function σ1(x) { return ROTR(17, x) ^ ROTR(19, x) ^ (x >>> 10); }

    function Ch(x, y, z) { return (x & y) ^ (~x & z); }
    function Maj(x, y, z) { return (x & y) ^ (x & z) ^ (y & z); }

    const H = new Uint32Array([
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
        0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
    ]);

    const l = inputBytes.length;
    const bitLen = l * 8;

    const withPadding = new Uint8Array(((l + 9 + 63) >> 6) << 6); // pad to multiple of 64 bytes
    withPadding.set(inputBytes);
    withPadding[l] = 0x80;
    withPadding.set([
        0, 0, 0, 0,
        (bitLen >>> 24) & 0xff,
        (bitLen >>> 16) & 0xff,
        (bitLen >>> 8) & 0xff,
        bitLen & 0xff
    ], withPadding.length - 8);

    const w = new Uint32Array(64);
    for (let i = 0; i < withPadding.length; i += 64) {
        for (let j = 0; j < 16; j++) {
            w[j] = (
                (withPadding[i + 4 * j] << 24) |
                (withPadding[i + 4 * j + 1] << 16) |
                (withPadding[i + 4 * j + 2] << 8) |
                (withPadding[i + 4 * j + 3])
            ) >>> 0;
        }
        for (let j = 16; j < 64; j++) {
            w[j] = (σ1(w[j - 2]) + w[j - 7] + σ0(w[j - 15]) + w[j - 16]) >>> 0;
        }

        let [a, b, c, d, e, f, g, h] = H;

        for (let j = 0; j < 64; j++) {
            const T1 = (h + Σ1(e) + Ch(e, f, g) + K[j] + w[j]) >>> 0;
            const T2 = (Σ0(a) + Maj(a, b, c)) >>> 0;
            h = g;
            g = f;
            f = e;
            e = (d + T1) >>> 0;
            d = c;
            c = b;
            b = a;
            a = (T1 + T2) >>> 0;
        }

        H[0] = (H[0] + a) >>> 0;
        H[1] = (H[1] + b) >>> 0;
        H[2] = (H[2] + c) >>> 0;
        H[3] = (H[3] + d) >>> 0;
        H[4] = (H[4] + e) >>> 0;
        H[5] = (H[5] + f) >>> 0;
        H[6] = (H[6] + g) >>> 0;
        H[7] = (H[7] + h) >>> 0;
    }

    const output = new Uint8Array(32);
    for (let i = 0; i < 8; i++) {
        output[i * 4 + 0] = (H[i] >>> 24) & 0xff;
        output[i * 4 + 1] = (H[i] >>> 16) & 0xff;
        output[i * 4 + 2] = (H[i] >>> 8) & 0xff;
        output[i * 4 + 3] = H[i] & 0xff;
    }

    return output;
}

// create a message signature
mavlink20.create_signature = function(key, msgbuf) {
    const input = new Uint8Array(32 + msgbuf.length);
    input.set(key, 0);
    input.set(msgbuf, 32);

    const hash = mavlink20.sha256(input);
    const sig = hash.slice(0, 6);

    return sig;
}

// sign outgoing packet
mavlink20.message.prototype.sign_packet = function( mav) {
    function packUint48LE(value) {
        const bytes = []
        for (let i = 0; i < 6; i++) {
            bytes.push(Number((value >> BigInt(8 * i)) & 0xFFn));
        }
        return bytes;
    }

    var tsbuf = packUint48LE(BigInt(mav.signing.timestamp));

    // first add the linkid(1 byte) and timestamp(6 bytes) that start the signature
    this._msgbuf = this._msgbuf.concat([mav.signing.link_id])
    this._msgbuf = this._msgbuf.concat(tsbuf);

    sig = mavlink20.create_signature(mav.signing.secret_key, this._msgbuf);
    this._msgbuf = this._msgbuf.concat( ... sig );

    mav.signing.timestamp += 1;
}

// This pack function builds the header and produces a complete MAVLink message,
// including header and message CRC.
mavlink20.message.prototype.pack = function(mav, crc_extra, payload) {

    this._payload = payload;
    var plen = this._payload.length;
    //in MAVLink2 we can strip trailing zeros off payloads. This allows for simple
    // variable length arrays and smaller packets
    while ((plen > 1) && ( (this._payload[plen-1] == 0) || (this._payload[plen-1] == null) ) ) {
            plen = plen - 1;
    }
    this._payload = this._payload.slice(0, plen);
    // signing is our first incompat flag. 
    var incompat_flags = 0; 
    if (mav.signing.sign_outgoing){ 
            incompat_flags |= mavlink20.MAVLINK_IFLAG_SIGNED 
    } 
    // header 
    this._header = new mavlink20.header(this._id, this._payload.length, mav.seq, mav.srcSystem, mav.srcComponent, incompat_flags, 0,);
    // payload     
    this._msgbuf = this._header.pack().concat(this._payload);
    // crc -  for now, assume always using crc_extra = True.  TODO: check/fix this. 
    var crc = mavlink20.x25Crc(this._msgbuf.slice(1));
    crc = mavlink20.x25Crc([crc_extra], crc);
    this._msgbuf = this._msgbuf.concat(jspack.Pack('<H', [crc] ) );

    // signing 
    this._signed     = false 
    this._link_id    = undefined 

    //console.log(mav.signing); 
    //optionally add signing 
    if (mav.signing.sign_outgoing){ 
                this.sign_packet(mav) 
    } 
    return this._msgbuf;

}


// enums

// HL_FAILURE_FLAG
mavlink20.HL_FAILURE_FLAG_GPS = 1 // GPS failure.
mavlink20.HL_FAILURE_FLAG_DIFFERENTIAL_PRESSURE = 2 // Differential pressure sensor failure.
mavlink20.HL_FAILURE_FLAG_ABSOLUTE_PRESSURE = 4 // Absolute pressure sensor failure.
mavlink20.HL_FAILURE_FLAG_3D_ACCEL = 8 // Accelerometer sensor failure.
mavlink20.HL_FAILURE_FLAG_3D_GYRO = 16 // Gyroscope sensor failure.
mavlink20.HL_FAILURE_FLAG_3D_MAG = 32 // Magnetometer sensor failure.
mavlink20.HL_FAILURE_FLAG_TERRAIN = 64 // Terrain subsystem failure.
mavlink20.HL_FAILURE_FLAG_BATTERY = 128 // Battery failure/critical low battery.
mavlink20.HL_FAILURE_FLAG_RC_RECEIVER = 256 // RC receiver failure/no RC connection.
mavlink20.HL_FAILURE_FLAG_OFFBOARD_LINK = 512 // Offboard link failure.
mavlink20.HL_FAILURE_FLAG_ENGINE = 1024 // Engine failure.
mavlink20.HL_FAILURE_FLAG_GEOFENCE = 2048 // Geofence violation.
mavlink20.HL_FAILURE_FLAG_ESTIMATOR = 4096 // Estimator failure, for example measurement rejection or large
                        // variances.
mavlink20.HL_FAILURE_FLAG_MISSION = 8192 // Mission failure.
mavlink20.HL_FAILURE_FLAG_ENUM_END = 8193 // 

// MAV_GOTO
mavlink20.MAV_GOTO_DO_HOLD = 0 // Hold at the current position.
mavlink20.MAV_GOTO_DO_CONTINUE = 1 // Continue with the next item in mission execution.
mavlink20.MAV_GOTO_HOLD_AT_CURRENT_POSITION = 2 // Hold at the current position of the system
mavlink20.MAV_GOTO_HOLD_AT_SPECIFIED_POSITION = 3 // Hold at the position specified in the parameters of the DO_HOLD action
mavlink20.MAV_GOTO_ENUM_END = 4 // 

// MAV_MODE
mavlink20.MAV_MODE_PREFLIGHT = 0 // System is not ready to fly, booting, calibrating, etc. No flag is set.
mavlink20.MAV_MODE_MANUAL_DISARMED = 64 // System is allowed to be active, under manual (RC) control, no
                        // stabilization
                        // (MAV_MODE_FLAG_MANUAL_INPUT_ENABLED)
mavlink20.MAV_MODE_TEST_DISARMED = 66 // UNDEFINED mode. This solely depends on the autopilot - use with
                        // caution, intended for developers only.
                        // (MAV_MODE_FLAG_MANUAL_INPUT_ENABLED,
                        // MAV_MODE_FLAG_TEST_ENABLED).
mavlink20.MAV_MODE_STABILIZE_DISARMED = 80 // System is allowed to be active, under assisted RC control
                        // (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_STABILIZE_ENABLED)
mavlink20.MAV_MODE_GUIDED_DISARMED = 88 // System is allowed to be active, under autonomous control, manual
                        // setpoint (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_STABILIZE_ENABLED,
                        // MAV_MODE_FLAG_GUIDED_ENABLED)
mavlink20.MAV_MODE_AUTO_DISARMED = 92 // System is allowed to be active, under autonomous control and
                        // navigation (the trajectory is decided
                        // onboard and not pre-programmed by
                        // waypoints). (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_STABILIZE_ENABLED,
                        // MAV_MODE_FLAG_GUIDED_ENABLED,
                        // MAV_MODE_FLAG_AUTO_ENABLED).
mavlink20.MAV_MODE_MANUAL_ARMED = 192 // System is allowed to be active, under manual (RC) control, no
                        // stabilization (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_MANUAL_INPUT_ENABLED)
mavlink20.MAV_MODE_TEST_ARMED = 194 // UNDEFINED mode. This solely depends on the autopilot - use with
                        // caution, intended for developers only
                        // (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_MANUAL_INPUT_ENABLED,
                        // MAV_MODE_FLAG_TEST_ENABLED)
mavlink20.MAV_MODE_STABILIZE_ARMED = 208 // System is allowed to be active, under assisted RC control
                        // (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_MANUAL_INPUT_ENABLED,
                        // MAV_MODE_FLAG_STABILIZE_ENABLED)
mavlink20.MAV_MODE_GUIDED_ARMED = 216 // System is allowed to be active, under autonomous control, manual
                        // setpoint (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_MANUAL_INPUT_ENABLED,
                        // MAV_MODE_FLAG_STABILIZE_ENABLED,
                        // MAV_MODE_FLAG_GUIDED_ENABLED)
mavlink20.MAV_MODE_AUTO_ARMED = 220 // System is allowed to be active, under autonomous control and
                        // navigation (the trajectory is decided
                        // onboard and not pre-programmed by
                        // waypoints). (MAV_MODE_FLAG_SAFETY_ARMED,
                        // MAV_MODE_FLAG_MANUAL_INPUT_ENABLED,
                        // MAV_MODE_FLAG_STABILIZE_ENABLED, MAV_MODE_F
                        // LAG_GUIDED_ENABLED,MAV_MODE_FLAG_AUTO_ENABL
                        // ED).
mavlink20.MAV_MODE_ENUM_END = 221 // 

// MAV_SYS_STATUS_SENSOR
mavlink20.MAV_SYS_STATUS_SENSOR_3D_GYRO = 1 // 0x01 3D gyro
mavlink20.MAV_SYS_STATUS_SENSOR_3D_ACCEL = 2 // 0x02 3D accelerometer
mavlink20.MAV_SYS_STATUS_SENSOR_3D_MAG = 4 // 0x04 3D magnetometer
mavlink20.MAV_SYS_STATUS_SENSOR_ABSOLUTE_PRESSURE = 8 // 0x08 absolute pressure
mavlink20.MAV_SYS_STATUS_SENSOR_DIFFERENTIAL_PRESSURE = 16 // 0x10 differential pressure
mavlink20.MAV_SYS_STATUS_SENSOR_GPS = 32 // 0x20 GPS
mavlink20.MAV_SYS_STATUS_SENSOR_OPTICAL_FLOW = 64 // 0x40 optical flow
mavlink20.MAV_SYS_STATUS_SENSOR_VISION_POSITION = 128 // 0x80 computer vision position
mavlink20.MAV_SYS_STATUS_SENSOR_LASER_POSITION = 256 // 0x100 laser based position
mavlink20.MAV_SYS_STATUS_SENSOR_EXTERNAL_GROUND_TRUTH = 512 // 0x200 external ground truth (Vicon or Leica)
mavlink20.MAV_SYS_STATUS_SENSOR_ANGULAR_RATE_CONTROL = 1024 // 0x400 3D angular rate control
mavlink20.MAV_SYS_STATUS_SENSOR_ATTITUDE_STABILIZATION = 2048 // 0x800 attitude stabilization
mavlink20.MAV_SYS_STATUS_SENSOR_YAW_POSITION = 4096 // 0x1000 yaw position
mavlink20.MAV_SYS_STATUS_SENSOR_Z_ALTITUDE_CONTROL = 8192 // 0x2000 z/altitude control
mavlink20.MAV_SYS_STATUS_SENSOR_XY_POSITION_CONTROL = 16384 // 0x4000 x/y position control
mavlink20.MAV_SYS_STATUS_SENSOR_MOTOR_OUTPUTS = 32768 // 0x8000 motor outputs / control
mavlink20.MAV_SYS_STATUS_SENSOR_RC_RECEIVER = 65536 // 0x10000 RC receiver
mavlink20.MAV_SYS_STATUS_SENSOR_3D_GYRO2 = 131072 // 0x20000 2nd 3D gyro
mavlink20.MAV_SYS_STATUS_SENSOR_3D_ACCEL2 = 262144 // 0x40000 2nd 3D accelerometer
mavlink20.MAV_SYS_STATUS_SENSOR_3D_MAG2 = 524288 // 0x80000 2nd 3D magnetometer
mavlink20.MAV_SYS_STATUS_GEOFENCE = 1048576 // 0x100000 geofence
mavlink20.MAV_SYS_STATUS_AHRS = 2097152 // 0x200000 AHRS subsystem health
mavlink20.MAV_SYS_STATUS_TERRAIN = 4194304 // 0x400000 Terrain subsystem health
mavlink20.MAV_SYS_STATUS_REVERSE_MOTOR = 8388608 // 0x800000 Motors are reversed
mavlink20.MAV_SYS_STATUS_LOGGING = 16777216 // 0x1000000 Logging
mavlink20.MAV_SYS_STATUS_SENSOR_BATTERY = 33554432 // 0x2000000 Battery
mavlink20.MAV_SYS_STATUS_SENSOR_PROXIMITY = 67108864 // 0x4000000 Proximity
mavlink20.MAV_SYS_STATUS_SENSOR_SATCOM = 134217728 // 0x8000000 Satellite Communication
mavlink20.MAV_SYS_STATUS_PREARM_CHECK = 268435456 // 0x10000000 pre-arm check status. Always healthy when armed
mavlink20.MAV_SYS_STATUS_OBSTACLE_AVOIDANCE = 536870912 // 0x20000000 Avoidance/collision prevention
mavlink20.MAV_SYS_STATUS_SENSOR_PROPULSION = 1073741824 // 0x40000000 propulsion (actuator, esc, motor or propellor)
mavlink20.MAV_SYS_STATUS_EXTENSION_USED = 2147483648 // 0x80000000 Extended bit-field are used for further sensor status bits
                        // (needs to be set in
                        // onboard_control_sensors_present only)
mavlink20.MAV_SYS_STATUS_SENSOR_ENUM_END = 2147483649 // 

// MAV_SYS_STATUS_SENSOR_EXTENDED
mavlink20.MAV_SYS_STATUS_RECOVERY_SYSTEM = 1 // 0x01 Recovery system (parachute, balloon, retracts etc)
mavlink20.MAV_SYS_STATUS_SENSOR_LEAK = 2 // 0x02 Leak detection
mavlink20.MAV_SYS_STATUS_SENSOR_EXTENDED_ENUM_END = 3 // 

// MAV_FRAME
mavlink20.MAV_FRAME_GLOBAL = 0 // Global (WGS84) coordinate frame + altitude relative to mean sea level
                        // (MSL).
mavlink20.MAV_FRAME_LOCAL_NED = 1 // NED local tangent frame (x: North, y: East, z: Down) with origin fixed
                        // relative to earth.
mavlink20.MAV_FRAME_MISSION = 2 // NOT a coordinate frame, indicates a mission command.
mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT = 3 //            Global (WGS84) coordinate frame + altitude relative to the
                        // home position.
mavlink20.MAV_FRAME_LOCAL_ENU = 4 // ENU local tangent frame (x: East, y: North, z: Up) with origin fixed
                        // relative to earth.
mavlink20.MAV_FRAME_GLOBAL_INT = 5 // Global (WGS84) coordinate frame (scaled) + altitude relative to mean
                        // sea level (MSL).
mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT = 6 // Global (WGS84) coordinate frame (scaled) + altitude relative to the
                        // home position.
mavlink20.MAV_FRAME_LOCAL_OFFSET_NED = 7 // NED local tangent frame (x: North, y: East, z: Down) with origin that
                        // travels with the vehicle.
mavlink20.MAV_FRAME_BODY_NED = 8 // Same as MAV_FRAME_LOCAL_NED when used to represent position values.
                        // Same as MAV_FRAME_BODY_FRD when used with
                        // velocity/acceleration values.
mavlink20.MAV_FRAME_BODY_OFFSET_NED = 9 // This is the same as MAV_FRAME_BODY_FRD.
mavlink20.MAV_FRAME_GLOBAL_TERRAIN_ALT = 10 // Global (WGS84) coordinate frame with AGL altitude (altitude at ground
                        // level).
mavlink20.MAV_FRAME_GLOBAL_TERRAIN_ALT_INT = 11 // Global (WGS84) coordinate frame (scaled) with AGL altitude (altitude
                        // at ground level).
mavlink20.MAV_FRAME_BODY_FRD = 12 // FRD local frame aligned to the vehicle's attitude (x: Forward, y:
                        // Right, z: Down) with an origin that travels
                        // with vehicle.
mavlink20.MAV_FRAME_RESERVED_13 = 13 // MAV_FRAME_BODY_FLU - Body fixed frame of reference, Z-up (x: Forward,
                        // y: Left, z: Up).
mavlink20.MAV_FRAME_RESERVED_14 = 14 // MAV_FRAME_MOCAP_NED - Odometry local coordinate frame of data given by
                        // a motion capture system, Z-down (x: North,
                        // y: East, z: Down).
mavlink20.MAV_FRAME_RESERVED_15 = 15 // MAV_FRAME_MOCAP_ENU - Odometry local coordinate frame of data given by
                        // a motion capture system, Z-up (x: East, y:
                        // North, z: Up).
mavlink20.MAV_FRAME_RESERVED_16 = 16 // MAV_FRAME_VISION_NED - Odometry local coordinate frame of data given
                        // by a vision estimation system, Z-down (x:
                        // North, y: East, z: Down).
mavlink20.MAV_FRAME_RESERVED_17 = 17 // MAV_FRAME_VISION_ENU - Odometry local coordinate frame of data given
                        // by a vision estimation system, Z-up (x:
                        // East, y: North, z: Up).
mavlink20.MAV_FRAME_RESERVED_18 = 18 // MAV_FRAME_ESTIM_NED - Odometry local coordinate frame of data given by
                        // an estimator running onboard the vehicle,
                        // Z-down (x: North, y: East, z: Down).
mavlink20.MAV_FRAME_RESERVED_19 = 19 // MAV_FRAME_ESTIM_ENU - Odometry local coordinate frame of data given by
                        // an estimator running onboard the vehicle,
                        // Z-up (x: East, y: North, z: Up).
mavlink20.MAV_FRAME_LOCAL_FRD = 20 // FRD local tangent frame (x: Forward, y: Right, z: Down) with origin
                        // fixed relative to earth. The forward axis
                        // is aligned to the front of the vehicle in
                        // the horizontal plane.
mavlink20.MAV_FRAME_LOCAL_FLU = 21 // FLU local tangent frame (x: Forward, y: Left, z: Up) with origin fixed
                        // relative to earth. The forward axis is
                        // aligned to the front of the vehicle in the
                        // horizontal plane.
mavlink20.MAV_FRAME_ENUM_END = 22 // 

// MAVLINK_DATA_STREAM_TYPE
mavlink20.MAVLINK_DATA_STREAM_IMG_JPEG = 0 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_BMP = 1 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_RAW8U = 2 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_RAW32U = 3 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_PGM = 4 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_PNG = 5 // 
mavlink20.MAVLINK_DATA_STREAM_TYPE_ENUM_END = 6 // 

// FENCE_BREACH
mavlink20.FENCE_BREACH_NONE = 0 // No last fence breach
mavlink20.FENCE_BREACH_MINALT = 1 // Breached minimum altitude
mavlink20.FENCE_BREACH_MAXALT = 2 // Breached maximum altitude
mavlink20.FENCE_BREACH_BOUNDARY = 3 // Breached fence boundary
mavlink20.FENCE_BREACH_ENUM_END = 4 // 

// FENCE_MITIGATE
mavlink20.FENCE_MITIGATE_UNKNOWN = 0 // Unknown
mavlink20.FENCE_MITIGATE_NONE = 1 // No actions being taken
mavlink20.FENCE_MITIGATE_VEL_LIMIT = 2 // Velocity limiting active to prevent breach
mavlink20.FENCE_MITIGATE_ENUM_END = 3 // 

// FENCE_TYPE
mavlink20.FENCE_TYPE_ALT_MAX = 1 // Maximum altitude fence
mavlink20.FENCE_TYPE_CIRCLE = 2 // Circle fence
mavlink20.FENCE_TYPE_POLYGON = 4 // Polygon fence
mavlink20.FENCE_TYPE_ALT_MIN = 8 // Minimum altitude fence
mavlink20.FENCE_TYPE_ENUM_END = 9 // 

// MAV_MOUNT_MODE
mavlink20.MAV_MOUNT_MODE_RETRACT = 0 // Load and keep safe position (Roll,Pitch,Yaw) from permanent memory and
                        // stop stabilization
mavlink20.MAV_MOUNT_MODE_NEUTRAL = 1 // Load and keep neutral position (Roll,Pitch,Yaw) from permanent memory.
mavlink20.MAV_MOUNT_MODE_MAVLINK_TARGETING = 2 // Load neutral position and start MAVLink Roll,Pitch,Yaw control with
                        // stabilization
mavlink20.MAV_MOUNT_MODE_RC_TARGETING = 3 // Load neutral position and start RC Roll,Pitch,Yaw control with
                        // stabilization
mavlink20.MAV_MOUNT_MODE_GPS_POINT = 4 // Load neutral position and start to point to Lat,Lon,Alt
mavlink20.MAV_MOUNT_MODE_SYSID_TARGET = 5 // Gimbal tracks system with specified system ID
mavlink20.MAV_MOUNT_MODE_HOME_LOCATION = 6 // Gimbal tracks home position
mavlink20.MAV_MOUNT_MODE_ENUM_END = 7 // 

// GIMBAL_DEVICE_CAP_FLAGS
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_RETRACT = 1 // Gimbal device supports a retracted position.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_NEUTRAL = 2 // Gimbal device supports a horizontal, forward looking position,
                        // stabilized.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_AXIS = 4 // Gimbal device supports rotating around roll axis.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_FOLLOW = 8 // Gimbal device supports to follow a roll angle relative to the vehicle.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_LOCK = 16 // Gimbal device supports locking to a roll angle (generally that's the
                        // default with roll stabilized).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_AXIS = 32 // Gimbal device supports rotating around pitch axis.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_FOLLOW = 64 // Gimbal device supports to follow a pitch angle relative to the
                        // vehicle.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_LOCK = 128 // Gimbal device supports locking to a pitch angle (generally that's the
                        // default with pitch stabilized).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_AXIS = 256 // Gimbal device supports rotating around yaw axis.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_FOLLOW = 512 // Gimbal device supports to follow a yaw angle relative to the vehicle
                        // (generally that's the default).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_LOCK = 1024 // Gimbal device supports locking to an absolute heading, i.e., yaw angle
                        // relative to North (earth frame, often this
                        // is an option available).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_INFINITE_YAW = 2048 // Gimbal device supports yawing/panning infinitely (e.g. using slip
                        // disk).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME = 4096 // Gimbal device supports yaw angles and angular velocities relative to
                        // North (earth frame). This usually requires
                        // support by an autopilot via
                        // AUTOPILOT_STATE_FOR_GIMBAL_DEVICE. Support
                        // can go on and off during runtime, which is
                        // reported by the flag GIMBAL_DEVICE_FLAGS_CA
                        // N_ACCEPT_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_RC_INPUTS = 8192 // Gimbal device supports radio control inputs as an alternative input
                        // for controlling the gimbal orientation.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_CAN_POINT_LOCATION_LOCAL = 65536 // Gimbal device supports to point to a local position.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_CAN_POINT_LOCATION_GLOBAL = 131072 // Gimbal device supports to point to a global latitude, longitude,
                        // altitude position.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_ENUM_END = 131073 // 

// GIMBAL_MANAGER_CAP_FLAGS
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_RETRACT = 1 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_RETRACT.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_NEUTRAL = 2 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_NEUTRAL.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_AXIS = 4 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_AXIS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_FOLLOW = 8 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_FOLLOW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_LOCK = 16 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_LOCK.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_AXIS = 32 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_AXIS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_FOLLOW = 64 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_FOLLOW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_LOCK = 128 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_LOCK.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_AXIS = 256 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_AXIS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_FOLLOW = 512 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_FOLLOW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_LOCK = 1024 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_LOCK.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_SUPPORTS_INFINITE_YAW = 2048 // Based on GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_INFINITE_YAW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME = 4096 // Based on GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_RC_INPUTS = 8192 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_RC_INPUTS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_CAN_POINT_LOCATION_LOCAL = 65536 // Based on GIMBAL_DEVICE_CAP_FLAGS_CAN_POINT_LOCATION_LOCAL.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_CAN_POINT_LOCATION_GLOBAL = 131072 // Based on GIMBAL_DEVICE_CAP_FLAGS_CAN_POINT_LOCATION_GLOBAL.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_ENUM_END = 131073 // 

// GIMBAL_DEVICE_FLAGS
mavlink20.GIMBAL_DEVICE_FLAGS_RETRACT = 1 // Set to retracted safe position (no stabilization), takes precedence
                        // over all other flags.
mavlink20.GIMBAL_DEVICE_FLAGS_NEUTRAL = 2 // Set to neutral/default position, taking precedence over all other
                        // flags except RETRACT. Neutral is commonly
                        // forward-facing and horizontal
                        // (roll=pitch=yaw=0) but may be any
                        // orientation.
mavlink20.GIMBAL_DEVICE_FLAGS_ROLL_LOCK = 4 // Lock roll angle to absolute angle relative to horizon (not relative to
                        // vehicle). This is generally the default
                        // with a stabilizing gimbal.
mavlink20.GIMBAL_DEVICE_FLAGS_PITCH_LOCK = 8 // Lock pitch angle to absolute angle relative to horizon (not relative
                        // to vehicle). This is generally the default
                        // with a stabilizing gimbal.
mavlink20.GIMBAL_DEVICE_FLAGS_YAW_LOCK = 16 // Lock yaw angle to absolute angle relative to North (not relative to
                        // vehicle). If this flag is set, the yaw
                        // angle and z component of angular velocity
                        // are relative to North (earth frame, x-axis
                        // pointing North), else they are relative to
                        // the vehicle heading (vehicle frame, earth
                        // frame rotated so that the x-axis is
                        // pointing forward).
mavlink20.GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME = 32 // Yaw angle and z component of angular velocity are relative to the
                        // vehicle heading (vehicle frame, earth frame
                        // rotated such that the x-axis is pointing
                        // forward).
mavlink20.GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME = 64 // Yaw angle and z component of angular velocity are relative to North
                        // (earth frame, x-axis is pointing North).
mavlink20.GIMBAL_DEVICE_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME = 128 // Gimbal device can accept yaw angle inputs relative to North (earth
                        // frame). This flag is only for reporting
                        // (attempts to set this flag are ignored).
mavlink20.GIMBAL_DEVICE_FLAGS_RC_EXCLUSIVE = 256 // The gimbal orientation is set exclusively by the RC signals feed to
                        // the gimbal's radio control inputs. MAVLink
                        // messages for setting the gimbal orientation
                        // (GIMBAL_DEVICE_SET_ATTITUDE) are ignored.
mavlink20.GIMBAL_DEVICE_FLAGS_RC_MIXED = 512 // The gimbal orientation is determined by combining/mixing the RC
                        // signals feed to the gimbal's radio control
                        // inputs and the MAVLink messages for setting
                        // the gimbal orientation
                        // (GIMBAL_DEVICE_SET_ATTITUDE). How these two
                        // controls are combined or mixed is not
                        // defined by the protocol but is up to the
                        // implementation.
mavlink20.GIMBAL_DEVICE_FLAGS_ENUM_END = 513 // 

// GIMBAL_MANAGER_FLAGS
mavlink20.GIMBAL_MANAGER_FLAGS_RETRACT = 1 // Based on GIMBAL_DEVICE_FLAGS_RETRACT.
mavlink20.GIMBAL_MANAGER_FLAGS_NEUTRAL = 2 // Based on GIMBAL_DEVICE_FLAGS_NEUTRAL.
mavlink20.GIMBAL_MANAGER_FLAGS_ROLL_LOCK = 4 // Based on GIMBAL_DEVICE_FLAGS_ROLL_LOCK.
mavlink20.GIMBAL_MANAGER_FLAGS_PITCH_LOCK = 8 // Based on GIMBAL_DEVICE_FLAGS_PITCH_LOCK.
mavlink20.GIMBAL_MANAGER_FLAGS_YAW_LOCK = 16 // Based on GIMBAL_DEVICE_FLAGS_YAW_LOCK.
mavlink20.GIMBAL_MANAGER_FLAGS_YAW_IN_VEHICLE_FRAME = 32 // Based on GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME.
mavlink20.GIMBAL_MANAGER_FLAGS_YAW_IN_EARTH_FRAME = 64 // Based on GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_MANAGER_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME = 128 // Based on GIMBAL_DEVICE_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_MANAGER_FLAGS_RC_EXCLUSIVE = 256 // Based on GIMBAL_DEVICE_FLAGS_RC_EXCLUSIVE.
mavlink20.GIMBAL_MANAGER_FLAGS_RC_MIXED = 512 // Based on GIMBAL_DEVICE_FLAGS_RC_MIXED.
mavlink20.GIMBAL_MANAGER_FLAGS_ENUM_END = 513 // 

// GIMBAL_DEVICE_ERROR_FLAGS
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_AT_ROLL_LIMIT = 1 // Gimbal device is limited by hardware roll limit.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_AT_PITCH_LIMIT = 2 // Gimbal device is limited by hardware pitch limit.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_AT_YAW_LIMIT = 4 // Gimbal device is limited by hardware yaw limit.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_ENCODER_ERROR = 8 // There is an error with the gimbal encoders.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_POWER_ERROR = 16 // There is an error with the gimbal power source.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_MOTOR_ERROR = 32 // There is an error with the gimbal motors.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_SOFTWARE_ERROR = 64 // There is an error with the gimbal's software.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_COMMS_ERROR = 128 // There is an error with the gimbal's communication.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_CALIBRATION_RUNNING = 256 // Gimbal device is currently calibrating.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_NO_MANAGER = 512 // Gimbal device is not assigned to a gimbal manager.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_ENUM_END = 513 // 

// GRIPPER_ACTIONS
mavlink20.GRIPPER_ACTION_RELEASE = 0 // Gripper release cargo.
mavlink20.GRIPPER_ACTION_GRAB = 1 // Gripper grab onto cargo.
mavlink20.GRIPPER_ACTION_HOLD = 2 // Gripper hold current grip state/position.
mavlink20.GRIPPER_ACTIONS_ENUM_END = 3 // 

// WINCH_ACTIONS
mavlink20.WINCH_RELAXED = 0 // Allow motor to freewheel.
mavlink20.WINCH_RELATIVE_LENGTH_CONTROL = 1 // Wind or unwind specified length of line, optionally using specified
                        // rate.
mavlink20.WINCH_RATE_CONTROL = 2 // Wind or unwind line at specified rate.
mavlink20.WINCH_LOCK = 3 // Perform the locking sequence to relieve motor while in the fully
                        // retracted position. Only action and
                        // instance command parameters are used,
                        // others are ignored.
mavlink20.WINCH_DELIVER = 4 // Sequence of drop, slow down, touch down, reel up, lock. Only action
                        // and instance command parameters are used,
                        // others are ignored.
mavlink20.WINCH_HOLD = 5 // Engage motor and hold current position. Only action and instance
                        // command parameters are used, others are
                        // ignored.
mavlink20.WINCH_RETRACT = 6 // Return the reel to the fully retracted position. Only action and
                        // instance command parameters are used,
                        // others are ignored.
mavlink20.WINCH_LOAD_LINE = 7 // Load the reel with line. The winch will calculate the total loaded
                        // length and stop when the tension exceeds a
                        // threshold. Only action and instance command
                        // parameters are used, others are ignored.
mavlink20.WINCH_ABANDON_LINE = 8 // Spool out the entire length of the line. Only action and instance
                        // command parameters are used, others are
                        // ignored.
mavlink20.WINCH_LOAD_PAYLOAD = 9 // Spools out just enough to present the hook to the user to load the
                        // payload. Only action and instance command
                        // parameters are used, others are ignored
mavlink20.WINCH_ACTIONS_ENUM_END = 10 // 

// UAVCAN_NODE_HEALTH
mavlink20.UAVCAN_NODE_HEALTH_OK = 0 // The node is functioning properly.
mavlink20.UAVCAN_NODE_HEALTH_WARNING = 1 // A critical parameter went out of range or the node has encountered a
                        // minor failure.
mavlink20.UAVCAN_NODE_HEALTH_ERROR = 2 // The node has encountered a major failure.
mavlink20.UAVCAN_NODE_HEALTH_CRITICAL = 3 // The node has suffered a fatal malfunction.
mavlink20.UAVCAN_NODE_HEALTH_ENUM_END = 4 // 

// UAVCAN_NODE_MODE
mavlink20.UAVCAN_NODE_MODE_OPERATIONAL = 0 // The node is performing its primary functions.
mavlink20.UAVCAN_NODE_MODE_INITIALIZATION = 1 // The node is initializing; this mode is entered immediately after
                        // startup.
mavlink20.UAVCAN_NODE_MODE_MAINTENANCE = 2 // The node is under maintenance.
mavlink20.UAVCAN_NODE_MODE_SOFTWARE_UPDATE = 3 // The node is in the process of updating its software.
mavlink20.UAVCAN_NODE_MODE_OFFLINE = 7 // The node is no longer available online.
mavlink20.UAVCAN_NODE_MODE_ENUM_END = 8 // 

// ESC_CONNECTION_TYPE
mavlink20.ESC_CONNECTION_TYPE_PPM = 0 // Traditional PPM ESC.
mavlink20.ESC_CONNECTION_TYPE_SERIAL = 1 // Serial Bus connected ESC.
mavlink20.ESC_CONNECTION_TYPE_ONESHOT = 2 // One Shot PPM ESC.
mavlink20.ESC_CONNECTION_TYPE_I2C = 3 // I2C ESC.
mavlink20.ESC_CONNECTION_TYPE_CAN = 4 // CAN-Bus ESC.
mavlink20.ESC_CONNECTION_TYPE_DSHOT = 5 // DShot ESC.
mavlink20.ESC_CONNECTION_TYPE_ENUM_END = 6 // 

// ESC_FAILURE_FLAGS
mavlink20.ESC_FAILURE_OVER_CURRENT = 1 // Over current failure.
mavlink20.ESC_FAILURE_OVER_VOLTAGE = 2 // Over voltage failure.
mavlink20.ESC_FAILURE_OVER_TEMPERATURE = 4 // Over temperature failure.
mavlink20.ESC_FAILURE_OVER_RPM = 8 // Over RPM failure.
mavlink20.ESC_FAILURE_INCONSISTENT_CMD = 16 // Inconsistent command failure i.e. out of bounds.
mavlink20.ESC_FAILURE_MOTOR_STUCK = 32 // Motor stuck failure.
mavlink20.ESC_FAILURE_GENERIC = 64 // Generic ESC failure.
mavlink20.ESC_FAILURE_FLAGS_ENUM_END = 65 // 

// STORAGE_STATUS
mavlink20.STORAGE_STATUS_EMPTY = 0 // Storage is missing (no microSD card loaded for example.)
mavlink20.STORAGE_STATUS_UNFORMATTED = 1 // Storage present but unformatted.
mavlink20.STORAGE_STATUS_READY = 2 // Storage present and ready.
mavlink20.STORAGE_STATUS_NOT_SUPPORTED = 3 // Camera does not supply storage status information. Capacity
                        // information in STORAGE_INFORMATION fields
                        // will be ignored.
mavlink20.STORAGE_STATUS_ENUM_END = 4 // 

// STORAGE_TYPE
mavlink20.STORAGE_TYPE_UNKNOWN = 0 // Storage type is not known.
mavlink20.STORAGE_TYPE_USB_STICK = 1 // Storage type is USB device.
mavlink20.STORAGE_TYPE_SD = 2 // Storage type is SD card.
mavlink20.STORAGE_TYPE_MICROSD = 3 // Storage type is microSD card.
mavlink20.STORAGE_TYPE_CF = 4 // Storage type is CFast.
mavlink20.STORAGE_TYPE_CFE = 5 // Storage type is CFexpress.
mavlink20.STORAGE_TYPE_XQD = 6 // Storage type is XQD.
mavlink20.STORAGE_TYPE_HD = 7 // Storage type is HD mass storage type.
mavlink20.STORAGE_TYPE_OTHER = 254 // Storage type is other, not listed type.
mavlink20.STORAGE_TYPE_ENUM_END = 255 // 

// STORAGE_USAGE_FLAG
mavlink20.STORAGE_USAGE_FLAG_SET = 1 // Always set to 1 (indicates STORAGE_INFORMATION.storage_usage is
                        // supported).
mavlink20.STORAGE_USAGE_FLAG_PHOTO = 2 // Storage for saving photos.
mavlink20.STORAGE_USAGE_FLAG_VIDEO = 4 // Storage for saving videos.
mavlink20.STORAGE_USAGE_FLAG_LOGS = 8 // Storage for saving logs.
mavlink20.STORAGE_USAGE_FLAG_ENUM_END = 9 // 

// ORBIT_YAW_BEHAVIOUR
mavlink20.ORBIT_YAW_BEHAVIOUR_HOLD_FRONT_TO_CIRCLE_CENTER = 0 // Vehicle front points to the center (default).
mavlink20.ORBIT_YAW_BEHAVIOUR_HOLD_INITIAL_HEADING = 1 // Vehicle front holds heading when message received.
mavlink20.ORBIT_YAW_BEHAVIOUR_UNCONTROLLED = 2 // Yaw uncontrolled.
mavlink20.ORBIT_YAW_BEHAVIOUR_HOLD_FRONT_TANGENT_TO_CIRCLE = 3 // Vehicle front follows flight path (tangential to circle).
mavlink20.ORBIT_YAW_BEHAVIOUR_RC_CONTROLLED = 4 // Yaw controlled by RC input.
mavlink20.ORBIT_YAW_BEHAVIOUR_UNCHANGED = 5 // Vehicle uses current yaw behaviour (unchanged). The vehicle-default
                        // yaw behaviour is used if this value is
                        // specified when orbit is first commanded.
mavlink20.ORBIT_YAW_BEHAVIOUR_ENUM_END = 6 // 

// WIFI_CONFIG_AP_RESPONSE
mavlink20.WIFI_CONFIG_AP_RESPONSE_UNDEFINED = 0 // Undefined response. Likely an indicative of a system that doesn't
                        // support this request.
mavlink20.WIFI_CONFIG_AP_RESPONSE_ACCEPTED = 1 // Changes accepted.
mavlink20.WIFI_CONFIG_AP_RESPONSE_REJECTED = 2 // Changes rejected.
mavlink20.WIFI_CONFIG_AP_RESPONSE_MODE_ERROR = 3 // Invalid Mode.
mavlink20.WIFI_CONFIG_AP_RESPONSE_SSID_ERROR = 4 // Invalid SSID.
mavlink20.WIFI_CONFIG_AP_RESPONSE_PASSWORD_ERROR = 5 // Invalid Password.
mavlink20.WIFI_CONFIG_AP_RESPONSE_ENUM_END = 6 // 

// CELLULAR_CONFIG_RESPONSE
mavlink20.CELLULAR_CONFIG_RESPONSE_ACCEPTED = 0 // Changes accepted.
mavlink20.CELLULAR_CONFIG_RESPONSE_APN_ERROR = 1 // Invalid APN.
mavlink20.CELLULAR_CONFIG_RESPONSE_PIN_ERROR = 2 // Invalid PIN.
mavlink20.CELLULAR_CONFIG_RESPONSE_REJECTED = 3 // Changes rejected.
mavlink20.CELLULAR_CONFIG_BLOCKED_PUK_REQUIRED = 4 // PUK is required to unblock SIM card.
mavlink20.CELLULAR_CONFIG_RESPONSE_ENUM_END = 5 // 

// WIFI_CONFIG_AP_MODE
mavlink20.WIFI_CONFIG_AP_MODE_UNDEFINED = 0 // WiFi mode is undefined.
mavlink20.WIFI_CONFIG_AP_MODE_AP = 1 // WiFi configured as an access point.
mavlink20.WIFI_CONFIG_AP_MODE_STATION = 2 // WiFi configured as a station connected to an existing local WiFi
                        // network.
mavlink20.WIFI_CONFIG_AP_MODE_DISABLED = 3 // WiFi disabled.
mavlink20.WIFI_CONFIG_AP_MODE_ENUM_END = 4 // 

// COMP_METADATA_TYPE
mavlink20.COMP_METADATA_TYPE_GENERAL = 0 // General information about the component. General metadata includes
                        // information about other metadata types
                        // supported by the component. Files of this
                        // type must be supported, and must be
                        // downloadable from vehicle using a MAVLink
                        // FTP URI.
mavlink20.COMP_METADATA_TYPE_PARAMETER = 1 // Parameter meta data.
mavlink20.COMP_METADATA_TYPE_COMMANDS = 2 // Meta data that specifies which commands and command parameters the
                        // vehicle supports. (WIP)
mavlink20.COMP_METADATA_TYPE_PERIPHERALS = 3 // Meta data that specifies external non-MAVLink peripherals.
mavlink20.COMP_METADATA_TYPE_EVENTS = 4 // Meta data for the events interface.
mavlink20.COMP_METADATA_TYPE_ACTUATORS = 5 // Meta data for actuator configuration (motors, servos and vehicle
                        // geometry) and testing.
mavlink20.COMP_METADATA_TYPE_ENUM_END = 6 // 

// ACTUATOR_CONFIGURATION
mavlink20.ACTUATOR_CONFIGURATION_NONE = 0 // Do nothing.
mavlink20.ACTUATOR_CONFIGURATION_BEEP = 1 // Command the actuator to beep now.
mavlink20.ACTUATOR_CONFIGURATION_3D_MODE_ON = 2 // Permanently set the actuator (ESC) to 3D mode (reversible thrust).
mavlink20.ACTUATOR_CONFIGURATION_3D_MODE_OFF = 3 // Permanently set the actuator (ESC) to non 3D mode (non-reversible
                        // thrust).
mavlink20.ACTUATOR_CONFIGURATION_SPIN_DIRECTION1 = 4 // Permanently set the actuator (ESC) to spin direction 1 (which can be
                        // clockwise or counter-clockwise).
mavlink20.ACTUATOR_CONFIGURATION_SPIN_DIRECTION2 = 5 // Permanently set the actuator (ESC) to spin direction 2 (opposite of
                        // direction 1).
mavlink20.ACTUATOR_CONFIGURATION_ENUM_END = 6 // 

// ACTUATOR_OUTPUT_FUNCTION
mavlink20.ACTUATOR_OUTPUT_FUNCTION_NONE = 0 // No function (disabled).
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR1 = 1 // Motor 1
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR2 = 2 // Motor 2
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR3 = 3 // Motor 3
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR4 = 4 // Motor 4
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR5 = 5 // Motor 5
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR6 = 6 // Motor 6
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR7 = 7 // Motor 7
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR8 = 8 // Motor 8
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR9 = 9 // Motor 9
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR10 = 10 // Motor 10
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR11 = 11 // Motor 11
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR12 = 12 // Motor 12
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR13 = 13 // Motor 13
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR14 = 14 // Motor 14
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR15 = 15 // Motor 15
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR16 = 16 // Motor 16
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO1 = 33 // Servo 1
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO2 = 34 // Servo 2
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO3 = 35 // Servo 3
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO4 = 36 // Servo 4
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO5 = 37 // Servo 5
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO6 = 38 // Servo 6
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO7 = 39 // Servo 7
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO8 = 40 // Servo 8
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO9 = 41 // Servo 9
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO10 = 42 // Servo 10
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO11 = 43 // Servo 11
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO12 = 44 // Servo 12
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO13 = 45 // Servo 13
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO14 = 46 // Servo 14
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO15 = 47 // Servo 15
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO16 = 48 // Servo 16
mavlink20.ACTUATOR_OUTPUT_FUNCTION_ENUM_END = 49 // 

// AUTOTUNE_AXIS
mavlink20.AUTOTUNE_AXIS_ROLL = 1 // Autotune roll axis.
mavlink20.AUTOTUNE_AXIS_PITCH = 2 // Autotune pitch axis.
mavlink20.AUTOTUNE_AXIS_YAW = 4 // Autotune yaw axis.
mavlink20.AUTOTUNE_AXIS_ENUM_END = 5 // 

// PREFLIGHT_STORAGE_PARAMETER_ACTION
mavlink20.PARAM_READ_PERSISTENT = 0 // Read all parameters from persistent storage. Replaces values in
                        // volatile storage.
mavlink20.PARAM_WRITE_PERSISTENT = 1 // Write all parameter values to persistent storage (flash/EEPROM)
mavlink20.PARAM_RESET_FACTORY_DEFAULT = 2 // Reset parameters to default values (such as sensor calibration, safety
                        // settings, and so on). Note that a flight
                        // stack may choose not to reset some
                        // parameters at their own discretion (such as
                        // those that are locked or expected to
                        // persist for the vehicle lifetime).
mavlink20.PARAM_RESET_SENSOR_DEFAULT = 3 // Reset only sensor calibration parameters to factory defaults (or
                        // firmware default if not available)
mavlink20.PARAM_RESET_ALL_DEFAULT = 4 // Reset all parameters to default values.
mavlink20.PREFLIGHT_STORAGE_PARAMETER_ACTION_ENUM_END = 5 // 

// PREFLIGHT_STORAGE_MISSION_ACTION
mavlink20.MISSION_READ_PERSISTENT = 0 // Read current mission data from persistent storage
mavlink20.MISSION_WRITE_PERSISTENT = 1 // Write current mission data to persistent storage
mavlink20.MISSION_RESET_DEFAULT = 2 // Erase all mission data stored on the vehicle (both persistent and
                        // volatile storage)
mavlink20.PREFLIGHT_STORAGE_MISSION_ACTION_ENUM_END = 3 // 

// REBOOT_SHUTDOWN_ACTION
mavlink20.REBOOT_SHUTDOWN_ACTION_NONE = 0 // Do nothing.
mavlink20.REBOOT_SHUTDOWN_ACTION_REBOOT = 1 // Reboot component.
mavlink20.REBOOT_SHUTDOWN_ACTION_SHUTDOWN = 2 // Shutdown component.
mavlink20.REBOOT_SHUTDOWN_ACTION_REBOOT_TO_BOOTLOADER = 3 // Reboot component and keep it in the bootloader until upgraded.
mavlink20.REBOOT_SHUTDOWN_ACTION_POWER_ON = 4 // Power on component. Do nothing if component is already powered (ACK
                        // command with MAV_RESULT_ACCEPTED).
mavlink20.REBOOT_SHUTDOWN_ACTION_ENUM_END = 5 // 

// REBOOT_SHUTDOWN_CONDITIONS
mavlink20.REBOOT_SHUTDOWN_CONDITIONS_SAFETY_INTERLOCKED = 0 // Reboot/Shutdown only if allowed by safety checks, such as being
                        // landed.
mavlink20.REBOOT_SHUTDOWN_CONDITIONS_FORCE = 20190226 // Force reboot/shutdown of the autopilot/component regardless of system
                        // state.
mavlink20.REBOOT_SHUTDOWN_CONDITIONS_ENUM_END = 20190227 // 

// PREFLIGHT_CALIBRATION_MAGNETOMETER
mavlink20.PREFLIGHT_CALIBRATION_MAGNETOMETER_NONE = 0 // No action.
mavlink20.PREFLIGHT_CALIBRATION_MAGNETOMETER_START = 1 // Start magnetometer calibration.
mavlink20.PREFLIGHT_CALIBRATION_MAGNETOMETER_FORCE_SAVE = 76 // Force-accept the existing compass calibration as valid without re-
                        // running it. Useful after a parameter reload
                        // that cleared calibration validity flags.
mavlink20.PREFLIGHT_CALIBRATION_MAGNETOMETER_ENUM_END = 77 // 

// PREFLIGHT_CALIBRATION_ACCELEROMETER
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_NONE = 0 // No action.
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_FULL = 1 // Full 6-position accelerometer calibration.
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_TRIM = 2 // Board level (trim) calibration.
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_TEMPERATURE = 3 // Accelerometer temperature calibration.
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_SIMPLE = 4 // Simple accelerometer calibration.
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_FORCE_SAVE = 76 // Force-accept the existing accelerometer calibration as valid without
                        // re-running it. Useful after a parameter
                        // reload that cleared calibration validity
                        // flags.
mavlink20.PREFLIGHT_CALIBRATION_ACCELEROMETER_ENUM_END = 77 // 

// NAV_TAKEOFF_FLAGS
mavlink20.NAV_TAKEOFF_FLAGS_HORIZONTAL_POSITION_NOT_REQUIRED = 1 // Accept the command even if the autopilot does not have control over
                        // its horizontal position (note that it might
                        // not have altitude control either).
mavlink20.NAV_TAKEOFF_FLAGS_ENUM_END = 2 // 

// MAV_CMD
mavlink20.MAV_CMD_NAV_WAYPOINT = 16 // Navigate to waypoint. This is intended for use in missions (for guided
                        // commands outside of missions use
                        // MAV_CMD_DO_REPOSITION).
mavlink20.MAV_CMD_NAV_LOITER_UNLIM = 17 // Loiter around this waypoint an unlimited amount of time
mavlink20.MAV_CMD_NAV_LOITER_TURNS = 18 // Loiter around this waypoint for X turns
mavlink20.MAV_CMD_NAV_LOITER_TIME = 19 // Loiter at the specified latitude, longitude and altitude for a certain
                        // amount of time. Multicopter vehicles stop
                        // at the point (within a vehicle-specific
                        // acceptance radius). Forward-only moving
                        // vehicles (e.g. fixed-wing) circle the point
                        // with the specified radius/direction. If the
                        // Heading Required parameter (2) is non-zero
                        // forward moving aircraft will only leave the
                        // loiter circle once heading towards the next
                        // waypoint.
mavlink20.MAV_CMD_NAV_RETURN_TO_LAUNCH = 20 // Return to launch location
mavlink20.MAV_CMD_NAV_LAND = 21 // Land at location.
mavlink20.MAV_CMD_NAV_TAKEOFF = 22 // Takeoff from ground / hand. Vehicles that support multiple takeoff
                        // modes (e.g. VTOL quadplane) should take off
                        // using the currently configured mode.
mavlink20.MAV_CMD_NAV_LAND_LOCAL = 23 // Land at local position (local frame only)
mavlink20.MAV_CMD_NAV_TAKEOFF_LOCAL = 24 // Takeoff from local position (local frame only)
mavlink20.MAV_CMD_NAV_FOLLOW = 25 // Vehicle following, i.e. this waypoint represents the position of a
                        // moving vehicle
mavlink20.MAV_CMD_NAV_CONTINUE_AND_CHANGE_ALT = 30 // Continue on the current course and climb/descend to specified
                        // altitude.  When the altitude is reached
                        // continue to the next command (i.e., don't
                        // proceed to the next command until the
                        // desired altitude is reached.
mavlink20.MAV_CMD_NAV_LOITER_TO_ALT = 31 // Begin loiter at the specified Latitude and Longitude.  If Lat=Lon=0,
                        // then loiter at the current position.  Don't
                        // consider the navigation command complete
                        // (don't leave loiter) until the altitude has
                        // been reached. Additionally, if the Heading
                        // Required parameter is non-zero the aircraft
                        // will not leave the loiter until heading
                        // toward the next waypoint.
mavlink20.MAV_CMD_DO_FOLLOW = 32 // Begin following a target
mavlink20.MAV_CMD_DO_FOLLOW_REPOSITION = 33 // Reposition the MAV after a follow target command has been sent
mavlink20.MAV_CMD_DO_ORBIT = 34 // Start orbiting on the circumference of a circle defined by the
                        // parameters. Setting values to NaN/INT32_MAX
                        // (as appropriate) results in using defaults.
mavlink20.MAV_CMD_DO_FIGURE_EIGHT = 35 // Fly a figure eight path as defined by the parameters.           Set
                        // parameters to NaN/INT32_MAX (as
                        // appropriate) to use system-default values.
                        // The command is intended for fixed wing
                        // vehicles (and VTOL hybrids flying in fixed-
                        // wing mode), allowing POI tracking for
                        // gimbals that don't support infinite
                        // rotation.           This command only
                        // defines the flight path. Speed should be
                        // set independently (use e.g.
                        // MAV_CMD_DO_CHANGE_SPEED).           Yaw and
                        // other degrees of freedom are not specified,
                        // and will be flight-stack specific (on
                        // vehicles where they can be controlled
                        // independent of the heading).
mavlink20.MAV_CMD_NAV_ARC_WAYPOINT = 36 // Circular arc path waypoint.           This defines the end/exit point
                        // and angle (param1) of an arc path from the
                        // previous waypoint. A position is required
                        // before this command to define the start of
                        // the arc (e.g. current position, a
                        // MAV_CMD_NAV_WAYPOINT, or a
                        // MAV_CMD_NAV_ARC_WAYPOINT).           The
                        // resulting path is a circular arc in the NE
                        // frame, with the difference in height being
                        // defined by the difference in waypoint
                        // altitudes.
mavlink20.MAV_CMD_NAV_ROI = 80 // Sets the region of interest (ROI) for a sensor set or the vehicle
                        // itself. This can then be used by the
                        // vehicle's control system to control the
                        // vehicle attitude and the attitude of
                        // various sensors such as cameras.
mavlink20.MAV_CMD_NAV_PATHPLANNING = 81 // Control autonomous path planning on the MAV.
mavlink20.MAV_CMD_NAV_SPLINE_WAYPOINT = 82 // Navigate to waypoint using a spline path.
mavlink20.MAV_CMD_NAV_VTOL_TAKEOFF = 84 // Takeoff from ground using VTOL mode, and transition to forward flight
                        // with specified heading. The command should
                        // be ignored by vehicles that dont support
                        // both VTOL and fixed-wing flight
                        // (multicopters, boats,etc.).
mavlink20.MAV_CMD_NAV_VTOL_LAND = 85 // Land using VTOL mode
mavlink20.MAV_CMD_NAV_GUIDED_ENABLE = 92 // Hand control over to an external controller
mavlink20.MAV_CMD_NAV_DELAY = 93 // Delay the next navigation command a number of seconds or until a
                        // specified time
mavlink20.MAV_CMD_NAV_PAYLOAD_PLACE = 94 // Descend and place payload. Vehicle moves to specified location,
                        // descends until it detects a hanging payload
                        // has reached the ground, and then releases
                        // the payload. If ground is not detected
                        // before the reaching the maximum descent
                        // value (param1), the command will complete
                        // without releasing the payload.
mavlink20.MAV_CMD_NAV_LAST = 95 // NOP - This command is only used to mark the upper limit of the
                        // NAV/ACTION commands in the enumeration
mavlink20.MAV_CMD_CONDITION_DELAY = 112 // Delay mission state machine.
mavlink20.MAV_CMD_CONDITION_CHANGE_ALT = 113 // Ascend/descend to target altitude at specified rate. Delay mission
                        // state machine until desired altitude
                        // reached.
mavlink20.MAV_CMD_CONDITION_DISTANCE = 114 // Delay mission state machine until within desired distance of next NAV
                        // point.
mavlink20.MAV_CMD_CONDITION_YAW = 115 // Reach a certain target angle.
mavlink20.MAV_CMD_CONDITION_LAST = 159 // NOP - This command is only used to mark the upper limit of the
                        // CONDITION commands in the enumeration
mavlink20.MAV_CMD_DO_SET_MODE = 176 // Set system mode.
mavlink20.MAV_CMD_DO_JUMP = 177 // Jump to the desired command in the mission list.  Repeat this action
                        // only the specified number of times
mavlink20.MAV_CMD_DO_CHANGE_SPEED = 178 // Change speed and/or throttle set points. The value persists until it
                        // is overridden or there is a mode change
mavlink20.MAV_CMD_DO_SET_HOME = 179 //            Sets the home position to either to the current position or
                        // a specified position.           The home
                        // position is the default position that the
                        // system will return to and land on.
                        // The position is set automatically by the
                        // system during the takeoff (and may also be
                        // set using this command).           Note:
                        // the current home position may be emitted in
                        // a HOME_POSITION message on request (using
                        // MAV_CMD_REQUEST_MESSAGE with param1=242).
mavlink20.MAV_CMD_DO_SET_PARAMETER = 180 // Set a system parameter.  Caution!  Use of this command requires
                        // knowledge of the numeric enumeration value
                        // of the parameter.
mavlink20.MAV_CMD_DO_SET_RELAY = 181 // Set a relay to a condition. The current value may optionally be
                        // reported using RELAY_STATUS.
mavlink20.MAV_CMD_DO_REPEAT_RELAY = 182 // Cycle a relay on and off for a desired number of cycles with a desired
                        // period.
mavlink20.MAV_CMD_DO_SET_SERVO = 183 // Set a servo to a desired PWM value.
mavlink20.MAV_CMD_DO_REPEAT_SERVO = 184 // Cycle a between its nominal setting and a desired PWM for a desired
                        // number of cycles with a desired period.
mavlink20.MAV_CMD_DO_FLIGHTTERMINATION = 185 // Terminate flight immediately.           Flight termination immediately
                        // and irreversibly terminates the current
                        // flight, returning the vehicle to ground.
                        // The vehicle will ignore RC or other input
                        // until it has been power-cycled.
                        // Termination may trigger safety measures,
                        // including: disabling motors and deployment
                        // of parachute on multicopters, and setting
                        // flight surfaces to initiate a landing
                        // pattern on fixed-wing).           On
                        // multicopters without a parachute it may
                        // trigger a crash landing.           Support
                        // for this command can be tested using the
                        // protocol bit:
                        // MAV_PROTOCOL_CAPABILITY_FLIGHT_TERMINATION.
                        // Support for this command can also be tested
                        // by sending the command with param1=0 (<
                        // 0.5); the ACK should be either
                        // MAV_RESULT_FAILED or
                        // MAV_RESULT_UNSUPPORTED.
mavlink20.MAV_CMD_DO_CHANGE_ALTITUDE = 186 // Change altitude set point.
mavlink20.MAV_CMD_DO_SET_ACTUATOR = 187 // Sets actuators (e.g. servos) to a desired value. The actuator numbers
                        // are mapped to specific outputs (e.g. on any
                        // MAIN or AUX PWM or UAVCAN) using a flight-
                        // stack specific mechanism (i.e. a
                        // parameter).
mavlink20.MAV_CMD_DO_RETURN_PATH_START = 188 // Mission item to specify the start of a failsafe/landing return-path
                        // segment (the end of the segment is the next
                        // MAV_CMD_DO_LAND_START item).           A
                        // vehicle that is using missions for landing
                        // (e.g. in a return mode) will join the
                        // mission on the closest path of the return-
                        // path segment (instead of
                        // MAV_CMD_DO_LAND_START or the nearest
                        // waypoint).           The main use case is
                        // to minimize the failsafe flight path in
                        // corridor missions, where the
                        // inbound/outbound paths are constrained (by
                        // geofences) to the same particular path.
                        // The MAV_CMD_NAV_RETURN_PATH_START would be
                        // placed at the start of the return path.
                        // If a failsafe occurs on the outbound path
                        // the vehicle will move to the nearest point
                        // on the return path (which is parallel for
                        // this kind of mission), effectively turning
                        // round and following the shortest path to
                        // landing.           If a failsafe occurs on
                        // the inbound path the vehicle is already on
                        // the return segment and will continue to
                        // landing.           The
                        // Latitude/Longitude/Altitude are optional,
                        // and may be set to 0 if not needed.
                        // If specified, the item defines the waypoint
                        // at which the return segment starts.
                        // If sent using as a command, the vehicle
                        // will perform a mission landing (using the
                        // land segment if defined) or reject the
                        // command if mission landings are not
                        // supported, or no mission landing is
                        // defined. When used as a command any
                        // position information in the command is
                        // ignored.
mavlink20.MAV_CMD_DO_LAND_START = 189 // Mission item to mark the start of a mission landing pattern, or a
                        // command to land with a mission landing
                        // pattern.          When used in a mission,
                        // this is a marker for the start of a
                        // sequence of mission items that represent a
                        // landing pattern.         It should be
                        // followed by a navigation item that defines
                        // the first waypoint of the landing sequence.
                        // The start marker positional params are used
                        // only for selecting what landing pattern to
                        // use if several are defined in the mission
                        // (the selected pattern will be the one with
                        // the marker position that is closest to the
                        // vehicle when a landing is commanded).
                        // If the marker item position has zero-values
                        // for latitude, longitude, and altitude, then
                        // landing pattern selection is instead based
                        // on the position of the first waypoint in
                        // the landing sequence.                When
                        // sent as a command it triggers a landing
                        // using a mission landing pattern.
                        // The location parameters are not used in
                        // this case, and should be set to 0.
mavlink20.MAV_CMD_DO_RALLY_LAND = 190 // Mission command to perform a landing from a rally point.
mavlink20.MAV_CMD_DO_GO_AROUND = 191 // Mission command to safely abort an autonomous landing.
mavlink20.MAV_CMD_DO_REPOSITION = 192 // Reposition the vehicle to a specific WGS84 global position. This
                        // command is intended for guided commands
                        // (for missions use MAV_CMD_NAV_WAYPOINT
                        // instead).
mavlink20.MAV_CMD_DO_PAUSE_CONTINUE = 193 // If in a GPS controlled position mode, hold the current position or
                        // continue.
mavlink20.MAV_CMD_DO_SET_REVERSE = 194 // Set moving direction to forward or reverse.
mavlink20.MAV_CMD_DO_SET_ROI_LOCATION = 195 // Sets the region of interest (ROI) to a location. This can then be used
                        // by the vehicle's control system to control
                        // the vehicle attitude and the attitude of
                        // various sensors such as cameras. This
                        // command can be sent to a gimbal manager but
                        // not to a gimbal device. A gimbal is not to
                        // react to this message.
mavlink20.MAV_CMD_DO_SET_ROI_WPNEXT_OFFSET = 196 // Sets the region of interest (ROI) to be toward next waypoint, with
                        // optional pitch/roll/yaw offset. This can
                        // then be used by the vehicle's control
                        // system to control the vehicle attitude and
                        // the attitude of various sensors such as
                        // cameras. This command can be sent to a
                        // gimbal manager but not to a gimbal device.
                        // A gimbal device is not to react to this
                        // message.
mavlink20.MAV_CMD_DO_SET_ROI_NONE = 197 // Cancels any previous ROI command returning the vehicle/sensors to
                        // default flight characteristics. This can
                        // then be used by the vehicle's control
                        // system to control the vehicle attitude and
                        // the attitude of various sensors such as
                        // cameras. This command can be sent to a
                        // gimbal manager but not to a gimbal device.
                        // A gimbal device is not to react to this
                        // message. After this command the gimbal
                        // manager should go back to manual input if
                        // available, and otherwise assume a neutral
                        // position.
mavlink20.MAV_CMD_DO_SET_ROI_SYSID = 198 // Mount tracks system with specified system ID. Determination of target
                        // vehicle position may be done with
                        // GLOBAL_POSITION_INT or any other means.
                        // This command can be sent to a gimbal
                        // manager but not to a gimbal device. A
                        // gimbal device is not to react to this
                        // message.
mavlink20.MAV_CMD_DO_CONTROL_VIDEO = 200 // Control onboard camera system.
mavlink20.MAV_CMD_DO_SET_ROI = 201 // Sets the region of interest (ROI) for a sensor set or the vehicle
                        // itself. This can then be used by the
                        // vehicle's control system to control the
                        // vehicle attitude and the attitude of
                        // various sensors such as cameras.
mavlink20.MAV_CMD_DO_DIGICAM_CONFIGURE = 202 // Configure digital camera. This is a fallback message for systems that
                        // have not yet implemented PARAM_EXT_XXX
                        // messages and camera definition files (see h
                        // ttps://mavlink.io/en/services/camera_def.ht
                        // ml ).
mavlink20.MAV_CMD_DO_DIGICAM_CONTROL = 203 // Control digital camera. This is a fallback message for systems that
                        // have not yet implemented PARAM_EXT_XXX
                        // messages and camera definition files (see h
                        // ttps://mavlink.io/en/services/camera_def.ht
                        // ml ).
mavlink20.MAV_CMD_DO_MOUNT_CONFIGURE = 204 // Mission command to configure a camera or antenna mount
mavlink20.MAV_CMD_DO_MOUNT_CONTROL = 205 // Mission command to control a camera or antenna mount
mavlink20.MAV_CMD_DO_SET_CAM_TRIGG_DIST = 206 // Mission command to set camera trigger distance for this flight. The
                        // camera is triggered each time this distance
                        // is exceeded. This command can also be used
                        // to set the shutter integration time for the
                        // camera.
mavlink20.MAV_CMD_DO_FENCE_ENABLE = 207 //            Enable the geofence.           This can be used in a
                        // mission or via the command protocol.
                        // The persistence/lifetime of the setting is
                        // undefined.           Depending on flight
                        // stack implementation it may persist until
                        // superseded, or it may revert to a system
                        // default at the end of a mission.
                        // Flight stacks typically reset the setting
                        // to system defaults on reboot.
mavlink20.MAV_CMD_DO_PARACHUTE = 208 // Mission item/command to release a parachute or enable/disable auto
                        // release.
mavlink20.MAV_CMD_DO_MOTOR_TEST = 209 // Command to perform motor test.
mavlink20.MAV_CMD_DO_INVERTED_FLIGHT = 210 // Change to/from inverted flight.
mavlink20.MAV_CMD_DO_GRIPPER = 211 // Mission command to operate a gripper.
mavlink20.MAV_CMD_DO_AUTOTUNE_ENABLE = 212 // Enable/disable autotune.
mavlink20.MAV_CMD_NAV_SET_YAW_SPEED = 213 // Sets a desired vehicle turn angle and speed change.
mavlink20.MAV_CMD_DO_SET_CAM_TRIGG_INTERVAL = 214 // Mission command to set camera trigger interval for this flight. If
                        // triggering is enabled, the camera is
                        // triggered each time this interval expires.
                        // This command can also be used to set the
                        // shutter integration time for the camera.
mavlink20.MAV_CMD_DO_MOUNT_CONTROL_QUAT = 220 // Mission command to control a camera or antenna mount, using a
                        // quaternion as reference.
mavlink20.MAV_CMD_DO_GUIDED_MASTER = 221 // set id of master controller
mavlink20.MAV_CMD_DO_GUIDED_LIMITS = 222 // Set limits for external control
mavlink20.MAV_CMD_DO_ENGINE_CONTROL = 223 // Control vehicle engine. This is interpreted by the vehicles engine
                        // controller to change the target engine
                        // state. It is intended for vehicles with
                        // internal combustion engines
mavlink20.MAV_CMD_DO_SET_MISSION_CURRENT = 224 //            Set the mission item with sequence number seq as the
                        // current item and emit MISSION_CURRENT
                        // (whether or not the mission number
                        // changed).           If a mission is
                        // currently being executed, the system will
                        // continue to this new mission item on the
                        // shortest path, skipping any intermediate
                        // mission items.           Note that mission
                        // jump repeat counters are not reset unless
                        // param2 is set (see MAV_CMD_DO_JUMP param2).
                        // This command may trigger a mission state-
                        // machine change on some systems: for example
                        // from MISSION_STATE_NOT_STARTED or
                        // MISSION_STATE_PAUSED to
                        // MISSION_STATE_ACTIVE.           If the
                        // system is in mission mode, on those systems
                        // this command might therefore start, restart
                        // or resume the mission.           If the
                        // system is not in mission mode this command
                        // must not trigger a switch to mission mode.
                        // The mission may be "reset" using param2.
                        // Resetting sets jump counters to initial
                        // values (to reset counters without changing
                        // the current mission item set the param1 to
                        // `-1`).           Resetting also explicitly
                        // changes a mission state of
                        // MISSION_STATE_COMPLETE to
                        // MISSION_STATE_PAUSED or
                        // MISSION_STATE_ACTIVE, potentially allowing
                        // it to resume when it is (next) in a mission
                        // mode.            The command will ACK with
                        // MAV_RESULT_FAILED if the sequence number is
                        // out of range (including if there is no
                        // mission item).
mavlink20.MAV_CMD_DO_LAST = 240 // NOP - This command is only used to mark the upper limit of the DO
                        // commands in the enumeration
mavlink20.MAV_CMD_PREFLIGHT_CALIBRATION = 241 // Trigger calibration. This command will be only accepted if in pre-
                        // flight mode. Except for Temperature
                        // Calibration, only one sensor should be set
                        // in a single message and all others should
                        // be zero.
mavlink20.MAV_CMD_PREFLIGHT_SET_SENSOR_OFFSETS = 242 // Set sensor offsets. This command will be only accepted if in pre-
                        // flight mode.
mavlink20.MAV_CMD_PREFLIGHT_UAVCAN = 243 // Trigger UAVCAN configuration (actuator ID assignment and direction
                        // mapping). Note that this maps to the legacy
                        // UAVCAN v0 function UAVCAN_ENUMERATE, which
                        // is intended to be executed just once during
                        // initial vehicle configuration (it is not a
                        // normal pre-flight command and has been
                        // poorly named).
mavlink20.MAV_CMD_PREFLIGHT_STORAGE = 245 // Request storage of different parameter values and logs. This command
                        // will be only accepted if in pre-flight
                        // mode.
mavlink20.MAV_CMD_PREFLIGHT_REBOOT_SHUTDOWN = 246 // Request the reboot or shutdown of system components.
mavlink20.MAV_CMD_OVERRIDE_GOTO = 252 // Override current mission with command to pause mission, pause mission
                        // and move to position, continue/resume
                        // mission. When param 1 indicates that the
                        // mission is paused (MAV_GOTO_DO_HOLD), param
                        // 2 defines whether it holds in place or
                        // moves to another position.
mavlink20.MAV_CMD_OBLIQUE_SURVEY = 260 // Mission command to set a Camera Auto Mount Pivoting Oblique Survey
                        // (Replaces CAM_TRIGG_DIST for this purpose).
                        // The camera is triggered each time this
                        // distance is exceeded, then the mount moves
                        // to the next position. Params 4~6 set-up the
                        // angle limits and number of positions for
                        // oblique survey, where mount-enabled
                        // vehicles automatically roll the camera
                        // between shots to emulate an oblique camera
                        // setup (providing an increased HFOV). This
                        // command can also be used to set the shutter
                        // integration time for the camera.
mavlink20.MAV_CMD_DO_SET_STANDARD_MODE = 262 // Enable the specified standard MAVLink mode.           If the specified
                        // mode is not supported, the vehicle should
                        // ACK with MAV_RESULT_FAILED.           See h
                        // ttps://mavlink.io/en/services/standard_mode
                        // s.html
mavlink20.MAV_CMD_MISSION_START = 300 // start running a mission
mavlink20.MAV_CMD_ACTUATOR_TEST = 310 // Actuator testing command. This is similar to MAV_CMD_DO_MOTOR_TEST but
                        // operates on the level of output functions,
                        // i.e. it is possible to test Motor1
                        // independent from which output it is
                        // configured on. Autopilots must NACK this
                        // command with
                        // MAV_RESULT_TEMPORARILY_REJECTED while
                        // armed.
mavlink20.MAV_CMD_CONFIGURE_ACTUATOR = 311 // Actuator configuration command.
mavlink20.MAV_CMD_COMPONENT_ARM_DISARM = 400 // Arms / Disarms a component
mavlink20.MAV_CMD_RUN_PREARM_CHECKS = 401 // Instructs a target system to run pre-arm checks.           This allows
                        // preflight checks to be run on demand, which
                        // may be useful on systems that normally run
                        // them at low rate, or which do not trigger
                        // checks when the armable state might have
                        // changed.           This command should
                        // return MAV_RESULT_ACCEPTED if it will run
                        // the checks.           The results of the
                        // checks are usually then reported in
                        // SYS_STATUS messages (this is system-
                        // specific).           The command should
                        // return MAV_RESULT_TEMPORARILY_REJECTED if
                        // the system is already armed.
mavlink20.MAV_CMD_ILLUMINATOR_ON_OFF = 405 // Turns illuminators ON/OFF. An illuminator is a light source that is
                        // used for lighting up dark areas external to
                        // the system: e.g. a torch or searchlight (as
                        // opposed to a light source for illuminating
                        // the system itself, e.g. an indicator
                        // light).
mavlink20.MAV_CMD_DO_ILLUMINATOR_CONFIGURE = 406 // Configures illuminator settings. An illuminator is a light source that
                        // is used for lighting up dark areas external
                        // to the system: e.g. a torch or searchlight
                        // (as opposed to a light source for
                        // illuminating the system itself, e.g. an
                        // indicator light).
mavlink20.MAV_CMD_GET_HOME_POSITION = 410 // Request the home position from the vehicle.           The vehicle will
                        // ACK the command and emit the HOME_POSITION
                        // message.
mavlink20.MAV_CMD_INJECT_FAILURE = 420 // Inject artificial failure for testing purposes. Note that autopilots
                        // should implement an additional protection
                        // before accepting this command such as a
                        // specific param setting.
mavlink20.MAV_CMD_START_RX_PAIR = 500 // Starts receiver pairing.
mavlink20.MAV_CMD_GET_MESSAGE_INTERVAL = 510 //            Request the interval between messages for a particular
                        // MAVLink message ID.           The receiver
                        // should ACK the command and then emit its
                        // response in a MESSAGE_INTERVAL message.
mavlink20.MAV_CMD_SET_MESSAGE_INTERVAL = 511 // Set the interval between messages for a particular MAVLink message ID.
                        // This interface replaces
                        // REQUEST_DATA_STREAM.
mavlink20.MAV_CMD_REQUEST_MESSAGE = 512 // Request the target system(s) emit a single instance of a specified
                        // message (i.e. a "one-shot" version of
                        // MAV_CMD_SET_MESSAGE_INTERVAL).
mavlink20.MAV_CMD_REQUEST_PROTOCOL_VERSION = 519 // Request MAVLink protocol version compatibility. All receivers should
                        // ACK the command and then emit their
                        // capabilities in an PROTOCOL_VERSION message
mavlink20.MAV_CMD_REQUEST_AUTOPILOT_CAPABILITIES = 520 // Request autopilot capabilities. The receiver should ACK the command
                        // and then emit its capabilities in an
                        // AUTOPILOT_VERSION message
mavlink20.MAV_CMD_REQUEST_CAMERA_INFORMATION = 521 // Request camera information (CAMERA_INFORMATION).
mavlink20.MAV_CMD_REQUEST_CAMERA_SETTINGS = 522 // Request camera settings (CAMERA_SETTINGS).
mavlink20.MAV_CMD_REQUEST_STORAGE_INFORMATION = 525 // Request storage information (STORAGE_INFORMATION). Use the command's
                        // target_component to target a specific
                        // component's storage.
mavlink20.MAV_CMD_STORAGE_FORMAT = 526 // Format a storage medium. Once format is complete, a
                        // STORAGE_INFORMATION message is sent. Use
                        // the command's target_component to target a
                        // specific component's storage.
mavlink20.MAV_CMD_REQUEST_CAMERA_CAPTURE_STATUS = 527 // Request camera capture status (CAMERA_CAPTURE_STATUS)
mavlink20.MAV_CMD_REQUEST_FLIGHT_INFORMATION = 528 // Request flight information (FLIGHT_INFORMATION)
mavlink20.MAV_CMD_RESET_CAMERA_SETTINGS = 529 // Reset all camera settings to Factory Default
mavlink20.MAV_CMD_SET_CAMERA_MODE = 530 // Set camera running mode. Use NaN for reserved values. GCS will send a
                        // MAV_CMD_REQUEST_VIDEO_STREAM_STATUS command
                        // after a mode change if the camera supports
                        // video streaming.
mavlink20.MAV_CMD_SET_CAMERA_ZOOM = 531 // Set camera zoom. Camera must respond with a CAMERA_SETTINGS message
                        // (on success).
mavlink20.MAV_CMD_SET_CAMERA_FOCUS = 532 // Set camera focus. Camera must respond with a CAMERA_SETTINGS message
                        // (on success).
mavlink20.MAV_CMD_SET_STORAGE_USAGE = 533 // Set that a particular storage is the preferred location for saving
                        // photos, videos, and/or other media (e.g. to
                        // set that an SD card is used for storing
                        // videos).           There can only be one
                        // preferred save location for each particular
                        // media type: setting a media usage flag will
                        // clear/reset that same flag if set on any
                        // other storage.           If no flag is set
                        // the system should use its default storage.
                        // A target system can choose to always use
                        // default storage, in which case it should
                        // ACK the command with
                        // MAV_RESULT_UNSUPPORTED.           A target
                        // system can choose to not allow a particular
                        // storage to be set as preferred storage, in
                        // which case it should ACK the command with
                        // MAV_RESULT_DENIED.
mavlink20.MAV_CMD_SET_CAMERA_SOURCE = 534 // Set camera source. Changes the camera's active sources on cameras with
                        // multiple image sensors.
mavlink20.MAV_CMD_JUMP_TAG = 600 // Tagged jump target. Can be jumped to with MAV_CMD_DO_JUMP_TAG.
mavlink20.MAV_CMD_DO_JUMP_TAG = 601 // Jump to the matching tag in the mission list. Repeat this action for
                        // the specified number of times. A mission
                        // should contain a single matching tag for
                        // each jump. If this is not the case then a
                        // jump to a missing tag should complete the
                        // mission, and a jump where there are
                        // multiple matching tags should always select
                        // the one with the lowest mission sequence
                        // number.
mavlink20.MAV_CMD_DO_GIMBAL_MANAGER_PITCHYAW = 1000 // Set gimbal manager pitch/yaw setpoints (low rate command). It is
                        // possible to set combinations of the values
                        // below. E.g. an angle as well as a desired
                        // angular rate can be used to get to this
                        // angle at a certain angular rate, or an
                        // angular rate only will result in continuous
                        // turning. NaN is to be used to signal unset.
                        // Note: only the gimbal manager will react to
                        // this command - it will be ignored by a
                        // gimbal device. Use
                        // GIMBAL_MANAGER_SET_PITCHYAW if you need to
                        // stream pitch/yaw setpoints at higher rate.
mavlink20.MAV_CMD_DO_GIMBAL_MANAGER_CONFIGURE = 1001 // Gimbal configuration to set which sysid/compid is in primary and
                        // secondary control.
mavlink20.MAV_CMD_IMAGE_START_CAPTURE = 2000 // Start image capture sequence. CAMERA_IMAGE_CAPTURED must be emitted
                        // after each capture.            Param1 (id)
                        // may be used to specify the target camera:
                        // 0: all cameras, 1 to 6: autopilot-connected
                        // cameras, 7-255: MAVLink camera component
                        // ID.           It is needed in order to
                        // target specific cameras connected to the
                        // autopilot, or specific sensors in a multi-
                        // sensor camera (neither of which have a
                        // distinct MAVLink component ID).
                        // It is also needed to specify the target
                        // camera in missions.            When used in
                        // a mission, an autopilot should execute the
                        // MAV_CMD for a specified local camera
                        // (param1 = 1-6), or resend it as a command
                        // if it is intended for a MAVLink camera
                        // (param1 = 7 - 255), setting the command's
                        // target_component as the param1 value (and
                        // setting param1 in the command to zero).
                        // If the param1 is 0 the autopilot should do
                        // both.            When sent in a command the
                        // target MAVLink address is set using
                        // target_component.           If addressed
                        // specifically to an autopilot: param1 should
                        // be used in the same way as it is for
                        // missions (though command should NACK with
                        // MAV_RESULT_DENIED if a specified local
                        // camera does not exist).           If
                        // addressed to a MAVLink camera, param 1 can
                        // be used to address all cameras (0), or to
                        // separately address 1 to 7 individual
                        // sensors. Other values should be NACKed with
                        // MAV_RESULT_DENIED.           If the command
                        // is broadcast (target_component is 0) then
                        // param 1 should be set to 0 (any other value
                        // should be NACKED with MAV_RESULT_DENIED).
                        // An autopilot would trigger any local
                        // cameras and forward the command to all
                        // channels.
mavlink20.MAV_CMD_IMAGE_STOP_CAPTURE = 2001 // Stop image capture sequence.            Param1 (id) may be used to
                        // specify the target camera: 0: all cameras,
                        // 1 to 6: autopilot-connected cameras, 7-255:
                        // MAVLink camera component ID.           It
                        // is needed in order to target specific
                        // cameras connected to the autopilot, or
                        // specific sensors in a multi-sensor camera
                        // (neither of which have a distinct MAVLink
                        // component ID).           It is also needed
                        // to specify the target camera in missions.
                        // When used in a mission, an autopilot should
                        // execute the MAV_CMD for a specified local
                        // camera (param1 = 1-6), or resend it as a
                        // command if it is intended for a MAVLink
                        // camera (param1 = 7 - 255), setting the
                        // command's target_component as the param1
                        // value (and setting param1 in the command to
                        // zero).           If the param1 is 0 the
                        // autopilot should do both.            When
                        // sent in a command the target MAVLink
                        // address is set using target_component.
                        // If addressed specifically to an autopilot:
                        // param1 should be used in the same way as it
                        // is for missions (though command should NACK
                        // with MAV_RESULT_DENIED if a specified local
                        // camera does not exist).           If
                        // addressed to a MAVLink camera, param1 can
                        // be used to address all cameras (0), or to
                        // separately address 1 to 7 individual
                        // sensors. Other values should be NACKed with
                        // MAV_RESULT_DENIED.           If the command
                        // is broadcast (target_component is 0) then
                        // param 1 should be set to 0 (any other value
                        // should be NACKED with MAV_RESULT_DENIED).
                        // An autopilot would trigger any local
                        // cameras and forward the command to all
                        // channels.
mavlink20.MAV_CMD_REQUEST_CAMERA_IMAGE_CAPTURE = 2002 // Re-request a CAMERA_IMAGE_CAPTURED message.
mavlink20.MAV_CMD_DO_TRIGGER_CONTROL = 2003 // Enable or disable on-board camera triggering system.
mavlink20.MAV_CMD_CAMERA_TRACK_POINT = 2004 // If the camera supports point visual tracking
                        // (CAMERA_CAP_FLAGS_HAS_TRACKING_POINT is
                        // set), this command allows to initiate the
                        // tracking.
mavlink20.MAV_CMD_CAMERA_TRACK_RECTANGLE = 2005 // If the camera supports rectangle visual tracking
                        // (CAMERA_CAP_FLAGS_HAS_TRACKING_RECTANGLE is
                        // set), this command allows to initiate the
                        // tracking.
mavlink20.MAV_CMD_CAMERA_STOP_TRACKING = 2010 // Stops ongoing tracking.
mavlink20.MAV_CMD_VIDEO_START_CAPTURE = 2500 // Starts video capture (recording).
mavlink20.MAV_CMD_VIDEO_STOP_CAPTURE = 2501 // Stop the current video capture (recording).
mavlink20.MAV_CMD_VIDEO_START_STREAMING = 2502 // Start video streaming
mavlink20.MAV_CMD_VIDEO_STOP_STREAMING = 2503 // Stop the given video stream
mavlink20.MAV_CMD_REQUEST_VIDEO_STREAM_INFORMATION = 2504 // Request video stream information (VIDEO_STREAM_INFORMATION)
mavlink20.MAV_CMD_REQUEST_VIDEO_STREAM_STATUS = 2505 // Request video stream status (VIDEO_STREAM_STATUS)
mavlink20.MAV_CMD_LOGGING_START = 2510 // Request to start streaming logging data over MAVLink (see also
                        // LOGGING_DATA message)
mavlink20.MAV_CMD_LOGGING_STOP = 2511 // Request to stop streaming log data over MAVLink
mavlink20.MAV_CMD_AIRFRAME_CONFIGURATION = 2520 // 
mavlink20.MAV_CMD_CONTROL_HIGH_LATENCY = 2600 // Request to start/stop transmitting over the high latency telemetry
mavlink20.MAV_CMD_PANORAMA_CREATE = 2800 // Create a panorama at the current position
mavlink20.MAV_CMD_DO_VTOL_TRANSITION = 3000 // Request VTOL transition
mavlink20.MAV_CMD_ARM_AUTHORIZATION_REQUEST = 3001 // Request authorization to arm the vehicle to a external entity, the arm
                        // authorizer is responsible to request all
                        // data that is needs from the vehicle before
                        // authorize or deny the request.
                        // If approved the COMMAND_ACK message
                        // progress field should be set with period of
                        // time that this authorization is valid in
                        // seconds.                 If the
                        // authorization is denied
                        // COMMAND_ACK.result_param2 should be set
                        // with one of the reasons in
                        // MAV_ARM_AUTH_DENIED_REASON.
mavlink20.MAV_CMD_SET_GUIDED_SUBMODE_STANDARD = 4000 // This command sets the submode to standard guided when vehicle is in
                        // guided mode. The vehicle holds position and
                        // altitude and the user can input the desired
                        // velocities along all three axes.
mavlink20.MAV_CMD_SET_GUIDED_SUBMODE_CIRCLE = 4001 // This command sets submode circle when vehicle is in guided mode.
                        // Vehicle flies along a circle facing the
                        // center of the circle. The user can input
                        // the velocity along the circle and change
                        // the radius. If no input is given the
                        // vehicle will hold position.
mavlink20.MAV_CMD_CONDITION_GATE = 4501 // Delay mission state machine until gate has been reached.
mavlink20.MAV_CMD_NAV_FENCE_RETURN_POINT = 5000 // Fence return point (there can only be one such point in a geofence
                        // definition). If rally points are supported
                        // they should be used instead.
mavlink20.MAV_CMD_NAV_FENCE_POLYGON_VERTEX_INCLUSION = 5001 // Fence vertex for an inclusion polygon (the polygon must not be self-
                        // intersecting). The vehicle must stay within
                        // this area. Minimum of 3 vertices required.
                        // The vertices for a polygon must be sent
                        // sequentially, each with param1 set to the
                        // total number of vertices in the polygon.
mavlink20.MAV_CMD_NAV_FENCE_POLYGON_VERTEX_EXCLUSION = 5002 // Fence vertex for an exclusion polygon (the polygon must not be self-
                        // intersecting). The vehicle must stay
                        // outside this area. Minimum of 3 vertices
                        // required.           The vertices for a
                        // polygon must be sent sequentially, each
                        // with param1 set to the total number of
                        // vertices in the polygon.
mavlink20.MAV_CMD_NAV_FENCE_CIRCLE_INCLUSION = 5003 // Circular fence area. The vehicle must stay inside this area.
mavlink20.MAV_CMD_NAV_FENCE_CIRCLE_EXCLUSION = 5004 // Circular fence area. The vehicle must stay outside this area.
mavlink20.MAV_CMD_NAV_RALLY_POINT = 5100 // Rally point. You can have multiple rally points defined.
mavlink20.MAV_CMD_UAVCAN_GET_NODE_INFO = 5200 // Commands the vehicle to respond with a sequence of messages
                        // UAVCAN_NODE_INFO, one message per every
                        // UAVCAN node that is online. Note that some
                        // of the response messages can be lost, which
                        // the receiver can detect easily by checking
                        // whether every received UAVCAN_NODE_STATUS
                        // has a matching message UAVCAN_NODE_INFO
                        // received earlier; if not, this command
                        // should be sent again in order to request
                        // re-transmission of the node information
                        // messages.
mavlink20.MAV_CMD_DO_SET_SAFETY_SWITCH_STATE = 5300 // Change state of safety switch.
mavlink20.MAV_CMD_DO_ADSB_OUT_IDENT = 10001 // Trigger the start of an ADSB-out IDENT. This should only be used when
                        // requested to do so by an Air Traffic
                        // Controller in controlled airspace. This
                        // starts the IDENT which is then typically
                        // held for 18 seconds by the hardware per the
                        // Mode A, C, and S transponder spec.
mavlink20.MAV_CMD_PAYLOAD_PREPARE_DEPLOY = 30001 // Deploy payload on a Lat / Lon / Alt position. This includes the
                        // navigation to reach the required release
                        // position and velocity.
mavlink20.MAV_CMD_PAYLOAD_CONTROL_DEPLOY = 30002 // Control the payload deployment.
mavlink20.MAV_CMD_WAYPOINT_USER_1 = 31000 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_2 = 31001 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_3 = 31002 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_4 = 31003 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_5 = 31004 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_SPATIAL_USER_1 = 31005 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_2 = 31006 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_3 = 31007 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_4 = 31008 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_5 = 31009 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_USER_1 = 31010 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_2 = 31011 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_3 = 31012 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_4 = 31013 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_5 = 31014 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_CAN_FORWARD = 32000 // Request forwarding of CAN packets from the given CAN bus to this
                        // component via this MAVLink channel. CAN
                        // Frames are sent using CAN_FRAME and
                        // CANFD_FRAME messages
mavlink20.MAV_CMD_FIXED_MAG_CAL_YAW = 42006 // Magnetometer calibration based on provided known yaw. This allows for
                        // fast calibration using WMM field tables in
                        // the vehicle, given only the known yaw of
                        // the vehicle. If Latitude and longitude are
                        // both zero then use the current vehicle
                        // location.
mavlink20.MAV_CMD_DO_WINCH = 42600 // Command to operate winch.
mavlink20.MAV_CMD_GUIDED_CHANGE_HEADING = 43002 // Change to target direction at a given rate, overriding previous
                        // heading/s. This slews the vehicle at a
                        // controllable rate between its previous
                        // heading and the new one.
mavlink20.MAV_CMD_EXTERNAL_POSITION_ESTIMATE = 43003 // Provide an external position estimate for use when dead-reckoning.
                        // This is meant to be used for occasional
                        // position resets that may be provided by a
                        // external system such as a remote pilot
                        // using landmarks over a video link.
mavlink20.MAV_CMD_ENUM_END = 43004 // 

// MAV_DATA_STREAM
mavlink20.MAV_DATA_STREAM_ALL = 0 // Enable all data streams
mavlink20.MAV_DATA_STREAM_RAW_SENSORS = 1 // Enable IMU_RAW, GPS_RAW, GPS_STATUS packets.
mavlink20.MAV_DATA_STREAM_EXTENDED_STATUS = 2 // Enable GPS_STATUS, CONTROL_STATUS, AUX_STATUS
mavlink20.MAV_DATA_STREAM_RC_CHANNELS = 3 // Enable RC_CHANNELS_SCALED, RC_CHANNELS_RAW, SERVO_OUTPUT_RAW
mavlink20.MAV_DATA_STREAM_RAW_CONTROLLER = 4 // Enable ATTITUDE_CONTROLLER_OUTPUT, POSITION_CONTROLLER_OUTPUT,
                        // NAV_CONTROLLER_OUTPUT.
mavlink20.MAV_DATA_STREAM_POSITION = 6 // Enable LOCAL_POSITION, GLOBAL_POSITION_INT messages.
mavlink20.MAV_DATA_STREAM_EXTRA1 = 10 // Dependent on the autopilot
mavlink20.MAV_DATA_STREAM_EXTRA2 = 11 // Dependent on the autopilot
mavlink20.MAV_DATA_STREAM_EXTRA3 = 12 // Dependent on the autopilot
mavlink20.MAV_DATA_STREAM_ENUM_END = 13 // 

// MAV_ROI
mavlink20.MAV_ROI_NONE = 0 // No region of interest.
mavlink20.MAV_ROI_WPNEXT = 1 // Point toward next waypoint, with optional pitch/roll/yaw offset.
mavlink20.MAV_ROI_WPINDEX = 2 // Point toward given waypoint.
mavlink20.MAV_ROI_LOCATION = 3 // Point toward fixed location.
mavlink20.MAV_ROI_TARGET = 4 // Point toward of given id.
mavlink20.MAV_ROI_ENUM_END = 5 // 

// MAV_PARAM_TYPE
mavlink20.MAV_PARAM_TYPE_UINT8 = 1 // 8-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT8 = 2 // 8-bit signed integer
mavlink20.MAV_PARAM_TYPE_UINT16 = 3 // 16-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT16 = 4 // 16-bit signed integer
mavlink20.MAV_PARAM_TYPE_UINT32 = 5 // 32-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT32 = 6 // 32-bit signed integer
mavlink20.MAV_PARAM_TYPE_UINT64 = 7 // 64-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT64 = 8 // 64-bit signed integer
mavlink20.MAV_PARAM_TYPE_REAL32 = 9 // 32-bit floating-point
mavlink20.MAV_PARAM_TYPE_REAL64 = 10 // 64-bit floating-point
mavlink20.MAV_PARAM_TYPE_ENUM_END = 11 // 

// MAV_PARAM_ERROR
mavlink20.MAV_PARAM_ERROR_NO_ERROR = 0 // No error occurred (not expected in PARAM_ERROR but may be used in
                        // future implementations.
mavlink20.MAV_PARAM_ERROR_DOES_NOT_EXIST = 1 // Parameter does not exist
mavlink20.MAV_PARAM_ERROR_VALUE_OUT_OF_RANGE = 2 // Parameter value does not fit within accepted range
mavlink20.MAV_PARAM_ERROR_PERMISSION_DENIED = 3 // Caller is not permitted to set the value of this parameter
mavlink20.MAV_PARAM_ERROR_COMPONENT_NOT_FOUND = 4 // Unknown component specified
mavlink20.MAV_PARAM_ERROR_READ_ONLY = 5 // Parameter is read-only
mavlink20.MAV_PARAM_ERROR_TYPE_UNSUPPORTED = 6 // Parameter data type (MAV_PARAM_TYPE) is not supported by flight stack
                        // (at all)
mavlink20.MAV_PARAM_ERROR_TYPE_MISMATCH = 7 // Parameter type does not match expected type
mavlink20.MAV_PARAM_ERROR_READ_FAIL = 8 // Parameter exists but reading failed
mavlink20.MAV_PARAM_ERROR_ENUM_END = 9 // 

// MAV_PARAM_EXT_TYPE
mavlink20.MAV_PARAM_EXT_TYPE_UINT8 = 1 // 8-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT8 = 2 // 8-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_UINT16 = 3 // 16-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT16 = 4 // 16-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_UINT32 = 5 // 32-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT32 = 6 // 32-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_UINT64 = 7 // 64-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT64 = 8 // 64-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_REAL32 = 9 // 32-bit floating-point
mavlink20.MAV_PARAM_EXT_TYPE_REAL64 = 10 // 64-bit floating-point
mavlink20.MAV_PARAM_EXT_TYPE_CUSTOM = 11 // Custom Type
mavlink20.MAV_PARAM_EXT_TYPE_ENUM_END = 12 // 

// MAV_RESULT
mavlink20.MAV_RESULT_ACCEPTED = 0 // Command is valid (is supported and has valid parameters), and was
                        // executed.
mavlink20.MAV_RESULT_TEMPORARILY_REJECTED = 1 // Command is valid, but cannot be executed at this time. This is used to
                        // indicate a problem that should be fixed
                        // just by waiting (e.g. a state machine is
                        // busy, can't arm because have not got GPS
                        // lock, etc.). Retrying later should work.
mavlink20.MAV_RESULT_DENIED = 2 // Command is invalid; it is supported but one or more parameter values
                        // are invalid (i.e. parameter reserved, value
                        // allowed by spec but not supported by flight
                        // stack, and so on). Retrying the same
                        // command and parameters will not work.
mavlink20.MAV_RESULT_UNSUPPORTED = 3 // Command is not supported (unknown).
mavlink20.MAV_RESULT_FAILED = 4 // Command is valid, but execution has failed. This is used to indicate
                        // any non-temporary or unexpected problem,
                        // i.e. any problem that must be fixed before
                        // the command can succeed/be retried. For
                        // example, attempting to write a file when
                        // out of memory, attempting to arm when
                        // sensors are not calibrated, etc.
mavlink20.MAV_RESULT_IN_PROGRESS = 5 // Command is valid and is being executed. This will be followed by
                        // further progress updates, i.e. the
                        // component may send further COMMAND_ACK
                        // messages with result MAV_RESULT_IN_PROGRESS
                        // (at a rate decided by the implementation),
                        // and must terminate by sending a COMMAND_ACK
                        // message with final result of the operation.
                        // The COMMAND_ACK.progress field can be used
                        // to indicate the progress of the operation.
mavlink20.MAV_RESULT_CANCELLED = 6 // Command has been cancelled (as a result of receiving a COMMAND_CANCEL
                        // message).
mavlink20.MAV_RESULT_COMMAND_LONG_ONLY = 7 // Command is only accepted when sent as a COMMAND_LONG.
mavlink20.MAV_RESULT_COMMAND_INT_ONLY = 8 // Command is only accepted when sent as a COMMAND_INT.
mavlink20.MAV_RESULT_COMMAND_UNSUPPORTED_MAV_FRAME = 9 // Command is invalid because a frame is required and the specified frame
                        // is not supported.
mavlink20.MAV_RESULT_NOT_IN_CONTROL = 10 // Command has been rejected because source system is not in control of
                        // the target system/component.
mavlink20.MAV_RESULT_ENUM_END = 11 // 

// MAV_MISSION_RESULT
mavlink20.MAV_MISSION_ACCEPTED = 0 // mission accepted OK
mavlink20.MAV_MISSION_ERROR = 1 // Generic error / not accepting mission commands at all right now.
mavlink20.MAV_MISSION_UNSUPPORTED_FRAME = 2 // Coordinate frame is not supported.
mavlink20.MAV_MISSION_UNSUPPORTED = 3 // Command is not supported.
mavlink20.MAV_MISSION_NO_SPACE = 4 // Mission items exceed storage space.
mavlink20.MAV_MISSION_INVALID = 5 // One of the parameters has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM1 = 6 // param1 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM2 = 7 // param2 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM3 = 8 // param3 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM4 = 9 // param4 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM5_X = 10 // x / param5 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM6_Y = 11 // y / param6 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM7 = 12 // z / param7 has an invalid value.
mavlink20.MAV_MISSION_INVALID_SEQUENCE = 13 // Mission item received out of sequence
mavlink20.MAV_MISSION_DENIED = 14 // Not accepting any mission commands from this communication partner.
mavlink20.MAV_MISSION_OPERATION_CANCELLED = 15 // Current mission operation cancelled (e.g. mission upload, mission
                        // download).
mavlink20.MAV_MISSION_RESULT_ENUM_END = 16 // 

// MAV_SEVERITY
mavlink20.MAV_SEVERITY_EMERGENCY = 0 // System is unusable. This is a "panic" condition.
mavlink20.MAV_SEVERITY_ALERT = 1 // Action should be taken immediately. Indicates error in non-critical
                        // systems.
mavlink20.MAV_SEVERITY_CRITICAL = 2 // Action must be taken immediately. Indicates failure in a primary
                        // system.
mavlink20.MAV_SEVERITY_ERROR = 3 // Indicates an error in secondary/redundant systems.
mavlink20.MAV_SEVERITY_WARNING = 4 // Indicates about a possible future error if this is not resolved within
                        // a given timeframe. Example would be a low
                        // battery warning.
mavlink20.MAV_SEVERITY_NOTICE = 5 // An unusual event has occurred, though not an error condition. This
                        // should be investigated for the root cause.
mavlink20.MAV_SEVERITY_INFO = 6 // Normal operational messages. Useful for logging. No action is required
                        // for these messages.
mavlink20.MAV_SEVERITY_DEBUG = 7 // Useful non-operational messages that can assist in debugging. These
                        // should not occur during normal operation.
mavlink20.MAV_SEVERITY_ENUM_END = 8 // 

// MAV_POWER_STATUS
mavlink20.MAV_POWER_STATUS_BRICK_VALID = 1 // main brick power supply valid
mavlink20.MAV_POWER_STATUS_SERVO_VALID = 2 // main servo power supply valid for FMU
mavlink20.MAV_POWER_STATUS_USB_CONNECTED = 4 // USB power is connected
mavlink20.MAV_POWER_STATUS_PERIPH_OVERCURRENT = 8 // peripheral supply is in over-current state
mavlink20.MAV_POWER_STATUS_PERIPH_HIPOWER_OVERCURRENT = 16 // hi-power peripheral supply is in over-current state
mavlink20.MAV_POWER_STATUS_CHANGED = 32 // Power status has changed since boot
mavlink20.MAV_POWER_STATUS_ENUM_END = 33 // 

// SERIAL_CONTROL_DEV
mavlink20.SERIAL_CONTROL_DEV_TELEM1 = 0 // First telemetry port
mavlink20.SERIAL_CONTROL_DEV_TELEM2 = 1 // Second telemetry port
mavlink20.SERIAL_CONTROL_DEV_GPS1 = 2 // First GPS port
mavlink20.SERIAL_CONTROL_DEV_GPS2 = 3 // Second GPS port
mavlink20.SERIAL_CONTROL_DEV_SHELL = 10 // system shell
mavlink20.SERIAL_CONTROL_SERIAL0 = 100 // SERIAL0
mavlink20.SERIAL_CONTROL_SERIAL1 = 101 // SERIAL1
mavlink20.SERIAL_CONTROL_SERIAL2 = 102 // SERIAL2
mavlink20.SERIAL_CONTROL_SERIAL3 = 103 // SERIAL3
mavlink20.SERIAL_CONTROL_SERIAL4 = 104 // SERIAL4
mavlink20.SERIAL_CONTROL_SERIAL5 = 105 // SERIAL5
mavlink20.SERIAL_CONTROL_SERIAL6 = 106 // SERIAL6
mavlink20.SERIAL_CONTROL_SERIAL7 = 107 // SERIAL7
mavlink20.SERIAL_CONTROL_SERIAL8 = 108 // SERIAL8
mavlink20.SERIAL_CONTROL_SERIAL9 = 109 // SERIAL9
mavlink20.SERIAL_CONTROL_DEV_ENUM_END = 110 // 

// SERIAL_CONTROL_FLAG
mavlink20.SERIAL_CONTROL_FLAG_REPLY = 1 // Set if this is a reply
mavlink20.SERIAL_CONTROL_FLAG_RESPOND = 2 // Set if the sender wants the receiver to send a response as another
                        // SERIAL_CONTROL message
mavlink20.SERIAL_CONTROL_FLAG_EXCLUSIVE = 4 // Set if access to the serial port should be removed from whatever
                        // driver is currently using it, giving
                        // exclusive access to the SERIAL_CONTROL
                        // protocol. The port can be handed back by
                        // sending a request without this flag set
mavlink20.SERIAL_CONTROL_FLAG_BLOCKING = 8 // Block on writes to the serial port
mavlink20.SERIAL_CONTROL_FLAG_MULTI = 16 // Send multiple replies until port is drained
mavlink20.SERIAL_CONTROL_FLAG_ENUM_END = 17 // 

// MAV_DISTANCE_SENSOR
mavlink20.MAV_DISTANCE_SENSOR_LASER = 0 // Laser rangefinder, e.g. LightWare SF02/F or PulsedLight units
mavlink20.MAV_DISTANCE_SENSOR_ULTRASOUND = 1 // Ultrasound rangefinder, e.g. MaxBotix units
mavlink20.MAV_DISTANCE_SENSOR_INFRARED = 2 // Infrared rangefinder, e.g. Sharp units
mavlink20.MAV_DISTANCE_SENSOR_RADAR = 3 // Radar type, e.g. uLanding units
mavlink20.MAV_DISTANCE_SENSOR_UNKNOWN = 4 // Broken or unknown type, e.g. analog units
mavlink20.MAV_DISTANCE_SENSOR_ENUM_END = 5 // 

// MAV_SENSOR_ORIENTATION
mavlink20.MAV_SENSOR_ROTATION_NONE = 0 // Roll: 0, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_YAW_45 = 1 // Roll: 0, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_YAW_90 = 2 // Roll: 0, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_YAW_135 = 3 // Roll: 0, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_YAW_180 = 4 // Roll: 0, Pitch: 0, Yaw: 180
mavlink20.MAV_SENSOR_ROTATION_YAW_225 = 5 // Roll: 0, Pitch: 0, Yaw: 225
mavlink20.MAV_SENSOR_ROTATION_YAW_270 = 6 // Roll: 0, Pitch: 0, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_YAW_315 = 7 // Roll: 0, Pitch: 0, Yaw: 315
mavlink20.MAV_SENSOR_ROTATION_ROLL_180 = 8 // Roll: 180, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_45 = 9 // Roll: 180, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_90 = 10 // Roll: 180, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_135 = 11 // Roll: 180, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_PITCH_180 = 12 // Roll: 0, Pitch: 180, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_225 = 13 // Roll: 180, Pitch: 0, Yaw: 225
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_270 = 14 // Roll: 180, Pitch: 0, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_315 = 15 // Roll: 180, Pitch: 0, Yaw: 315
mavlink20.MAV_SENSOR_ROTATION_ROLL_90 = 16 // Roll: 90, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_45 = 17 // Roll: 90, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_90 = 18 // Roll: 90, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_135 = 19 // Roll: 90, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_ROLL_270 = 20 // Roll: 270, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_YAW_45 = 21 // Roll: 270, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_YAW_90 = 22 // Roll: 270, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_YAW_135 = 23 // Roll: 270, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_PITCH_90 = 24 // Roll: 0, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_PITCH_270 = 25 // Roll: 0, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_PITCH_180_YAW_90 = 26 // Roll: 0, Pitch: 180, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_PITCH_180_YAW_270 = 27 // Roll: 0, Pitch: 180, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_90 = 28 // Roll: 90, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_PITCH_90 = 29 // Roll: 180, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_PITCH_90 = 30 // Roll: 270, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_180 = 31 // Roll: 90, Pitch: 180, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_PITCH_180 = 32 // Roll: 270, Pitch: 180, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_270 = 33 // Roll: 90, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_PITCH_270 = 34 // Roll: 180, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_PITCH_270 = 35 // Roll: 270, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_180_YAW_90 = 36 // Roll: 90, Pitch: 180, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_270 = 37 // Roll: 90, Pitch: 0, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_68_YAW_293 = 38 // Roll: 90, Pitch: 68, Yaw: 293
mavlink20.MAV_SENSOR_ROTATION_PITCH_315 = 39 // Pitch: 315
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_315 = 40 // Roll: 90, Pitch: 315
mavlink20.MAV_SENSOR_ROTATION_CUSTOM = 100 // Custom orientation
mavlink20.MAV_SENSOR_ORIENTATION_ENUM_END = 101 // 

// MAV_MISSION_TYPE
mavlink20.MAV_MISSION_TYPE_MISSION = 0 // Items are mission commands for main mission.
mavlink20.MAV_MISSION_TYPE_FENCE = 1 // Specifies GeoFence area(s). Items are MAV_CMD_NAV_FENCE_ GeoFence
                        // items.
mavlink20.MAV_MISSION_TYPE_RALLY = 2 // Specifies the rally points for the vehicle. Rally points are
                        // alternative RTL points. Items are
                        // MAV_CMD_NAV_RALLY_POINT rally point items.
mavlink20.MAV_MISSION_TYPE_ALL = 255 // Only used in MISSION_CLEAR_ALL to clear all mission types.
mavlink20.MAV_MISSION_TYPE_ENUM_END = 256 // 

// MAV_ESTIMATOR_TYPE
mavlink20.MAV_ESTIMATOR_TYPE_UNKNOWN = 0 // Unknown type of the estimator.
mavlink20.MAV_ESTIMATOR_TYPE_NAIVE = 1 // This is a naive estimator without any real covariance feedback.
mavlink20.MAV_ESTIMATOR_TYPE_VISION = 2 // Computer vision based estimate. Might be up to scale.
mavlink20.MAV_ESTIMATOR_TYPE_VIO = 3 // Visual-inertial estimate.
mavlink20.MAV_ESTIMATOR_TYPE_GPS = 4 // Plain GPS estimate.
mavlink20.MAV_ESTIMATOR_TYPE_GPS_INS = 5 // Estimator integrating GPS and inertial sensing.
mavlink20.MAV_ESTIMATOR_TYPE_MOCAP = 6 // Estimate from external motion capturing system.
mavlink20.MAV_ESTIMATOR_TYPE_LIDAR = 7 // Estimator based on lidar sensor input.
mavlink20.MAV_ESTIMATOR_TYPE_AUTOPILOT = 8 // Estimator on autopilot.
mavlink20.MAV_ESTIMATOR_TYPE_ENUM_END = 9 // 

// MAV_BATTERY_TYPE
mavlink20.MAV_BATTERY_TYPE_UNKNOWN = 0 // Not specified.
mavlink20.MAV_BATTERY_TYPE_LIPO = 1 // Lithium polymer battery
mavlink20.MAV_BATTERY_TYPE_LIFE = 2 // Lithium-iron-phosphate battery
mavlink20.MAV_BATTERY_TYPE_LION = 3 // Lithium-ION battery
mavlink20.MAV_BATTERY_TYPE_NIMH = 4 // Nickel metal hydride battery
mavlink20.MAV_BATTERY_TYPE_ENUM_END = 5 // 

// MAV_BATTERY_FUNCTION
mavlink20.MAV_BATTERY_FUNCTION_UNKNOWN = 0 // Battery function is unknown
mavlink20.MAV_BATTERY_FUNCTION_ALL = 1 // Battery supports all flight systems
mavlink20.MAV_BATTERY_FUNCTION_PROPULSION = 2 // Battery for the propulsion system
mavlink20.MAV_BATTERY_FUNCTION_AVIONICS = 3 // Avionics battery
mavlink20.MAV_BATTERY_FUNCTION_PAYLOAD = 4 // Payload battery
mavlink20.MAV_BATTERY_FUNCTION_ENUM_END = 5 // 

// MAV_BATTERY_CHARGE_STATE
mavlink20.MAV_BATTERY_CHARGE_STATE_UNDEFINED = 0 // Low battery state is not provided
mavlink20.MAV_BATTERY_CHARGE_STATE_OK = 1 // Battery is not in low state. Normal operation.
mavlink20.MAV_BATTERY_CHARGE_STATE_LOW = 2 // Battery state is low, warn and monitor close.
mavlink20.MAV_BATTERY_CHARGE_STATE_CRITICAL = 3 // Battery state is critical, return or abort immediately.
mavlink20.MAV_BATTERY_CHARGE_STATE_EMERGENCY = 4 // Battery state is too low for ordinary abort sequence. Perform fastest
                        // possible emergency stop to prevent damage.
mavlink20.MAV_BATTERY_CHARGE_STATE_FAILED = 5 // Battery failed, damage unavoidable. Possible causes (faults) are
                        // listed in MAV_BATTERY_FAULT.
mavlink20.MAV_BATTERY_CHARGE_STATE_UNHEALTHY = 6 // Battery is diagnosed to be defective or an error occurred, usage is
                        // discouraged / prohibited. Possible causes
                        // (faults) are listed in MAV_BATTERY_FAULT.
mavlink20.MAV_BATTERY_CHARGE_STATE_CHARGING = 7 // Battery is charging.
mavlink20.MAV_BATTERY_CHARGE_STATE_ENUM_END = 8 // 

// MAV_BATTERY_MODE
mavlink20.MAV_BATTERY_MODE_UNKNOWN = 0 // Battery mode not supported/unknown battery mode/normal operation.
mavlink20.MAV_BATTERY_MODE_AUTO_DISCHARGING = 1 // Battery is auto discharging (towards storage level).
mavlink20.MAV_BATTERY_MODE_HOT_SWAP = 2 // Battery in hot-swap mode (current limited to prevent spikes that might
                        // damage sensitive electrical circuits).
mavlink20.MAV_BATTERY_MODE_ENUM_END = 3 // 

// MAV_BATTERY_FAULT
mavlink20.MAV_BATTERY_FAULT_DEEP_DISCHARGE = 1 // Battery has deep discharged.
mavlink20.MAV_BATTERY_FAULT_SPIKES = 2 // Voltage spikes.
mavlink20.MAV_BATTERY_FAULT_CELL_FAIL = 4 // One or more cells have failed. Battery should also report
                        // MAV_BATTERY_CHARGE_STATE_FAILE (and should
                        // not be used).
mavlink20.MAV_BATTERY_FAULT_OVER_CURRENT = 8 // Over-current fault.
mavlink20.MAV_BATTERY_FAULT_OVER_TEMPERATURE = 16 // Over-temperature fault.
mavlink20.MAV_BATTERY_FAULT_UNDER_TEMPERATURE = 32 // Under-temperature fault.
mavlink20.MAV_BATTERY_FAULT_INCOMPATIBLE_VOLTAGE = 64 // Vehicle voltage is not compatible with this battery (batteries on same
                        // power rail should have similar voltage).
mavlink20.MAV_BATTERY_FAULT_INCOMPATIBLE_FIRMWARE = 128 // Battery firmware is not compatible with current autopilot firmware.
mavlink20.BATTERY_FAULT_INCOMPATIBLE_CELLS_CONFIGURATION = 256 // Battery is not compatible due to cell configuration (e.g. 5s1p when
                        // vehicle requires 6s).
mavlink20.MAV_BATTERY_FAULT_ENUM_END = 257 // 

// MAV_FUEL_TYPE
mavlink20.MAV_FUEL_TYPE_UNKNOWN = 0 // Not specified. Fuel levels are normalized (i.e. maximum is 1, and
                        // other levels are relative to 1).
mavlink20.MAV_FUEL_TYPE_LIQUID = 1 // A generic liquid fuel. Fuel levels are in millilitres (ml). Fuel rates
                        // are in millilitres/second.
mavlink20.MAV_FUEL_TYPE_GAS = 2 // A gas tank. Fuel levels are in kilo-Pascal (kPa), and flow rates are
                        // in milliliters per second (ml/s).
mavlink20.MAV_FUEL_TYPE_ENUM_END = 3 // 

// MAV_GENERATOR_STATUS_FLAG
mavlink20.MAV_GENERATOR_STATUS_FLAG_OFF = 1 // Generator is off.
mavlink20.MAV_GENERATOR_STATUS_FLAG_READY = 2 // Generator is ready to start generating power.
mavlink20.MAV_GENERATOR_STATUS_FLAG_GENERATING = 4 // Generator is generating power.
mavlink20.MAV_GENERATOR_STATUS_FLAG_CHARGING = 8 // Generator is charging the batteries (generating enough power to charge
                        // and provide the load).
mavlink20.MAV_GENERATOR_STATUS_FLAG_REDUCED_POWER = 16 // Generator is operating at a reduced maximum power.
mavlink20.MAV_GENERATOR_STATUS_FLAG_MAXPOWER = 32 // Generator is providing the maximum output.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERTEMP_WARNING = 64 // Generator is near the maximum operating temperature, cooling is
                        // insufficient.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERTEMP_FAULT = 128 // Generator hit the maximum operating temperature and shutdown.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_OVERTEMP_WARNING = 256 // Power electronics are near the maximum operating temperature, cooling
                        // is insufficient.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_OVERTEMP_FAULT = 512 // Power electronics hit the maximum operating temperature and shutdown.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_FAULT = 1024 // Power electronics experienced a fault and shutdown.
mavlink20.MAV_GENERATOR_STATUS_FLAG_POWERSOURCE_FAULT = 2048 // The power source supplying the generator failed e.g. mechanical
                        // generator stopped, tether is no longer
                        // providing power, solar cell is in shade,
                        // hydrogen reaction no longer happening.
mavlink20.MAV_GENERATOR_STATUS_FLAG_COMMUNICATION_WARNING = 4096 // Generator controller having communication problems.
mavlink20.MAV_GENERATOR_STATUS_FLAG_COOLING_WARNING = 8192 // Power electronic or generator cooling system error.
mavlink20.MAV_GENERATOR_STATUS_FLAG_POWER_RAIL_FAULT = 16384 // Generator controller power rail experienced a fault.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERCURRENT_FAULT = 32768 // Generator controller exceeded the overcurrent threshold and shutdown
                        // to prevent damage.
mavlink20.MAV_GENERATOR_STATUS_FLAG_BATTERY_OVERCHARGE_CURRENT_FAULT = 65536 // Generator controller detected a high current going into the batteries
                        // and shutdown to prevent battery damage.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERVOLTAGE_FAULT = 131072 // Generator controller exceeded it's overvoltage threshold and shutdown
                        // to prevent it exceeding the voltage rating.
mavlink20.MAV_GENERATOR_STATUS_FLAG_BATTERY_UNDERVOLT_FAULT = 262144 // Batteries are under voltage (generator will not start).
mavlink20.MAV_GENERATOR_STATUS_FLAG_START_INHIBITED = 524288 // Generator start is inhibited by e.g. a safety switch.
mavlink20.MAV_GENERATOR_STATUS_FLAG_MAINTENANCE_REQUIRED = 1048576 // Generator requires maintenance.
mavlink20.MAV_GENERATOR_STATUS_FLAG_WARMING_UP = 2097152 // Generator is not ready to generate yet.
mavlink20.MAV_GENERATOR_STATUS_FLAG_IDLE = 4194304 // Generator is idle.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ENUM_END = 4194305 // 

// MAV_VTOL_STATE
mavlink20.MAV_VTOL_STATE_UNDEFINED = 0 // MAV is not configured as VTOL
mavlink20.MAV_VTOL_STATE_TRANSITION_TO_FW = 1 // VTOL is in transition from multicopter to fixed-wing
mavlink20.MAV_VTOL_STATE_TRANSITION_TO_MC = 2 // VTOL is in transition from fixed-wing to multicopter
mavlink20.MAV_VTOL_STATE_MC = 3 // VTOL is in multicopter state
mavlink20.MAV_VTOL_STATE_FW = 4 // VTOL is in fixed-wing state
mavlink20.MAV_VTOL_STATE_ENUM_END = 5 // 

// MAV_LANDED_STATE
mavlink20.MAV_LANDED_STATE_UNDEFINED = 0 // MAV landed state is unknown
mavlink20.MAV_LANDED_STATE_ON_GROUND = 1 // MAV is landed (on ground)
mavlink20.MAV_LANDED_STATE_IN_AIR = 2 // MAV is in air
mavlink20.MAV_LANDED_STATE_TAKEOFF = 3 // MAV currently taking off
mavlink20.MAV_LANDED_STATE_LANDING = 4 // MAV currently landing
mavlink20.MAV_LANDED_STATE_ENUM_END = 5 // 

// ADSB_ALTITUDE_TYPE
mavlink20.ADSB_ALTITUDE_TYPE_PRESSURE_QNH = 0 // Altitude reported from a Baro source using QNH reference
mavlink20.ADSB_ALTITUDE_TYPE_GEOMETRIC = 1 // Altitude reported from a GNSS source
mavlink20.ADSB_ALTITUDE_TYPE_ENUM_END = 2 // 

// ADSB_EMITTER_TYPE
mavlink20.ADSB_EMITTER_TYPE_NO_INFO = 0 // 
mavlink20.ADSB_EMITTER_TYPE_LIGHT = 1 // 
mavlink20.ADSB_EMITTER_TYPE_SMALL = 2 // 
mavlink20.ADSB_EMITTER_TYPE_LARGE = 3 // 
mavlink20.ADSB_EMITTER_TYPE_HIGH_VORTEX_LARGE = 4 // 
mavlink20.ADSB_EMITTER_TYPE_HEAVY = 5 // 
mavlink20.ADSB_EMITTER_TYPE_HIGHLY_MANUV = 6 // 
mavlink20.ADSB_EMITTER_TYPE_ROTOCRAFT = 7 // 
mavlink20.ADSB_EMITTER_TYPE_UNASSIGNED = 8 // 
mavlink20.ADSB_EMITTER_TYPE_GLIDER = 9 // 
mavlink20.ADSB_EMITTER_TYPE_LIGHTER_AIR = 10 // 
mavlink20.ADSB_EMITTER_TYPE_PARACHUTE = 11 // 
mavlink20.ADSB_EMITTER_TYPE_ULTRA_LIGHT = 12 // 
mavlink20.ADSB_EMITTER_TYPE_UNASSIGNED2 = 13 // 
mavlink20.ADSB_EMITTER_TYPE_UAV = 14 // 
mavlink20.ADSB_EMITTER_TYPE_SPACE = 15 // 
mavlink20.ADSB_EMITTER_TYPE_UNASSGINED3 = 16 // 
mavlink20.ADSB_EMITTER_TYPE_EMERGENCY_SURFACE = 17 // 
mavlink20.ADSB_EMITTER_TYPE_SERVICE_SURFACE = 18 // 
mavlink20.ADSB_EMITTER_TYPE_POINT_OBSTACLE = 19 // 
mavlink20.ADSB_EMITTER_TYPE_ENUM_END = 20 // 

// ADSB_FLAGS
mavlink20.ADSB_FLAGS_VALID_COORDS = 1 // 
mavlink20.ADSB_FLAGS_VALID_ALTITUDE = 2 // 
mavlink20.ADSB_FLAGS_VALID_HEADING = 4 // 
mavlink20.ADSB_FLAGS_VALID_VELOCITY = 8 // 
mavlink20.ADSB_FLAGS_VALID_CALLSIGN = 16 // 
mavlink20.ADSB_FLAGS_VALID_SQUAWK = 32 // 
mavlink20.ADSB_FLAGS_SIMULATED = 64 // 
mavlink20.ADSB_FLAGS_VERTICAL_VELOCITY_VALID = 128 // 
mavlink20.ADSB_FLAGS_BARO_VALID = 256 // 
mavlink20.ADSB_FLAGS_SOURCE_UAT = 32768 // 
mavlink20.ADSB_FLAGS_ENUM_END = 32769 // 

// MAV_DO_REPOSITION_FLAGS
mavlink20.MAV_DO_REPOSITION_FLAGS_CHANGE_MODE = 1 // The aircraft should immediately transition into guided. This should
                        // not be set for follow me applications
mavlink20.MAV_DO_REPOSITION_FLAGS_RELATIVE_YAW = 2 // Yaw relative to the vehicle current heading (if not set, relative to
                        // North).
mavlink20.MAV_DO_REPOSITION_FLAGS_ENUM_END = 3 // 

// SPEED_TYPE
mavlink20.SPEED_TYPE_AIRSPEED = 0 // Airspeed
mavlink20.SPEED_TYPE_GROUNDSPEED = 1 // Groundspeed
mavlink20.SPEED_TYPE_CLIMB_SPEED = 2 // Climb speed
mavlink20.SPEED_TYPE_DESCENT_SPEED = 3 // Descent speed
mavlink20.SPEED_TYPE_ENUM_END = 4 // 

// HEADING_TYPE
mavlink20.HEADING_TYPE_COURSE_OVER_GROUND = 0 // Course over ground.
mavlink20.HEADING_TYPE_HEADING = 1 // Raw vehicle heading.
mavlink20.HEADING_TYPE_DEFAULT = 2 // Default heading.
mavlink20.HEADING_TYPE_ENUM_END = 3 // 

// ESTIMATOR_STATUS_FLAGS
mavlink20.ESTIMATOR_ATTITUDE = 1 // True if the attitude estimate is good
mavlink20.ESTIMATOR_VELOCITY_HORIZ = 2 // True if the horizontal velocity estimate is good
mavlink20.ESTIMATOR_VELOCITY_VERT = 4 // True if the  vertical velocity estimate is good
mavlink20.ESTIMATOR_POS_HORIZ_REL = 8 // True if the horizontal position (relative) estimate is good
mavlink20.ESTIMATOR_POS_HORIZ_ABS = 16 // True if the horizontal position (absolute) estimate is good
mavlink20.ESTIMATOR_POS_VERT_ABS = 32 // True if the vertical position (absolute) estimate is good
mavlink20.ESTIMATOR_POS_VERT_AGL = 64 // True if the vertical position (above ground) estimate is good
mavlink20.ESTIMATOR_CONST_POS_MODE = 128 // True if the EKF is in a constant position mode and is not using
                        // external measurements (eg GPS or optical
                        // flow)
mavlink20.ESTIMATOR_PRED_POS_HORIZ_REL = 256 // True if the EKF has sufficient data to enter a mode that will provide
                        // a (relative) position estimate
mavlink20.ESTIMATOR_PRED_POS_HORIZ_ABS = 512 // True if the EKF has sufficient data to enter a mode that will provide
                        // a (absolute) position estimate
mavlink20.ESTIMATOR_GPS_GLITCH = 1024 // True if the EKF has detected a GPS glitch
mavlink20.ESTIMATOR_ACCEL_ERROR = 2048 // True if the EKF has detected bad accelerometer data
mavlink20.ESTIMATOR_STATUS_FLAGS_ENUM_END = 2049 // 

// MOTOR_TEST_ORDER
mavlink20.MOTOR_TEST_ORDER_DEFAULT = 0 // Default autopilot motor test method.
mavlink20.MOTOR_TEST_ORDER_SEQUENCE = 1 // Motor numbers are specified as their index in a predefined vehicle-
                        // specific sequence.
mavlink20.MOTOR_TEST_ORDER_BOARD = 2 // Motor numbers are specified as the output as labeled on the board.
mavlink20.MOTOR_TEST_ORDER_ENUM_END = 3 // 

// MOTOR_TEST_THROTTLE_TYPE
mavlink20.MOTOR_TEST_THROTTLE_PERCENT = 0 // Throttle as a percentage (0 ~ 100)
mavlink20.MOTOR_TEST_THROTTLE_PWM = 1 // Throttle as an absolute PWM value (normally in range of 1000~2000).
mavlink20.MOTOR_TEST_THROTTLE_PILOT = 2 // Throttle pass-through from pilot's transmitter.
mavlink20.MOTOR_TEST_COMPASS_CAL = 3 // Per-motor compass calibration test.
mavlink20.MOTOR_TEST_THROTTLE_TYPE_ENUM_END = 4 // 

// GPS_INPUT_IGNORE_FLAGS
mavlink20.GPS_INPUT_IGNORE_FLAG_ALT = 1 // ignore altitude field
mavlink20.GPS_INPUT_IGNORE_FLAG_HDOP = 2 // ignore hdop field
mavlink20.GPS_INPUT_IGNORE_FLAG_VDOP = 4 // ignore vdop field
mavlink20.GPS_INPUT_IGNORE_FLAG_VEL_HORIZ = 8 // ignore horizontal velocity field (vn and ve)
mavlink20.GPS_INPUT_IGNORE_FLAG_VEL_VERT = 16 // ignore vertical velocity field (vd)
mavlink20.GPS_INPUT_IGNORE_FLAG_SPEED_ACCURACY = 32 // ignore speed accuracy field
mavlink20.GPS_INPUT_IGNORE_FLAG_HORIZONTAL_ACCURACY = 64 // ignore horizontal accuracy field
mavlink20.GPS_INPUT_IGNORE_FLAG_VERTICAL_ACCURACY = 128 // ignore vertical accuracy field
mavlink20.GPS_INPUT_IGNORE_FLAGS_ENUM_END = 129 // 

// MAV_COLLISION_ACTION
mavlink20.MAV_COLLISION_ACTION_NONE = 0 // Ignore any potential collisions
mavlink20.MAV_COLLISION_ACTION_REPORT = 1 // Report potential collision
mavlink20.MAV_COLLISION_ACTION_ASCEND_OR_DESCEND = 2 // Ascend or Descend to avoid threat
mavlink20.MAV_COLLISION_ACTION_MOVE_HORIZONTALLY = 3 // Move horizontally to avoid threat
mavlink20.MAV_COLLISION_ACTION_MOVE_PERPENDICULAR = 4 // Aircraft to move perpendicular to the collision's velocity vector
mavlink20.MAV_COLLISION_ACTION_RTL = 5 // Aircraft to fly directly back to its launch point
mavlink20.MAV_COLLISION_ACTION_HOVER = 6 // Aircraft to stop in place
mavlink20.MAV_COLLISION_ACTION_ENUM_END = 7 // 

// MAV_COLLISION_THREAT_LEVEL
mavlink20.MAV_COLLISION_THREAT_LEVEL_NONE = 0 // Not a threat
mavlink20.MAV_COLLISION_THREAT_LEVEL_LOW = 1 // Craft is mildly concerned about this threat
mavlink20.MAV_COLLISION_THREAT_LEVEL_HIGH = 2 // Craft is panicking, and may take actions to avoid threat
mavlink20.MAV_COLLISION_THREAT_LEVEL_ENUM_END = 3 // 

// MAV_COLLISION_SRC
mavlink20.MAV_COLLISION_SRC_ADSB = 0 // ID field references ADSB_VEHICLE packets
mavlink20.MAV_COLLISION_SRC_MAVLINK_GPS_GLOBAL_INT = 1 // ID field references MAVLink SRC ID
mavlink20.MAV_COLLISION_SRC_ENUM_END = 2 // 

// GPS_FIX_TYPE
mavlink20.GPS_FIX_TYPE_NO_GPS = 0 // No GPS connected
mavlink20.GPS_FIX_TYPE_NO_FIX = 1 // No position information, GPS is connected
mavlink20.GPS_FIX_TYPE_2D_FIX = 2 // 2D position
mavlink20.GPS_FIX_TYPE_3D_FIX = 3 // 3D position
mavlink20.GPS_FIX_TYPE_DGPS = 4 // DGPS/SBAS aided 3D position
mavlink20.GPS_FIX_TYPE_RTK_FLOAT = 5 // RTK float, 3D position
mavlink20.GPS_FIX_TYPE_RTK_FIXED = 6 // RTK Fixed, 3D position
mavlink20.GPS_FIX_TYPE_STATIC = 7 // Static fixed, typically used for base stations
mavlink20.GPS_FIX_TYPE_PPP = 8 // PPP, 3D position.
mavlink20.GPS_FIX_TYPE_ENUM_END = 9 // 

// RTK_BASELINE_COORDINATE_SYSTEM
mavlink20.RTK_BASELINE_COORDINATE_SYSTEM_ECEF = 0 // Earth-centered, Earth-fixed
mavlink20.RTK_BASELINE_COORDINATE_SYSTEM_NED = 1 // RTK basestation centered, north, east, down
mavlink20.RTK_BASELINE_COORDINATE_SYSTEM_ENUM_END = 2 // 

// LANDING_TARGET_TYPE
mavlink20.LANDING_TARGET_TYPE_LIGHT_BEACON = 0 // Landing target signaled by light beacon (ex: IR-LOCK)
mavlink20.LANDING_TARGET_TYPE_RADIO_BEACON = 1 // Landing target signaled by radio beacon (ex: ILS, NDB)
mavlink20.LANDING_TARGET_TYPE_VISION_FIDUCIAL = 2 // Landing target represented by a fiducial marker (ex: ARTag)
mavlink20.LANDING_TARGET_TYPE_VISION_OTHER = 3 // Landing target represented by a pre-defined visual shape/feature (ex:
                        // X-marker, H-marker, square)
mavlink20.LANDING_TARGET_TYPE_ENUM_END = 4 // 

// VTOL_TRANSITION_HEADING
mavlink20.VTOL_TRANSITION_HEADING_VEHICLE_DEFAULT = 0 // Respect the heading configuration of the vehicle.
mavlink20.VTOL_TRANSITION_HEADING_NEXT_WAYPOINT = 1 // Use the heading pointing towards the next waypoint.
mavlink20.VTOL_TRANSITION_HEADING_TAKEOFF = 2 // Use the heading on takeoff (while sitting on the ground).
mavlink20.VTOL_TRANSITION_HEADING_SPECIFIED = 3 // Use the specified heading in parameter 4.
mavlink20.VTOL_TRANSITION_HEADING_ANY = 4 // Use the current heading when reaching takeoff altitude (potentially
                        // facing the wind when weather-vaning is
                        // active).
mavlink20.VTOL_TRANSITION_HEADING_ENUM_END = 5 // 

// CAMERA_CAP_FLAGS
mavlink20.CAMERA_CAP_FLAGS_CAPTURE_VIDEO = 1 // Camera is able to record video
mavlink20.CAMERA_CAP_FLAGS_CAPTURE_IMAGE = 2 // Camera is able to capture images
mavlink20.CAMERA_CAP_FLAGS_HAS_MODES = 4 // Camera has separate Video and Image/Photo modes
                        // (MAV_CMD_SET_CAMERA_MODE)
mavlink20.CAMERA_CAP_FLAGS_CAN_CAPTURE_IMAGE_IN_VIDEO_MODE = 8 // Camera can capture images while in video mode
mavlink20.CAMERA_CAP_FLAGS_CAN_CAPTURE_VIDEO_IN_IMAGE_MODE = 16 // Camera can capture videos while in Photo/Image mode
mavlink20.CAMERA_CAP_FLAGS_HAS_IMAGE_SURVEY_MODE = 32 // Camera has image survey mode (MAV_CMD_SET_CAMERA_MODE)
mavlink20.CAMERA_CAP_FLAGS_HAS_BASIC_ZOOM = 64 // Camera has basic zoom control (MAV_CMD_SET_CAMERA_ZOOM)
mavlink20.CAMERA_CAP_FLAGS_HAS_BASIC_FOCUS = 128 // Camera has basic focus control (MAV_CMD_SET_CAMERA_FOCUS)
mavlink20.CAMERA_CAP_FLAGS_HAS_VIDEO_STREAM = 256 // Camera has video streaming capabilities (request
                        // VIDEO_STREAM_INFORMATION with
                        // MAV_CMD_REQUEST_MESSAGE for video streaming
                        // info)
mavlink20.CAMERA_CAP_FLAGS_HAS_TRACKING_POINT = 512 // Camera supports tracking of a point on the camera view.
mavlink20.CAMERA_CAP_FLAGS_HAS_TRACKING_RECTANGLE = 1024 // Camera supports tracking of a selection rectangle on the camera view.
mavlink20.CAMERA_CAP_FLAGS_HAS_TRACKING_GEO_STATUS = 2048 // Camera supports tracking geo status (CAMERA_TRACKING_GEO_STATUS).
mavlink20.CAMERA_CAP_FLAGS_HAS_THERMAL_RANGE = 4096 // Camera supports absolute thermal range (request CAMERA_THERMAL_RANGE
                        // with MAV_CMD_REQUEST_MESSAGE).
mavlink20.CAMERA_CAP_FLAGS_HAS_MTI = 8192 // Camera supports Moving Target Indicators (MTI) on the camera view
                        // (using MAV_CMD_CAMERA_START_MTI).
mavlink20.CAMERA_CAP_FLAGS_ENUM_END = 8193 // 

// VIDEO_STREAM_STATUS_FLAGS
mavlink20.VIDEO_STREAM_STATUS_FLAGS_RUNNING = 1 // Stream is active (running)
mavlink20.VIDEO_STREAM_STATUS_FLAGS_THERMAL = 2 // Stream is thermal imaging
mavlink20.VIDEO_STREAM_STATUS_FLAGS_THERMAL_RANGE_ENABLED = 4 // Stream can report absolute thermal range (see CAMERA_THERMAL_RANGE).
mavlink20.VIDEO_STREAM_STATUS_FLAGS_ENUM_END = 5 // 

// VIDEO_STREAM_TYPE
mavlink20.VIDEO_STREAM_TYPE_RTSP = 0 // Stream is RTSP
mavlink20.VIDEO_STREAM_TYPE_RTPUDP = 1 // Stream is RTP UDP (URI gives the port number)
mavlink20.VIDEO_STREAM_TYPE_TCP_MPEG = 2 // Stream is MPEG on TCP
mavlink20.VIDEO_STREAM_TYPE_MPEG_TS = 3 // Stream is MPEG TS (URI gives the port number)
mavlink20.VIDEO_STREAM_TYPE_WHEP = 4 // Stream is WHEP (WebRTC-HTTP Egress Protocol)
mavlink20.VIDEO_STREAM_TYPE_ENUM_END = 5 // 

// VIDEO_STREAM_ENCODING
mavlink20.VIDEO_STREAM_ENCODING_UNKNOWN = 0 // Stream encoding is unknown
mavlink20.VIDEO_STREAM_ENCODING_H264 = 1 // Stream encoding is H.264
mavlink20.VIDEO_STREAM_ENCODING_H265 = 2 // Stream encoding is H.265
mavlink20.VIDEO_STREAM_ENCODING_ENUM_END = 3 // 

// CAMERA_TRACKING_STATUS_FLAGS
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_IDLE = 0 // Camera is not tracking
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_ACTIVE = 1 // Camera is tracking
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_ERROR = 2 // Camera tracking in error state
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_MTI = 4 // Camera Moving Target Indicators (MTI) are active
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_COASTING = 8 // Camera tracking target is obscured and is being predicted
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_ENUM_END = 9 // 

// CAMERA_TRACKING_MODE
mavlink20.CAMERA_TRACKING_MODE_NONE = 0 // Not tracking
mavlink20.CAMERA_TRACKING_MODE_POINT = 1 // Target is a point
mavlink20.CAMERA_TRACKING_MODE_RECTANGLE = 2 // Target is a rectangle
mavlink20.CAMERA_TRACKING_MODE_ENUM_END = 3 // 

// CAMERA_TRACKING_TARGET_DATA
mavlink20.CAMERA_TRACKING_TARGET_DATA_EMBEDDED = 1 // Target data embedded in image data (proprietary)
mavlink20.CAMERA_TRACKING_TARGET_DATA_RENDERED = 2 // Target data rendered in image
mavlink20.CAMERA_TRACKING_TARGET_DATA_IN_STATUS = 4 // Target data within status message (Point or Rectangle)
mavlink20.CAMERA_TRACKING_TARGET_DATA_ENUM_END = 5 // 

// CAMERA_ZOOM_TYPE
mavlink20.ZOOM_TYPE_STEP = 0 // Zoom one step increment (-1 for wide, 1 for tele)
mavlink20.ZOOM_TYPE_CONTINUOUS = 1 // Continuous normalized zoom in/out rate until stopped. Range -1..1,
                        // negative: wide, positive: narrow/tele, 0 to
                        // stop zooming. Other values should be
                        // clipped to the range.
mavlink20.ZOOM_TYPE_RANGE = 2 // Zoom value as proportion of full camera range (a percentage value
                        // between 0.0 and 100.0)
mavlink20.ZOOM_TYPE_FOCAL_LENGTH = 3 // Zoom value/variable focal length in millimetres. Note that there is no
                        // message to get the valid zoom range of the
                        // camera, so this can type can only be used
                        // for cameras where the zoom range is known
                        // (implying that this cannot reliably be used
                        // in a GCS for an arbitrary camera)
mavlink20.ZOOM_TYPE_HORIZONTAL_FOV = 4 // Zoom value as horizontal field of view in degrees.
mavlink20.CAMERA_ZOOM_TYPE_ENUM_END = 5 // 

// SET_FOCUS_TYPE
mavlink20.FOCUS_TYPE_STEP = 0 // Focus one step increment (-1 for focusing in, 1 for focusing out
                        // towards infinity).
mavlink20.FOCUS_TYPE_CONTINUOUS = 1 // Continuous normalized focus in/out rate until stopped. Range -1..1,
                        // negative: in, positive: out towards
                        // infinity, 0 to stop focusing. Other values
                        // should be clipped to the range.
mavlink20.FOCUS_TYPE_RANGE = 2 // Focus value as proportion of full camera focus range (a value between
                        // 0.0 and 100.0)
mavlink20.FOCUS_TYPE_METERS = 3 // Focus value in metres. Note that there is no message to get the valid
                        // focus range of the camera, so this can type
                        // can only be used for cameras where the
                        // range is known (implying that this cannot
                        // reliably be used in a GCS for an arbitrary
                        // camera).
mavlink20.FOCUS_TYPE_AUTO = 4 // Focus automatically.
mavlink20.FOCUS_TYPE_AUTO_SINGLE = 5 // Single auto focus. Mainly used for still pictures. Usually abbreviated
                        // as AF-S.
mavlink20.FOCUS_TYPE_AUTO_CONTINUOUS = 6 // Continuous auto focus. Mainly used for dynamic scenes. Abbreviated as
                        // AF-C.
mavlink20.SET_FOCUS_TYPE_ENUM_END = 7 // 

// CAMERA_SOURCE
mavlink20.CAMERA_SOURCE_DEFAULT = 0 // Default camera source.
mavlink20.CAMERA_SOURCE_RGB = 1 // RGB camera source.
mavlink20.CAMERA_SOURCE_IR = 2 // IR camera source.
mavlink20.CAMERA_SOURCE_NDVI = 3 // NDVI camera source.
mavlink20.CAMERA_SOURCE_ENUM_END = 4 // 

// PARAM_ACK
mavlink20.PARAM_ACK_ACCEPTED = 0 // Parameter value ACCEPTED and SET
mavlink20.PARAM_ACK_VALUE_UNSUPPORTED = 1 // Parameter value UNKNOWN/UNSUPPORTED
mavlink20.PARAM_ACK_FAILED = 2 // Parameter failed to set
mavlink20.PARAM_ACK_IN_PROGRESS = 3 // Parameter value received but not yet set/accepted. A subsequent
                        // PARAM_EXT_ACK with the final result will
                        // follow once operation is completed. This is
                        // returned immediately for parameters that
                        // take longer to set, indicating that the the
                        // parameter was received and does not need to
                        // be resent.
mavlink20.PARAM_ACK_ENUM_END = 4 // 

// CAMERA_MODE
mavlink20.CAMERA_MODE_IMAGE = 0 // Camera is in image/photo capture mode.
mavlink20.CAMERA_MODE_VIDEO = 1 // Camera is in video capture mode.
mavlink20.CAMERA_MODE_IMAGE_SURVEY = 2 // Camera is in image survey capture mode. It allows for camera
                        // controller to do specific settings for
                        // surveys.
mavlink20.CAMERA_MODE_ENUM_END = 3 // 

// MAV_ARM_AUTH_DENIED_REASON
mavlink20.MAV_ARM_AUTH_DENIED_REASON_GENERIC = 0 // Not a specific reason
mavlink20.MAV_ARM_AUTH_DENIED_REASON_NONE = 1 // Authorizer will send the error as string to GCS
mavlink20.MAV_ARM_AUTH_DENIED_REASON_INVALID_WAYPOINT = 2 // At least one waypoint have a invalid value
mavlink20.MAV_ARM_AUTH_DENIED_REASON_TIMEOUT = 3 // Timeout in the authorizer process(in case it depends on network)
mavlink20.MAV_ARM_AUTH_DENIED_REASON_AIRSPACE_IN_USE = 4 // Airspace of the mission in use by another vehicle, second result
                        // parameter can have the waypoint id that
                        // caused it to be denied.
mavlink20.MAV_ARM_AUTH_DENIED_REASON_BAD_WEATHER = 5 // Weather is not good to fly
mavlink20.MAV_ARM_AUTH_DENIED_REASON_ENUM_END = 6 // 

// RC_TYPE
mavlink20.RC_TYPE_SPEKTRUM = 0 // Spektrum
mavlink20.RC_TYPE_CRSF = 1 // CRSF
mavlink20.RC_TYPE_ENUM_END = 2 // 

// RC_SUB_TYPE
mavlink20.RC_SUB_TYPE_SPEKTRUM_DSM2 = 0 // Spektrum DSM2
mavlink20.RC_SUB_TYPE_SPEKTRUM_DSMX = 1 // Spektrum DSMX
mavlink20.RC_SUB_TYPE_SPEKTRUM_DSMX8 = 2 // Spektrum DSMX8
mavlink20.RC_SUB_TYPE_ENUM_END = 3 // 

// ENGINE_CONTROL_OPTIONS
mavlink20.ENGINE_CONTROL_OPTIONS_ALLOW_START_WHILE_DISARMED = 1 // Allow starting the engine while disarmed (without changing the
                        // vehicle's armed state). This effectively
                        // arms just the ICE, without arming the
                        // vehicle to start other motors or
                        // propellers.
mavlink20.ENGINE_CONTROL_OPTIONS_ENUM_END = 2 // 

// POSITION_TARGET_TYPEMASK
mavlink20.POSITION_TARGET_TYPEMASK_X_IGNORE = 1 // Ignore position x
mavlink20.POSITION_TARGET_TYPEMASK_Y_IGNORE = 2 // Ignore position y
mavlink20.POSITION_TARGET_TYPEMASK_Z_IGNORE = 4 // Ignore position z
mavlink20.POSITION_TARGET_TYPEMASK_VX_IGNORE = 8 // Ignore velocity x
mavlink20.POSITION_TARGET_TYPEMASK_VY_IGNORE = 16 // Ignore velocity y
mavlink20.POSITION_TARGET_TYPEMASK_VZ_IGNORE = 32 // Ignore velocity z
mavlink20.POSITION_TARGET_TYPEMASK_AX_IGNORE = 64 // Ignore acceleration x
mavlink20.POSITION_TARGET_TYPEMASK_AY_IGNORE = 128 // Ignore acceleration y
mavlink20.POSITION_TARGET_TYPEMASK_AZ_IGNORE = 256 // Ignore acceleration z
mavlink20.POSITION_TARGET_TYPEMASK_FORCE_SET = 512 // Use force instead of acceleration
mavlink20.POSITION_TARGET_TYPEMASK_YAW_IGNORE = 1024 // Ignore yaw
mavlink20.POSITION_TARGET_TYPEMASK_YAW_RATE_IGNORE = 2048 // Ignore yaw rate
mavlink20.POSITION_TARGET_TYPEMASK_ENUM_END = 2049 // 

// ATTITUDE_TARGET_TYPEMASK
mavlink20.ATTITUDE_TARGET_TYPEMASK_BODY_ROLL_RATE_IGNORE = 1 // Ignore body roll rate
mavlink20.ATTITUDE_TARGET_TYPEMASK_BODY_PITCH_RATE_IGNORE = 2 // Ignore body pitch rate
mavlink20.ATTITUDE_TARGET_TYPEMASK_BODY_YAW_RATE_IGNORE = 4 // Ignore body yaw rate
mavlink20.ATTITUDE_TARGET_TYPEMASK_THRUST_BODY_SET = 32 // Use 3D body thrust setpoint instead of throttle
mavlink20.ATTITUDE_TARGET_TYPEMASK_THROTTLE_IGNORE = 64 // Ignore throttle
mavlink20.ATTITUDE_TARGET_TYPEMASK_ATTITUDE_IGNORE = 128 // Ignore attitude
mavlink20.ATTITUDE_TARGET_TYPEMASK_ENUM_END = 129 // 

// UTM_FLIGHT_STATE
mavlink20.UTM_FLIGHT_STATE_UNKNOWN = 1 // The flight state can't be determined.
mavlink20.UTM_FLIGHT_STATE_GROUND = 2 // UAS on ground.
mavlink20.UTM_FLIGHT_STATE_AIRBORNE = 3 // UAS airborne.
mavlink20.UTM_FLIGHT_STATE_EMERGENCY = 16 // UAS is in an emergency flight state.
mavlink20.UTM_FLIGHT_STATE_NOCTRL = 32 // UAS has no active controls.
mavlink20.UTM_FLIGHT_STATE_ENUM_END = 33 // 

// UTM_DATA_AVAIL_FLAGS
mavlink20.UTM_DATA_AVAIL_FLAGS_TIME_VALID = 1 // The field time contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_UAS_ID_AVAILABLE = 2 // The field uas_id contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_POSITION_AVAILABLE = 4 // The fields lat, lon and h_acc contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_ALTITUDE_AVAILABLE = 8 // The fields alt and v_acc contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_RELATIVE_ALTITUDE_AVAILABLE = 16 // The field relative_alt contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_HORIZONTAL_VELO_AVAILABLE = 32 // The fields vx and vy contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_VERTICAL_VELO_AVAILABLE = 64 // The field vz contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_NEXT_WAYPOINT_AVAILABLE = 128 // The fields next_lat, next_lon and next_alt contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_ENUM_END = 129 // 

// CELLULAR_STATUS_FLAG
mavlink20.CELLULAR_STATUS_FLAG_UNKNOWN = 0 // State unknown or not reportable.
mavlink20.CELLULAR_STATUS_FLAG_FAILED = 1 // Modem is unusable
mavlink20.CELLULAR_STATUS_FLAG_INITIALIZING = 2 // Modem is being initialized
mavlink20.CELLULAR_STATUS_FLAG_LOCKED = 3 // Modem is locked
mavlink20.CELLULAR_STATUS_FLAG_DISABLED = 4 // Modem is not enabled and is powered down
mavlink20.CELLULAR_STATUS_FLAG_DISABLING = 5 // Modem is currently transitioning to the CELLULAR_STATUS_FLAG_DISABLED
                        // state
mavlink20.CELLULAR_STATUS_FLAG_ENABLING = 6 // Modem is currently transitioning to the CELLULAR_STATUS_FLAG_ENABLED
                        // state
mavlink20.CELLULAR_STATUS_FLAG_ENABLED = 7 // Modem is enabled and powered on but not registered with a network
                        // provider and not available for data
                        // connections
mavlink20.CELLULAR_STATUS_FLAG_SEARCHING = 8 // Modem is searching for a network provider to register
mavlink20.CELLULAR_STATUS_FLAG_REGISTERED = 9 // Modem is registered with a network provider, and data connections and
                        // messaging may be available for use
mavlink20.CELLULAR_STATUS_FLAG_DISCONNECTING = 10 // Modem is disconnecting and deactivating the last active packet data
                        // bearer. This state will not be entered if
                        // more than one packet data bearer is active
                        // and one of the active bearers is
                        // deactivated
mavlink20.CELLULAR_STATUS_FLAG_CONNECTING = 11 // Modem is activating and connecting the first packet data bearer.
                        // Subsequent bearer activations when another
                        // bearer is already active do not cause this
                        // state to be entered
mavlink20.CELLULAR_STATUS_FLAG_CONNECTED = 12 // One or more packet data bearers is active and connected
mavlink20.CELLULAR_STATUS_FLAG_ENUM_END = 13 // 

// CELLULAR_NETWORK_FAILED_REASON
mavlink20.CELLULAR_NETWORK_FAILED_REASON_NONE = 0 // No error
mavlink20.CELLULAR_NETWORK_FAILED_REASON_UNKNOWN = 1 // Error state is unknown
mavlink20.CELLULAR_NETWORK_FAILED_REASON_SIM_MISSING = 2 // SIM is required for the modem but missing
mavlink20.CELLULAR_NETWORK_FAILED_REASON_SIM_ERROR = 3 // SIM is available, but not usable for connection
mavlink20.CELLULAR_NETWORK_FAILED_REASON_ENUM_END = 4 // 

// CELLULAR_NETWORK_RADIO_TYPE
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_NONE = 0 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_GSM = 1 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_CDMA = 2 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_WCDMA = 3 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_LTE = 4 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_ENUM_END = 5 // 

// PRECISION_LAND_MODE
mavlink20.PRECISION_LAND_MODE_DISABLED = 0 // Normal (non-precision) landing.
mavlink20.PRECISION_LAND_MODE_OPPORTUNISTIC = 1 // Use precision landing if beacon detected when land command accepted,
                        // otherwise land normally.
mavlink20.PRECISION_LAND_MODE_REQUIRED = 2 // Use precision landing, searching for beacon if not found when land
                        // command accepted (land normally if beacon
                        // cannot be found).
mavlink20.PRECISION_LAND_MODE_ENUM_END = 3 // 

// PARACHUTE_ACTION
mavlink20.PARACHUTE_DISABLE = 0 // Disable auto-release of parachute (i.e. release triggered by crash
                        // detectors).
mavlink20.PARACHUTE_ENABLE = 1 // Enable auto-release of parachute.
mavlink20.PARACHUTE_RELEASE = 2 // Release parachute and kill motors.
mavlink20.PARACHUTE_ACTION_ENUM_END = 3 // 

// MAV_TUNNEL_PAYLOAD_TYPE
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_UNKNOWN = 0 // Encoding of payload unknown.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED0 = 200 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED1 = 201 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED2 = 202 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED3 = 203 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED4 = 204 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED5 = 205 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED6 = 206 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED7 = 207 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED8 = 208 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED9 = 209 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_MODALAI_REMOTE_OSD = 210 // Registered for ModalAI remote OSD protocol.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_MODALAI_ESC_UART_PASSTHRU = 211 // Registered for ModalAI ESC UART passthru protocol.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_MODALAI_IO_UART_PASSTHRU = 212 // Registered for ModalAI vendor use.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_ENUM_END = 213 // 

// MAV_ODID_ID_TYPE
mavlink20.MAV_ODID_ID_TYPE_NONE = 0 // No type defined.
mavlink20.MAV_ODID_ID_TYPE_SERIAL_NUMBER = 1 // Manufacturer Serial Number (ANSI/CTA-2063 format).
mavlink20.MAV_ODID_ID_TYPE_CAA_REGISTRATION_ID = 2 // CAA (Civil Aviation Authority) registered ID. Format: [ICAO Country
                        // Code].[CAA Assigned ID].
mavlink20.MAV_ODID_ID_TYPE_UTM_ASSIGNED_UUID = 3 // UTM (Unmanned Traffic Management) assigned UUID (RFC4122).
mavlink20.MAV_ODID_ID_TYPE_SPECIFIC_SESSION_ID = 4 // A 20 byte ID for a specific flight/session. The exact ID type is
                        // indicated by the first byte of uas_id and
                        // these type values are managed by ICAO.
mavlink20.MAV_ODID_ID_TYPE_ENUM_END = 5 // 

// MAV_ODID_UA_TYPE
mavlink20.MAV_ODID_UA_TYPE_NONE = 0 // No UA (Unmanned Aircraft) type defined.
mavlink20.MAV_ODID_UA_TYPE_AEROPLANE = 1 // Aeroplane/Airplane. Fixed wing.
mavlink20.MAV_ODID_UA_TYPE_HELICOPTER_OR_MULTIROTOR = 2 // Helicopter or multirotor.
mavlink20.MAV_ODID_UA_TYPE_GYROPLANE = 3 // Gyroplane.
mavlink20.MAV_ODID_UA_TYPE_HYBRID_LIFT = 4 // VTOL (Vertical Take-Off and Landing). Fixed wing aircraft that can
                        // take off vertically.
mavlink20.MAV_ODID_UA_TYPE_ORNITHOPTER = 5 // Ornithopter.
mavlink20.MAV_ODID_UA_TYPE_GLIDER = 6 // Glider.
mavlink20.MAV_ODID_UA_TYPE_KITE = 7 // Kite.
mavlink20.MAV_ODID_UA_TYPE_FREE_BALLOON = 8 // Free Balloon.
mavlink20.MAV_ODID_UA_TYPE_CAPTIVE_BALLOON = 9 // Captive Balloon.
mavlink20.MAV_ODID_UA_TYPE_AIRSHIP = 10 // Airship. E.g. a blimp.
mavlink20.MAV_ODID_UA_TYPE_FREE_FALL_PARACHUTE = 11 // Free Fall/Parachute (unpowered).
mavlink20.MAV_ODID_UA_TYPE_ROCKET = 12 // Rocket.
mavlink20.MAV_ODID_UA_TYPE_TETHERED_POWERED_AIRCRAFT = 13 // Tethered powered aircraft.
mavlink20.MAV_ODID_UA_TYPE_GROUND_OBSTACLE = 14 // Ground Obstacle.
mavlink20.MAV_ODID_UA_TYPE_OTHER = 15 // Other type of aircraft not listed earlier.
mavlink20.MAV_ODID_UA_TYPE_ENUM_END = 16 // 

// MAV_ODID_STATUS
mavlink20.MAV_ODID_STATUS_UNDECLARED = 0 // The status of the (UA) Unmanned Aircraft is undefined.
mavlink20.MAV_ODID_STATUS_GROUND = 1 // The UA is on the ground.
mavlink20.MAV_ODID_STATUS_AIRBORNE = 2 // The UA is in the air.
mavlink20.MAV_ODID_STATUS_EMERGENCY = 3 // The UA is having an emergency.
mavlink20.MAV_ODID_STATUS_REMOTE_ID_SYSTEM_FAILURE = 4 // The remote ID system is failing or unreliable in some way.
mavlink20.MAV_ODID_STATUS_ENUM_END = 5 // 

// MAV_ODID_HEIGHT_REF
mavlink20.MAV_ODID_HEIGHT_REF_OVER_TAKEOFF = 0 // The height field is relative to the take-off location.
mavlink20.MAV_ODID_HEIGHT_REF_OVER_GROUND = 1 // The height field is relative to ground.
mavlink20.MAV_ODID_HEIGHT_REF_ENUM_END = 2 // 

// MAV_ODID_HOR_ACC
mavlink20.MAV_ODID_HOR_ACC_UNKNOWN = 0 // The horizontal accuracy is unknown.
mavlink20.MAV_ODID_HOR_ACC_10NM = 1 // The horizontal accuracy is smaller than 10 Nautical Miles. 18.52 km.
mavlink20.MAV_ODID_HOR_ACC_4NM = 2 // The horizontal accuracy is smaller than 4 Nautical Miles. 7.408 km.
mavlink20.MAV_ODID_HOR_ACC_2NM = 3 // The horizontal accuracy is smaller than 2 Nautical Miles. 3.704 km.
mavlink20.MAV_ODID_HOR_ACC_1NM = 4 // The horizontal accuracy is smaller than 1 Nautical Miles. 1.852 km.
mavlink20.MAV_ODID_HOR_ACC_0_5NM = 5 // The horizontal accuracy is smaller than 0.5 Nautical Miles. 926 m.
mavlink20.MAV_ODID_HOR_ACC_0_3NM = 6 // The horizontal accuracy is smaller than 0.3 Nautical Miles. 555.6 m.
mavlink20.MAV_ODID_HOR_ACC_0_1NM = 7 // The horizontal accuracy is smaller than 0.1 Nautical Miles. 185.2 m.
mavlink20.MAV_ODID_HOR_ACC_0_05NM = 8 // The horizontal accuracy is smaller than 0.05 Nautical Miles. 92.6 m.
mavlink20.MAV_ODID_HOR_ACC_30_METER = 9 // The horizontal accuracy is smaller than 30 meter.
mavlink20.MAV_ODID_HOR_ACC_10_METER = 10 // The horizontal accuracy is smaller than 10 meter.
mavlink20.MAV_ODID_HOR_ACC_3_METER = 11 // The horizontal accuracy is smaller than 3 meter.
mavlink20.MAV_ODID_HOR_ACC_1_METER = 12 // The horizontal accuracy is smaller than 1 meter.
mavlink20.MAV_ODID_HOR_ACC_ENUM_END = 13 // 

// MAV_ODID_VER_ACC
mavlink20.MAV_ODID_VER_ACC_UNKNOWN = 0 // The vertical accuracy is unknown.
mavlink20.MAV_ODID_VER_ACC_150_METER = 1 // The vertical accuracy is smaller than 150 meter.
mavlink20.MAV_ODID_VER_ACC_45_METER = 2 // The vertical accuracy is smaller than 45 meter.
mavlink20.MAV_ODID_VER_ACC_25_METER = 3 // The vertical accuracy is smaller than 25 meter.
mavlink20.MAV_ODID_VER_ACC_10_METER = 4 // The vertical accuracy is smaller than 10 meter.
mavlink20.MAV_ODID_VER_ACC_3_METER = 5 // The vertical accuracy is smaller than 3 meter.
mavlink20.MAV_ODID_VER_ACC_1_METER = 6 // The vertical accuracy is smaller than 1 meter.
mavlink20.MAV_ODID_VER_ACC_ENUM_END = 7 // 

// MAV_ODID_SPEED_ACC
mavlink20.MAV_ODID_SPEED_ACC_UNKNOWN = 0 // The speed accuracy is unknown.
mavlink20.MAV_ODID_SPEED_ACC_10_METERS_PER_SECOND = 1 // The speed accuracy is smaller than 10 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_3_METERS_PER_SECOND = 2 // The speed accuracy is smaller than 3 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_1_METERS_PER_SECOND = 3 // The speed accuracy is smaller than 1 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_0_3_METERS_PER_SECOND = 4 // The speed accuracy is smaller than 0.3 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_ENUM_END = 5 // 

// MAV_ODID_TIME_ACC
mavlink20.MAV_ODID_TIME_ACC_UNKNOWN = 0 // The timestamp accuracy is unknown.
mavlink20.MAV_ODID_TIME_ACC_0_1_SECOND = 1 // The timestamp accuracy is smaller than or equal to 0.1 second.
mavlink20.MAV_ODID_TIME_ACC_0_2_SECOND = 2 // The timestamp accuracy is smaller than or equal to 0.2 second.
mavlink20.MAV_ODID_TIME_ACC_0_3_SECOND = 3 // The timestamp accuracy is smaller than or equal to 0.3 second.
mavlink20.MAV_ODID_TIME_ACC_0_4_SECOND = 4 // The timestamp accuracy is smaller than or equal to 0.4 second.
mavlink20.MAV_ODID_TIME_ACC_0_5_SECOND = 5 // The timestamp accuracy is smaller than or equal to 0.5 second.
mavlink20.MAV_ODID_TIME_ACC_0_6_SECOND = 6 // The timestamp accuracy is smaller than or equal to 0.6 second.
mavlink20.MAV_ODID_TIME_ACC_0_7_SECOND = 7 // The timestamp accuracy is smaller than or equal to 0.7 second.
mavlink20.MAV_ODID_TIME_ACC_0_8_SECOND = 8 // The timestamp accuracy is smaller than or equal to 0.8 second.
mavlink20.MAV_ODID_TIME_ACC_0_9_SECOND = 9 // The timestamp accuracy is smaller than or equal to 0.9 second.
mavlink20.MAV_ODID_TIME_ACC_1_0_SECOND = 10 // The timestamp accuracy is smaller than or equal to 1.0 second.
mavlink20.MAV_ODID_TIME_ACC_1_1_SECOND = 11 // The timestamp accuracy is smaller than or equal to 1.1 second.
mavlink20.MAV_ODID_TIME_ACC_1_2_SECOND = 12 // The timestamp accuracy is smaller than or equal to 1.2 second.
mavlink20.MAV_ODID_TIME_ACC_1_3_SECOND = 13 // The timestamp accuracy is smaller than or equal to 1.3 second.
mavlink20.MAV_ODID_TIME_ACC_1_4_SECOND = 14 // The timestamp accuracy is smaller than or equal to 1.4 second.
mavlink20.MAV_ODID_TIME_ACC_1_5_SECOND = 15 // The timestamp accuracy is smaller than or equal to 1.5 second.
mavlink20.MAV_ODID_TIME_ACC_ENUM_END = 16 // 

// MAV_ODID_AUTH_TYPE
mavlink20.MAV_ODID_AUTH_TYPE_NONE = 0 // No authentication type is specified.
mavlink20.MAV_ODID_AUTH_TYPE_UAS_ID_SIGNATURE = 1 // Signature for the UAS (Unmanned Aircraft System) ID.
mavlink20.MAV_ODID_AUTH_TYPE_OPERATOR_ID_SIGNATURE = 2 // Signature for the Operator ID.
mavlink20.MAV_ODID_AUTH_TYPE_MESSAGE_SET_SIGNATURE = 3 // Signature for the entire message set.
mavlink20.MAV_ODID_AUTH_TYPE_NETWORK_REMOTE_ID = 4 // Authentication is provided by Network Remote ID.
mavlink20.MAV_ODID_AUTH_TYPE_SPECIFIC_AUTHENTICATION = 5 // The exact authentication type is indicated by the first byte of
                        // authentication_data and these type values
                        // are managed by ICAO.
mavlink20.MAV_ODID_AUTH_TYPE_ENUM_END = 6 // 

// MAV_ODID_DESC_TYPE
mavlink20.MAV_ODID_DESC_TYPE_TEXT = 0 // Optional free-form text description of the purpose of the flight.
mavlink20.MAV_ODID_DESC_TYPE_EMERGENCY = 1 // Optional additional clarification when status ==
                        // MAV_ODID_STATUS_EMERGENCY.
mavlink20.MAV_ODID_DESC_TYPE_EXTENDED_STATUS = 2 // Optional additional clarification when status !=
                        // MAV_ODID_STATUS_EMERGENCY.
mavlink20.MAV_ODID_DESC_TYPE_ENUM_END = 3 // 

// MAV_ODID_OPERATOR_LOCATION_TYPE
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_TAKEOFF = 0 // The location/altitude of the operator is the same as the take-off
                        // location.
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_LIVE_GNSS = 1 // The location/altitude of the operator is dynamic. E.g. based on live
                        // GNSS data.
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_FIXED = 2 // The location/altitude of the operator are fixed values.
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_ENUM_END = 3 // 

// MAV_ODID_CLASSIFICATION_TYPE
mavlink20.MAV_ODID_CLASSIFICATION_TYPE_UNDECLARED = 0 // The classification type for the UA is undeclared.
mavlink20.MAV_ODID_CLASSIFICATION_TYPE_EU = 1 // The classification type for the UA follows EU (European Union)
                        // specifications.
mavlink20.MAV_ODID_CLASSIFICATION_TYPE_ENUM_END = 2 // 

// MAV_ODID_CATEGORY_EU
mavlink20.MAV_ODID_CATEGORY_EU_UNDECLARED = 0 // The category for the UA, according to the EU specification, is
                        // undeclared.
mavlink20.MAV_ODID_CATEGORY_EU_OPEN = 1 // The category for the UA, according to the EU specification, is the
                        // Open category.
mavlink20.MAV_ODID_CATEGORY_EU_SPECIFIC = 2 // The category for the UA, according to the EU specification, is the
                        // Specific category.
mavlink20.MAV_ODID_CATEGORY_EU_CERTIFIED = 3 // The category for the UA, according to the EU specification, is the
                        // Certified category.
mavlink20.MAV_ODID_CATEGORY_EU_ENUM_END = 4 // 

// MAV_ODID_CLASS_EU
mavlink20.MAV_ODID_CLASS_EU_UNDECLARED = 0 // The class for the UA, according to the EU specification, is
                        // undeclared.
mavlink20.MAV_ODID_CLASS_EU_CLASS_0 = 1 // The class for the UA, according to the EU specification, is Class 0.
mavlink20.MAV_ODID_CLASS_EU_CLASS_1 = 2 // The class for the UA, according to the EU specification, is Class 1.
mavlink20.MAV_ODID_CLASS_EU_CLASS_2 = 3 // The class for the UA, according to the EU specification, is Class 2.
mavlink20.MAV_ODID_CLASS_EU_CLASS_3 = 4 // The class for the UA, according to the EU specification, is Class 3.
mavlink20.MAV_ODID_CLASS_EU_CLASS_4 = 5 // The class for the UA, according to the EU specification, is Class 4.
mavlink20.MAV_ODID_CLASS_EU_CLASS_5 = 6 // The class for the UA, according to the EU specification, is Class 5.
mavlink20.MAV_ODID_CLASS_EU_CLASS_6 = 7 // The class for the UA, according to the EU specification, is Class 6.
mavlink20.MAV_ODID_CLASS_EU_ENUM_END = 8 // 

// MAV_ODID_OPERATOR_ID_TYPE
mavlink20.MAV_ODID_OPERATOR_ID_TYPE_CAA = 0 // CAA (Civil Aviation Authority) registered operator ID.
mavlink20.MAV_ODID_OPERATOR_ID_TYPE_ENUM_END = 1 // 

// MAV_ODID_ARM_STATUS
mavlink20.MAV_ODID_ARM_STATUS_GOOD_TO_ARM = 0 // Passing arming checks.
mavlink20.MAV_ODID_ARM_STATUS_PRE_ARM_FAIL_GENERIC = 1 // Generic arming failure, see error string for details.
mavlink20.MAV_ODID_ARM_STATUS_ENUM_END = 2 // 

// TUNE_FORMAT
mavlink20.TUNE_FORMAT_QBASIC1_1 = 1 // Format is QBasic 1.1 Play:
                        // https://www.qbasic.net/en/reference/qb11/St
                        // atement/PLAY-006.htm.
mavlink20.TUNE_FORMAT_MML_MODERN = 2 // Format is Modern Music Markup Language (MML):
                        // https://en.wikipedia.org/wiki/Music_Macro_L
                        // anguage#Modern_MML.
mavlink20.TUNE_FORMAT_ENUM_END = 3 // 

// AIS_TYPE
mavlink20.AIS_TYPE_UNKNOWN = 0 // Not available (default).
mavlink20.AIS_TYPE_RESERVED_1 = 1 // 
mavlink20.AIS_TYPE_RESERVED_2 = 2 // 
mavlink20.AIS_TYPE_RESERVED_3 = 3 // 
mavlink20.AIS_TYPE_RESERVED_4 = 4 // 
mavlink20.AIS_TYPE_RESERVED_5 = 5 // 
mavlink20.AIS_TYPE_RESERVED_6 = 6 // 
mavlink20.AIS_TYPE_RESERVED_7 = 7 // 
mavlink20.AIS_TYPE_RESERVED_8 = 8 // 
mavlink20.AIS_TYPE_RESERVED_9 = 9 // 
mavlink20.AIS_TYPE_RESERVED_10 = 10 // 
mavlink20.AIS_TYPE_RESERVED_11 = 11 // 
mavlink20.AIS_TYPE_RESERVED_12 = 12 // 
mavlink20.AIS_TYPE_RESERVED_13 = 13 // 
mavlink20.AIS_TYPE_RESERVED_14 = 14 // 
mavlink20.AIS_TYPE_RESERVED_15 = 15 // 
mavlink20.AIS_TYPE_RESERVED_16 = 16 // 
mavlink20.AIS_TYPE_RESERVED_17 = 17 // 
mavlink20.AIS_TYPE_RESERVED_18 = 18 // 
mavlink20.AIS_TYPE_RESERVED_19 = 19 // 
mavlink20.AIS_TYPE_WIG = 20 // Wing In Ground effect.
mavlink20.AIS_TYPE_WIG_HAZARDOUS_A = 21 // 
mavlink20.AIS_TYPE_WIG_HAZARDOUS_B = 22 // 
mavlink20.AIS_TYPE_WIG_HAZARDOUS_C = 23 // 
mavlink20.AIS_TYPE_WIG_HAZARDOUS_D = 24 // 
mavlink20.AIS_TYPE_WIG_RESERVED_1 = 25 // 
mavlink20.AIS_TYPE_WIG_RESERVED_2 = 26 // 
mavlink20.AIS_TYPE_WIG_RESERVED_3 = 27 // 
mavlink20.AIS_TYPE_WIG_RESERVED_4 = 28 // 
mavlink20.AIS_TYPE_WIG_RESERVED_5 = 29 // 
mavlink20.AIS_TYPE_FISHING = 30 // 
mavlink20.AIS_TYPE_TOWING = 31 // 
mavlink20.AIS_TYPE_TOWING_LARGE = 32 // Towing: length exceeds 200m or breadth exceeds 25m.
mavlink20.AIS_TYPE_DREDGING = 33 // Dredging or other underwater ops.
mavlink20.AIS_TYPE_DIVING = 34 // 
mavlink20.AIS_TYPE_MILITARY = 35 // 
mavlink20.AIS_TYPE_SAILING = 36 // 
mavlink20.AIS_TYPE_PLEASURE = 37 // 
mavlink20.AIS_TYPE_RESERVED_20 = 38 // 
mavlink20.AIS_TYPE_RESERVED_21 = 39 // 
mavlink20.AIS_TYPE_HSC = 40 // High Speed Craft.
mavlink20.AIS_TYPE_HSC_HAZARDOUS_A = 41 // 
mavlink20.AIS_TYPE_HSC_HAZARDOUS_B = 42 // 
mavlink20.AIS_TYPE_HSC_HAZARDOUS_C = 43 // 
mavlink20.AIS_TYPE_HSC_HAZARDOUS_D = 44 // 
mavlink20.AIS_TYPE_HSC_RESERVED_1 = 45 // 
mavlink20.AIS_TYPE_HSC_RESERVED_2 = 46 // 
mavlink20.AIS_TYPE_HSC_RESERVED_3 = 47 // 
mavlink20.AIS_TYPE_HSC_RESERVED_4 = 48 // 
mavlink20.AIS_TYPE_HSC_UNKNOWN = 49 // 
mavlink20.AIS_TYPE_PILOT = 50 // 
mavlink20.AIS_TYPE_SAR = 51 // Search And Rescue vessel.
mavlink20.AIS_TYPE_TUG = 52 // 
mavlink20.AIS_TYPE_PORT_TENDER = 53 // 
mavlink20.AIS_TYPE_ANTI_POLLUTION = 54 // Anti-pollution equipment.
mavlink20.AIS_TYPE_LAW_ENFORCEMENT = 55 // 
mavlink20.AIS_TYPE_SPARE_LOCAL_1 = 56 // 
mavlink20.AIS_TYPE_SPARE_LOCAL_2 = 57 // 
mavlink20.AIS_TYPE_MEDICAL_TRANSPORT = 58 // 
mavlink20.AIS_TYPE_NONECOMBATANT = 59 // Noncombatant ship according to RR Resolution No. 18.
mavlink20.AIS_TYPE_PASSENGER = 60 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_A = 61 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_B = 62 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_C = 63 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_D = 64 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_1 = 65 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_2 = 66 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_3 = 67 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_4 = 68 // 
mavlink20.AIS_TYPE_PASSENGER_UNKNOWN = 69 // 
mavlink20.AIS_TYPE_CARGO = 70 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_A = 71 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_B = 72 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_C = 73 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_D = 74 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_1 = 75 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_2 = 76 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_3 = 77 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_4 = 78 // 
mavlink20.AIS_TYPE_CARGO_UNKNOWN = 79 // 
mavlink20.AIS_TYPE_TANKER = 80 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_A = 81 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_B = 82 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_C = 83 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_D = 84 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_1 = 85 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_2 = 86 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_3 = 87 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_4 = 88 // 
mavlink20.AIS_TYPE_TANKER_UNKNOWN = 89 // 
mavlink20.AIS_TYPE_OTHER = 90 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_A = 91 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_B = 92 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_C = 93 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_D = 94 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_1 = 95 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_2 = 96 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_3 = 97 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_4 = 98 // 
mavlink20.AIS_TYPE_OTHER_UNKNOWN = 99 // 
mavlink20.AIS_TYPE_ENUM_END = 100 // 

// AIS_NAV_STATUS
mavlink20.AIS_NAV_STATUS_UNDER_WAY = 0 // Under way using engine.
mavlink20.AIS_NAV_STATUS_ANCHORED = 1 // 
mavlink20.AIS_NAV_STATUS_UN_COMMANDED = 2 // 
mavlink20.AIS_NAV_STATUS_RESTRICTED_MANOEUVERABILITY = 3 // 
mavlink20.AIS_NAV_STATUS_DRAUGHT_CONSTRAINED = 4 // 
mavlink20.AIS_NAV_STATUS_MOORED = 5 // 
mavlink20.AIS_NAV_STATUS_AGROUND = 6 // 
mavlink20.AIS_NAV_STATUS_FISHING = 7 // 
mavlink20.AIS_NAV_STATUS_SAILING = 8 // 
mavlink20.AIS_NAV_STATUS_RESERVED_HSC = 9 // 
mavlink20.AIS_NAV_STATUS_RESERVED_WIG = 10 // 
mavlink20.AIS_NAV_STATUS_RESERVED_1 = 11 // 
mavlink20.AIS_NAV_STATUS_RESERVED_2 = 12 // 
mavlink20.AIS_NAV_STATUS_RESERVED_3 = 13 // 
mavlink20.AIS_NAV_STATUS_AIS_SART = 14 // Search And Rescue Transponder.
mavlink20.AIS_NAV_STATUS_UNKNOWN = 15 // Not available (default).
mavlink20.AIS_NAV_STATUS_ENUM_END = 16 // 

// AIS_FLAGS
mavlink20.AIS_FLAGS_POSITION_ACCURACY = 1 // 1 = High (Position accuracy less than or equal to 10m), 0 = Low
                        // (position accuracy greater than 10m).
mavlink20.AIS_FLAGS_VALID_COG = 2 // The COG field contains valid data
mavlink20.AIS_FLAGS_VALID_VELOCITY = 4 // The velocity field contains valid data
mavlink20.AIS_FLAGS_HIGH_VELOCITY = 8 // 1 = Velocity over 52.5765m/s (102.2 knots)
mavlink20.AIS_FLAGS_VALID_TURN_RATE = 16 // The turn_rate field contains valid data
mavlink20.AIS_FLAGS_TURN_RATE_SIGN_ONLY = 32 // Only the sign of the returned turn_rate value is valid. The actual
                        // turn rate is either greater than 5deg/30s
                        // or less than -5deg/30s.
mavlink20.AIS_FLAGS_VALID_DIMENSIONS = 64 // 
mavlink20.AIS_FLAGS_LARGE_BOW_DIMENSION = 128 // Distance to bow is greater than or equal to 511m
mavlink20.AIS_FLAGS_LARGE_STERN_DIMENSION = 256 // Distance to stern is greater than or equal to 511m
mavlink20.AIS_FLAGS_LARGE_PORT_DIMENSION = 512 // Distance to port side is greater than or equal to 63m
mavlink20.AIS_FLAGS_LARGE_STARBOARD_DIMENSION = 1024 // Distance to starboard side is greater than or equal to 63m
mavlink20.AIS_FLAGS_VALID_CALLSIGN = 2048 // The callsign field contains valid data
mavlink20.AIS_FLAGS_VALID_NAME = 4096 // The name field contains valid data
mavlink20.AIS_FLAGS_ENUM_END = 4097 // 

// FAILURE_UNIT
mavlink20.FAILURE_UNIT_SENSOR_GYRO = 0 // 
mavlink20.FAILURE_UNIT_SENSOR_ACCEL = 1 // 
mavlink20.FAILURE_UNIT_SENSOR_MAG = 2 // 
mavlink20.FAILURE_UNIT_SENSOR_BARO = 3 // 
mavlink20.FAILURE_UNIT_SENSOR_GPS = 4 // 
mavlink20.FAILURE_UNIT_SENSOR_OPTICAL_FLOW = 5 // 
mavlink20.FAILURE_UNIT_SENSOR_VIO = 6 // 
mavlink20.FAILURE_UNIT_SENSOR_DISTANCE_SENSOR = 7 // 
mavlink20.FAILURE_UNIT_SENSOR_AIRSPEED = 8 // 
mavlink20.FAILURE_UNIT_SYSTEM_BATTERY = 100 // 
mavlink20.FAILURE_UNIT_SYSTEM_MOTOR = 101 // 
mavlink20.FAILURE_UNIT_SYSTEM_SERVO = 102 // 
mavlink20.FAILURE_UNIT_SYSTEM_AVOIDANCE = 103 // 
mavlink20.FAILURE_UNIT_SYSTEM_RC_SIGNAL = 104 // 
mavlink20.FAILURE_UNIT_SYSTEM_MAVLINK_SIGNAL = 105 // 
mavlink20.FAILURE_UNIT_ENUM_END = 106 // 

// FAILURE_TYPE
mavlink20.FAILURE_TYPE_OK = 0 // No failure injected, used to reset a previous failure.
mavlink20.FAILURE_TYPE_OFF = 1 // Sets unit off, so completely non-responsive.
mavlink20.FAILURE_TYPE_STUCK = 2 // Unit is stuck e.g. keeps reporting the same value.
mavlink20.FAILURE_TYPE_GARBAGE = 3 // Unit is reporting complete garbage.
mavlink20.FAILURE_TYPE_WRONG = 4 // Unit is consistently wrong.
mavlink20.FAILURE_TYPE_SLOW = 5 // Unit is slow, so e.g. reporting at slower than expected rate.
mavlink20.FAILURE_TYPE_DELAYED = 6 // Data of unit is delayed in time.
mavlink20.FAILURE_TYPE_INTERMITTENT = 7 // Unit is sometimes working, sometimes not.
mavlink20.FAILURE_TYPE_ENUM_END = 8 // 

// NAV_VTOL_LAND_OPTIONS
mavlink20.NAV_VTOL_LAND_OPTIONS_DEFAULT = 0 // Default autopilot landing behaviour.
mavlink20.NAV_VTOL_LAND_OPTIONS_FW_SPIRAL_APPROACH = 1 // Use a fixed wing spiral desent approach before landing.
mavlink20.NAV_VTOL_LAND_OPTIONS_FW_APPROACH = 2 // Use a fixed wing approach before detransitioning and landing
                        // vertically.
mavlink20.NAV_VTOL_LAND_OPTIONS_ENUM_END = 3 // 

// MAV_WINCH_STATUS_FLAG
mavlink20.MAV_WINCH_STATUS_HEALTHY = 1 // Winch is healthy
mavlink20.MAV_WINCH_STATUS_FULLY_RETRACTED = 2 // Winch line is fully retracted
mavlink20.MAV_WINCH_STATUS_MOVING = 4 // Winch motor is moving
mavlink20.MAV_WINCH_STATUS_CLUTCH_ENGAGED = 8 // Winch clutch is engaged allowing motor to move freely.
mavlink20.MAV_WINCH_STATUS_LOCKED = 16 // Winch is locked by locking mechanism.
mavlink20.MAV_WINCH_STATUS_DROPPING = 32 // Winch is gravity dropping payload.
mavlink20.MAV_WINCH_STATUS_ARRESTING = 64 // Winch is arresting payload descent.
mavlink20.MAV_WINCH_STATUS_GROUND_SENSE = 128 // Winch is using torque measurements to sense the ground.
mavlink20.MAV_WINCH_STATUS_RETRACTING = 256 // Winch is returning to the fully retracted position.
mavlink20.MAV_WINCH_STATUS_REDELIVER = 512 // Winch is redelivering the payload. This is a failover state if the
                        // line tension goes above a threshold during
                        // RETRACTING.
mavlink20.MAV_WINCH_STATUS_ABANDON_LINE = 1024 // Winch is abandoning the line and possibly payload. Winch unspools the
                        // entire calculated line length. This is a
                        // failover state from REDELIVER if the number
                        // of attempts exceeds a threshold.
mavlink20.MAV_WINCH_STATUS_LOCKING = 2048 // Winch is engaging the locking mechanism.
mavlink20.MAV_WINCH_STATUS_LOAD_LINE = 4096 // Winch is spooling on line.
mavlink20.MAV_WINCH_STATUS_LOAD_PAYLOAD = 8192 // Winch is loading a payload.
mavlink20.MAV_WINCH_STATUS_FLAG_ENUM_END = 8193 // 

// MAG_CAL_STATUS
mavlink20.MAG_CAL_NOT_STARTED = 0 // 
mavlink20.MAG_CAL_WAITING_TO_START = 1 // 
mavlink20.MAG_CAL_RUNNING_STEP_ONE = 2 // 
mavlink20.MAG_CAL_RUNNING_STEP_TWO = 3 // 
mavlink20.MAG_CAL_SUCCESS = 4 // 
mavlink20.MAG_CAL_FAILED = 5 // 
mavlink20.MAG_CAL_BAD_ORIENTATION = 6 // 
mavlink20.MAG_CAL_BAD_RADIUS = 7 // 
mavlink20.MAG_CAL_STATUS_ENUM_END = 8 // 

// MAV_EVENT_ERROR_REASON
mavlink20.MAV_EVENT_ERROR_REASON_UNAVAILABLE = 0 // The requested event is not available (anymore).
mavlink20.MAV_EVENT_ERROR_REASON_ENUM_END = 1 // 

// MAV_EVENT_CURRENT_SEQUENCE_FLAGS
mavlink20.MAV_EVENT_CURRENT_SEQUENCE_FLAGS_RESET = 1 // A sequence reset has happened (e.g. vehicle reboot).
mavlink20.MAV_EVENT_CURRENT_SEQUENCE_FLAGS_ENUM_END = 2 // 

// HIL_SENSOR_UPDATED_FLAGS
mavlink20.HIL_SENSOR_UPDATED_XACC = 1 // The value in the xacc field has been updated
mavlink20.HIL_SENSOR_UPDATED_YACC = 2 // The value in the yacc field has been updated
mavlink20.HIL_SENSOR_UPDATED_ZACC = 4 // The value in the zacc field has been updated
mavlink20.HIL_SENSOR_UPDATED_XGYRO = 8 // The value in the xgyro field has been updated
mavlink20.HIL_SENSOR_UPDATED_YGYRO = 16 // The value in the ygyro field has been updated
mavlink20.HIL_SENSOR_UPDATED_ZGYRO = 32 // The value in the zgyro field has been updated
mavlink20.HIL_SENSOR_UPDATED_XMAG = 64 // The value in the xmag field has been updated
mavlink20.HIL_SENSOR_UPDATED_YMAG = 128 // The value in the ymag field has been updated
mavlink20.HIL_SENSOR_UPDATED_ZMAG = 256 // The value in the zmag field has been updated
mavlink20.HIL_SENSOR_UPDATED_ABS_PRESSURE = 512 // The value in the abs_pressure field has been updated
mavlink20.HIL_SENSOR_UPDATED_DIFF_PRESSURE = 1024 // The value in the diff_pressure field has been updated
mavlink20.HIL_SENSOR_UPDATED_PRESSURE_ALT = 2048 // The value in the pressure_alt field has been updated
mavlink20.HIL_SENSOR_UPDATED_TEMPERATURE = 4096 // The value in the temperature field has been updated
mavlink20.HIL_SENSOR_UPDATED_RESET = 2147483648 // Full reset of attitude/position/velocities/etc was performed in sim
                        // (Bit 31).
mavlink20.HIL_SENSOR_UPDATED_FLAGS_ENUM_END = 2147483649 // 

// HIGHRES_IMU_UPDATED_FLAGS
mavlink20.HIGHRES_IMU_UPDATED_XACC = 1 // The value in the xacc field has been updated
mavlink20.HIGHRES_IMU_UPDATED_YACC = 2 // The value in the yacc field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ZACC = 4 // The value in the zacc field has been updated since
mavlink20.HIGHRES_IMU_UPDATED_XGYRO = 8 // The value in the xgyro field has been updated
mavlink20.HIGHRES_IMU_UPDATED_YGYRO = 16 // The value in the ygyro field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ZGYRO = 32 // The value in the zgyro field has been updated
mavlink20.HIGHRES_IMU_UPDATED_XMAG = 64 // The value in the xmag field has been updated
mavlink20.HIGHRES_IMU_UPDATED_YMAG = 128 // The value in the ymag field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ZMAG = 256 // The value in the zmag field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ABS_PRESSURE = 512 // The value in the abs_pressure field has been updated
mavlink20.HIGHRES_IMU_UPDATED_DIFF_PRESSURE = 1024 // The value in the diff_pressure field has been updated
mavlink20.HIGHRES_IMU_UPDATED_PRESSURE_ALT = 2048 // The value in the pressure_alt field has been updated
mavlink20.HIGHRES_IMU_UPDATED_TEMPERATURE = 4096 // The value in the temperature field has been updated
mavlink20.HIGHRES_IMU_UPDATED_FLAGS_ENUM_END = 4097 // 

// CAN_FILTER_OP
mavlink20.CAN_FILTER_REPLACE = 0 // 
mavlink20.CAN_FILTER_ADD = 1 // 
mavlink20.CAN_FILTER_REMOVE = 2 // 
mavlink20.CAN_FILTER_OP_ENUM_END = 3 // 

// MAV_FTP_ERR
mavlink20.MAV_FTP_ERR_NONE = 0 // None: No error
mavlink20.MAV_FTP_ERR_FAIL = 1 // Fail: Unknown failure
mavlink20.MAV_FTP_ERR_FAILERRNO = 2 // FailErrno: Command failed, Err number sent back in
                        // PayloadHeader.data[1].                 This
                        // is a file-system error number understood by
                        // the server operating system.
mavlink20.MAV_FTP_ERR_INVALIDDATASIZE = 3 // InvalidDataSize: Payload size is invalid
mavlink20.MAV_FTP_ERR_INVALIDSESSION = 4 // InvalidSession: Session is not currently open
mavlink20.MAV_FTP_ERR_NOSESSIONSAVAILABLE = 5 // NoSessionsAvailable: All available sessions are already in use
mavlink20.MAV_FTP_ERR_EOF = 6 // EOF: Offset past end of file for ListDirectory and ReadFile commands
mavlink20.MAV_FTP_ERR_UNKNOWNCOMMAND = 7 // UnknownCommand: Unknown command / opcode
mavlink20.MAV_FTP_ERR_FILEEXISTS = 8 // FileExists: File/directory already exists
mavlink20.MAV_FTP_ERR_FILEPROTECTED = 9 // FileProtected: File/directory is write protected
mavlink20.MAV_FTP_ERR_FILENOTFOUND = 10 // FileNotFound: File/directory not found
mavlink20.MAV_FTP_ERR_ENUM_END = 11 // 

// MAV_FTP_OPCODE
mavlink20.MAV_FTP_OPCODE_NONE = 0 // None. Ignored, always ACKed
mavlink20.MAV_FTP_OPCODE_TERMINATESESSION = 1 // TerminateSession: Terminates open Read session
mavlink20.MAV_FTP_OPCODE_RESETSESSION = 2 // ResetSessions: Terminates all open read sessions
mavlink20.MAV_FTP_OPCODE_LISTDIRECTORY = 3 // ListDirectory. List files and directories in path from offset
mavlink20.MAV_FTP_OPCODE_OPENFILERO = 4 // OpenFileRO: Opens file at path for reading, returns session
mavlink20.MAV_FTP_OPCODE_READFILE = 5 // ReadFile: Reads size bytes from offset in session
mavlink20.MAV_FTP_OPCODE_CREATEFILE = 6 // CreateFile: Creates file at path for writing, returns session
mavlink20.MAV_FTP_OPCODE_WRITEFILE = 7 // WriteFile: Writes size bytes to offset in session
mavlink20.MAV_FTP_OPCODE_REMOVEFILE = 8 // RemoveFile: Remove file at path
mavlink20.MAV_FTP_OPCODE_CREATEDIRECTORY = 9 // CreateDirectory: Creates directory at path
mavlink20.MAV_FTP_OPCODE_REMOVEDIRECTORY = 10 // RemoveDirectory: Removes directory at path. The directory must be
                        // empty.
mavlink20.MAV_FTP_OPCODE_OPENFILEWO = 11 // OpenFileWO: Opens file at path for writing, returns session
mavlink20.MAV_FTP_OPCODE_TRUNCATEFILE = 12 // TruncateFile: Truncate file at path to offset length
mavlink20.MAV_FTP_OPCODE_RENAME = 13 // Rename: Rename path1 to path2
mavlink20.MAV_FTP_OPCODE_CALCFILECRC = 14 // CalcFileCRC32: Calculate CRC32 for file at path
mavlink20.MAV_FTP_OPCODE_BURSTREADFILE = 15 // BurstReadFile: Burst download session file
mavlink20.MAV_FTP_OPCODE_LISTDIRECTORYWITHTIME = 16 // ListDirectoryWithTime: List files and directories, along with last-
                        // modification timestamps, in path from
                        // offset. This is the same as ListDirectory
                        // except for the addition of timestamps.
                        // Servers that do not support this opcode
                        // respond with a NAK
                        // (MAV_FTP_ERR_UNKNOWNCOMMAND).
mavlink20.MAV_FTP_OPCODE_ACK = 128 // ACK: ACK response
mavlink20.MAV_FTP_OPCODE_NAK = 129 // NAK: NAK response
mavlink20.MAV_FTP_OPCODE_ENUM_END = 130 // 

// MISSION_STATE
mavlink20.MISSION_STATE_UNKNOWN = 0 // The mission status reporting is not supported.
mavlink20.MISSION_STATE_NO_MISSION = 1 // No mission on the vehicle.
mavlink20.MISSION_STATE_NOT_STARTED = 2 // Mission has not started. This is the case after a mission has uploaded
                        // but not yet started executing.
mavlink20.MISSION_STATE_ACTIVE = 3 // Mission is active, and will execute mission items when in auto mode.
mavlink20.MISSION_STATE_PAUSED = 4 // Mission is paused when in auto mode.
mavlink20.MISSION_STATE_COMPLETE = 5 // Mission has executed all mission items.
mavlink20.MISSION_STATE_ENUM_END = 6 // 

// SAFETY_SWITCH_STATE
mavlink20.SAFETY_SWITCH_STATE_SAFE = 0 // Safety switch is engaged and vehicle should be safe to approach.
mavlink20.SAFETY_SWITCH_STATE_DANGEROUS = 1 // Safety switch is NOT engaged and motors, propellers and other
                        // actuators should be considered active.
mavlink20.SAFETY_SWITCH_STATE_ENUM_END = 2 // 

// ILLUMINATOR_MODE
mavlink20.ILLUMINATOR_MODE_UNKNOWN = 0 // Illuminator mode is not specified/unknown
mavlink20.ILLUMINATOR_MODE_INTERNAL_CONTROL = 1 // Illuminator behavior is controlled by MAV_CMD_DO_ILLUMINATOR_CONFIGURE
                        // settings
mavlink20.ILLUMINATOR_MODE_EXTERNAL_SYNC = 2 // Illuminator behavior is controlled by external factors: e.g. an
                        // external hardware signal
mavlink20.ILLUMINATOR_MODE_ENUM_END = 3 // 

// ILLUMINATOR_ERROR_FLAGS
mavlink20.ILLUMINATOR_ERROR_FLAGS_THERMAL_THROTTLING = 1 // Illuminator thermal throttling error.
mavlink20.ILLUMINATOR_ERROR_FLAGS_OVER_TEMPERATURE_SHUTDOWN = 2 // Illuminator over temperature shutdown error.
mavlink20.ILLUMINATOR_ERROR_FLAGS_THERMISTOR_FAILURE = 4 // Illuminator thermistor failure.
mavlink20.ILLUMINATOR_ERROR_FLAGS_ENUM_END = 5 // 

// MAV_STANDARD_MODE
mavlink20.MAV_STANDARD_MODE_NON_STANDARD = 0 // Non standard mode.           This may be used when reporting the mode
                        // if the current flight mode is not a
                        // standard mode.
mavlink20.MAV_STANDARD_MODE_POSITION_HOLD = 1 // Position mode (manual).           Position-controlled and stabilized
                        // manual mode.           When sticks are
                        // released vehicles return to their level-
                        // flight orientation and hold both position
                        // and altitude against wind and external
                        // forces.           This mode can only be set
                        // by vehicles that can hold a fixed position.
                        // Multicopter (MC) vehicles actively brake
                        // and hold both position and altitude against
                        // wind and external forces.           Hybrid
                        // MC/FW ("VTOL") vehicles first transition to
                        // multicopter mode (if needed) but otherwise
                        // behave in the same way as MC vehicles.
                        // Fixed-wing (FW) vehicles must not support
                        // this mode.           Other vehicle types
                        // must not support this mode (this may be
                        // revisited through the PR process).
mavlink20.MAV_STANDARD_MODE_ORBIT = 2 // Orbit (manual).           Position-controlled and stabilized manual
                        // mode.           The vehicle circles around
                        // a fixed setpoint in the horizontal plane at
                        // a particular radius, altitude, and
                        // direction.           Flight stacks may
                        // further allow manual control over the
                        // setpoint position, radius, direction,
                        // speed, and/or altitude of the circle, but
                        // this is not mandated.           Flight
                        // stacks may support the [MAV_CMD_DO_ORBIT](h
                        // ttps://mavlink.io/en/messages/common.html#M
                        // AV_CMD_DO_ORBIT) for changing the orbit
                        // parameters.           MC and FW vehicles
                        // may support this mode.           Hybrid
                        // MC/FW ("VTOL") vehicles may support this
                        // mode in MC/FW or both modes; if the mode is
                        // not supported by the current configuration
                        // the vehicle should transition to the
                        // supported configuration.           Other
                        // vehicle types must not support this mode
                        // (this may be revisited through the PR
                        // process).
mavlink20.MAV_STANDARD_MODE_CRUISE = 3 // Cruise mode (manual).           Position-controlled and stabilized
                        // manual mode.           When sticks are
                        // released vehicles return to their level-
                        // flight orientation and hold their original
                        // track against wind and external forces.
                        // Fixed-wing (FW) vehicles level orientation
                        // and maintain current track and altitude
                        // against wind and external forces.
                        // Hybrid MC/FW ("VTOL") vehicles first
                        // transition to FW mode (if needed) but
                        // otherwise behave in the same way as MC
                        // vehicles.           Multicopter (MC)
                        // vehicles must not support this mode.
                        // Other vehicle types must not support this
                        // mode (this may be revisited through the PR
                        // process).
mavlink20.MAV_STANDARD_MODE_ALTITUDE_HOLD = 4 // Altitude hold (manual).           Altitude-controlled and stabilized
                        // manual mode.           When sticks are
                        // released vehicles return to their level-
                        // flight orientation and hold their altitude.
                        // MC vehicles continue with existing momentum
                        // and may move with wind (or other external
                        // forces).           FW vehicles continue
                        // with current heading, but may be moved off-
                        // track by wind.           Hybrid MC/FW
                        // ("VTOL") vehicles behave according to their
                        // current configuration/mode (FW or MC).
                        // Other vehicle types must not support this
                        // mode (this may be revisited through the PR
                        // process).
mavlink20.MAV_STANDARD_MODE_SAFE_RECOVERY = 5 // Safe recovery mode (auto).           Automatic mode that takes vehicle
                        // to a predefined safe location via a safe
                        // flight path, and may also automatically
                        // land the vehicle.           This mode is
                        // more commonly referred to as RTL and/or or
                        // Smart RTL.           The precise return
                        // location, flight path, and landing
                        // behaviour depend on vehicle configuration
                        // and type.           For example, the
                        // vehicle might return to the home/launch
                        // location, a rally point, or the start of a
                        // mission landing, it might follow a direct
                        // path, mission path, or breadcrumb path, and
                        // land using a mission landing pattern or
                        // some other kind of descent.
mavlink20.MAV_STANDARD_MODE_MISSION = 6 // Mission mode (automatic).           Automatic mode that executes
                        // MAVLink missions.           Missions are
                        // executed from the current waypoint as soon
                        // as the mode is enabled.
mavlink20.MAV_STANDARD_MODE_LAND = 7 // Land mode (auto).           Automatic mode that lands the vehicle at
                        // the current location.           The precise
                        // landing behaviour depends on vehicle
                        // configuration and type.
mavlink20.MAV_STANDARD_MODE_TAKEOFF = 8 // Takeoff mode (auto).           Automatic takeoff mode.           The
                        // precise takeoff behaviour depends on
                        // vehicle configuration and type.
mavlink20.MAV_STANDARD_MODE_ENUM_END = 9 // 

// MAV_MODE_PROPERTY
mavlink20.MAV_MODE_PROPERTY_ADVANCED = 1 // If set, this mode is an advanced mode.           For example a rate-
                        // controlled manual mode might be advanced,
                        // whereas a position-controlled manual mode
                        // is not.           A GCS can optionally use
                        // this flag to configure the UI for its
                        // intended users.
mavlink20.MAV_MODE_PROPERTY_NOT_USER_SELECTABLE = 2 // If set, this mode should not be added to the list of selectable modes.
                        // The mode might still be selected by the FC
                        // directly (for example as part of a
                        // failsafe).
mavlink20.MAV_MODE_PROPERTY_AUTO_MODE = 4 // If set, this mode is automatically controlled (it may use but does not
                        // require a manual controller).           If
                        // unset the mode is a assumed to require user
                        // input (be a manual mode).
mavlink20.MAV_MODE_PROPERTY_ENUM_END = 5 // 

// HIL_ACTUATOR_CONTROLS_FLAGS
mavlink20.HIL_ACTUATOR_CONTROLS_FLAGS_LOCKSTEP = 1 // Simulation is using lockstep
mavlink20.HIL_ACTUATOR_CONTROLS_FLAGS_ENUM_END = 2 // 

// COMPUTER_STATUS_FLAGS
mavlink20.COMPUTER_STATUS_FLAGS_UNDER_VOLTAGE = 1 // Indicates if the system is experiencing voltage outside of acceptable
                        // range.
mavlink20.COMPUTER_STATUS_FLAGS_CPU_THROTTLE = 2 // Indicates if CPU throttling is active.
mavlink20.COMPUTER_STATUS_FLAGS_THERMAL_THROTTLE = 4 // Indicates if thermal throttling is active.
mavlink20.COMPUTER_STATUS_FLAGS_DISK_FULL = 8 // Indicates if main disk is full.
mavlink20.COMPUTER_STATUS_FLAGS_ENUM_END = 9 // 

// AIRSPEED_SENSOR_FLAGS
mavlink20.AIRSPEED_SENSOR_UNHEALTHY = 1 // Airspeed sensor is unhealthy
mavlink20.AIRSPEED_SENSOR_USING = 2 // True if the data from this sensor is being actively used by the flight
                        // controller for guidance, navigation or
                        // control.
mavlink20.AIRSPEED_SENSOR_FLAGS_ENUM_END = 3 // 

// GLOBAL_POSITION_SRC
mavlink20.GLOBAL_POSITION_SRC_UNKNOWN = 0 // Source is unknown or not one of the listed types.
mavlink20.GLOBAL_POSITION_SRC_GNSS = 1 // Global Navigation Satellite System (e.g.: GPS, Galileo, Glonass,
                        // BeiDou).
mavlink20.GLOBAL_POSITION_SRC_VISION = 2 // Vision system (e.g.: map matching).
mavlink20.GLOBAL_POSITION_SRC_PSEUDOLITES = 3 // A pseudo-satellite system using transceiver beacons to perform GNSS-
                        // like positioning.
mavlink20.GLOBAL_POSITION_SRC_TERRAIN = 4 // Terrain referenced navigation.
mavlink20.GLOBAL_POSITION_SRC_MAGNETIC = 5 // Magnetic positioning.
mavlink20.GLOBAL_POSITION_SRC_ESTIMATOR = 6 // Estimated position based on various sensors (eg. a Kalman Filter).
mavlink20.GLOBAL_POSITION_SRC_LEO = 7 // Low Earth Orbit satellite-based positioning (e.g.: Starlink, Xona
                        // PULSAR).
mavlink20.GLOBAL_POSITION_SRC_ENUM_END = 8 // 

// GLOBAL_POSITION_FLAGS
mavlink20.GLOBAL_POSITION_UNHEALTHY = 1 // Unhealthy sensor/estimator.
mavlink20.GLOBAL_POSITION_PRIMARY = 2 // True if the data originates from or is consumed by the primary
                        // estimator.
mavlink20.GLOBAL_POSITION_FLAGS_ENUM_END = 3 // 

// MAV_BOOL
mavlink20.MAV_BOOL_FALSE = 0 // False.
mavlink20.MAV_BOOL_TRUE = 1 // True.
mavlink20.MAV_BOOL_ENUM_END = 2 // 

// MAV_PROTOCOL_CAPABILITY
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_FLOAT = 1 // Autopilot supports the MISSION_ITEM float message type.           Note
                        // that MISSION_ITEM is deprecated, and
                        // autopilots should use MISSION_ITEM_INT
                        // instead.
mavlink20.MAV_PROTOCOL_CAPABILITY_PARAM_FLOAT = 2 // Autopilot supports the new param float message type.
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_INT = 4 // Autopilot supports MISSION_ITEM_INT scaled integer message type.
                        // Note that this flag must always be set if
                        // missions are supported, because missions
                        // must always use MISSION_ITEM_INT (rather
                        // than MISSION_ITEM, which is deprecated).
mavlink20.MAV_PROTOCOL_CAPABILITY_COMMAND_INT = 8 // Autopilot supports COMMAND_INT scaled integer message type.
mavlink20.MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_BYTEWISE = 16 // Parameter protocol uses byte-wise encoding of parameter values into
                        // param_value (float) fields: https://mavlink
                        // .io/en/services/parameter.html#parameter-
                        // encoding.           Note that either this
                        // flag or
                        // MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_C_CAST
                        // should be set if the parameter protocol is
                        // supported.
mavlink20.MAV_PROTOCOL_CAPABILITY_FTP = 32 // Autopilot supports the File Transfer Protocol v1:
                        // https://mavlink.io/en/services/ftp.html.
mavlink20.MAV_PROTOCOL_CAPABILITY_SET_ATTITUDE_TARGET = 64 // Autopilot supports commanding attitude offboard.
mavlink20.MAV_PROTOCOL_CAPABILITY_SET_POSITION_TARGET_LOCAL_NED = 128 // Autopilot supports commanding position and velocity targets in local
                        // NED frame.
mavlink20.MAV_PROTOCOL_CAPABILITY_SET_POSITION_TARGET_GLOBAL_INT = 256 // Autopilot supports commanding position and velocity targets in global
                        // scaled integers.
mavlink20.MAV_PROTOCOL_CAPABILITY_TERRAIN = 512 // Autopilot supports terrain protocol / data handling.
mavlink20.MAV_PROTOCOL_CAPABILITY_RESERVED3 = 1024 // Reserved for future use.
mavlink20.MAV_PROTOCOL_CAPABILITY_FLIGHT_TERMINATION = 2048 // Autopilot supports the MAV_CMD_DO_FLIGHTTERMINATION command (flight
                        // termination).
mavlink20.MAV_PROTOCOL_CAPABILITY_COMPASS_CALIBRATION = 4096 // Autopilot supports onboard compass calibration.
mavlink20.MAV_PROTOCOL_CAPABILITY_MAVLINK2 = 8192 // Autopilot supports MAVLink version 2.
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_FENCE = 16384 // Autopilot supports mission fence protocol.
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_RALLY = 32768 // Autopilot supports mission rally point protocol.
mavlink20.MAV_PROTOCOL_CAPABILITY_RESERVED2 = 65536 // Reserved for future use.
mavlink20.MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_C_CAST = 131072 // Parameter protocol uses C-cast of parameter values to set the
                        // param_value (float) fields: https://mavlink
                        // .io/en/services/parameter.html#parameter-
                        // encoding.           Note that either this
                        // flag or MAV_PROTOCOL_CAPABILITY_PARAM_ENCOD
                        // E_BYTEWISE should be set if the parameter
                        // protocol is supported.
mavlink20.MAV_PROTOCOL_CAPABILITY_COMPONENT_IMPLEMENTS_GIMBAL_MANAGER = 262144 // This component implements/is a gimbal manager. This means the
                        // GIMBAL_MANAGER_INFORMATION, and other
                        // messages can be requested.
mavlink20.MAV_PROTOCOL_CAPABILITY_COMPONENT_ACCEPTS_GCS_CONTROL = 524288 // Component supports locking control to a particular GCS independent of
                        // its system (via
                        // MAV_CMD_REQUEST_OPERATOR_CONTROL).
mavlink20.MAV_PROTOCOL_CAPABILITY_GRIPPER = 1048576 // Autopilot has a connected gripper. MAVLink Grippers would set
                        // MAV_TYPE_GRIPPER instead.
mavlink20.MAV_PROTOCOL_CAPABILITY_ENUM_END = 1048577 // 

// FIRMWARE_VERSION_TYPE
mavlink20.FIRMWARE_VERSION_TYPE_DEV = 0 // development release
mavlink20.FIRMWARE_VERSION_TYPE_ALPHA = 64 // alpha release
mavlink20.FIRMWARE_VERSION_TYPE_BETA = 128 // beta release
mavlink20.FIRMWARE_VERSION_TYPE_RC = 192 // release candidate
mavlink20.FIRMWARE_VERSION_TYPE_OFFICIAL = 255 // official stable release
mavlink20.FIRMWARE_VERSION_TYPE_ENUM_END = 256 // 

// MAV_AUTOPILOT
mavlink20.MAV_AUTOPILOT_GENERIC = 0 // Generic autopilot, full support for everything
mavlink20.MAV_AUTOPILOT_RESERVED = 1 // Reserved for future use.
mavlink20.MAV_AUTOPILOT_SLUGS = 2 // SLUGS autopilot, http://slugsuav.soe.ucsc.edu
mavlink20.MAV_AUTOPILOT_ARDUPILOTMEGA = 3 // ArduPilot - Plane/Copter/Rover/Sub/Tracker, https://ardupilot.org
mavlink20.MAV_AUTOPILOT_OPENPILOT = 4 // OpenPilot, http://openpilot.org
mavlink20.MAV_AUTOPILOT_GENERIC_WAYPOINTS_ONLY = 5 // Generic autopilot only supporting simple waypoints
mavlink20.MAV_AUTOPILOT_GENERIC_WAYPOINTS_AND_SIMPLE_NAVIGATION_ONLY = 6 // Generic autopilot supporting waypoints and other simple navigation
                        // commands
mavlink20.MAV_AUTOPILOT_GENERIC_MISSION_FULL = 7 // Generic autopilot supporting the full mission command set
mavlink20.MAV_AUTOPILOT_INVALID = 8 // No valid autopilot, e.g. a GCS or other MAVLink component
mavlink20.MAV_AUTOPILOT_PPZ = 9 // PPZ UAV - http://nongnu.org/paparazzi
mavlink20.MAV_AUTOPILOT_UDB = 10 // UAV Dev Board
mavlink20.MAV_AUTOPILOT_FP = 11 // FlexiPilot
mavlink20.MAV_AUTOPILOT_PX4 = 12 // PX4 Autopilot - http://px4.io/
mavlink20.MAV_AUTOPILOT_SMACCMPILOT = 13 // SMACCMPilot - http://smaccmpilot.org
mavlink20.MAV_AUTOPILOT_AUTOQUAD = 14 // AutoQuad -- http://autoquad.org
mavlink20.MAV_AUTOPILOT_ARMAZILA = 15 // Armazila -- http://armazila.com
mavlink20.MAV_AUTOPILOT_AEROB = 16 // Aerob -- http://aerob.ru
mavlink20.MAV_AUTOPILOT_ASLUAV = 17 // ASLUAV autopilot -- http://www.asl.ethz.ch
mavlink20.MAV_AUTOPILOT_SMARTAP = 18 // SmartAP Autopilot - http://sky-drones.com
mavlink20.MAV_AUTOPILOT_AIRRAILS = 19 // AirRails - http://uaventure.com
mavlink20.MAV_AUTOPILOT_REFLEX = 20 // Fusion Reflex - https://fusion.engineering
mavlink20.MAV_AUTOPILOT_ENUM_END = 21 // 

// MAV_TYPE
mavlink20.MAV_TYPE_GENERIC = 0 // Generic micro air vehicle
mavlink20.MAV_TYPE_FIXED_WING = 1 // Fixed wing aircraft.
mavlink20.MAV_TYPE_QUADROTOR = 2 // Quadrotor
mavlink20.MAV_TYPE_COAXIAL = 3 // Coaxial helicopter
mavlink20.MAV_TYPE_HELICOPTER = 4 // Normal helicopter with tail rotor.
mavlink20.MAV_TYPE_ANTENNA_TRACKER = 5 // Ground installation
mavlink20.MAV_TYPE_GCS = 6 // Operator control unit / ground control station
mavlink20.MAV_TYPE_AIRSHIP = 7 // Airship, controlled
mavlink20.MAV_TYPE_FREE_BALLOON = 8 // Free balloon, uncontrolled
mavlink20.MAV_TYPE_ROCKET = 9 // Rocket
mavlink20.MAV_TYPE_GROUND_ROVER = 10 // Ground rover
mavlink20.MAV_TYPE_SURFACE_BOAT = 11 // Surface vessel, boat, ship
mavlink20.MAV_TYPE_SUBMARINE = 12 // Submarine
mavlink20.MAV_TYPE_HEXAROTOR = 13 // Hexarotor
mavlink20.MAV_TYPE_OCTOROTOR = 14 // Octorotor
mavlink20.MAV_TYPE_TRICOPTER = 15 // Tricopter
mavlink20.MAV_TYPE_FLAPPING_WING = 16 // Flapping wing
mavlink20.MAV_TYPE_KITE = 17 // Kite
mavlink20.MAV_TYPE_ONBOARD_CONTROLLER = 18 // Onboard companion controller
mavlink20.MAV_TYPE_VTOL_TAILSITTER_DUOROTOR = 19 // Two-rotor Tailsitter VTOL that additionally uses control surfaces in
                        // vertical operation. Note, value previously
                        // named MAV_TYPE_VTOL_DUOROTOR.
mavlink20.MAV_TYPE_VTOL_TAILSITTER_QUADROTOR = 20 // Quad-rotor Tailsitter VTOL using a V-shaped quad config in vertical
                        // operation. Note: value previously named
                        // MAV_TYPE_VTOL_QUADROTOR.
mavlink20.MAV_TYPE_VTOL_TILTROTOR = 21 // Tiltrotor VTOL. Fuselage and wings stay (nominally) horizontal in all
                        // flight phases. It able to tilt (some)
                        // rotors to provide thrust in cruise flight.
mavlink20.MAV_TYPE_VTOL_FIXEDROTOR = 22 // VTOL with separate fixed rotors for hover and cruise flight. Fuselage
                        // and wings stay (nominally) horizontal in
                        // all flight phases.
mavlink20.MAV_TYPE_VTOL_TAILSITTER = 23 // Tailsitter VTOL. Fuselage and wings orientation changes depending on
                        // flight phase: vertical for hover,
                        // horizontal for cruise. Use more specific
                        // VTOL MAV_TYPE_VTOL_TAILSITTER_DUOROTOR or
                        // MAV_TYPE_VTOL_TAILSITTER_QUADROTOR if
                        // appropriate.
mavlink20.MAV_TYPE_VTOL_TILTWING = 24 // Tiltwing VTOL. Fuselage stays horizontal in all flight phases. The
                        // whole wing, along with any attached engine,
                        // can tilt between vertical and horizontal
                        // mode.
mavlink20.MAV_TYPE_VTOL_RESERVED5 = 25 // VTOL reserved 5
mavlink20.MAV_TYPE_GIMBAL = 26 // Gimbal
mavlink20.MAV_TYPE_ADSB = 27 // ADSB system
mavlink20.MAV_TYPE_PARAFOIL = 28 // Steerable, nonrigid airfoil
mavlink20.MAV_TYPE_DODECAROTOR = 29 // Dodecarotor
mavlink20.MAV_TYPE_CAMERA = 30 // Camera
mavlink20.MAV_TYPE_CHARGING_STATION = 31 // Charging station
mavlink20.MAV_TYPE_FLARM = 32 // FLARM collision avoidance system
mavlink20.MAV_TYPE_SERVO = 33 // Servo
mavlink20.MAV_TYPE_ODID = 34 // Open Drone ID. See https://mavlink.io/en/services/opendroneid.html.
mavlink20.MAV_TYPE_DECAROTOR = 35 // Decarotor
mavlink20.MAV_TYPE_BATTERY = 36 // Battery
mavlink20.MAV_TYPE_PARACHUTE = 37 // Parachute
mavlink20.MAV_TYPE_LOG = 38 // Log
mavlink20.MAV_TYPE_OSD = 39 // OSD
mavlink20.MAV_TYPE_IMU = 40 // IMU
mavlink20.MAV_TYPE_GPS = 41 // GPS
mavlink20.MAV_TYPE_WINCH = 42 // Winch
mavlink20.MAV_TYPE_GENERIC_MULTIROTOR = 43 // Generic multirotor that does not fit into a specific type or whose
                        // type is unknown
mavlink20.MAV_TYPE_ILLUMINATOR = 44 // Illuminator. An illuminator is a light source that is used for
                        // lighting up dark areas external to the
                        // system: e.g. a torch or searchlight (as
                        // opposed to a light source for illuminating
                        // the system itself, e.g. an indicator
                        // light).
mavlink20.MAV_TYPE_SPACECRAFT_ORBITER = 45 // Orbiter spacecraft. Includes satellites orbiting terrestrial and
                        // extra-terrestrial bodies. Follows NASA
                        // Spacecraft Classification.
mavlink20.MAV_TYPE_GROUND_QUADRUPED = 46 // A generic four-legged ground vehicle (e.g., a robot dog).
mavlink20.MAV_TYPE_VTOL_GYRODYNE = 47 // VTOL hybrid of helicopter and autogyro. It has a main rotor for lift
                        // and separate propellers for forward flight.
                        // The rotor must be powered for hover but can
                        // autorotate in cruise flight. See:
                        // https://en.wikipedia.org/wiki/Gyrodyne
mavlink20.MAV_TYPE_GRIPPER = 48 // Gripper
mavlink20.MAV_TYPE_RADIO = 49 // Radio
mavlink20.MAV_TYPE_ENUM_END = 50 // 

// MAV_MODE_FLAG
mavlink20.MAV_MODE_FLAG_CUSTOM_MODE_ENABLED = 1 // 0b00000001 system-specific custom mode is enabled. When using this
                        // flag to enable a custom mode all other
                        // flags should be ignored.
mavlink20.MAV_MODE_FLAG_TEST_ENABLED = 2 // 0b00000010 system has a test mode enabled. This flag is intended for
                        // temporary system tests and should not be
                        // used for stable implementations.
mavlink20.MAV_MODE_FLAG_AUTO_ENABLED = 4 // 0b00000100 autonomous mode enabled, system finds its own goal
                        // positions. Guided flag can be set or not,
                        // depends on the actual implementation.
mavlink20.MAV_MODE_FLAG_GUIDED_ENABLED = 8 // 0b00001000 guided mode enabled, system flies waypoints / mission
                        // items.
mavlink20.MAV_MODE_FLAG_STABILIZE_ENABLED = 16 // 0b00010000 system stabilizes electronically its attitude (and
                        // optionally position). It needs however
                        // further control inputs to move around.
mavlink20.MAV_MODE_FLAG_HIL_ENABLED = 32 // 0b00100000 hardware in the loop simulation. All motors / actuators are
                        // blocked, but internal software is full
                        // operational.
mavlink20.MAV_MODE_FLAG_MANUAL_INPUT_ENABLED = 64 // 0b01000000 remote control input is enabled.
mavlink20.MAV_MODE_FLAG_SAFETY_ARMED = 128 // 0b10000000 MAV safety set to armed. Motors are enabled / running / can
                        // start. Ready to fly. Additional note: this
                        // flag is to be ignore when sent in the
                        // command MAV_CMD_DO_SET_MODE and
                        // MAV_CMD_COMPONENT_ARM_DISARM shall be used
                        // instead. The flag can still be used to
                        // report the armed state.
mavlink20.MAV_MODE_FLAG_ENUM_END = 129 // 

// MAV_MODE_FLAG_DECODE_POSITION
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_CUSTOM_MODE = 1 // Eighth bit: 00000001
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_TEST = 2 // Seventh bit: 00000010
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_AUTO = 4 // Sixth bit:   00000100
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_GUIDED = 8 // Fifth bit:  00001000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_STABILIZE = 16 // Fourth bit: 00010000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_HIL = 32 // Third bit:  00100000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_MANUAL = 64 // Second bit: 01000000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_SAFETY = 128 // First bit:  10000000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_ENUM_END = 129 // 

// MAV_STATE
mavlink20.MAV_STATE_UNINIT = 0 // Uninitialized system, state is unknown.
mavlink20.MAV_STATE_BOOT = 1 // System is booting up.
mavlink20.MAV_STATE_CALIBRATING = 2 // System is calibrating and not flight-ready.
mavlink20.MAV_STATE_STANDBY = 3 // System is grounded and on standby. It can be launched any time.
mavlink20.MAV_STATE_ACTIVE = 4 // System is active and might be already airborne. Motors are engaged.
mavlink20.MAV_STATE_CRITICAL = 5 // System is in a non-normal flight mode (failsafe). It can however still
                        // navigate.
mavlink20.MAV_STATE_EMERGENCY = 6 // System is in a non-normal flight mode (failsafe). It lost control over
                        // parts or over the whole airframe. It is in
                        // mayday and going down.
mavlink20.MAV_STATE_POWEROFF = 7 // System just initialized its power-down sequence, will shut down now.
mavlink20.MAV_STATE_FLIGHT_TERMINATION = 8 // System is terminating itself (failsafe or commanded).
mavlink20.MAV_STATE_ENUM_END = 9 // 

// MAV_COMPONENT
mavlink20.MAV_COMP_ID_ALL = 0 // Target id (target_component) used to broadcast messages to all
                        // components of the receiving system.
                        // Components should attempt to process
                        // messages with this component ID and forward
                        // to components on any other interfaces.
                        // Note: This is not a valid *source*
                        // component id for a message.
mavlink20.MAV_COMP_ID_AUTOPILOT1 = 1 // System flight controller component ("autopilot"). Only one autopilot
                        // is expected in a particular system.
mavlink20.MAV_COMP_ID_USER1 = 25 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER2 = 26 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER3 = 27 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER4 = 28 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER5 = 29 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER6 = 30 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER7 = 31 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER8 = 32 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER9 = 33 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER10 = 34 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER11 = 35 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER12 = 36 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER13 = 37 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER14 = 38 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER15 = 39 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER16 = 40 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER17 = 41 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER18 = 42 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER19 = 43 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER20 = 44 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER21 = 45 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER22 = 46 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER23 = 47 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER24 = 48 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER25 = 49 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER26 = 50 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER27 = 51 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER28 = 52 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER29 = 53 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER30 = 54 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER31 = 55 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER32 = 56 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER33 = 57 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER34 = 58 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER35 = 59 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER36 = 60 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER37 = 61 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER38 = 62 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER39 = 63 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER40 = 64 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER41 = 65 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER42 = 66 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER43 = 67 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_TELEMETRY_RADIO = 68 // Telemetry radio (e.g. SiK radio, or other component that emits
                        // RADIO_STATUS messages).
mavlink20.MAV_COMP_ID_USER45 = 69 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER46 = 70 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER47 = 71 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER48 = 72 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER49 = 73 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER50 = 74 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER51 = 75 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER52 = 76 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER53 = 77 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER54 = 78 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER55 = 79 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER56 = 80 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER57 = 81 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER58 = 82 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER59 = 83 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER60 = 84 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER61 = 85 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER62 = 86 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER63 = 87 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER64 = 88 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER65 = 89 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER66 = 90 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER67 = 91 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER68 = 92 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER69 = 93 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER70 = 94 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER71 = 95 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER72 = 96 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER73 = 97 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER74 = 98 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER75 = 99 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_CAMERA = 100 // Camera #1.
mavlink20.MAV_COMP_ID_CAMERA2 = 101 // Camera #2.
mavlink20.MAV_COMP_ID_CAMERA3 = 102 // Camera #3.
mavlink20.MAV_COMP_ID_CAMERA4 = 103 // Camera #4.
mavlink20.MAV_COMP_ID_CAMERA5 = 104 // Camera #5.
mavlink20.MAV_COMP_ID_CAMERA6 = 105 // Camera #6.
mavlink20.MAV_COMP_ID_RADIO = 110 // Radio #1.
mavlink20.MAV_COMP_ID_RADIO2 = 111 // Radio #2.
mavlink20.MAV_COMP_ID_RADIO3 = 112 // Radio #3.
mavlink20.MAV_COMP_ID_SERVO1 = 140 // Servo #1.
mavlink20.MAV_COMP_ID_SERVO2 = 141 // Servo #2.
mavlink20.MAV_COMP_ID_SERVO3 = 142 // Servo #3.
mavlink20.MAV_COMP_ID_SERVO4 = 143 // Servo #4.
mavlink20.MAV_COMP_ID_SERVO5 = 144 // Servo #5.
mavlink20.MAV_COMP_ID_SERVO6 = 145 // Servo #6.
mavlink20.MAV_COMP_ID_SERVO7 = 146 // Servo #7.
mavlink20.MAV_COMP_ID_SERVO8 = 147 // Servo #8.
mavlink20.MAV_COMP_ID_SERVO9 = 148 // Servo #9.
mavlink20.MAV_COMP_ID_SERVO10 = 149 // Servo #10.
mavlink20.MAV_COMP_ID_SERVO11 = 150 // Servo #11.
mavlink20.MAV_COMP_ID_SERVO12 = 151 // Servo #12.
mavlink20.MAV_COMP_ID_SERVO13 = 152 // Servo #13.
mavlink20.MAV_COMP_ID_SERVO14 = 153 // Servo #14.
mavlink20.MAV_COMP_ID_GIMBAL = 154 // Gimbal #1.
mavlink20.MAV_COMP_ID_LOG = 155 // Logging component.
mavlink20.MAV_COMP_ID_ADSB = 156 // Automatic Dependent Surveillance-Broadcast (ADS-B) component.
mavlink20.MAV_COMP_ID_OSD = 157 // On Screen Display (OSD) devices for video links.
mavlink20.MAV_COMP_ID_PERIPHERAL = 158 // Generic autopilot peripheral component ID. Meant for devices that do
                        // not implement the parameter microservice.
mavlink20.MAV_COMP_ID_QX1_GIMBAL = 159 // Gimbal ID for QX1.
mavlink20.MAV_COMP_ID_FLARM = 160 // FLARM collision alert component.
mavlink20.MAV_COMP_ID_PARACHUTE = 161 // Parachute component.
mavlink20.MAV_COMP_ID_WINCH = 169 // Winch component.
mavlink20.MAV_COMP_ID_GIMBAL2 = 171 // Gimbal #2.
mavlink20.MAV_COMP_ID_GIMBAL3 = 172 // Gimbal #3.
mavlink20.MAV_COMP_ID_GIMBAL4 = 173 // Gimbal #4
mavlink20.MAV_COMP_ID_GIMBAL5 = 174 // Gimbal #5.
mavlink20.MAV_COMP_ID_GIMBAL6 = 175 // Gimbal #6.
mavlink20.MAV_COMP_ID_BATTERY = 180 // Battery #1.
mavlink20.MAV_COMP_ID_BATTERY2 = 181 // Battery #2.
mavlink20.MAV_COMP_ID_MAVCAN = 189 // CAN over MAVLink client.
mavlink20.MAV_COMP_ID_MISSIONPLANNER = 190 // Component that can generate/supply a mission flight plan (e.g. GCS or
                        // developer API).
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER = 191 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER2 = 192 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER3 = 193 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER4 = 194 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_PATHPLANNER = 195 // Component that finds an optimal path between points based on a certain
                        // constraint (e.g. minimum snap, shortest
                        // path, cost, etc.).
mavlink20.MAV_COMP_ID_OBSTACLE_AVOIDANCE = 196 // Component that plans a collision free path between two points.
mavlink20.MAV_COMP_ID_VISUAL_INERTIAL_ODOMETRY = 197 // Component that provides position estimates using VIO techniques.
mavlink20.MAV_COMP_ID_PAIRING_MANAGER = 198 // Component that manages pairing of vehicle and GCS.
mavlink20.MAV_COMP_ID_IMU = 200 // Inertial Measurement Unit (IMU) #1.
mavlink20.MAV_COMP_ID_IMU_2 = 201 // Inertial Measurement Unit (IMU) #2.
mavlink20.MAV_COMP_ID_IMU_3 = 202 // Inertial Measurement Unit (IMU) #3.
mavlink20.MAV_COMP_ID_GPS = 220 // GPS #1.
mavlink20.MAV_COMP_ID_GPS2 = 221 // GPS #2.
mavlink20.MAV_COMP_ID_ODID_TXRX_1 = 236 // Open Drone ID transmitter/receiver (Bluetooth/WiFi/Internet).
mavlink20.MAV_COMP_ID_ODID_TXRX_2 = 237 // Open Drone ID transmitter/receiver (Bluetooth/WiFi/Internet).
mavlink20.MAV_COMP_ID_ODID_TXRX_3 = 238 // Open Drone ID transmitter/receiver (Bluetooth/WiFi/Internet).
mavlink20.MAV_COMP_ID_UDP_BRIDGE = 240 // Component to bridge MAVLink to UDP (i.e. from a UART).
mavlink20.MAV_COMP_ID_UART_BRIDGE = 241 // Component to bridge to UART (i.e. from UDP).
mavlink20.MAV_COMP_ID_TUNNEL_NODE = 242 // Component handling TUNNEL messages (e.g. vendor specific GUI of a
                        // component).
mavlink20.MAV_COMP_ID_ILLUMINATOR = 243 // Illuminator
mavlink20.MAV_COMP_ID_SYSTEM_CONTROL = 250 // Deprecated, don't use. Component for handling system messages (e.g. to
                        // ARM, takeoff, etc.).
mavlink20.MAV_COMPONENT_ENUM_END = 251 // 

// message IDs
mavlink20.MAVLINK_MSG_ID_BAD_DATA = -1
mavlink20.MAVLINK_MSG_ID_SYS_STATUS = 1
mavlink20.MAVLINK_MSG_ID_SYSTEM_TIME = 2
mavlink20.MAVLINK_MSG_ID_PING = 4
mavlink20.MAVLINK_MSG_ID_CHANGE_OPERATOR_CONTROL = 5
mavlink20.MAVLINK_MSG_ID_CHANGE_OPERATOR_CONTROL_ACK = 6
mavlink20.MAVLINK_MSG_ID_AUTH_KEY = 7
mavlink20.MAVLINK_MSG_ID_LINK_NODE_STATUS = 8
mavlink20.MAVLINK_MSG_ID_SET_MODE = 11
mavlink20.MAVLINK_MSG_ID_PARAM_REQUEST_READ = 20
mavlink20.MAVLINK_MSG_ID_PARAM_REQUEST_LIST = 21
mavlink20.MAVLINK_MSG_ID_PARAM_VALUE = 22
mavlink20.MAVLINK_MSG_ID_PARAM_SET = 23
mavlink20.MAVLINK_MSG_ID_GPS_RAW_INT = 24
mavlink20.MAVLINK_MSG_ID_GPS_STATUS = 25
mavlink20.MAVLINK_MSG_ID_SCALED_IMU = 26
mavlink20.MAVLINK_MSG_ID_RAW_IMU = 27
mavlink20.MAVLINK_MSG_ID_RAW_PRESSURE = 28
mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE = 29
mavlink20.MAVLINK_MSG_ID_ATTITUDE = 30
mavlink20.MAVLINK_MSG_ID_ATTITUDE_QUATERNION = 31
mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED = 32
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_SCALED = 34
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_RAW = 35
mavlink20.MAVLINK_MSG_ID_SERVO_OUTPUT_RAW = 36
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_PARTIAL_LIST = 37
mavlink20.MAVLINK_MSG_ID_MISSION_WRITE_PARTIAL_LIST = 38
mavlink20.MAVLINK_MSG_ID_MISSION_ITEM = 39
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST = 40
mavlink20.MAVLINK_MSG_ID_MISSION_SET_CURRENT = 41
mavlink20.MAVLINK_MSG_ID_MISSION_CURRENT = 42
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_LIST = 43
mavlink20.MAVLINK_MSG_ID_MISSION_COUNT = 44
mavlink20.MAVLINK_MSG_ID_MISSION_CLEAR_ALL = 45
mavlink20.MAVLINK_MSG_ID_MISSION_ITEM_REACHED = 46
mavlink20.MAVLINK_MSG_ID_MISSION_ACK = 47
mavlink20.MAVLINK_MSG_ID_SET_GPS_GLOBAL_ORIGIN = 48
mavlink20.MAVLINK_MSG_ID_GPS_GLOBAL_ORIGIN = 49
mavlink20.MAVLINK_MSG_ID_PARAM_MAP_RC = 50
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_INT = 51
mavlink20.MAVLINK_MSG_ID_SAFETY_SET_ALLOWED_AREA = 54
mavlink20.MAVLINK_MSG_ID_SAFETY_ALLOWED_AREA = 55
mavlink20.MAVLINK_MSG_ID_ATTITUDE_QUATERNION_COV = 61
mavlink20.MAVLINK_MSG_ID_NAV_CONTROLLER_OUTPUT = 62
mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_INT_COV = 63
mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED_COV = 64
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS = 65
mavlink20.MAVLINK_MSG_ID_REQUEST_DATA_STREAM = 66
mavlink20.MAVLINK_MSG_ID_DATA_STREAM = 67
mavlink20.MAVLINK_MSG_ID_MANUAL_CONTROL = 69
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_OVERRIDE = 70
mavlink20.MAVLINK_MSG_ID_MISSION_ITEM_INT = 73
mavlink20.MAVLINK_MSG_ID_VFR_HUD = 74
mavlink20.MAVLINK_MSG_ID_COMMAND_INT = 75
mavlink20.MAVLINK_MSG_ID_COMMAND_LONG = 76
mavlink20.MAVLINK_MSG_ID_COMMAND_ACK = 77
mavlink20.MAVLINK_MSG_ID_COMMAND_CANCEL = 80
mavlink20.MAVLINK_MSG_ID_MANUAL_SETPOINT = 81
mavlink20.MAVLINK_MSG_ID_SET_ATTITUDE_TARGET = 82
mavlink20.MAVLINK_MSG_ID_ATTITUDE_TARGET = 83
mavlink20.MAVLINK_MSG_ID_SET_POSITION_TARGET_LOCAL_NED = 84
mavlink20.MAVLINK_MSG_ID_POSITION_TARGET_LOCAL_NED = 85
mavlink20.MAVLINK_MSG_ID_SET_POSITION_TARGET_GLOBAL_INT = 86
mavlink20.MAVLINK_MSG_ID_POSITION_TARGET_GLOBAL_INT = 87
mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED_SYSTEM_GLOBAL_OFFSET = 89
mavlink20.MAVLINK_MSG_ID_HIL_STATE = 90
mavlink20.MAVLINK_MSG_ID_HIL_CONTROLS = 91
mavlink20.MAVLINK_MSG_ID_HIL_RC_INPUTS_RAW = 92
mavlink20.MAVLINK_MSG_ID_HIL_ACTUATOR_CONTROLS = 93
mavlink20.MAVLINK_MSG_ID_OPTICAL_FLOW = 100
mavlink20.MAVLINK_MSG_ID_GLOBAL_VISION_POSITION_ESTIMATE = 101
mavlink20.MAVLINK_MSG_ID_VISION_POSITION_ESTIMATE = 102
mavlink20.MAVLINK_MSG_ID_VISION_SPEED_ESTIMATE = 103
mavlink20.MAVLINK_MSG_ID_VICON_POSITION_ESTIMATE = 104
mavlink20.MAVLINK_MSG_ID_HIGHRES_IMU = 105
mavlink20.MAVLINK_MSG_ID_OPTICAL_FLOW_RAD = 106
mavlink20.MAVLINK_MSG_ID_HIL_SENSOR = 107
mavlink20.MAVLINK_MSG_ID_SIM_STATE = 108
mavlink20.MAVLINK_MSG_ID_RADIO_STATUS = 109
mavlink20.MAVLINK_MSG_ID_FILE_TRANSFER_PROTOCOL = 110
mavlink20.MAVLINK_MSG_ID_TIMESYNC = 111
mavlink20.MAVLINK_MSG_ID_CAMERA_TRIGGER = 112
mavlink20.MAVLINK_MSG_ID_HIL_GPS = 113
mavlink20.MAVLINK_MSG_ID_HIL_OPTICAL_FLOW = 114
mavlink20.MAVLINK_MSG_ID_HIL_STATE_QUATERNION = 115
mavlink20.MAVLINK_MSG_ID_SCALED_IMU2 = 116
mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_LIST = 117
mavlink20.MAVLINK_MSG_ID_LOG_ENTRY = 118
mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_DATA = 119
mavlink20.MAVLINK_MSG_ID_LOG_DATA = 120
mavlink20.MAVLINK_MSG_ID_LOG_ERASE = 121
mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_END = 122
mavlink20.MAVLINK_MSG_ID_GPS_INJECT_DATA = 123
mavlink20.MAVLINK_MSG_ID_GPS2_RAW = 124
mavlink20.MAVLINK_MSG_ID_POWER_STATUS = 125
mavlink20.MAVLINK_MSG_ID_SERIAL_CONTROL = 126
mavlink20.MAVLINK_MSG_ID_GPS_RTK = 127
mavlink20.MAVLINK_MSG_ID_GPS2_RTK = 128
mavlink20.MAVLINK_MSG_ID_SCALED_IMU3 = 129
mavlink20.MAVLINK_MSG_ID_DATA_TRANSMISSION_HANDSHAKE = 130
mavlink20.MAVLINK_MSG_ID_ENCAPSULATED_DATA = 131
mavlink20.MAVLINK_MSG_ID_DISTANCE_SENSOR = 132
mavlink20.MAVLINK_MSG_ID_TERRAIN_REQUEST = 133
mavlink20.MAVLINK_MSG_ID_TERRAIN_DATA = 134
mavlink20.MAVLINK_MSG_ID_TERRAIN_CHECK = 135
mavlink20.MAVLINK_MSG_ID_TERRAIN_REPORT = 136
mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE2 = 137
mavlink20.MAVLINK_MSG_ID_ATT_POS_MOCAP = 138
mavlink20.MAVLINK_MSG_ID_SET_ACTUATOR_CONTROL_TARGET = 139
mavlink20.MAVLINK_MSG_ID_ACTUATOR_CONTROL_TARGET = 140
mavlink20.MAVLINK_MSG_ID_ALTITUDE = 141
mavlink20.MAVLINK_MSG_ID_RESOURCE_REQUEST = 142
mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE3 = 143
mavlink20.MAVLINK_MSG_ID_FOLLOW_TARGET = 144
mavlink20.MAVLINK_MSG_ID_CONTROL_SYSTEM_STATE = 146
mavlink20.MAVLINK_MSG_ID_BATTERY_STATUS = 147
mavlink20.MAVLINK_MSG_ID_LANDING_TARGET = 149
mavlink20.MAVLINK_MSG_ID_FENCE_STATUS = 162
mavlink20.MAVLINK_MSG_ID_MAG_CAL_PROGRESS = 191
mavlink20.MAVLINK_MSG_ID_MAG_CAL_REPORT = 192
mavlink20.MAVLINK_MSG_ID_EFI_STATUS = 225
mavlink20.MAVLINK_MSG_ID_ESTIMATOR_STATUS = 230
mavlink20.MAVLINK_MSG_ID_WIND_COV = 231
mavlink20.MAVLINK_MSG_ID_GPS_INPUT = 232
mavlink20.MAVLINK_MSG_ID_GPS_RTCM_DATA = 233
mavlink20.MAVLINK_MSG_ID_HIGH_LATENCY = 234
mavlink20.MAVLINK_MSG_ID_HIGH_LATENCY2 = 235
mavlink20.MAVLINK_MSG_ID_VIBRATION = 241
mavlink20.MAVLINK_MSG_ID_HOME_POSITION = 242
mavlink20.MAVLINK_MSG_ID_SET_HOME_POSITION = 243
mavlink20.MAVLINK_MSG_ID_MESSAGE_INTERVAL = 244
mavlink20.MAVLINK_MSG_ID_EXTENDED_SYS_STATE = 245
mavlink20.MAVLINK_MSG_ID_ADSB_VEHICLE = 246
mavlink20.MAVLINK_MSG_ID_COLLISION = 247
mavlink20.MAVLINK_MSG_ID_V2_EXTENSION = 248
mavlink20.MAVLINK_MSG_ID_MEMORY_VECT = 249
mavlink20.MAVLINK_MSG_ID_DEBUG_VECT = 250
mavlink20.MAVLINK_MSG_ID_NAMED_VALUE_FLOAT = 251
mavlink20.MAVLINK_MSG_ID_NAMED_VALUE_INT = 252
mavlink20.MAVLINK_MSG_ID_STATUSTEXT = 253
mavlink20.MAVLINK_MSG_ID_DEBUG = 254
mavlink20.MAVLINK_MSG_ID_SETUP_SIGNING = 256
mavlink20.MAVLINK_MSG_ID_BUTTON_CHANGE = 257
mavlink20.MAVLINK_MSG_ID_PLAY_TUNE = 258
mavlink20.MAVLINK_MSG_ID_CAMERA_INFORMATION = 259
mavlink20.MAVLINK_MSG_ID_CAMERA_SETTINGS = 260
mavlink20.MAVLINK_MSG_ID_STORAGE_INFORMATION = 261
mavlink20.MAVLINK_MSG_ID_CAMERA_CAPTURE_STATUS = 262
mavlink20.MAVLINK_MSG_ID_CAMERA_IMAGE_CAPTURED = 263
mavlink20.MAVLINK_MSG_ID_FLIGHT_INFORMATION = 264
mavlink20.MAVLINK_MSG_ID_MOUNT_ORIENTATION = 265
mavlink20.MAVLINK_MSG_ID_LOGGING_DATA = 266
mavlink20.MAVLINK_MSG_ID_LOGGING_DATA_ACKED = 267
mavlink20.MAVLINK_MSG_ID_LOGGING_ACK = 268
mavlink20.MAVLINK_MSG_ID_VIDEO_STREAM_INFORMATION = 269
mavlink20.MAVLINK_MSG_ID_VIDEO_STREAM_STATUS = 270
mavlink20.MAVLINK_MSG_ID_CAMERA_FOV_STATUS = 271
mavlink20.MAVLINK_MSG_ID_CAMERA_TRACKING_IMAGE_STATUS = 275
mavlink20.MAVLINK_MSG_ID_CAMERA_TRACKING_GEO_STATUS = 276
mavlink20.MAVLINK_MSG_ID_CAMERA_THERMAL_RANGE = 277
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_INFORMATION = 280
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_STATUS = 281
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_ATTITUDE = 282
mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_INFORMATION = 283
mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_SET_ATTITUDE = 284
mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_ATTITUDE_STATUS = 285
mavlink20.MAVLINK_MSG_ID_AUTOPILOT_STATE_FOR_GIMBAL_DEVICE = 286
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_PITCHYAW = 287
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_MANUAL_CONTROL = 288
mavlink20.MAVLINK_MSG_ID_ESC_INFO = 290
mavlink20.MAVLINK_MSG_ID_ESC_STATUS = 291
mavlink20.MAVLINK_MSG_ID_AIRSPEED = 295
mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_SENSOR = 296
mavlink20.MAVLINK_MSG_ID_WIFI_CONFIG_AP = 299
mavlink20.MAVLINK_MSG_ID_PROTOCOL_VERSION = 300
mavlink20.MAVLINK_MSG_ID_AIS_VESSEL = 301
mavlink20.MAVLINK_MSG_ID_UAVCAN_NODE_STATUS = 310
mavlink20.MAVLINK_MSG_ID_UAVCAN_NODE_INFO = 311
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_REQUEST_READ = 320
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_REQUEST_LIST = 321
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_VALUE = 322
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_SET = 323
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_ACK = 324
mavlink20.MAVLINK_MSG_ID_OBSTACLE_DISTANCE = 330
mavlink20.MAVLINK_MSG_ID_ODOMETRY = 331
mavlink20.MAVLINK_MSG_ID_TRAJECTORY_REPRESENTATION_WAYPOINTS = 332
mavlink20.MAVLINK_MSG_ID_TRAJECTORY_REPRESENTATION_BEZIER = 333
mavlink20.MAVLINK_MSG_ID_CELLULAR_STATUS = 334
mavlink20.MAVLINK_MSG_ID_ISBD_LINK_STATUS = 335
mavlink20.MAVLINK_MSG_ID_CELLULAR_CONFIG = 336
mavlink20.MAVLINK_MSG_ID_RAW_RPM = 339
mavlink20.MAVLINK_MSG_ID_UTM_GLOBAL_POSITION = 340
mavlink20.MAVLINK_MSG_ID_PARAM_ERROR = 345
mavlink20.MAVLINK_MSG_ID_DEBUG_FLOAT_ARRAY = 350
mavlink20.MAVLINK_MSG_ID_ORBIT_EXECUTION_STATUS = 360
mavlink20.MAVLINK_MSG_ID_SMART_BATTERY_INFO = 370
mavlink20.MAVLINK_MSG_ID_FIGURE_EIGHT_EXECUTION_STATUS = 361
mavlink20.MAVLINK_MSG_ID_FUEL_STATUS = 371
mavlink20.MAVLINK_MSG_ID_BATTERY_INFO = 372
mavlink20.MAVLINK_MSG_ID_GENERATOR_STATUS = 373
mavlink20.MAVLINK_MSG_ID_ACTUATOR_OUTPUT_STATUS = 375
mavlink20.MAVLINK_MSG_ID_RELAY_STATUS = 376
mavlink20.MAVLINK_MSG_ID_TIME_ESTIMATE_TO_TARGET = 380
mavlink20.MAVLINK_MSG_ID_TUNNEL = 385
mavlink20.MAVLINK_MSG_ID_CAN_FRAME = 386
mavlink20.MAVLINK_MSG_ID_CANFD_FRAME = 387
mavlink20.MAVLINK_MSG_ID_CAN_FILTER_MODIFY = 388
mavlink20.MAVLINK_MSG_ID_ONBOARD_COMPUTER_STATUS = 390
mavlink20.MAVLINK_MSG_ID_COMPONENT_INFORMATION = 395
mavlink20.MAVLINK_MSG_ID_COMPONENT_INFORMATION_BASIC = 396
mavlink20.MAVLINK_MSG_ID_COMPONENT_METADATA = 397
mavlink20.MAVLINK_MSG_ID_PLAY_TUNE_V2 = 400
mavlink20.MAVLINK_MSG_ID_SUPPORTED_TUNES = 401
mavlink20.MAVLINK_MSG_ID_EVENT = 410
mavlink20.MAVLINK_MSG_ID_CURRENT_EVENT_SEQUENCE = 411
mavlink20.MAVLINK_MSG_ID_REQUEST_EVENT = 412
mavlink20.MAVLINK_MSG_ID_RESPONSE_EVENT_ERROR = 413
mavlink20.MAVLINK_MSG_ID_AVAILABLE_MODES = 435
mavlink20.MAVLINK_MSG_ID_CURRENT_MODE = 436
mavlink20.MAVLINK_MSG_ID_AVAILABLE_MODES_MONITOR = 437
mavlink20.MAVLINK_MSG_ID_ILLUMINATOR_STATUS = 440
mavlink20.MAVLINK_MSG_ID_WHEEL_DISTANCE = 9000
mavlink20.MAVLINK_MSG_ID_WINCH_STATUS = 9005
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_BASIC_ID = 12900
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_LOCATION = 12901
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_AUTHENTICATION = 12902
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SELF_ID = 12903
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SYSTEM = 12904
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_OPERATOR_ID = 12905
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_MESSAGE_PACK = 12915
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_ARM_STATUS = 12918
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SYSTEM_UPDATE = 12919
mavlink20.MAVLINK_MSG_ID_HYGROMETER_SENSOR = 12920
mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_INT = 33
mavlink20.MAVLINK_MSG_ID_AUTOPILOT_VERSION = 148
mavlink20.MAVLINK_MSG_ID_HEARTBEAT = 0
mavlink20.messages = {};


/* 
Sensor and subsystem status information. Provides a compact
representation of sensor/subsystem status and a few other basic
statistics.

                onboard_control_sensors_present        : Bitmap showing which onboard controllers and sensors are present. Value of 0: not present. Value of 1: present. (uint32_t)
                onboard_control_sensors_enabled        : Bitmap showing which onboard controllers and sensors are enabled:  Value of 0: not enabled. Value of 1: enabled. (uint32_t)
                onboard_control_sensors_health        : Bitmap showing which onboard controllers and sensors have an error (or are operational). Value of 0: error. Value of 1: healthy. (uint32_t)
                load                      : Maximum usage in percent of the mainloop time. Values: [0-1000] - should always be below 1000 (uint16_t)
                voltage_battery           : Battery voltage, UINT16_MAX: Voltage not sent by autopilot (uint16_t)
                current_battery           : Battery current, -1: Current not sent by autopilot (int16_t)
                battery_remaining         : Battery energy remaining, -1: Battery remaining energy not sent by autopilot (int8_t)
                drop_rate_comm            : Communication drop rate, (UART, I2C, SPI, CAN), dropped packets on all links (packets that were corrupted on reception on the MAV) (uint16_t)
                errors_comm               : Communication errors (UART, I2C, SPI, CAN), dropped packets on all links (packets that were corrupted on reception on the MAV) (uint16_t)
                errors_count1             : Autopilot-specific errors (uint16_t)
                errors_count2             : Autopilot-specific errors (uint16_t)
                errors_count3             : Autopilot-specific errors (uint16_t)
                errors_count4             : Autopilot-specific errors (uint16_t)
                onboard_control_sensors_present_extended        : Bitmap showing which onboard controllers and sensors are present. Value of 0: not present. Value of 1: present. (uint32_t)
                onboard_control_sensors_enabled_extended        : Bitmap showing which onboard controllers and sensors are enabled:  Value of 0: not enabled. Value of 1: enabled. (uint32_t)
                onboard_control_sensors_health_extended        : Bitmap showing which onboard controllers and sensors have an error (or are operational). Value of 0: error. Value of 1: healthy. (uint32_t)

*/
    mavlink20.messages.sys_status = function( ...moreargs ) {
    [ this.onboard_control_sensors_present , this.onboard_control_sensors_enabled , this.onboard_control_sensors_health , this.load , this.voltage_battery , this.current_battery , this.battery_remaining , this.drop_rate_comm , this.errors_comm , this.errors_count1 , this.errors_count2 , this.errors_count3 , this.errors_count4 , this.onboard_control_sensors_present_extended , this.onboard_control_sensors_enabled_extended , this.onboard_control_sensors_health_extended ] = moreargs;

    this._format = '<IIIHHhHHHHHHbIII';
    this._id = mavlink20.MAVLINK_MSG_ID_SYS_STATUS;
    this.order_map = [0, 1, 2, 3, 4, 5, 12, 6, 7, 8, 9, 10, 11, 13, 14, 15];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 124;
    this._name = 'SYS_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['onboard_control_sensors_present', 'onboard_control_sensors_enabled', 'onboard_control_sensors_health', 'load', 'voltage_battery', 'current_battery', 'battery_remaining', 'drop_rate_comm', 'errors_comm', 'errors_count1', 'errors_count2', 'errors_count3', 'errors_count4', 'onboard_control_sensors_present_extended', 'onboard_control_sensors_enabled_extended', 'onboard_control_sensors_health_extended'];

}

mavlink20.messages.sys_status.prototype = new mavlink20.message;
mavlink20.messages.sys_status.prototype.pack = function(mav) {
    var orderedfields = [ this.onboard_control_sensors_present, this.onboard_control_sensors_enabled, this.onboard_control_sensors_health, this.load, this.voltage_battery, this.current_battery, this.drop_rate_comm, this.errors_comm, this.errors_count1, this.errors_count2, this.errors_count3, this.errors_count4, this.battery_remaining, this.onboard_control_sensors_present_extended, this.onboard_control_sensors_enabled_extended, this.onboard_control_sensors_health_extended];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The system time is the time of the sender's master clock.         This
can be emitted by flight controllers, onboard computers, or other
components in the MAVLink network.         Components that are using a
less reliable time source, such as a battery-backed real time clock,
can choose to match their system clock to that of a system that
indicates a more recent time.         This allows more broadly
accurate date stamping of logs, and so on.         If precise time
synchronization is needed then use TIMESYNC instead.

                time_unix_usec            : Timestamp (UNIX epoch time). (uint64_t)
                time_boot_ms              : Timestamp (time since system boot). (uint32_t)

*/
    mavlink20.messages.system_time = function( ...moreargs ) {
    [ this.time_unix_usec , this.time_boot_ms ] = moreargs;

    this._format = '<QI';
    this._id = mavlink20.MAVLINK_MSG_ID_SYSTEM_TIME;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 137;
    this._name = 'SYSTEM_TIME';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_unix_usec', 'time_boot_ms'];

}

mavlink20.messages.system_time.prototype = new mavlink20.message;
mavlink20.messages.system_time.prototype.pack = function(mav) {
    var orderedfields = [ this.time_unix_usec, this.time_boot_ms];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A ping message either requesting or responding to a ping. This allows
to measure the system latencies, including serial port, radio modem
and UDP connections. The ping microservice is documented at
https://mavlink.io/en/services/ping.html

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                seq                       : PING sequence (uint32_t)
                target_system             : 0: request ping from all receiving systems. If greater than 0: message is a ping response and number is the system id of the requesting system (uint8_t)
                target_component          : 0: request ping from all receiving components. If greater than 0: message is a ping response and number is the component id of the requesting component. (uint8_t)

*/
    mavlink20.messages.ping = function( ...moreargs ) {
    [ this.time_usec , this.seq , this.target_system , this.target_component ] = moreargs;

    this._format = '<QIBB';
    this._id = mavlink20.MAVLINK_MSG_ID_PING;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 237;
    this._name = 'PING';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'seq', 'target_system', 'target_component'];

}

mavlink20.messages.ping.prototype = new mavlink20.message;
mavlink20.messages.ping.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.seq, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request to control this MAV

                target_system             : System the GCS requests control for (uint8_t)
                control_request           : 0: request control of this MAV, 1: Release control of this MAV (uint8_t)
                version                   : 0: key as plaintext, 1-255: future, different hashing/encryption variants. The GCS should in general use the safest mode possible initially and then gradually move down the encryption level if it gets a NACK message indicating an encryption mismatch. (uint8_t)
                passkey                   : Password / Key, depending on version plaintext or encrypted. 25 or less characters, NULL terminated. The characters may involve A-Z, a-z, 0-9, and "!?,.-" (char)

*/
    mavlink20.messages.change_operator_control = function( ...moreargs ) {
    [ this.target_system , this.control_request , this.version , this.passkey ] = moreargs;

    this._format = '<BBB25s';
    this._id = mavlink20.MAVLINK_MSG_ID_CHANGE_OPERATOR_CONTROL;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 25];
    this.crc_extra = 217;
    this._name = 'CHANGE_OPERATOR_CONTROL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'control_request', 'version', 'passkey'];

}

mavlink20.messages.change_operator_control.prototype = new mavlink20.message;
mavlink20.messages.change_operator_control.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.control_request, this.version, this.passkey];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Accept / deny control of this MAV

                gcs_system_id             : ID of the GCS this message (uint8_t)
                control_request           : 0: request control of this MAV, 1: Release control of this MAV (uint8_t)
                ack                       : 0: ACK, 1: NACK: Wrong passkey, 2: NACK: Unsupported passkey encryption method, 3: NACK: Already under control (uint8_t)

*/
    mavlink20.messages.change_operator_control_ack = function( ...moreargs ) {
    [ this.gcs_system_id , this.control_request , this.ack ] = moreargs;

    this._format = '<BBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CHANGE_OPERATOR_CONTROL_ACK;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 104;
    this._name = 'CHANGE_OPERATOR_CONTROL_ACK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['gcs_system_id', 'control_request', 'ack'];

}

mavlink20.messages.change_operator_control_ack.prototype = new mavlink20.message;
mavlink20.messages.change_operator_control_ack.prototype.pack = function(mav) {
    var orderedfields = [ this.gcs_system_id, this.control_request, this.ack];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Emit an encrypted signature / key identifying this system. PLEASE
NOTE: This protocol has been kept simple, so transmitting the key
requires an encrypted channel for true safety.

                key                       : key (char)

*/
    mavlink20.messages.auth_key = function( ...moreargs ) {
    [ this.key ] = moreargs;

    this._format = '<32s';
    this._id = mavlink20.MAVLINK_MSG_ID_AUTH_KEY;
    this.order_map = [0];
    this.len_map = [1];
    this.array_len_map = [32];
    this.crc_extra = 119;
    this._name = 'AUTH_KEY';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['key'];

}

mavlink20.messages.auth_key.prototype = new mavlink20.message;
mavlink20.messages.auth_key.prototype.pack = function(mav) {
    var orderedfields = [ this.key];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Status generated in each node in the communication chain and injected
into MAVLink stream.

                timestamp                 : Timestamp (time since system boot). (uint64_t)
                tx_buf                    : Remaining free transmit buffer space (uint8_t)
                rx_buf                    : Remaining free receive buffer space (uint8_t)
                tx_rate                   : Transmit rate (uint32_t)
                rx_rate                   : Receive rate (uint32_t)
                rx_parse_err              : Number of bytes that could not be parsed correctly. (uint16_t)
                tx_overflows              : Transmit buffer overflows. This number wraps around as it reaches UINT16_MAX (uint16_t)
                rx_overflows              : Receive buffer overflows. This number wraps around as it reaches UINT16_MAX (uint16_t)
                messages_sent             : Messages sent (uint32_t)
                messages_received         : Messages received (estimated from counting seq) (uint32_t)
                messages_lost             : Messages lost (estimated from counting seq) (uint32_t)

*/
    mavlink20.messages.link_node_status = function( ...moreargs ) {
    [ this.timestamp , this.tx_buf , this.rx_buf , this.tx_rate , this.rx_rate , this.rx_parse_err , this.tx_overflows , this.rx_overflows , this.messages_sent , this.messages_received , this.messages_lost ] = moreargs;

    this._format = '<QIIIIIHHHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_LINK_NODE_STATUS;
    this.order_map = [0, 9, 10, 1, 2, 6, 7, 8, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 117;
    this._name = 'LINK_NODE_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['timestamp', 'tx_buf', 'rx_buf', 'tx_rate', 'rx_rate', 'rx_parse_err', 'tx_overflows', 'rx_overflows', 'messages_sent', 'messages_received', 'messages_lost'];

}

mavlink20.messages.link_node_status.prototype = new mavlink20.message;
mavlink20.messages.link_node_status.prototype.pack = function(mav) {
    var orderedfields = [ this.timestamp, this.tx_rate, this.rx_rate, this.messages_sent, this.messages_received, this.messages_lost, this.rx_parse_err, this.tx_overflows, this.rx_overflows, this.tx_buf, this.rx_buf];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set the system mode, as defined by enum MAV_MODE. There is no target
component id as the mode is by definition for the overall aircraft,
not only for one component.

                target_system             : The system setting the mode (uint8_t)
                base_mode                 : The new base mode. (uint8_t)
                custom_mode               : The new autopilot-specific mode. This field can be ignored by an autopilot. (uint32_t)

*/
    mavlink20.messages.set_mode = function( ...moreargs ) {
    [ this.target_system , this.base_mode , this.custom_mode ] = moreargs;

    this._format = '<IBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_MODE;
    this.order_map = [1, 2, 0];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 89;
    this._name = 'SET_MODE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'base_mode', 'custom_mode'];

}

mavlink20.messages.set_mode.prototype = new mavlink20.message;
mavlink20.messages.set_mode.prototype.pack = function(mav) {
    var orderedfields = [ this.custom_mode, this.target_system, this.base_mode];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request to read the onboard parameter with the param_id string id.
Onboard parameters are stored as key[const char*] -> value[float].
This allows to send a parameter to any other component (such as the
GCS) without the need of previous knowledge of possible parameter
names. Thus the same GCS can store different parameters for different
autopilots. See also https://mavlink.io/en/services/parameter.html for
a full documentation of QGroundControl and IMU code.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                param_id                  : Onboard parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_index               : Parameter index. Send -1 to use the param ID field as identifier (else the param id will be ignored) (int16_t)

*/
    mavlink20.messages.param_request_read = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.param_id , this.param_index ] = moreargs;

    this._format = '<hBB16s';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_REQUEST_READ;
    this.order_map = [1, 2, 3, 0];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 16];
    this.crc_extra = 214;
    this._name = 'PARAM_REQUEST_READ';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'param_id', 'param_index'];

}

mavlink20.messages.param_request_read.prototype = new mavlink20.message;
mavlink20.messages.param_request_read.prototype.pack = function(mav) {
    var orderedfields = [ this.param_index, this.target_system, this.target_component, this.param_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request all parameters of this component. After this request, all
parameters are emitted. The parameter microservice is documented at
https://mavlink.io/en/services/parameter.html

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)

*/
    mavlink20.messages.param_request_list = function( ...moreargs ) {
    [ this.target_system , this.target_component ] = moreargs;

    this._format = '<BB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_REQUEST_LIST;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 159;
    this._name = 'PARAM_REQUEST_LIST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component'];

}

mavlink20.messages.param_request_list.prototype = new mavlink20.message;
mavlink20.messages.param_request_list.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Emit the value of a onboard parameter. The inclusion of param_count
and param_index in the message allows the recipient to keep track of
received parameters and allows him to re-request missing parameters
after a loss or timeout. The parameter microservice is documented at
https://mavlink.io/en/services/parameter.html

                param_id                  : Onboard parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_value               : Onboard parameter value (float)
                param_type                : Onboard parameter type. (uint8_t)
                param_count               : Total number of onboard parameters (uint16_t)
                param_index               : Index of this onboard parameter (uint16_t)

*/
    mavlink20.messages.param_value = function( ...moreargs ) {
    [ this.param_id , this.param_value , this.param_type , this.param_count , this.param_index ] = moreargs;

    this._format = '<fHH16sB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_VALUE;
    this.order_map = [3, 0, 4, 1, 2];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 16, 0];
    this.crc_extra = 220;
    this._name = 'PARAM_VALUE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['param_id', 'param_value', 'param_type', 'param_count', 'param_index'];

}

mavlink20.messages.param_value.prototype = new mavlink20.message;
mavlink20.messages.param_value.prototype.pack = function(mav) {
    var orderedfields = [ this.param_value, this.param_count, this.param_index, this.param_id, this.param_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set a parameter value (write new value to permanent storage).
The receiving component should acknowledge the new parameter value by
broadcasting a PARAM_VALUE message (broadcasting ensures that multiple
GCS all have an up-to-date list of all parameters). If the sending GCS
did not receive a PARAM_VALUE within its timeout time, it should re-
send the PARAM_SET message. The parameter microservice is documented
at https://mavlink.io/en/services/parameter.html.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                param_id                  : Onboard parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_value               : Onboard parameter value (float)
                param_type                : Onboard parameter type. (uint8_t)

*/
    mavlink20.messages.param_set = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.param_id , this.param_value , this.param_type ] = moreargs;

    this._format = '<fBB16sB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_SET;
    this.order_map = [1, 2, 3, 0, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 16, 0];
    this.crc_extra = 168;
    this._name = 'PARAM_SET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'param_id', 'param_value', 'param_type'];

}

mavlink20.messages.param_set.prototype = new mavlink20.message;
mavlink20.messages.param_set.prototype.pack = function(mav) {
    var orderedfields = [ this.param_value, this.target_system, this.target_component, this.param_id, this.param_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The global position, as returned by the Global Positioning System
(GPS). This is                 NOT the global position estimate of the
system, but rather a RAW sensor value. See message GLOBAL_POSITION_INT
for the global position estimate.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                fix_type                  : GPS fix type. (uint8_t)
                lat                       : Latitude (WGS84, EGM96 ellipsoid) (int32_t)
                lon                       : Longitude (WGS84, EGM96 ellipsoid) (int32_t)
                alt                       : Altitude (MSL). Positive for up. Note that virtually all GPS modules provide the MSL altitude in addition to the WGS84 altitude. (int32_t)
                eph                       : GPS HDOP horizontal dilution of position (unitless * 100). If unknown, set to: UINT16_MAX (uint16_t)
                epv                       : GPS VDOP vertical dilution of position (unitless * 100). If unknown, set to: UINT16_MAX (uint16_t)
                vel                       : GPS ground speed. If unknown, set to: UINT16_MAX (uint16_t)
                cog                       : Course over ground (NOT heading, but direction of movement) in degrees * 100, 0.0..359.99 degrees. If unknown, set to: UINT16_MAX (uint16_t)
                satellites_visible        : Number of satellites visible. If unknown, set to UINT8_MAX (uint8_t)
                alt_ellipsoid             : Altitude (above WGS84, EGM96 ellipsoid). Positive for up. (int32_t)
                h_acc                     : Position uncertainty. (uint32_t)
                v_acc                     : Altitude uncertainty. (uint32_t)
                vel_acc                   : Speed uncertainty. (uint32_t)
                hdg_acc                   : Heading / track uncertainty (uint32_t)
                yaw                       : Yaw in earth frame from north. Use 0 if this GPS does not provide yaw. Use UINT16_MAX if this GPS is configured to provide yaw and is currently unable to provide it. Use 36000 for north. (uint16_t)

*/
    mavlink20.messages.gps_raw_int = function( ...moreargs ) {
    [ this.time_usec , this.fix_type , this.lat , this.lon , this.alt , this.eph , this.epv , this.vel , this.cog , this.satellites_visible , this.alt_ellipsoid , this.h_acc , this.v_acc , this.vel_acc , this.hdg_acc , this.yaw ] = moreargs;

    this._format = '<QiiiHHHHBBiIIIIH';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_RAW_INT;
    this.order_map = [0, 8, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 24;
    this._name = 'GPS_RAW_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'fix_type', 'lat', 'lon', 'alt', 'eph', 'epv', 'vel', 'cog', 'satellites_visible', 'alt_ellipsoid', 'h_acc', 'v_acc', 'vel_acc', 'hdg_acc', 'yaw'];

}

mavlink20.messages.gps_raw_int.prototype = new mavlink20.message;
mavlink20.messages.gps_raw_int.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.lat, this.lon, this.alt, this.eph, this.epv, this.vel, this.cog, this.fix_type, this.satellites_visible, this.alt_ellipsoid, this.h_acc, this.v_acc, this.vel_acc, this.hdg_acc, this.yaw];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The positioning status, as reported by GPS. This message is intended
to display status information about each satellite visible to the
receiver. See message GLOBAL_POSITION_INT for the global position
estimate. This message can contain information for up to 20
satellites.

                satellites_visible        : Number of satellites visible (uint8_t)
                satellite_prn             : Global satellite ID (uint8_t)
                satellite_used            : 0: Satellite not used, 1: used for localization (uint8_t)
                satellite_elevation        : Elevation (0: right on top of receiver, 90: on the horizon) of satellite (uint8_t)
                satellite_azimuth         : Direction of satellite, 0: 0 deg, 255: 360 deg. (uint8_t)
                satellite_snr             : Signal to noise ratio of satellite (uint8_t)

*/
    mavlink20.messages.gps_status = function( ...moreargs ) {
    [ this.satellites_visible , this.satellite_prn , this.satellite_used , this.satellite_elevation , this.satellite_azimuth , this.satellite_snr ] = moreargs;

    this._format = '<B20s20s20s20s20s';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_STATUS;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 20, 20, 20, 20, 20];
    this.array_len_map = [0, 20, 20, 20, 20, 20];
    this.crc_extra = 23;
    this._name = 'GPS_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['satellites_visible', 'satellite_prn', 'satellite_used', 'satellite_elevation', 'satellite_azimuth', 'satellite_snr'];

}

mavlink20.messages.gps_status.prototype = new mavlink20.message;
mavlink20.messages.gps_status.prototype.pack = function(mav) {
    var orderedfields = [ this.satellites_visible, this.satellite_prn, this.satellite_used, this.satellite_elevation, this.satellite_azimuth, this.satellite_snr];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW IMU readings for the usual 9DOF sensor setup. This message
should contain the scaled values to the described units

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                xacc                      : X acceleration (int16_t)
                yacc                      : Y acceleration (int16_t)
                zacc                      : Z acceleration (int16_t)
                xgyro                     : Angular speed around X axis (int16_t)
                ygyro                     : Angular speed around Y axis (int16_t)
                zgyro                     : Angular speed around Z axis (int16_t)
                xmag                      : X Magnetic field (int16_t)
                ymag                      : Y Magnetic field (int16_t)
                zmag                      : Z Magnetic field (int16_t)
                temperature               : Temperature, 0: IMU does not provide temperature values. If the IMU is at 0C it must send 1 (0.01C). (int16_t)

*/
    mavlink20.messages.scaled_imu = function( ...moreargs ) {
    [ this.time_boot_ms , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.xmag , this.ymag , this.zmag , this.temperature ] = moreargs;

    this._format = '<Ihhhhhhhhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_SCALED_IMU;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 170;
    this._name = 'SCALED_IMU';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'xmag', 'ymag', 'zmag', 'temperature'];

}

mavlink20.messages.scaled_imu.prototype = new mavlink20.message;
mavlink20.messages.scaled_imu.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.xmag, this.ymag, this.zmag, this.temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW IMU readings for a 9DOF sensor, which is identified by the id
(default IMU1). This message should always contain the true raw values
without any scaling to allow data capture and system debugging.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                xacc                      : X acceleration (raw) (int16_t)
                yacc                      : Y acceleration (raw) (int16_t)
                zacc                      : Z acceleration (raw) (int16_t)
                xgyro                     : Angular speed around X axis (raw) (int16_t)
                ygyro                     : Angular speed around Y axis (raw) (int16_t)
                zgyro                     : Angular speed around Z axis (raw) (int16_t)
                xmag                      : X Magnetic field (raw) (int16_t)
                ymag                      : Y Magnetic field (raw) (int16_t)
                zmag                      : Z Magnetic field (raw) (int16_t)
                id                        : Id. Ids are numbered from 0 and map to IMUs numbered from 1 (e.g. IMU1 will have a message with id=0) (uint8_t)
                temperature               : Temperature, 0: IMU does not provide temperature values. If the IMU is at 0C it must send 1 (0.01C). (int16_t)

*/
    mavlink20.messages.raw_imu = function( ...moreargs ) {
    [ this.time_usec , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.xmag , this.ymag , this.zmag , this.id , this.temperature ] = moreargs;

    this._format = '<QhhhhhhhhhBh';
    this._id = mavlink20.MAVLINK_MSG_ID_RAW_IMU;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 144;
    this._name = 'RAW_IMU';

    this._instance_field = 'id';
    this._instance_offset = 26;

    this.fieldnames = ['time_usec', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'xmag', 'ymag', 'zmag', 'id', 'temperature'];

}

mavlink20.messages.raw_imu.prototype = new mavlink20.message;
mavlink20.messages.raw_imu.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.xmag, this.ymag, this.zmag, this.id, this.temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW pressure readings for the typical setup of one absolute
pressure and one differential pressure sensor. The sensor values
should be the raw, UNSCALED ADC values.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                press_abs                 : Absolute pressure (raw) (int16_t)
                press_diff1               : Differential pressure 1 (raw, 0 if nonexistent) (int16_t)
                press_diff2               : Differential pressure 2 (raw, 0 if nonexistent) (int16_t)
                temperature               : Raw Temperature measurement (raw) (int16_t)

*/
    mavlink20.messages.raw_pressure = function( ...moreargs ) {
    [ this.time_usec , this.press_abs , this.press_diff1 , this.press_diff2 , this.temperature ] = moreargs;

    this._format = '<Qhhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_RAW_PRESSURE;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 67;
    this._name = 'RAW_PRESSURE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'press_abs', 'press_diff1', 'press_diff2', 'temperature'];

}

mavlink20.messages.raw_pressure.prototype = new mavlink20.message;
mavlink20.messages.raw_pressure.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.press_abs, this.press_diff1, this.press_diff2, this.temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The pressure readings for the typical setup of one absolute and
differential pressure sensor. The units are as specified in each
field.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                press_abs                 : Absolute pressure (float)
                press_diff                : Differential pressure 1 (float)
                temperature               : Absolute pressure temperature (int16_t)
                temperature_press_diff        : Differential pressure temperature (0, if not available). Report values of 0 (or 1) as 1 cdegC. (int16_t)

*/
    mavlink20.messages.scaled_pressure = function( ...moreargs ) {
    [ this.time_boot_ms , this.press_abs , this.press_diff , this.temperature , this.temperature_press_diff ] = moreargs;

    this._format = '<Iffhh';
    this._id = mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 115;
    this._name = 'SCALED_PRESSURE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'press_abs', 'press_diff', 'temperature', 'temperature_press_diff'];

}

mavlink20.messages.scaled_pressure.prototype = new mavlink20.message;
mavlink20.messages.scaled_pressure.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.press_abs, this.press_diff, this.temperature, this.temperature_press_diff];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The attitude in the aeronautical frame (right-handed, Z-down, Y-right,
X-front, ZYX, intrinsic).

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                roll                      : Roll angle (-pi..+pi) (float)
                pitch                     : Pitch angle (-pi..+pi) (float)
                yaw                       : Yaw angle (-pi..+pi) (float)
                rollspeed                 : Roll angular speed (float)
                pitchspeed                : Pitch angular speed (float)
                yawspeed                  : Yaw angular speed (float)

*/
    mavlink20.messages.attitude = function( ...moreargs ) {
    [ this.time_boot_ms , this.roll , this.pitch , this.yaw , this.rollspeed , this.pitchspeed , this.yawspeed ] = moreargs;

    this._format = '<Iffffff';
    this._id = mavlink20.MAVLINK_MSG_ID_ATTITUDE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 39;
    this._name = 'ATTITUDE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'roll', 'pitch', 'yaw', 'rollspeed', 'pitchspeed', 'yawspeed'];

}

mavlink20.messages.attitude.prototype = new mavlink20.message;
mavlink20.messages.attitude.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.roll, this.pitch, this.yaw, this.rollspeed, this.pitchspeed, this.yawspeed];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The attitude in the aeronautical frame (right-handed, Z-down, X-front,
Y-right), expressed as quaternion. Quaternion order is w, x, y, z and
a zero rotation would be expressed as (1 0 0 0).

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                q1                        : Quaternion component 1, w (1 in null-rotation) (float)
                q2                        : Quaternion component 2, x (0 in null-rotation) (float)
                q3                        : Quaternion component 3, y (0 in null-rotation) (float)
                q4                        : Quaternion component 4, z (0 in null-rotation) (float)
                rollspeed                 : Roll angular speed (float)
                pitchspeed                : Pitch angular speed (float)
                yawspeed                  : Yaw angular speed (float)
                repr_offset_q             : Rotation offset by which the attitude quaternion and angular speed vector should be rotated for user display (quaternion with [w, x, y, z] order, zero-rotation is [1, 0, 0, 0], send [0, 0, 0, 0] if field not supported). This field is intended for systems in which the reference attitude may change during flight. For example, tailsitters VTOLs rotate their reference attitude by 90 degrees between hover mode and fixed wing mode, thus repr_offset_q is equal to [1, 0, 0, 0] in hover mode and equal to [0.7071, 0, 0.7071, 0] in fixed wing mode. (float)

*/
    mavlink20.messages.attitude_quaternion = function( ...moreargs ) {
    [ this.time_boot_ms , this.q1 , this.q2 , this.q3 , this.q4 , this.rollspeed , this.pitchspeed , this.yawspeed , this.repr_offset_q ] = moreargs;

    this._format = '<Ifffffff4f';
    this._id = mavlink20.MAVLINK_MSG_ID_ATTITUDE_QUATERNION;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 4];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 4];
    this.crc_extra = 246;
    this._name = 'ATTITUDE_QUATERNION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'q1', 'q2', 'q3', 'q4', 'rollspeed', 'pitchspeed', 'yawspeed', 'repr_offset_q'];

}

mavlink20.messages.attitude_quaternion.prototype = new mavlink20.message;
mavlink20.messages.attitude_quaternion.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.q1, this.q2, this.q3, this.q4, this.rollspeed, this.pitchspeed, this.yawspeed, this.repr_offset_q];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The filtered local position (e.g. fused computer vision and
accelerometers). Coordinate frame is right-handed, Z-axis down
(aeronautical frame, NED / north-east-down convention)

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                x                         : X Position (float)
                y                         : Y Position (float)
                z                         : Z Position (float)
                vx                        : X Speed (float)
                vy                        : Y Speed (float)
                vz                        : Z Speed (float)

*/
    mavlink20.messages.local_position_ned = function( ...moreargs ) {
    [ this.time_boot_ms , this.x , this.y , this.z , this.vx , this.vy , this.vz ] = moreargs;

    this._format = '<Iffffff';
    this._id = mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 185;
    this._name = 'LOCAL_POSITION_NED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'x', 'y', 'z', 'vx', 'vy', 'vz'];

}

mavlink20.messages.local_position_ned.prototype = new mavlink20.message;
mavlink20.messages.local_position_ned.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.x, this.y, this.z, this.vx, this.vy, this.vz];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The scaled values of the RC channels received: (-100%) -10000, (0%) 0,
(100%) 10000. Channels that are inactive should be set to INT16_MAX.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                port                      : Servo output port (set of 8 outputs = 1 port). Flight stacks running on Pixhawk should use: 0 = MAIN, 1 = AUX. (uint8_t)
                chan1_scaled              : RC channel 1 value scaled. (int16_t)
                chan2_scaled              : RC channel 2 value scaled. (int16_t)
                chan3_scaled              : RC channel 3 value scaled. (int16_t)
                chan4_scaled              : RC channel 4 value scaled. (int16_t)
                chan5_scaled              : RC channel 5 value scaled. (int16_t)
                chan6_scaled              : RC channel 6 value scaled. (int16_t)
                chan7_scaled              : RC channel 7 value scaled. (int16_t)
                chan8_scaled              : RC channel 8 value scaled. (int16_t)
                rssi                      : Receive signal strength indicator in device-dependent units/scale. Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)

*/
    mavlink20.messages.rc_channels_scaled = function( ...moreargs ) {
    [ this.time_boot_ms , this.port , this.chan1_scaled , this.chan2_scaled , this.chan3_scaled , this.chan4_scaled , this.chan5_scaled , this.chan6_scaled , this.chan7_scaled , this.chan8_scaled , this.rssi ] = moreargs;

    this._format = '<IhhhhhhhhBB';
    this._id = mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_SCALED;
    this.order_map = [0, 9, 1, 2, 3, 4, 5, 6, 7, 8, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 237;
    this._name = 'RC_CHANNELS_SCALED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'port', 'chan1_scaled', 'chan2_scaled', 'chan3_scaled', 'chan4_scaled', 'chan5_scaled', 'chan6_scaled', 'chan7_scaled', 'chan8_scaled', 'rssi'];

}

mavlink20.messages.rc_channels_scaled.prototype = new mavlink20.message;
mavlink20.messages.rc_channels_scaled.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.chan1_scaled, this.chan2_scaled, this.chan3_scaled, this.chan4_scaled, this.chan5_scaled, this.chan6_scaled, this.chan7_scaled, this.chan8_scaled, this.port, this.rssi];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW values of the RC channels received. The standard PPM
modulation is as follows: 1000 microseconds: 0%, 2000 microseconds:
100%. A value of UINT16_MAX implies the channel is unused. Individual
receivers/transmitters might violate this specification.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                port                      : Servo output port (set of 8 outputs = 1 port). Flight stacks running on Pixhawk should use: 0 = MAIN, 1 = AUX. (uint8_t)
                chan1_raw                 : RC channel 1 value. (uint16_t)
                chan2_raw                 : RC channel 2 value. (uint16_t)
                chan3_raw                 : RC channel 3 value. (uint16_t)
                chan4_raw                 : RC channel 4 value. (uint16_t)
                chan5_raw                 : RC channel 5 value. (uint16_t)
                chan6_raw                 : RC channel 6 value. (uint16_t)
                chan7_raw                 : RC channel 7 value. (uint16_t)
                chan8_raw                 : RC channel 8 value. (uint16_t)
                rssi                      : Receive signal strength indicator in device-dependent units/scale. Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)

*/
    mavlink20.messages.rc_channels_raw = function( ...moreargs ) {
    [ this.time_boot_ms , this.port , this.chan1_raw , this.chan2_raw , this.chan3_raw , this.chan4_raw , this.chan5_raw , this.chan6_raw , this.chan7_raw , this.chan8_raw , this.rssi ] = moreargs;

    this._format = '<IHHHHHHHHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_RAW;
    this.order_map = [0, 9, 1, 2, 3, 4, 5, 6, 7, 8, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 244;
    this._name = 'RC_CHANNELS_RAW';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'port', 'chan1_raw', 'chan2_raw', 'chan3_raw', 'chan4_raw', 'chan5_raw', 'chan6_raw', 'chan7_raw', 'chan8_raw', 'rssi'];

}

mavlink20.messages.rc_channels_raw.prototype = new mavlink20.message;
mavlink20.messages.rc_channels_raw.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.chan1_raw, this.chan2_raw, this.chan3_raw, this.chan4_raw, this.chan5_raw, this.chan6_raw, this.chan7_raw, this.chan8_raw, this.port, this.rssi];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Superseded by ACTUATOR_OUTPUT_STATUS. The RAW values of the servo
outputs (for RC input from the remote, use the RC_CHANNELS messages).
The standard PPM modulation is as follows: 1000 microseconds: 0%, 2000
microseconds: 100%.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint32_t)
                port                      : Servo output port (set of 8 outputs = 1 port). Flight stacks running on Pixhawk should use: 0 = MAIN, 1 = AUX. (uint8_t)
                servo1_raw                : Servo output 1 value (uint16_t)
                servo2_raw                : Servo output 2 value (uint16_t)
                servo3_raw                : Servo output 3 value (uint16_t)
                servo4_raw                : Servo output 4 value (uint16_t)
                servo5_raw                : Servo output 5 value (uint16_t)
                servo6_raw                : Servo output 6 value (uint16_t)
                servo7_raw                : Servo output 7 value (uint16_t)
                servo8_raw                : Servo output 8 value (uint16_t)
                servo9_raw                : Servo output 9 value (uint16_t)
                servo10_raw               : Servo output 10 value (uint16_t)
                servo11_raw               : Servo output 11 value (uint16_t)
                servo12_raw               : Servo output 12 value (uint16_t)
                servo13_raw               : Servo output 13 value (uint16_t)
                servo14_raw               : Servo output 14 value (uint16_t)
                servo15_raw               : Servo output 15 value (uint16_t)
                servo16_raw               : Servo output 16 value (uint16_t)

*/
    mavlink20.messages.servo_output_raw = function( ...moreargs ) {
    [ this.time_usec , this.port , this.servo1_raw , this.servo2_raw , this.servo3_raw , this.servo4_raw , this.servo5_raw , this.servo6_raw , this.servo7_raw , this.servo8_raw , this.servo9_raw , this.servo10_raw , this.servo11_raw , this.servo12_raw , this.servo13_raw , this.servo14_raw , this.servo15_raw , this.servo16_raw ] = moreargs;

    this._format = '<IHHHHHHHHBHHHHHHHH';
    this._id = mavlink20.MAVLINK_MSG_ID_SERVO_OUTPUT_RAW;
    this.order_map = [0, 9, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 222;
    this._name = 'SERVO_OUTPUT_RAW';

    this._instance_field = 'port';
    this._instance_offset = 20;

    this.fieldnames = ['time_usec', 'port', 'servo1_raw', 'servo2_raw', 'servo3_raw', 'servo4_raw', 'servo5_raw', 'servo6_raw', 'servo7_raw', 'servo8_raw', 'servo9_raw', 'servo10_raw', 'servo11_raw', 'servo12_raw', 'servo13_raw', 'servo14_raw', 'servo15_raw', 'servo16_raw'];

}

mavlink20.messages.servo_output_raw.prototype = new mavlink20.message;
mavlink20.messages.servo_output_raw.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.servo1_raw, this.servo2_raw, this.servo3_raw, this.servo4_raw, this.servo5_raw, this.servo6_raw, this.servo7_raw, this.servo8_raw, this.port, this.servo9_raw, this.servo10_raw, this.servo11_raw, this.servo12_raw, this.servo13_raw, this.servo14_raw, this.servo15_raw, this.servo16_raw];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request a partial list of mission items from the system/component.
https://mavlink.io/en/services/mission.html. If start and end index
are the same, just send one waypoint.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                start_index               : Start index (int16_t)
                end_index                 : End index, -1 by default (-1: send list to end). Else a valid index of the list (int16_t)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_request_partial_list = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.start_index , this.end_index , this.mission_type ] = moreargs;

    this._format = '<hhBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_PARTIAL_LIST;
    this.order_map = [2, 3, 0, 1, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 212;
    this._name = 'MISSION_REQUEST_PARTIAL_LIST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'start_index', 'end_index', 'mission_type'];

}

mavlink20.messages.mission_request_partial_list.prototype = new mavlink20.message;
mavlink20.messages.mission_request_partial_list.prototype.pack = function(mav) {
    var orderedfields = [ this.start_index, this.end_index, this.target_system, this.target_component, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
This message is sent to the MAV to write a partial list. If start
index == end index, only one item will be transmitted / updated. If
the start index is NOT 0 and above the current list size, this request
should be REJECTED!

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                start_index               : Start index. Must be smaller / equal to the largest index of the current onboard list. (int16_t)
                end_index                 : End index, equal or greater than start index. (int16_t)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_write_partial_list = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.start_index , this.end_index , this.mission_type ] = moreargs;

    this._format = '<hhBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_WRITE_PARTIAL_LIST;
    this.order_map = [2, 3, 0, 1, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 9;
    this._name = 'MISSION_WRITE_PARTIAL_LIST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'start_index', 'end_index', 'mission_type'];

}

mavlink20.messages.mission_write_partial_list.prototype = new mavlink20.message;
mavlink20.messages.mission_write_partial_list.prototype.pack = function(mav) {
    var orderedfields = [ this.start_index, this.end_index, this.target_system, this.target_component, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message encoding a mission item.         This message is emitted to
announce the presence of a mission item and to set a mission item on
the system.         The mission item can be either in x, y, z meters
(type: LOCAL) or x:lat, y:lon, z:altitude. Local frame is Z-down,
right handed (NED), global frame is Z-up, right handed (ENU). NaN may
be used to indicate an optional/default value (e.g. to use the
system's current latitude or yaw rather than a specific value). See
also https://mavlink.io/en/services/mission.html.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                seq                       : Sequence (uint16_t)
                frame                     : The coordinate system of the waypoint. (uint8_t)
                command                   : The scheduled action for the waypoint. (uint16_t)
                current                   : false:0, true:1 (uint8_t)
                autocontinue              : Autocontinue to next waypoint. 0: false, 1: true. Set false to pause mission after the item completes. (uint8_t)
                param1                    : PARAM1, see MAV_CMD enum (float)
                param2                    : PARAM2, see MAV_CMD enum (float)
                param3                    : PARAM3, see MAV_CMD enum (float)
                param4                    : PARAM4, see MAV_CMD enum (float)
                x                         : PARAM5 / local: X coordinate, global: latitude (float)
                y                         : PARAM6 / local: Y coordinate, global: longitude (float)
                z                         : PARAM7 / local: Z coordinate, global: altitude (relative or absolute, depending on frame). (float)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_item = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.seq , this.frame , this.command , this.current , this.autocontinue , this.param1 , this.param2 , this.param3 , this.param4 , this.x , this.y , this.z , this.mission_type ] = moreargs;

    this._format = '<fffffffHHBBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_ITEM;
    this.order_map = [9, 10, 7, 11, 8, 12, 13, 0, 1, 2, 3, 4, 5, 6, 14];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 254;
    this._name = 'MISSION_ITEM';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'seq', 'frame', 'command', 'current', 'autocontinue', 'param1', 'param2', 'param3', 'param4', 'x', 'y', 'z', 'mission_type'];

}

mavlink20.messages.mission_item.prototype = new mavlink20.message;
mavlink20.messages.mission_item.prototype.pack = function(mav) {
    var orderedfields = [ this.param1, this.param2, this.param3, this.param4, this.x, this.y, this.z, this.seq, this.command, this.target_system, this.target_component, this.frame, this.current, this.autocontinue, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request the information of the mission item with the sequence number
seq. The response of the system to this message should be a
MISSION_ITEM message. https://mavlink.io/en/services/mission.html

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                seq                       : Sequence (uint16_t)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_request = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.seq , this.mission_type ] = moreargs;

    this._format = '<HBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST;
    this.order_map = [1, 2, 0, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 230;
    this._name = 'MISSION_REQUEST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'seq', 'mission_type'];

}

mavlink20.messages.mission_request.prototype = new mavlink20.message;
mavlink20.messages.mission_request.prototype.pack = function(mav) {
    var orderedfields = [ this.seq, this.target_system, this.target_component, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set the mission item with sequence number seq as the current item and
emit MISSION_CURRENT (whether or not the mission number changed).
If a mission is currently being executed, the system will continue to
this new mission item on the shortest path, skipping any intermediate
mission items.         Note that mission jump repeat counters are not
reset (see MAV_CMD_DO_JUMP param2).          This message may trigger
a mission state-machine change on some systems: for example from
MISSION_STATE_NOT_STARTED or MISSION_STATE_PAUSED to
MISSION_STATE_ACTIVE.         If the system is in mission mode, on
those systems this command might therefore start, restart or resume
the mission.         If the system is not in mission mode this message
must not trigger a switch to mission mode.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                seq                       : Sequence (uint16_t)

*/
    mavlink20.messages.mission_set_current = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.seq ] = moreargs;

    this._format = '<HBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_SET_CURRENT;
    this.order_map = [1, 2, 0];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 28;
    this._name = 'MISSION_SET_CURRENT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'seq'];

}

mavlink20.messages.mission_set_current.prototype = new mavlink20.message;
mavlink20.messages.mission_set_current.prototype.pack = function(mav) {
    var orderedfields = [ this.seq, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message that announces the sequence number of the current target
mission item (that the system will fly towards/execute when the
mission is running).         This message should be streamed all the
time (nominally at 1Hz).         This message should be emitted
following a call to MAV_CMD_DO_SET_MISSION_CURRENT or
MISSION_SET_CURRENT.

                seq                       : Sequence (uint16_t)
                total                     : Total number of mission items on vehicle (on last item, sequence == total). If the autopilot stores its home location as part of the mission this will be excluded from the total. 0: Not supported, UINT16_MAX if no mission is present on the vehicle. (uint16_t)
                mission_state             : Mission state machine state. MISSION_STATE_UNKNOWN if state reporting not supported. (uint8_t)
                mission_mode              : Vehicle is in a mode that can execute mission items or suspended. 0: Unknown, 1: In mission mode, 2: Suspended (not in mission mode). (uint8_t)
                mission_id                : Id of current on-vehicle mission plan, or 0 if IDs are not supported or there is no mission loaded. GCS can use this to track changes to the mission plan type. The same value is returned on mission upload (in the MISSION_ACK). (uint32_t)
                fence_id                  : Id of current on-vehicle fence plan, or 0 if IDs are not supported or there is no fence loaded. GCS can use this to track changes to the fence plan type. The same value is returned on fence upload (in the MISSION_ACK). (uint32_t)
                rally_points_id           : Id of current on-vehicle rally point plan, or 0 if IDs are not supported or there are no rally points loaded. GCS can use this to track changes to the rally point plan type. The same value is returned on rally point upload (in the MISSION_ACK). (uint32_t)

*/
    mavlink20.messages.mission_current = function( ...moreargs ) {
    [ this.seq , this.total , this.mission_state , this.mission_mode , this.mission_id , this.fence_id , this.rally_points_id ] = moreargs;

    this._format = '<HHBBIII';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_CURRENT;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 28;
    this._name = 'MISSION_CURRENT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['seq', 'total', 'mission_state', 'mission_mode', 'mission_id', 'fence_id', 'rally_points_id'];

}

mavlink20.messages.mission_current.prototype = new mavlink20.message;
mavlink20.messages.mission_current.prototype.pack = function(mav) {
    var orderedfields = [ this.seq, this.total, this.mission_state, this.mission_mode, this.mission_id, this.fence_id, this.rally_points_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request the overall list of mission items from the system/component.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_request_list = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.mission_type ] = moreargs;

    this._format = '<BBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_LIST;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 132;
    this._name = 'MISSION_REQUEST_LIST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'mission_type'];

}

mavlink20.messages.mission_request_list.prototype = new mavlink20.message;
mavlink20.messages.mission_request_list.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
This message is emitted as response to MISSION_REQUEST_LIST by the MAV
and to initiate a write transaction. The GCS can then request the
individual mission item based on the knowledge of the total number of
waypoints.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                count                     : Number of mission items in the sequence (uint16_t)
                mission_type              : Mission type. (uint8_t)
                opaque_id                 : Id of current on-vehicle mission, fence, or rally point plan (on download from vehicle).
        This field is used when downloading a plan from a vehicle to a GCS.
        0 on upload to the vehicle from GCS.
        0 if plan ids are not supported.
        The current on-vehicle plan ids are streamed in `MISSION_CURRENT`, allowing a GCS to determine if any part of the plan has changed and needs to be re-uploaded.
        The ids are recalculated by the vehicle when any part of the on-vehicle plan changes (when a new plan is uploaded, the vehicle returns the new id to the GCS in MISSION_ACK). (uint32_t)

*/
    mavlink20.messages.mission_count = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.count , this.mission_type , this.opaque_id ] = moreargs;

    this._format = '<HBBBI';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_COUNT;
    this.order_map = [1, 2, 0, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 221;
    this._name = 'MISSION_COUNT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'count', 'mission_type', 'opaque_id'];

}

mavlink20.messages.mission_count.prototype = new mavlink20.message;
mavlink20.messages.mission_count.prototype.pack = function(mav) {
    var orderedfields = [ this.count, this.target_system, this.target_component, this.mission_type, this.opaque_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Delete all mission items at once.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_clear_all = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.mission_type ] = moreargs;

    this._format = '<BBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_CLEAR_ALL;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 232;
    this._name = 'MISSION_CLEAR_ALL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'mission_type'];

}

mavlink20.messages.mission_clear_all.prototype = new mavlink20.message;
mavlink20.messages.mission_clear_all.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A certain mission item has been reached. The system will either hold
this position (or circle on the orbit) or (if the autocontinue on the
WP was set) continue to the next waypoint.

                seq                       : Sequence (uint16_t)

*/
    mavlink20.messages.mission_item_reached = function( ...moreargs ) {
    [ this.seq ] = moreargs;

    this._format = '<H';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_ITEM_REACHED;
    this.order_map = [0];
    this.len_map = [1];
    this.array_len_map = [0];
    this.crc_extra = 11;
    this._name = 'MISSION_ITEM_REACHED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['seq'];

}

mavlink20.messages.mission_item_reached.prototype = new mavlink20.message;
mavlink20.messages.mission_item_reached.prototype.pack = function(mav) {
    var orderedfields = [ this.seq];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Acknowledgment message during waypoint handling. The type field states
if this message is a positive ack (type=0) or if an error happened
(type=non-zero).

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                type                      : Mission result. (uint8_t)
                mission_type              : Mission type. (uint8_t)
                opaque_id                 : Id of new on-vehicle mission, fence, or rally point plan (on upload to vehicle).
        The id is calculated and returned by a vehicle when a new plan is uploaded by a GCS.
        The only requirement on the id is that it must change when there is any change to the on-vehicle plan type (there is no requirement that the id be globally unique).
        0 on download from the vehicle to the GCS (on download the ID is set in MISSION_COUNT).
        0 if plan ids are not supported.
        The current on-vehicle plan ids are streamed in `MISSION_CURRENT`, allowing a GCS to determine if any part of the plan has changed and needs to be re-uploaded. (uint32_t)

*/
    mavlink20.messages.mission_ack = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.type , this.mission_type , this.opaque_id ] = moreargs;

    this._format = '<BBBBI';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_ACK;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 153;
    this._name = 'MISSION_ACK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'type', 'mission_type', 'opaque_id'];

}

mavlink20.messages.mission_ack.prototype = new mavlink20.message;
mavlink20.messages.mission_ack.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.type, this.mission_type, this.opaque_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sets the GPS coordinates of the vehicle local origin (0,0,0) position.
Vehicle should emit GPS_GLOBAL_ORIGIN irrespective of whether the
origin is changed. This enables transform between the local coordinate
frame and the global (GPS) coordinate frame, which may be necessary
when (for example) indoor and outdoor settings are connected and the
MAV should move from in- to outdoor.

                target_system             : System ID (uint8_t)
                latitude                  : Latitude (WGS84) (int32_t)
                longitude                 : Longitude (WGS84) (int32_t)
                altitude                  : Altitude (MSL). Positive for up. (int32_t)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)

*/
    mavlink20.messages.set_gps_global_origin = function( ...moreargs ) {
    [ this.target_system , this.latitude , this.longitude , this.altitude , this.time_usec ] = moreargs;

    this._format = '<iiiBQ';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_GPS_GLOBAL_ORIGIN;
    this.order_map = [3, 0, 1, 2, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 41;
    this._name = 'SET_GPS_GLOBAL_ORIGIN';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'latitude', 'longitude', 'altitude', 'time_usec'];

}

mavlink20.messages.set_gps_global_origin.prototype = new mavlink20.message;
mavlink20.messages.set_gps_global_origin.prototype.pack = function(mav) {
    var orderedfields = [ this.latitude, this.longitude, this.altitude, this.target_system, this.time_usec];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Publishes the GPS coordinates of the vehicle local origin (0,0,0)
position. Emitted whenever a new GPS-Local position mapping is
requested or set - e.g. following SET_GPS_GLOBAL_ORIGIN message.

                latitude                  : Latitude (WGS84) (int32_t)
                longitude                 : Longitude (WGS84) (int32_t)
                altitude                  : Altitude (MSL). Positive for up. (int32_t)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)

*/
    mavlink20.messages.gps_global_origin = function( ...moreargs ) {
    [ this.latitude , this.longitude , this.altitude , this.time_usec ] = moreargs;

    this._format = '<iiiQ';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_GLOBAL_ORIGIN;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 39;
    this._name = 'GPS_GLOBAL_ORIGIN';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['latitude', 'longitude', 'altitude', 'time_usec'];

}

mavlink20.messages.gps_global_origin.prototype = new mavlink20.message;
mavlink20.messages.gps_global_origin.prototype.pack = function(mav) {
    var orderedfields = [ this.latitude, this.longitude, this.altitude, this.time_usec];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Bind a RC channel to a parameter. The parameter should change
according to the RC channel value.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                param_id                  : Onboard parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_index               : Parameter index. Send -1 to use the param ID field as identifier (else the param id will be ignored), send -2 to disable any existing map for this rc_channel_index. (int16_t)
                parameter_rc_channel_index        : Index of parameter RC channel. Not equal to the RC channel id. Typically corresponds to a potentiometer-knob on the RC. (uint8_t)
                param_value0              : Initial parameter value (float)
                scale                     : Scale, maps the RC range [-1, 1] to a parameter value (float)
                param_value_min           : Minimum param value. The protocol does not define if this overwrites an onboard minimum value. (Depends on implementation) (float)
                param_value_max           : Maximum param value. The protocol does not define if this overwrites an onboard maximum value. (Depends on implementation) (float)

*/
    mavlink20.messages.param_map_rc = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.param_id , this.param_index , this.parameter_rc_channel_index , this.param_value0 , this.scale , this.param_value_min , this.param_value_max ] = moreargs;

    this._format = '<ffffhBB16sB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_MAP_RC;
    this.order_map = [5, 6, 7, 4, 8, 0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 16, 0];
    this.crc_extra = 78;
    this._name = 'PARAM_MAP_RC';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'param_id', 'param_index', 'parameter_rc_channel_index', 'param_value0', 'scale', 'param_value_min', 'param_value_max'];

}

mavlink20.messages.param_map_rc.prototype = new mavlink20.message;
mavlink20.messages.param_map_rc.prototype.pack = function(mav) {
    var orderedfields = [ this.param_value0, this.scale, this.param_value_min, this.param_value_max, this.param_index, this.target_system, this.target_component, this.param_id, this.parameter_rc_channel_index];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request the information of the mission item with the sequence number
seq. The response of the system to this message should be a
MISSION_ITEM_INT message. https://mavlink.io/en/services/mission.html

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                seq                       : Sequence (uint16_t)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_request_int = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.seq , this.mission_type ] = moreargs;

    this._format = '<HBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_INT;
    this.order_map = [1, 2, 0, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 196;
    this._name = 'MISSION_REQUEST_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'seq', 'mission_type'];

}

mavlink20.messages.mission_request_int.prototype = new mavlink20.message;
mavlink20.messages.mission_request_int.prototype.pack = function(mav) {
    var orderedfields = [ this.seq, this.target_system, this.target_component, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set a safety zone (volume), which is defined by two corners of a cube.
This message can be used to tell the MAV which setpoints/waypoints to
accept and which to reject. Safety areas are often enforced by
national or competition regulations.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                frame                     : Coordinate frame. Can be either global, GPS, right-handed with Z axis up or local, right handed, Z axis down. (uint8_t)
                p1x                       : x position 1 / Latitude 1 (float)
                p1y                       : y position 1 / Longitude 1 (float)
                p1z                       : z position 1 / Altitude 1 (float)
                p2x                       : x position 2 / Latitude 2 (float)
                p2y                       : y position 2 / Longitude 2 (float)
                p2z                       : z position 2 / Altitude 2 (float)

*/
    mavlink20.messages.safety_set_allowed_area = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.frame , this.p1x , this.p1y , this.p1z , this.p2x , this.p2y , this.p2z ] = moreargs;

    this._format = '<ffffffBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SAFETY_SET_ALLOWED_AREA;
    this.order_map = [6, 7, 8, 0, 1, 2, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 15;
    this._name = 'SAFETY_SET_ALLOWED_AREA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'frame', 'p1x', 'p1y', 'p1z', 'p2x', 'p2y', 'p2z'];

}

mavlink20.messages.safety_set_allowed_area.prototype = new mavlink20.message;
mavlink20.messages.safety_set_allowed_area.prototype.pack = function(mav) {
    var orderedfields = [ this.p1x, this.p1y, this.p1z, this.p2x, this.p2y, this.p2z, this.target_system, this.target_component, this.frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Read out the safety zone the MAV currently assumes.

                frame                     : Coordinate frame. Can be either global, GPS, right-handed with Z axis up or local, right handed, Z axis down. (uint8_t)
                p1x                       : x position 1 / Latitude 1 (float)
                p1y                       : y position 1 / Longitude 1 (float)
                p1z                       : z position 1 / Altitude 1 (float)
                p2x                       : x position 2 / Latitude 2 (float)
                p2y                       : y position 2 / Longitude 2 (float)
                p2z                       : z position 2 / Altitude 2 (float)

*/
    mavlink20.messages.safety_allowed_area = function( ...moreargs ) {
    [ this.frame , this.p1x , this.p1y , this.p1z , this.p2x , this.p2y , this.p2z ] = moreargs;

    this._format = '<ffffffB';
    this._id = mavlink20.MAVLINK_MSG_ID_SAFETY_ALLOWED_AREA;
    this.order_map = [6, 0, 1, 2, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 3;
    this._name = 'SAFETY_ALLOWED_AREA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['frame', 'p1x', 'p1y', 'p1z', 'p2x', 'p2y', 'p2z'];

}

mavlink20.messages.safety_allowed_area.prototype = new mavlink20.message;
mavlink20.messages.safety_allowed_area.prototype.pack = function(mav) {
    var orderedfields = [ this.p1x, this.p1y, this.p1z, this.p2x, this.p2y, this.p2z, this.frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The attitude in the aeronautical frame (right-handed, Z-down, X-front,
Y-right), expressed as quaternion. Quaternion order is w, x, y, z and
a zero rotation would be expressed as (1 0 0 0).

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                q                         : Quaternion components, w, x, y, z (1 0 0 0 is the null-rotation) (float)
                rollspeed                 : Roll angular speed (float)
                pitchspeed                : Pitch angular speed (float)
                yawspeed                  : Yaw angular speed (float)
                covariance                : Row-major representation of a 3x3 attitude covariance matrix (states: roll, pitch, yaw; first three entries are the first ROW, next three entries are the second row, etc.). If unknown, assign NaN value to first element in the array. (float)

*/
    mavlink20.messages.attitude_quaternion_cov = function( ...moreargs ) {
    [ this.time_usec , this.q , this.rollspeed , this.pitchspeed , this.yawspeed , this.covariance ] = moreargs;

    this._format = '<Q4ffff9f';
    this._id = mavlink20.MAVLINK_MSG_ID_ATTITUDE_QUATERNION_COV;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 4, 1, 1, 1, 9];
    this.array_len_map = [0, 4, 0, 0, 0, 9];
    this.crc_extra = 167;
    this._name = 'ATTITUDE_QUATERNION_COV';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'q', 'rollspeed', 'pitchspeed', 'yawspeed', 'covariance'];

}

mavlink20.messages.attitude_quaternion_cov.prototype = new mavlink20.message;
mavlink20.messages.attitude_quaternion_cov.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.q, this.rollspeed, this.pitchspeed, this.yawspeed, this.covariance];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The state of the navigation and position controller.

                nav_roll                  : Current desired roll (float)
                nav_pitch                 : Current desired pitch (float)
                nav_bearing               : Current desired heading (int16_t)
                target_bearing            : Bearing to current waypoint/target (int16_t)
                wp_dist                   : Distance to active waypoint (uint16_t)
                alt_error                 : Current altitude error (float)
                aspd_error                : Current airspeed error (float)
                xtrack_error              : Current crosstrack error on x-y plane (float)

*/
    mavlink20.messages.nav_controller_output = function( ...moreargs ) {
    [ this.nav_roll , this.nav_pitch , this.nav_bearing , this.target_bearing , this.wp_dist , this.alt_error , this.aspd_error , this.xtrack_error ] = moreargs;

    this._format = '<fffffhhH';
    this._id = mavlink20.MAVLINK_MSG_ID_NAV_CONTROLLER_OUTPUT;
    this.order_map = [0, 1, 5, 6, 7, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 183;
    this._name = 'NAV_CONTROLLER_OUTPUT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['nav_roll', 'nav_pitch', 'nav_bearing', 'target_bearing', 'wp_dist', 'alt_error', 'aspd_error', 'xtrack_error'];

}

mavlink20.messages.nav_controller_output.prototype = new mavlink20.message;
mavlink20.messages.nav_controller_output.prototype.pack = function(mav) {
    var orderedfields = [ this.nav_roll, this.nav_pitch, this.alt_error, this.aspd_error, this.xtrack_error, this.nav_bearing, this.target_bearing, this.wp_dist];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The filtered global position (e.g. fused GPS and accelerometers). The
position is in GPS-frame (right-handed, Z-up). It  is designed as
scaled integer message since the resolution of float is not
sufficient. NOTE: This message is intended for onboard networks /
companion computers and higher-bandwidth links and optimized for
accuracy and completeness. Please use the GLOBAL_POSITION_INT message
for a minimal subset.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                estimator_type            : Class id of the estimator this estimate originated from. (uint8_t)
                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)
                alt                       : Altitude in meters above MSL (int32_t)
                relative_alt              : Altitude above ground (int32_t)
                vx                        : Ground X Speed (Latitude) (float)
                vy                        : Ground Y Speed (Longitude) (float)
                vz                        : Ground Z Speed (Altitude) (float)
                covariance                : Row-major representation of a 6x6 position and velocity 6x6 cross-covariance matrix (states: lat, lon, alt, vx, vy, vz; first six entries are the first ROW, next six entries are the second row, etc.). If unknown, assign NaN value to first element in the array. (float)

*/
    mavlink20.messages.global_position_int_cov = function( ...moreargs ) {
    [ this.time_usec , this.estimator_type , this.lat , this.lon , this.alt , this.relative_alt , this.vx , this.vy , this.vz , this.covariance ] = moreargs;

    this._format = '<Qiiiifff36fB';
    this._id = mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_INT_COV;
    this.order_map = [0, 9, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 36, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 36, 0];
    this.crc_extra = 119;
    this._name = 'GLOBAL_POSITION_INT_COV';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'estimator_type', 'lat', 'lon', 'alt', 'relative_alt', 'vx', 'vy', 'vz', 'covariance'];

}

mavlink20.messages.global_position_int_cov.prototype = new mavlink20.message;
mavlink20.messages.global_position_int_cov.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.lat, this.lon, this.alt, this.relative_alt, this.vx, this.vy, this.vz, this.covariance, this.estimator_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The filtered local position (e.g. fused computer vision and
accelerometers). Coordinate frame is right-handed, Z-axis down
(aeronautical frame, NED / north-east-down convention)

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                estimator_type            : Class id of the estimator this estimate originated from. (uint8_t)
                x                         : X Position (float)
                y                         : Y Position (float)
                z                         : Z Position (float)
                vx                        : X Speed (float)
                vy                        : Y Speed (float)
                vz                        : Z Speed (float)
                ax                        : X Acceleration (float)
                ay                        : Y Acceleration (float)
                az                        : Z Acceleration (float)
                covariance                : Row-major representation of position, velocity and acceleration 9x9 cross-covariance matrix upper right triangle (states: x, y, z, vx, vy, vz, ax, ay, az; first nine entries are the first ROW, next eight entries are the second row, etc.). If unknown, assign NaN value to first element in the array. (float)

*/
    mavlink20.messages.local_position_ned_cov = function( ...moreargs ) {
    [ this.time_usec , this.estimator_type , this.x , this.y , this.z , this.vx , this.vy , this.vz , this.ax , this.ay , this.az , this.covariance ] = moreargs;

    this._format = '<Qfffffffff45fB';
    this._id = mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED_COV;
    this.order_map = [0, 11, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 45, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 45, 0];
    this.crc_extra = 191;
    this._name = 'LOCAL_POSITION_NED_COV';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'estimator_type', 'x', 'y', 'z', 'vx', 'vy', 'vz', 'ax', 'ay', 'az', 'covariance'];

}

mavlink20.messages.local_position_ned_cov.prototype = new mavlink20.message;
mavlink20.messages.local_position_ned_cov.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.x, this.y, this.z, this.vx, this.vy, this.vz, this.ax, this.ay, this.az, this.covariance, this.estimator_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The PPM values of the RC channels received. The standard PPM
modulation is as follows: 1000 microseconds: 0%, 2000 microseconds:
100%.  A value of UINT16_MAX implies the channel is unused. Individual
receivers/transmitters might violate this specification.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                chancount                 : Total number of RC channels being received. This can be larger than 18, indicating that more channels are available but not given in this message. This value should be 0 when no RC channels are available. (uint8_t)
                chan1_raw                 : RC channel 1 value. (uint16_t)
                chan2_raw                 : RC channel 2 value. (uint16_t)
                chan3_raw                 : RC channel 3 value. (uint16_t)
                chan4_raw                 : RC channel 4 value. (uint16_t)
                chan5_raw                 : RC channel 5 value. (uint16_t)
                chan6_raw                 : RC channel 6 value. (uint16_t)
                chan7_raw                 : RC channel 7 value. (uint16_t)
                chan8_raw                 : RC channel 8 value. (uint16_t)
                chan9_raw                 : RC channel 9 value. (uint16_t)
                chan10_raw                : RC channel 10 value. (uint16_t)
                chan11_raw                : RC channel 11 value. (uint16_t)
                chan12_raw                : RC channel 12 value. (uint16_t)
                chan13_raw                : RC channel 13 value. (uint16_t)
                chan14_raw                : RC channel 14 value. (uint16_t)
                chan15_raw                : RC channel 15 value. (uint16_t)
                chan16_raw                : RC channel 16 value. (uint16_t)
                chan17_raw                : RC channel 17 value. (uint16_t)
                chan18_raw                : RC channel 18 value. (uint16_t)
                rssi                      : Receive signal strength indicator in device-dependent units/scale. Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)

*/
    mavlink20.messages.rc_channels = function( ...moreargs ) {
    [ this.time_boot_ms , this.chancount , this.chan1_raw , this.chan2_raw , this.chan3_raw , this.chan4_raw , this.chan5_raw , this.chan6_raw , this.chan7_raw , this.chan8_raw , this.chan9_raw , this.chan10_raw , this.chan11_raw , this.chan12_raw , this.chan13_raw , this.chan14_raw , this.chan15_raw , this.chan16_raw , this.chan17_raw , this.chan18_raw , this.rssi ] = moreargs;

    this._format = '<IHHHHHHHHHHHHHHHHHHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_RC_CHANNELS;
    this.order_map = [0, 19, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 118;
    this._name = 'RC_CHANNELS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'chancount', 'chan1_raw', 'chan2_raw', 'chan3_raw', 'chan4_raw', 'chan5_raw', 'chan6_raw', 'chan7_raw', 'chan8_raw', 'chan9_raw', 'chan10_raw', 'chan11_raw', 'chan12_raw', 'chan13_raw', 'chan14_raw', 'chan15_raw', 'chan16_raw', 'chan17_raw', 'chan18_raw', 'rssi'];

}

mavlink20.messages.rc_channels.prototype = new mavlink20.message;
mavlink20.messages.rc_channels.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.chan1_raw, this.chan2_raw, this.chan3_raw, this.chan4_raw, this.chan5_raw, this.chan6_raw, this.chan7_raw, this.chan8_raw, this.chan9_raw, this.chan10_raw, this.chan11_raw, this.chan12_raw, this.chan13_raw, this.chan14_raw, this.chan15_raw, this.chan16_raw, this.chan17_raw, this.chan18_raw, this.chancount, this.rssi];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request a data stream.

                target_system             : The target requested to send the message stream. (uint8_t)
                target_component          : The target requested to send the message stream. (uint8_t)
                req_stream_id             : The ID of the requested data stream. (uint8_t)
                req_message_rate          : The requested message rate (uint16_t)
                start_stop                : 1 to start sending, 0 to stop sending. (uint8_t)

*/
    mavlink20.messages.request_data_stream = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.req_stream_id , this.req_message_rate , this.start_stop ] = moreargs;

    this._format = '<HBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_REQUEST_DATA_STREAM;
    this.order_map = [1, 2, 3, 0, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 148;
    this._name = 'REQUEST_DATA_STREAM';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'req_stream_id', 'req_message_rate', 'start_stop'];

}

mavlink20.messages.request_data_stream.prototype = new mavlink20.message;
mavlink20.messages.request_data_stream.prototype.pack = function(mav) {
    var orderedfields = [ this.req_message_rate, this.target_system, this.target_component, this.req_stream_id, this.start_stop];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data stream status information.

                stream_id                 : The ID of the requested data stream. (uint8_t)
                message_rate              : The message rate (uint16_t)
                on_off                    : 1 stream is enabled, 0 stream is stopped. (uint8_t)

*/
    mavlink20.messages.data_stream = function( ...moreargs ) {
    [ this.stream_id , this.message_rate , this.on_off ] = moreargs;

    this._format = '<HBB';
    this._id = mavlink20.MAVLINK_MSG_ID_DATA_STREAM;
    this.order_map = [1, 0, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 21;
    this._name = 'DATA_STREAM';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['stream_id', 'message_rate', 'on_off'];

}

mavlink20.messages.data_stream.prototype = new mavlink20.message;
mavlink20.messages.data_stream.prototype.pack = function(mav) {
    var orderedfields = [ this.message_rate, this.stream_id, this.on_off];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Manual (joystick) control message.         This message represents
movement axes and button using standard joystick axes nomenclature.
Unused axes can be disabled and buttons states are transmitted as
individual on/off bits of a bitmask. For more information see
https://mavlink.io/en/services/manual_control.html

                target                    : The system to be controlled. (uint8_t)
                x                         : X-axis, normalized to the range [-1000,1000]. A value of INT16_MAX indicates that this axis is invalid. Generally corresponds to forward(1000)-backward(-1000) movement on a joystick and the pitch of a vehicle. (int16_t)
                y                         : Y-axis, normalized to the range [-1000,1000]. A value of INT16_MAX indicates that this axis is invalid. Generally corresponds to left(-1000)-right(1000) movement on a joystick and the roll of a vehicle. (int16_t)
                z                         : Z-axis, normalized to the range [-1000,1000]. A value of INT16_MAX indicates that this axis is invalid. Generally corresponds to a separate slider movement with maximum being 1000 and minimum being -1000 on a joystick and the thrust of a vehicle. Positive values are positive thrust, negative values are negative thrust. (int16_t)
                r                         : R-axis, normalized to the range [-1000,1000]. A value of INT16_MAX indicates that this axis is invalid. Generally corresponds to a twisting of the joystick, with clockwise being 1000 and counter-clockwise being -1000, and the yaw of a vehicle. (int16_t)
                buttons                   : A bitfield corresponding to the joystick buttons' 0-15 current state, 1 for pressed, 0 for released. The lowest bit corresponds to Button 1. (uint16_t)
                buttons2                  : A bitfield corresponding to the joystick buttons' 16-31 current state, 1 for pressed, 0 for released. The lowest bit corresponds to Button 16. (uint16_t)
                enabled_extensions        : Set bits to 1 to indicate which of the following extension fields contain valid data: bit 0: pitch, bit 1: roll, bit 2: aux1, bit 3: aux2, bit 4: aux3, bit 5: aux4, bit 6: aux5, bit 7: aux6 (uint8_t)
                s                         : Pitch-only-axis, normalized to the range [-1000,1000]. Generally corresponds to pitch on vehicles with additional degrees of freedom. Valid if bit 0 of enabled_extensions field is set. Set to 0 if invalid. (int16_t)
                t                         : Roll-only-axis, normalized to the range [-1000,1000]. Generally corresponds to roll on vehicles with additional degrees of freedom. Valid if bit 1 of enabled_extensions field is set. Set to 0 if invalid. (int16_t)
                aux1                      : Aux continuous input field 1. Normalized in the range [-1000,1000]. Purpose defined by recipient. Valid data if bit 2 of enabled_extensions field is set. 0 if bit 2 is unset. (int16_t)
                aux2                      : Aux continuous input field 2. Normalized in the range [-1000,1000]. Purpose defined by recipient. Valid data if bit 3 of enabled_extensions field is set. 0 if bit 3 is unset. (int16_t)
                aux3                      : Aux continuous input field 3. Normalized in the range [-1000,1000]. Purpose defined by recipient. Valid data if bit 4 of enabled_extensions field is set. 0 if bit 4 is unset. (int16_t)
                aux4                      : Aux continuous input field 4. Normalized in the range [-1000,1000]. Purpose defined by recipient. Valid data if bit 5 of enabled_extensions field is set. 0 if bit 5 is unset. (int16_t)
                aux5                      : Aux continuous input field 5. Normalized in the range [-1000,1000]. Purpose defined by recipient. Valid data if bit 6 of enabled_extensions field is set. 0 if bit 6 is unset. (int16_t)
                aux6                      : Aux continuous input field 6. Normalized in the range [-1000,1000]. Purpose defined by recipient. Valid data if bit 7 of enabled_extensions field is set. 0 if bit 7 is unset. (int16_t)

*/
    mavlink20.messages.manual_control = function( ...moreargs ) {
    [ this.target , this.x , this.y , this.z , this.r , this.buttons , this.buttons2 , this.enabled_extensions , this.s , this.t , this.aux1 , this.aux2 , this.aux3 , this.aux4 , this.aux5 , this.aux6 ] = moreargs;

    this._format = '<hhhhHBHBhhhhhhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_MANUAL_CONTROL;
    this.order_map = [5, 0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 243;
    this._name = 'MANUAL_CONTROL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target', 'x', 'y', 'z', 'r', 'buttons', 'buttons2', 'enabled_extensions', 's', 't', 'aux1', 'aux2', 'aux3', 'aux4', 'aux5', 'aux6'];

}

mavlink20.messages.manual_control.prototype = new mavlink20.message;
mavlink20.messages.manual_control.prototype.pack = function(mav) {
    var orderedfields = [ this.x, this.y, this.z, this.r, this.buttons, this.target, this.buttons2, this.enabled_extensions, this.s, this.t, this.aux1, this.aux2, this.aux3, this.aux4, this.aux5, this.aux6];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW values of the RC channels sent to the MAV to override info
received from the RC radio. The standard PPM modulation is as follows:
1000 microseconds: 0%, 2000 microseconds: 100%. Individual
receivers/transmitters might violate this specification.  Note
carefully the semantic differences between the first 8 channels and
the subsequent channels

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                chan1_raw                 : RC channel 1 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan2_raw                 : RC channel 2 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan3_raw                 : RC channel 3 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan4_raw                 : RC channel 4 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan5_raw                 : RC channel 5 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan6_raw                 : RC channel 6 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan7_raw                 : RC channel 7 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan8_raw                 : RC channel 8 value. A value of UINT16_MAX means to ignore this field. A value of 0 means to release this channel back to the RC radio. (uint16_t)
                chan9_raw                 : RC channel 9 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan10_raw                : RC channel 10 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan11_raw                : RC channel 11 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan12_raw                : RC channel 12 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan13_raw                : RC channel 13 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan14_raw                : RC channel 14 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan15_raw                : RC channel 15 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan16_raw                : RC channel 16 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan17_raw                : RC channel 17 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)
                chan18_raw                : RC channel 18 value. A value of 0 or UINT16_MAX means to ignore this field. A value of UINT16_MAX-1 means to release this channel back to the RC radio. (uint16_t)

*/
    mavlink20.messages.rc_channels_override = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.chan1_raw , this.chan2_raw , this.chan3_raw , this.chan4_raw , this.chan5_raw , this.chan6_raw , this.chan7_raw , this.chan8_raw , this.chan9_raw , this.chan10_raw , this.chan11_raw , this.chan12_raw , this.chan13_raw , this.chan14_raw , this.chan15_raw , this.chan16_raw , this.chan17_raw , this.chan18_raw ] = moreargs;

    this._format = '<HHHHHHHHBBHHHHHHHHHH';
    this._id = mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_OVERRIDE;
    this.order_map = [8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 124;
    this._name = 'RC_CHANNELS_OVERRIDE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'chan1_raw', 'chan2_raw', 'chan3_raw', 'chan4_raw', 'chan5_raw', 'chan6_raw', 'chan7_raw', 'chan8_raw', 'chan9_raw', 'chan10_raw', 'chan11_raw', 'chan12_raw', 'chan13_raw', 'chan14_raw', 'chan15_raw', 'chan16_raw', 'chan17_raw', 'chan18_raw'];

}

mavlink20.messages.rc_channels_override.prototype = new mavlink20.message;
mavlink20.messages.rc_channels_override.prototype.pack = function(mav) {
    var orderedfields = [ this.chan1_raw, this.chan2_raw, this.chan3_raw, this.chan4_raw, this.chan5_raw, this.chan6_raw, this.chan7_raw, this.chan8_raw, this.target_system, this.target_component, this.chan9_raw, this.chan10_raw, this.chan11_raw, this.chan12_raw, this.chan13_raw, this.chan14_raw, this.chan15_raw, this.chan16_raw, this.chan17_raw, this.chan18_raw];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message encoding a mission item. This message is emitted to announce
the presence of a mission item and to set a mission item on the
system. The mission item can be either in x, y, z meters (type: LOCAL)
or x:lat, y:lon, z:altitude. Local frame is Z-down, right handed
(NED), global frame is Z-up, right handed (ENU). NaN or INT32_MAX may
be used in float/integer params (respectively) to indicate
optional/default values (e.g. to use the component's current latitude,
yaw rather than a specific value). See also
https://mavlink.io/en/services/mission.html.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                seq                       : Waypoint ID (sequence number). Starts at zero. Increases monotonically for each waypoint, no gaps in the sequence (0,1,2,3,4). (uint16_t)
                frame                     : The coordinate system of the waypoint. (uint8_t)
                command                   : The scheduled action for the waypoint. (uint16_t)
                current                   : false:0, true:1 (uint8_t)
                autocontinue              : Autocontinue to next waypoint. 0: false, 1: true. Set false to pause mission after the item completes. (uint8_t)
                param1                    : PARAM1, see MAV_CMD enum (float)
                param2                    : PARAM2, see MAV_CMD enum (float)
                param3                    : PARAM3, see MAV_CMD enum (float)
                param4                    : PARAM4, see MAV_CMD enum (float)
                x                         : PARAM5 / local: x position in meters * 1e4, global: latitude in degrees * 10^7 (int32_t)
                y                         : PARAM6 / y position: local: x position in meters * 1e4, global: longitude in degrees *10^7 (int32_t)
                z                         : PARAM7 / z position: global: altitude in meters (relative or absolute, depending on frame. (float)
                mission_type              : Mission type. (uint8_t)

*/
    mavlink20.messages.mission_item_int = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.seq , this.frame , this.command , this.current , this.autocontinue , this.param1 , this.param2 , this.param3 , this.param4 , this.x , this.y , this.z , this.mission_type ] = moreargs;

    this._format = '<ffffiifHHBBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MISSION_ITEM_INT;
    this.order_map = [9, 10, 7, 11, 8, 12, 13, 0, 1, 2, 3, 4, 5, 6, 14];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 38;
    this._name = 'MISSION_ITEM_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'seq', 'frame', 'command', 'current', 'autocontinue', 'param1', 'param2', 'param3', 'param4', 'x', 'y', 'z', 'mission_type'];

}

mavlink20.messages.mission_item_int.prototype = new mavlink20.message;
mavlink20.messages.mission_item_int.prototype.pack = function(mav) {
    var orderedfields = [ this.param1, this.param2, this.param3, this.param4, this.x, this.y, this.z, this.seq, this.command, this.target_system, this.target_component, this.frame, this.current, this.autocontinue, this.mission_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Metrics typically displayed on a HUD for fixed wing aircraft.

                airspeed                  : Vehicle speed in form appropriate for vehicle type. For standard aircraft this is typically calibrated airspeed (CAS) or indicated airspeed (IAS) - either of which can be used by a pilot to estimate stall speed. (float)
                groundspeed               : Current ground speed. (float)
                heading                   : Current heading in compass units (0-360, 0=north). (int16_t)
                throttle                  : Current throttle setting (0 to 100). (uint16_t)
                alt                       : Current altitude (MSL). (float)
                climb                     : Current climb rate. (float)

*/
    mavlink20.messages.vfr_hud = function( ...moreargs ) {
    [ this.airspeed , this.groundspeed , this.heading , this.throttle , this.alt , this.climb ] = moreargs;

    this._format = '<ffffhH';
    this._id = mavlink20.MAVLINK_MSG_ID_VFR_HUD;
    this.order_map = [0, 1, 4, 5, 2, 3];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0];
    this.crc_extra = 20;
    this._name = 'VFR_HUD';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['airspeed', 'groundspeed', 'heading', 'throttle', 'alt', 'climb'];

}

mavlink20.messages.vfr_hud.prototype = new mavlink20.message;
mavlink20.messages.vfr_hud.prototype.pack = function(mav) {
    var orderedfields = [ this.airspeed, this.groundspeed, this.alt, this.climb, this.heading, this.throttle];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Send a command with up to seven parameters to the MAV, where params 5
and 6 are integers and the other values are floats. This is preferred
over COMMAND_LONG as it allows the MAV_FRAME to be specified for
interpreting positional information, such as altitude. COMMAND_INT is
also preferred when sending latitude and longitude data in params 5
and 6, as it allows for greater precision. Param 5 and 6 encode
positional data as scaled integers, where the scaling depends on the
actual command value. NaN or INT32_MAX may be used in float/integer
params (respectively) to indicate optional/default values (e.g. to use
the component's current latitude, yaw rather than a specific value).
The command microservice is documented at
https://mavlink.io/en/services/command.html

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                frame                     : The coordinate system of the COMMAND. (uint8_t)
                command                   : The scheduled action for the mission item. (uint16_t)
                current                   : Not used. (uint8_t)
                autocontinue              : Not used (set 0). (uint8_t)
                param1                    : PARAM1, see MAV_CMD enum (float)
                param2                    : PARAM2, see MAV_CMD enum (float)
                param3                    : PARAM3, see MAV_CMD enum (float)
                param4                    : PARAM4, see MAV_CMD enum (float)
                x                         : PARAM5 / local: x position in meters * 1e4, global: latitude in degrees * 10^7 (int32_t)
                y                         : PARAM6 / local: y position in meters * 1e4, global: longitude in degrees * 10^7 (int32_t)
                z                         : PARAM7 / z position: global: altitude in meters (relative or absolute, depending on frame). (float)

*/
    mavlink20.messages.command_int = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.frame , this.command , this.current , this.autocontinue , this.param1 , this.param2 , this.param3 , this.param4 , this.x , this.y , this.z ] = moreargs;

    this._format = '<ffffiifHBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_COMMAND_INT;
    this.order_map = [8, 9, 10, 7, 11, 12, 0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 158;
    this._name = 'COMMAND_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'frame', 'command', 'current', 'autocontinue', 'param1', 'param2', 'param3', 'param4', 'x', 'y', 'z'];

}

mavlink20.messages.command_int.prototype = new mavlink20.message;
mavlink20.messages.command_int.prototype.pack = function(mav) {
    var orderedfields = [ this.param1, this.param2, this.param3, this.param4, this.x, this.y, this.z, this.command, this.target_system, this.target_component, this.frame, this.current, this.autocontinue];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Send a command with up to seven parameters to the MAV. COMMAND_INT is
generally preferred when sending MAV_CMD commands that include
positional information; it offers higher precision and allows the
MAV_FRAME to be specified (which may otherwise be ambiguous,
particularly for altitude). The command microservice is documented at
https://mavlink.io/en/services/command.html

                target_system             : System which should execute the command (uint8_t)
                target_component          : Component which should execute the command, 0 for all components (uint8_t)
                command                   : Command ID (of command to send). (uint16_t)
                confirmation              : 0: First transmission of this command. 1-255: Confirmation transmissions (e.g. for kill command) (uint8_t)
                param1                    : Parameter 1 (for the specific command). (float)
                param2                    : Parameter 2 (for the specific command). (float)
                param3                    : Parameter 3 (for the specific command). (float)
                param4                    : Parameter 4 (for the specific command). (float)
                param5                    : Parameter 5 (for the specific command). (float)
                param6                    : Parameter 6 (for the specific command). (float)
                param7                    : Parameter 7 (for the specific command). (float)

*/
    mavlink20.messages.command_long = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.command , this.confirmation , this.param1 , this.param2 , this.param3 , this.param4 , this.param5 , this.param6 , this.param7 ] = moreargs;

    this._format = '<fffffffHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_COMMAND_LONG;
    this.order_map = [8, 9, 7, 10, 0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 152;
    this._name = 'COMMAND_LONG';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'command', 'confirmation', 'param1', 'param2', 'param3', 'param4', 'param5', 'param6', 'param7'];

}

mavlink20.messages.command_long.prototype = new mavlink20.message;
mavlink20.messages.command_long.prototype.pack = function(mav) {
    var orderedfields = [ this.param1, this.param2, this.param3, this.param4, this.param5, this.param6, this.param7, this.command, this.target_system, this.target_component, this.confirmation];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Report status of a command. Includes feedback whether the command was
executed. The command microservice is documented at
https://mavlink.io/en/services/command.html

                command                   : Command ID (of acknowledged command). (uint16_t)
                result                    : Result of command. (uint8_t)
                progress                  : The progress percentage when result is MAV_RESULT_IN_PROGRESS. Values: [0-100], or UINT8_MAX if the progress is unknown. (uint8_t)
                result_param2             : Additional result information. Can be set with a command-specific enum containing command-specific error reasons for why the command might be denied. If used, the associated enum must be documented in the corresponding MAV_CMD (this enum should have a 0 value to indicate "unused" or "unknown"). (int32_t)
                target_system             : System ID of the target recipient. This is the ID of the system that sent the command for which this COMMAND_ACK is an acknowledgement. (uint8_t)
                target_component          : Component ID of the target recipient. This is the ID of the system that sent the command for which this COMMAND_ACK is an acknowledgement. (uint8_t)

*/
    mavlink20.messages.command_ack = function( ...moreargs ) {
    [ this.command , this.result , this.progress , this.result_param2 , this.target_system , this.target_component ] = moreargs;

    this._format = '<HBBiBB';
    this._id = mavlink20.MAVLINK_MSG_ID_COMMAND_ACK;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0];
    this.crc_extra = 143;
    this._name = 'COMMAND_ACK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['command', 'result', 'progress', 'result_param2', 'target_system', 'target_component'];

}

mavlink20.messages.command_ack.prototype = new mavlink20.message;
mavlink20.messages.command_ack.prototype.pack = function(mav) {
    var orderedfields = [ this.command, this.result, this.progress, this.result_param2, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Cancel a long running command. The target system should respond with a
COMMAND_ACK to the original command with result=MAV_RESULT_CANCELLED
if the long running process was cancelled. If it has already
completed, the cancel action can be ignored. The cancel action can be
retried until some sort of acknowledgement to the original command has
been received. The command microservice is documented at
https://mavlink.io/en/services/command.html

                target_system             : System executing long running command. Should not be broadcast (0). (uint8_t)
                target_component          : Component executing long running command. (uint8_t)
                command                   : Command ID (of command to cancel). (uint16_t)

*/
    mavlink20.messages.command_cancel = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.command ] = moreargs;

    this._format = '<HBB';
    this._id = mavlink20.MAVLINK_MSG_ID_COMMAND_CANCEL;
    this.order_map = [1, 2, 0];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 14;
    this._name = 'COMMAND_CANCEL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'command'];

}

mavlink20.messages.command_cancel.prototype = new mavlink20.message;
mavlink20.messages.command_cancel.prototype.pack = function(mav) {
    var orderedfields = [ this.command, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Setpoint in roll, pitch, yaw and thrust from the operator

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                roll                      : Desired roll rate (float)
                pitch                     : Desired pitch rate (float)
                yaw                       : Desired yaw rate (float)
                thrust                    : Collective thrust, normalized to 0 .. 1 (float)
                mode_switch               : Flight mode switch position, 0.. 255 (uint8_t)
                manual_override_switch        : Override mode switch position, 0.. 255 (uint8_t)

*/
    mavlink20.messages.manual_setpoint = function( ...moreargs ) {
    [ this.time_boot_ms , this.roll , this.pitch , this.yaw , this.thrust , this.mode_switch , this.manual_override_switch ] = moreargs;

    this._format = '<IffffBB';
    this._id = mavlink20.MAVLINK_MSG_ID_MANUAL_SETPOINT;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 106;
    this._name = 'MANUAL_SETPOINT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'roll', 'pitch', 'yaw', 'thrust', 'mode_switch', 'manual_override_switch'];

}

mavlink20.messages.manual_setpoint.prototype = new mavlink20.message;
mavlink20.messages.manual_setpoint.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.roll, this.pitch, this.yaw, this.thrust, this.mode_switch, this.manual_override_switch];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sets a desired vehicle attitude. Used by an external controller to
command the vehicle (manual controller or other system).

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                type_mask                 : Bitmap to indicate which dimensions should be ignored by the vehicle. (uint8_t)
                q                         : Attitude quaternion (w, x, y, z order, zero-rotation is 1, 0, 0, 0) from MAV_FRAME_LOCAL_NED to MAV_FRAME_BODY_FRD (float)
                body_roll_rate            : Body roll rate (float)
                body_pitch_rate           : Body pitch rate (float)
                body_yaw_rate             : Body yaw rate (float)
                thrust                    : Collective thrust, normalized to 0 .. 1 (-1 .. 1 for vehicles capable of reverse thrust) (float)
                thrust_body               : 3D thrust setpoint in the body NED frame, normalized to -1 .. 1 (float)

*/
    mavlink20.messages.set_attitude_target = function( ...moreargs ) {
    [ this.time_boot_ms , this.target_system , this.target_component , this.type_mask , this.q , this.body_roll_rate , this.body_pitch_rate , this.body_yaw_rate , this.thrust , this.thrust_body ] = moreargs;

    this._format = '<I4fffffBBB3f';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_ATTITUDE_TARGET;
    this.order_map = [0, 6, 7, 8, 1, 2, 3, 4, 5, 9];
    this.len_map = [1, 4, 1, 1, 1, 1, 1, 1, 1, 3];
    this.array_len_map = [0, 4, 0, 0, 0, 0, 0, 0, 0, 3];
    this.crc_extra = 49;
    this._name = 'SET_ATTITUDE_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'target_system', 'target_component', 'type_mask', 'q', 'body_roll_rate', 'body_pitch_rate', 'body_yaw_rate', 'thrust', 'thrust_body'];

}

mavlink20.messages.set_attitude_target.prototype = new mavlink20.message;
mavlink20.messages.set_attitude_target.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.q, this.body_roll_rate, this.body_pitch_rate, this.body_yaw_rate, this.thrust, this.target_system, this.target_component, this.type_mask, this.thrust_body];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports the current commanded attitude of the vehicle as specified by
the autopilot. This should match the commands sent in a
SET_ATTITUDE_TARGET message if the vehicle is being controlled this
way.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                type_mask                 : Bitmap to indicate which dimensions should be ignored by the vehicle. (uint8_t)
                q                         : Attitude quaternion (w, x, y, z order, zero-rotation is 1, 0, 0, 0) (float)
                body_roll_rate            : Body roll rate (float)
                body_pitch_rate           : Body pitch rate (float)
                body_yaw_rate             : Body yaw rate (float)
                thrust                    : Collective thrust, normalized to 0 .. 1 (-1 .. 1 for vehicles capable of reverse thrust) (float)

*/
    mavlink20.messages.attitude_target = function( ...moreargs ) {
    [ this.time_boot_ms , this.type_mask , this.q , this.body_roll_rate , this.body_pitch_rate , this.body_yaw_rate , this.thrust ] = moreargs;

    this._format = '<I4fffffB';
    this._id = mavlink20.MAVLINK_MSG_ID_ATTITUDE_TARGET;
    this.order_map = [0, 6, 1, 2, 3, 4, 5];
    this.len_map = [1, 4, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 4, 0, 0, 0, 0, 0];
    this.crc_extra = 22;
    this._name = 'ATTITUDE_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'type_mask', 'q', 'body_roll_rate', 'body_pitch_rate', 'body_yaw_rate', 'thrust'];

}

mavlink20.messages.attitude_target.prototype = new mavlink20.message;
mavlink20.messages.attitude_target.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.q, this.body_roll_rate, this.body_pitch_rate, this.body_yaw_rate, this.thrust, this.type_mask];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sets a desired vehicle position in a local north-east-down coordinate
frame. Used by an external controller to command the vehicle (manual
controller or other system).

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                coordinate_frame          : Valid options are: MAV_FRAME_LOCAL_NED = 1, MAV_FRAME_LOCAL_OFFSET_NED = 7, MAV_FRAME_BODY_NED = 8, MAV_FRAME_BODY_OFFSET_NED = 9 (uint8_t)
                type_mask                 : Bitmap to indicate which dimensions should be ignored by the vehicle. (uint16_t)
                x                         : X Position in NED frame (float)
                y                         : Y Position in NED frame (float)
                z                         : Z Position in NED frame (note, altitude is negative in NED) (float)
                vx                        : X velocity in NED frame (float)
                vy                        : Y velocity in NED frame (float)
                vz                        : Z velocity in NED frame (float)
                afx                       : X acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afy                       : Y acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afz                       : Z acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                yaw                       : yaw setpoint (float)
                yaw_rate                  : yaw rate setpoint (float)

*/
    mavlink20.messages.set_position_target_local_ned = function( ...moreargs ) {
    [ this.time_boot_ms , this.target_system , this.target_component , this.coordinate_frame , this.type_mask , this.x , this.y , this.z , this.vx , this.vy , this.vz , this.afx , this.afy , this.afz , this.yaw , this.yaw_rate ] = moreargs;

    this._format = '<IfffffffffffHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_POSITION_TARGET_LOCAL_NED;
    this.order_map = [0, 13, 14, 15, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 143;
    this._name = 'SET_POSITION_TARGET_LOCAL_NED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'target_system', 'target_component', 'coordinate_frame', 'type_mask', 'x', 'y', 'z', 'vx', 'vy', 'vz', 'afx', 'afy', 'afz', 'yaw', 'yaw_rate'];

}

mavlink20.messages.set_position_target_local_ned.prototype = new mavlink20.message;
mavlink20.messages.set_position_target_local_ned.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.x, this.y, this.z, this.vx, this.vy, this.vz, this.afx, this.afy, this.afz, this.yaw, this.yaw_rate, this.type_mask, this.target_system, this.target_component, this.coordinate_frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports the current commanded vehicle position, velocity, and
acceleration as specified by the autopilot. This should match the
commands sent in SET_POSITION_TARGET_LOCAL_NED if the vehicle is being
controlled this way.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                coordinate_frame          : Valid options are: MAV_FRAME_LOCAL_NED = 1, MAV_FRAME_LOCAL_OFFSET_NED = 7, MAV_FRAME_BODY_NED = 8, MAV_FRAME_BODY_OFFSET_NED = 9 (uint8_t)
                type_mask                 : Bitmap to indicate which dimensions should be ignored by the vehicle. (uint16_t)
                x                         : X Position in NED frame (float)
                y                         : Y Position in NED frame (float)
                z                         : Z Position in NED frame (note, altitude is negative in NED) (float)
                vx                        : X velocity in NED frame (float)
                vy                        : Y velocity in NED frame (float)
                vz                        : Z velocity in NED frame (float)
                afx                       : X acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afy                       : Y acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afz                       : Z acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                yaw                       : yaw setpoint (float)
                yaw_rate                  : yaw rate setpoint (float)

*/
    mavlink20.messages.position_target_local_ned = function( ...moreargs ) {
    [ this.time_boot_ms , this.coordinate_frame , this.type_mask , this.x , this.y , this.z , this.vx , this.vy , this.vz , this.afx , this.afy , this.afz , this.yaw , this.yaw_rate ] = moreargs;

    this._format = '<IfffffffffffHB';
    this._id = mavlink20.MAVLINK_MSG_ID_POSITION_TARGET_LOCAL_NED;
    this.order_map = [0, 13, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 140;
    this._name = 'POSITION_TARGET_LOCAL_NED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'coordinate_frame', 'type_mask', 'x', 'y', 'z', 'vx', 'vy', 'vz', 'afx', 'afy', 'afz', 'yaw', 'yaw_rate'];

}

mavlink20.messages.position_target_local_ned.prototype = new mavlink20.message;
mavlink20.messages.position_target_local_ned.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.x, this.y, this.z, this.vx, this.vy, this.vz, this.afx, this.afy, this.afz, this.yaw, this.yaw_rate, this.type_mask, this.coordinate_frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sets a desired vehicle position, velocity, and/or acceleration in a
global coordinate system (WGS84). Used by an external controller to
command the vehicle (manual controller or other system).

                time_boot_ms              : Timestamp (time since system boot). The rationale for the timestamp in the setpoint is to allow the system to compensate for the transport delay of the setpoint. This allows the system to compensate processing latency. (uint32_t)
                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                coordinate_frame          : Valid options are: MAV_FRAME_GLOBAL = 0, MAV_FRAME_GLOBAL_RELATIVE_ALT = 3, MAV_FRAME_GLOBAL_TERRAIN_ALT = 10 (MAV_FRAME_GLOBAL_INT, MAV_FRAME_GLOBAL_RELATIVE_ALT_INT, MAV_FRAME_GLOBAL_TERRAIN_ALT_INT are allowed synonyms, but have been deprecated) (uint8_t)
                type_mask                 : Bitmap to indicate which dimensions should be ignored by the vehicle. (uint16_t)
                lat_int                   : Latitude in WGS84 frame (int32_t)
                lon_int                   : Longitude in WGS84 frame (int32_t)
                alt                       : Altitude (MSL, Relative to home, or AGL - depending on frame) (float)
                vx                        : X velocity in NED frame (float)
                vy                        : Y velocity in NED frame (float)
                vz                        : Z velocity in NED frame (float)
                afx                       : X acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afy                       : Y acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afz                       : Z acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                yaw                       : yaw setpoint (float)
                yaw_rate                  : yaw rate setpoint (float)

*/
    mavlink20.messages.set_position_target_global_int = function( ...moreargs ) {
    [ this.time_boot_ms , this.target_system , this.target_component , this.coordinate_frame , this.type_mask , this.lat_int , this.lon_int , this.alt , this.vx , this.vy , this.vz , this.afx , this.afy , this.afz , this.yaw , this.yaw_rate ] = moreargs;

    this._format = '<IiifffffffffHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_POSITION_TARGET_GLOBAL_INT;
    this.order_map = [0, 13, 14, 15, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 5;
    this._name = 'SET_POSITION_TARGET_GLOBAL_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'target_system', 'target_component', 'coordinate_frame', 'type_mask', 'lat_int', 'lon_int', 'alt', 'vx', 'vy', 'vz', 'afx', 'afy', 'afz', 'yaw', 'yaw_rate'];

}

mavlink20.messages.set_position_target_global_int.prototype = new mavlink20.message;
mavlink20.messages.set_position_target_global_int.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.lat_int, this.lon_int, this.alt, this.vx, this.vy, this.vz, this.afx, this.afy, this.afz, this.yaw, this.yaw_rate, this.type_mask, this.target_system, this.target_component, this.coordinate_frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports the current commanded vehicle position, velocity, and
acceleration as specified by the autopilot. This should match the
commands sent in SET_POSITION_TARGET_GLOBAL_INT if the vehicle is
being controlled this way.

                time_boot_ms              : Timestamp (time since system boot). The rationale for the timestamp in the setpoint is to allow the system to compensate for the transport delay of the setpoint. This allows the system to compensate processing latency. (uint32_t)
                coordinate_frame          : Valid options are: MAV_FRAME_GLOBAL = 0, MAV_FRAME_GLOBAL_RELATIVE_ALT = 3, MAV_FRAME_GLOBAL_TERRAIN_ALT = 10 (MAV_FRAME_GLOBAL_INT, MAV_FRAME_GLOBAL_RELATIVE_ALT_INT, MAV_FRAME_GLOBAL_TERRAIN_ALT_INT are allowed synonyms, but have been deprecated) (uint8_t)
                type_mask                 : Bitmap to indicate which dimensions should be ignored by the vehicle. (uint16_t)
                lat_int                   : Latitude in WGS84 frame (int32_t)
                lon_int                   : Longitude in WGS84 frame (int32_t)
                alt                       : Altitude (MSL, AGL or relative to home altitude, depending on frame) (float)
                vx                        : X velocity in NED frame (float)
                vy                        : Y velocity in NED frame (float)
                vz                        : Z velocity in NED frame (float)
                afx                       : X acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afy                       : Y acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                afz                       : Z acceleration or force (if bit 10 of type_mask is set) in NED frame in meter / s^2 or N (float)
                yaw                       : yaw setpoint (float)
                yaw_rate                  : yaw rate setpoint (float)

*/
    mavlink20.messages.position_target_global_int = function( ...moreargs ) {
    [ this.time_boot_ms , this.coordinate_frame , this.type_mask , this.lat_int , this.lon_int , this.alt , this.vx , this.vy , this.vz , this.afx , this.afy , this.afz , this.yaw , this.yaw_rate ] = moreargs;

    this._format = '<IiifffffffffHB';
    this._id = mavlink20.MAVLINK_MSG_ID_POSITION_TARGET_GLOBAL_INT;
    this.order_map = [0, 13, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 150;
    this._name = 'POSITION_TARGET_GLOBAL_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'coordinate_frame', 'type_mask', 'lat_int', 'lon_int', 'alt', 'vx', 'vy', 'vz', 'afx', 'afy', 'afz', 'yaw', 'yaw_rate'];

}

mavlink20.messages.position_target_global_int.prototype = new mavlink20.message;
mavlink20.messages.position_target_global_int.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.lat_int, this.lon_int, this.alt, this.vx, this.vy, this.vz, this.afx, this.afy, this.afz, this.yaw, this.yaw_rate, this.type_mask, this.coordinate_frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The offset in X, Y, Z and yaw between the LOCAL_POSITION_NED messages
of MAV X and the global coordinate frame in NED coordinates.
Coordinate frame is right-handed, Z-axis down (aeronautical frame, NED
/ north-east-down convention)

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                x                         : X Position (float)
                y                         : Y Position (float)
                z                         : Z Position (float)
                roll                      : Roll (float)
                pitch                     : Pitch (float)
                yaw                       : Yaw (float)

*/
    mavlink20.messages.local_position_ned_system_global_offset = function( ...moreargs ) {
    [ this.time_boot_ms , this.x , this.y , this.z , this.roll , this.pitch , this.yaw ] = moreargs;

    this._format = '<Iffffff';
    this._id = mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED_SYSTEM_GLOBAL_OFFSET;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 231;
    this._name = 'LOCAL_POSITION_NED_SYSTEM_GLOBAL_OFFSET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'x', 'y', 'z', 'roll', 'pitch', 'yaw'];

}

mavlink20.messages.local_position_ned_system_global_offset.prototype = new mavlink20.message;
mavlink20.messages.local_position_ned_system_global_offset.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.x, this.y, this.z, this.roll, this.pitch, this.yaw];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sent from simulation to autopilot. This packet is useful for high
throughput applications such as hardware in the loop simulations.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                roll                      : Roll angle (float)
                pitch                     : Pitch angle (float)
                yaw                       : Yaw angle (float)
                rollspeed                 : Body frame roll / phi angular speed (float)
                pitchspeed                : Body frame pitch / theta angular speed (float)
                yawspeed                  : Body frame yaw / psi angular speed (float)
                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)
                alt                       : Altitude (int32_t)
                vx                        : Ground X Speed (Latitude) (int16_t)
                vy                        : Ground Y Speed (Longitude) (int16_t)
                vz                        : Ground Z Speed (Altitude) (int16_t)
                xacc                      : X acceleration (int16_t)
                yacc                      : Y acceleration (int16_t)
                zacc                      : Z acceleration (int16_t)

*/
    mavlink20.messages.hil_state = function( ...moreargs ) {
    [ this.time_usec , this.roll , this.pitch , this.yaw , this.rollspeed , this.pitchspeed , this.yawspeed , this.lat , this.lon , this.alt , this.vx , this.vy , this.vz , this.xacc , this.yacc , this.zacc ] = moreargs;

    this._format = '<Qffffffiiihhhhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_STATE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 183;
    this._name = 'HIL_STATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'roll', 'pitch', 'yaw', 'rollspeed', 'pitchspeed', 'yawspeed', 'lat', 'lon', 'alt', 'vx', 'vy', 'vz', 'xacc', 'yacc', 'zacc'];

}

mavlink20.messages.hil_state.prototype = new mavlink20.message;
mavlink20.messages.hil_state.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.roll, this.pitch, this.yaw, this.rollspeed, this.pitchspeed, this.yawspeed, this.lat, this.lon, this.alt, this.vx, this.vy, this.vz, this.xacc, this.yacc, this.zacc];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sent from autopilot to simulation. Hardware in the loop control
outputs. Alternative to HIL_ACTUATOR_CONTROLS.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                roll_ailerons             : Control output -1 .. 1 (float)
                pitch_elevator            : Control output -1 .. 1 (float)
                yaw_rudder                : Control output -1 .. 1 (float)
                throttle                  : Throttle 0 .. 1 (float)
                aux1                      : Aux 1, -1 .. 1 (float)
                aux2                      : Aux 2, -1 .. 1 (float)
                aux3                      : Aux 3, -1 .. 1 (float)
                aux4                      : Aux 4, -1 .. 1 (float)
                mode                      : System mode. (uint8_t)
                nav_mode                  : Navigation mode (MAV_NAV_MODE) (uint8_t)

*/
    mavlink20.messages.hil_controls = function( ...moreargs ) {
    [ this.time_usec , this.roll_ailerons , this.pitch_elevator , this.yaw_rudder , this.throttle , this.aux1 , this.aux2 , this.aux3 , this.aux4 , this.mode , this.nav_mode ] = moreargs;

    this._format = '<QffffffffBB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_CONTROLS;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 63;
    this._name = 'HIL_CONTROLS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'roll_ailerons', 'pitch_elevator', 'yaw_rudder', 'throttle', 'aux1', 'aux2', 'aux3', 'aux4', 'mode', 'nav_mode'];

}

mavlink20.messages.hil_controls.prototype = new mavlink20.message;
mavlink20.messages.hil_controls.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.roll_ailerons, this.pitch_elevator, this.yaw_rudder, this.throttle, this.aux1, this.aux2, this.aux3, this.aux4, this.mode, this.nav_mode];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sent from simulation to autopilot. The RAW values of the RC channels
received. The standard PPM modulation is as follows: 1000
microseconds: 0%, 2000 microseconds: 100%. Individual
receivers/transmitters might violate this specification.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                chan1_raw                 : RC channel 1 value (uint16_t)
                chan2_raw                 : RC channel 2 value (uint16_t)
                chan3_raw                 : RC channel 3 value (uint16_t)
                chan4_raw                 : RC channel 4 value (uint16_t)
                chan5_raw                 : RC channel 5 value (uint16_t)
                chan6_raw                 : RC channel 6 value (uint16_t)
                chan7_raw                 : RC channel 7 value (uint16_t)
                chan8_raw                 : RC channel 8 value (uint16_t)
                chan9_raw                 : RC channel 9 value (uint16_t)
                chan10_raw                : RC channel 10 value (uint16_t)
                chan11_raw                : RC channel 11 value (uint16_t)
                chan12_raw                : RC channel 12 value (uint16_t)
                rssi                      : Receive signal strength indicator in device-dependent units/scale. Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)

*/
    mavlink20.messages.hil_rc_inputs_raw = function( ...moreargs ) {
    [ this.time_usec , this.chan1_raw , this.chan2_raw , this.chan3_raw , this.chan4_raw , this.chan5_raw , this.chan6_raw , this.chan7_raw , this.chan8_raw , this.chan9_raw , this.chan10_raw , this.chan11_raw , this.chan12_raw , this.rssi ] = moreargs;

    this._format = '<QHHHHHHHHHHHHB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_RC_INPUTS_RAW;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 54;
    this._name = 'HIL_RC_INPUTS_RAW';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'chan1_raw', 'chan2_raw', 'chan3_raw', 'chan4_raw', 'chan5_raw', 'chan6_raw', 'chan7_raw', 'chan8_raw', 'chan9_raw', 'chan10_raw', 'chan11_raw', 'chan12_raw', 'rssi'];

}

mavlink20.messages.hil_rc_inputs_raw.prototype = new mavlink20.message;
mavlink20.messages.hil_rc_inputs_raw.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.chan1_raw, this.chan2_raw, this.chan3_raw, this.chan4_raw, this.chan5_raw, this.chan6_raw, this.chan7_raw, this.chan8_raw, this.chan9_raw, this.chan10_raw, this.chan11_raw, this.chan12_raw, this.rssi];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sent from autopilot to simulation. Hardware in the loop control
outputs. Alternative to HIL_CONTROLS.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                controls                  : Control outputs -1 .. 1. Channel assignment depends on the simulated hardware. (float)
                mode                      : System mode. Includes arming state. (uint8_t)
                flags                     : Flags bitmask. (uint64_t)

*/
    mavlink20.messages.hil_actuator_controls = function( ...moreargs ) {
    [ this.time_usec , this.controls , this.mode , this.flags ] = moreargs;

    this._format = '<QQ16fB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_ACTUATOR_CONTROLS;
    this.order_map = [0, 2, 3, 1];
    this.len_map = [1, 1, 16, 1];
    this.array_len_map = [0, 0, 16, 0];
    this.crc_extra = 47;
    this._name = 'HIL_ACTUATOR_CONTROLS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'controls', 'mode', 'flags'];

}

mavlink20.messages.hil_actuator_controls.prototype = new mavlink20.message;
mavlink20.messages.hil_actuator_controls.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.flags, this.controls, this.mode];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Optical flow from a flow sensor (e.g. optical mouse sensor)

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                sensor_id                 : Sensor ID (uint8_t)
                flow_x                    : Flow in x-sensor direction (int16_t)
                flow_y                    : Flow in y-sensor direction (int16_t)
                flow_comp_m_x             : Flow in x-sensor direction, angular-speed compensated (float)
                flow_comp_m_y             : Flow in y-sensor direction, angular-speed compensated (float)
                quality                   : Optical flow quality / confidence. 0: bad, 255: maximum quality (uint8_t)
                ground_distance           : Ground distance. Positive value: distance known. Negative value: Unknown distance (float)
                flow_rate_x               : Flow rate about X axis (float)
                flow_rate_y               : Flow rate about Y axis (float)

*/
    mavlink20.messages.optical_flow = function( ...moreargs ) {
    [ this.time_usec , this.sensor_id , this.flow_x , this.flow_y , this.flow_comp_m_x , this.flow_comp_m_y , this.quality , this.ground_distance , this.flow_rate_x , this.flow_rate_y ] = moreargs;

    this._format = '<QfffhhBBff';
    this._id = mavlink20.MAVLINK_MSG_ID_OPTICAL_FLOW;
    this.order_map = [0, 6, 4, 5, 1, 2, 7, 3, 8, 9];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 175;
    this._name = 'OPTICAL_FLOW';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'sensor_id', 'flow_x', 'flow_y', 'flow_comp_m_x', 'flow_comp_m_y', 'quality', 'ground_distance', 'flow_rate_x', 'flow_rate_y'];

}

mavlink20.messages.optical_flow.prototype = new mavlink20.message;
mavlink20.messages.optical_flow.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.flow_comp_m_x, this.flow_comp_m_y, this.ground_distance, this.flow_x, this.flow_y, this.sensor_id, this.quality, this.flow_rate_x, this.flow_rate_y];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Global position/attitude estimate from a vision source.

                usec                      : Timestamp (UNIX time or since system boot) (uint64_t)
                x                         : Global X position (float)
                y                         : Global Y position (float)
                z                         : Global Z position (float)
                roll                      : Roll angle (float)
                pitch                     : Pitch angle (float)
                yaw                       : Yaw angle (float)
                covariance                : Row-major representation of pose 6x6 cross-covariance matrix upper right triangle (states: x_global, y_global, z_global, roll, pitch, yaw; first six entries are the first ROW, next five entries are the second ROW, etc.). If unknown, assign NaN value to first element in the array. (float)
                reset_counter             : Estimate reset counter. This should be incremented when the estimate resets in any of the dimensions (position, velocity, attitude, angular speed). This is designed to be used when e.g an external SLAM system detects a loop-closure and the estimate jumps. (uint8_t)

*/
    mavlink20.messages.global_vision_position_estimate = function( ...moreargs ) {
    [ this.usec , this.x , this.y , this.z , this.roll , this.pitch , this.yaw , this.covariance , this.reset_counter ] = moreargs;

    this._format = '<Qffffff21fB';
    this._id = mavlink20.MAVLINK_MSG_ID_GLOBAL_VISION_POSITION_ESTIMATE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 21, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 21, 0];
    this.crc_extra = 102;
    this._name = 'GLOBAL_VISION_POSITION_ESTIMATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['usec', 'x', 'y', 'z', 'roll', 'pitch', 'yaw', 'covariance', 'reset_counter'];

}

mavlink20.messages.global_vision_position_estimate.prototype = new mavlink20.message;
mavlink20.messages.global_vision_position_estimate.prototype.pack = function(mav) {
    var orderedfields = [ this.usec, this.x, this.y, this.z, this.roll, this.pitch, this.yaw, this.covariance, this.reset_counter];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Local position/attitude estimate from a vision source.

                usec                      : Timestamp (UNIX time or time since system boot) (uint64_t)
                x                         : Local X position (float)
                y                         : Local Y position (float)
                z                         : Local Z position (float)
                roll                      : Roll angle (float)
                pitch                     : Pitch angle (float)
                yaw                       : Yaw angle (float)
                covariance                : Row-major representation of pose 6x6 cross-covariance matrix upper right triangle (states: x, y, z, roll, pitch, yaw; first six entries are the first ROW, next five entries are the second ROW, etc.). If unknown, assign NaN value to first element in the array. (float)
                reset_counter             : Estimate reset counter. This should be incremented when the estimate resets in any of the dimensions (position, velocity, attitude, angular speed). This is designed to be used when e.g an external SLAM system detects a loop-closure and the estimate jumps. (uint8_t)

*/
    mavlink20.messages.vision_position_estimate = function( ...moreargs ) {
    [ this.usec , this.x , this.y , this.z , this.roll , this.pitch , this.yaw , this.covariance , this.reset_counter ] = moreargs;

    this._format = '<Qffffff21fB';
    this._id = mavlink20.MAVLINK_MSG_ID_VISION_POSITION_ESTIMATE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 21, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 21, 0];
    this.crc_extra = 158;
    this._name = 'VISION_POSITION_ESTIMATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['usec', 'x', 'y', 'z', 'roll', 'pitch', 'yaw', 'covariance', 'reset_counter'];

}

mavlink20.messages.vision_position_estimate.prototype = new mavlink20.message;
mavlink20.messages.vision_position_estimate.prototype.pack = function(mav) {
    var orderedfields = [ this.usec, this.x, this.y, this.z, this.roll, this.pitch, this.yaw, this.covariance, this.reset_counter];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Speed estimate from a vision source.

                usec                      : Timestamp (UNIX time or time since system boot) (uint64_t)
                x                         : Global X speed (float)
                y                         : Global Y speed (float)
                z                         : Global Z speed (float)
                covariance                : Row-major representation of 3x3 linear velocity covariance matrix (states: vx, vy, vz; 1st three entries - 1st row, etc.). If unknown, assign NaN value to first element in the array. (float)
                reset_counter             : Estimate reset counter. This should be incremented when the estimate resets in any of the dimensions (position, velocity, attitude, angular speed). This is designed to be used when e.g an external SLAM system detects a loop-closure and the estimate jumps. (uint8_t)

*/
    mavlink20.messages.vision_speed_estimate = function( ...moreargs ) {
    [ this.usec , this.x , this.y , this.z , this.covariance , this.reset_counter ] = moreargs;

    this._format = '<Qfff9fB';
    this._id = mavlink20.MAVLINK_MSG_ID_VISION_SPEED_ESTIMATE;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 9, 1];
    this.array_len_map = [0, 0, 0, 0, 9, 0];
    this.crc_extra = 208;
    this._name = 'VISION_SPEED_ESTIMATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['usec', 'x', 'y', 'z', 'covariance', 'reset_counter'];

}

mavlink20.messages.vision_speed_estimate.prototype = new mavlink20.message;
mavlink20.messages.vision_speed_estimate.prototype.pack = function(mav) {
    var orderedfields = [ this.usec, this.x, this.y, this.z, this.covariance, this.reset_counter];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Global position estimate from a Vicon motion system source.

                usec                      : Timestamp (UNIX time or time since system boot) (uint64_t)
                x                         : Global X position (float)
                y                         : Global Y position (float)
                z                         : Global Z position (float)
                roll                      : Roll angle (float)
                pitch                     : Pitch angle (float)
                yaw                       : Yaw angle (float)
                covariance                : Row-major representation of 6x6 pose cross-covariance matrix upper right triangle (states: x, y, z, roll, pitch, yaw; first six entries are the first ROW, next five entries are the second ROW, etc.). If unknown, assign NaN value to first element in the array. (float)

*/
    mavlink20.messages.vicon_position_estimate = function( ...moreargs ) {
    [ this.usec , this.x , this.y , this.z , this.roll , this.pitch , this.yaw , this.covariance ] = moreargs;

    this._format = '<Qffffff21f';
    this._id = mavlink20.MAVLINK_MSG_ID_VICON_POSITION_ESTIMATE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 21];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 21];
    this.crc_extra = 56;
    this._name = 'VICON_POSITION_ESTIMATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['usec', 'x', 'y', 'z', 'roll', 'pitch', 'yaw', 'covariance'];

}

mavlink20.messages.vicon_position_estimate.prototype = new mavlink20.message;
mavlink20.messages.vicon_position_estimate.prototype.pack = function(mav) {
    var orderedfields = [ this.usec, this.x, this.y, this.z, this.roll, this.pitch, this.yaw, this.covariance];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The IMU readings in SI units in NED body frame

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                xacc                      : X acceleration (float)
                yacc                      : Y acceleration (float)
                zacc                      : Z acceleration (float)
                xgyro                     : Angular speed around X axis (float)
                ygyro                     : Angular speed around Y axis (float)
                zgyro                     : Angular speed around Z axis (float)
                xmag                      : X Magnetic field (float)
                ymag                      : Y Magnetic field (float)
                zmag                      : Z Magnetic field (float)
                abs_pressure              : Absolute pressure (float)
                diff_pressure             : Differential pressure (float)
                pressure_alt              : Altitude calculated from pressure (float)
                temperature               : Temperature (float)
                fields_updated            : Bitmap for fields that have updated since last message (uint16_t)
                id                        : Id. Ids are numbered from 0 and map to IMUs numbered from 1 (e.g. IMU1 will have a message with id=0) (uint8_t)

*/
    mavlink20.messages.highres_imu = function( ...moreargs ) {
    [ this.time_usec , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.xmag , this.ymag , this.zmag , this.abs_pressure , this.diff_pressure , this.pressure_alt , this.temperature , this.fields_updated , this.id ] = moreargs;

    this._format = '<QfffffffffffffHB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIGHRES_IMU;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 93;
    this._name = 'HIGHRES_IMU';

    this._instance_field = 'id';
    this._instance_offset = 62;

    this.fieldnames = ['time_usec', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'xmag', 'ymag', 'zmag', 'abs_pressure', 'diff_pressure', 'pressure_alt', 'temperature', 'fields_updated', 'id'];

}

mavlink20.messages.highres_imu.prototype = new mavlink20.message;
mavlink20.messages.highres_imu.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.xmag, this.ymag, this.zmag, this.abs_pressure, this.diff_pressure, this.pressure_alt, this.temperature, this.fields_updated, this.id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Optical flow from an angular rate flow sensor (e.g. PX4FLOW or mouse
sensor)

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                sensor_id                 : Sensor ID (uint8_t)
                integration_time_us        : Integration time. Divide integrated_x and integrated_y by the integration time to obtain average flow. The integration time also indicates the. (uint32_t)
                integrated_x              : Flow around X axis (Sensor RH rotation about the X axis induces a positive flow. Sensor linear motion along the positive Y axis induces a negative flow.) (float)
                integrated_y              : Flow around Y axis (Sensor RH rotation about the Y axis induces a positive flow. Sensor linear motion along the positive X axis induces a positive flow.) (float)
                integrated_xgyro          : RH rotation around X axis (float)
                integrated_ygyro          : RH rotation around Y axis (float)
                integrated_zgyro          : RH rotation around Z axis (float)
                temperature               : Temperature (int16_t)
                quality                   : Optical flow quality / confidence. 0: no valid flow, 255: maximum quality (uint8_t)
                time_delta_distance_us        : Time since the distance was sampled. (uint32_t)
                distance                  : Distance to the center of the flow field. Positive value (including zero): distance known. Negative value: Unknown distance. (float)

*/
    mavlink20.messages.optical_flow_rad = function( ...moreargs ) {
    [ this.time_usec , this.sensor_id , this.integration_time_us , this.integrated_x , this.integrated_y , this.integrated_xgyro , this.integrated_ygyro , this.integrated_zgyro , this.temperature , this.quality , this.time_delta_distance_us , this.distance ] = moreargs;

    this._format = '<QIfffffIfhBB';
    this._id = mavlink20.MAVLINK_MSG_ID_OPTICAL_FLOW_RAD;
    this.order_map = [0, 10, 1, 2, 3, 4, 5, 6, 9, 11, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 138;
    this._name = 'OPTICAL_FLOW_RAD';

    this._instance_field = 'sensor_id';
    this._instance_offset = 42;

    this.fieldnames = ['time_usec', 'sensor_id', 'integration_time_us', 'integrated_x', 'integrated_y', 'integrated_xgyro', 'integrated_ygyro', 'integrated_zgyro', 'temperature', 'quality', 'time_delta_distance_us', 'distance'];

}

mavlink20.messages.optical_flow_rad.prototype = new mavlink20.message;
mavlink20.messages.optical_flow_rad.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.integration_time_us, this.integrated_x, this.integrated_y, this.integrated_xgyro, this.integrated_ygyro, this.integrated_zgyro, this.time_delta_distance_us, this.distance, this.temperature, this.sensor_id, this.quality];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The IMU readings in SI units in NED body frame

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                xacc                      : X acceleration (float)
                yacc                      : Y acceleration (float)
                zacc                      : Z acceleration (float)
                xgyro                     : Angular speed around X axis in body frame (float)
                ygyro                     : Angular speed around Y axis in body frame (float)
                zgyro                     : Angular speed around Z axis in body frame (float)
                xmag                      : X Magnetic field (float)
                ymag                      : Y Magnetic field (float)
                zmag                      : Z Magnetic field (float)
                abs_pressure              : Absolute pressure (float)
                diff_pressure             : Differential pressure (airspeed) (float)
                pressure_alt              : Altitude calculated from pressure (float)
                temperature               : Temperature (float)
                fields_updated            : Bitmap for fields that have updated since last message (uint32_t)
                id                        : Sensor ID (zero indexed). Used for multiple sensor inputs (uint8_t)

*/
    mavlink20.messages.hil_sensor = function( ...moreargs ) {
    [ this.time_usec , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.xmag , this.ymag , this.zmag , this.abs_pressure , this.diff_pressure , this.pressure_alt , this.temperature , this.fields_updated , this.id ] = moreargs;

    this._format = '<QfffffffffffffIB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_SENSOR;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 108;
    this._name = 'HIL_SENSOR';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'xmag', 'ymag', 'zmag', 'abs_pressure', 'diff_pressure', 'pressure_alt', 'temperature', 'fields_updated', 'id'];

}

mavlink20.messages.hil_sensor.prototype = new mavlink20.message;
mavlink20.messages.hil_sensor.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.xmag, this.ymag, this.zmag, this.abs_pressure, this.diff_pressure, this.pressure_alt, this.temperature, this.fields_updated, this.id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Status of simulation environment, if used

                q1                        : True attitude quaternion component 1, w (1 in null-rotation) (float)
                q2                        : True attitude quaternion component 2, x (0 in null-rotation) (float)
                q3                        : True attitude quaternion component 3, y (0 in null-rotation) (float)
                q4                        : True attitude quaternion component 4, z (0 in null-rotation) (float)
                roll                      : Attitude roll expressed as Euler angles, not recommended except for human-readable outputs (float)
                pitch                     : Attitude pitch expressed as Euler angles, not recommended except for human-readable outputs (float)
                yaw                       : Attitude yaw expressed as Euler angles, not recommended except for human-readable outputs (float)
                xacc                      : X acceleration (float)
                yacc                      : Y acceleration (float)
                zacc                      : Z acceleration (float)
                xgyro                     : Angular speed around X axis (float)
                ygyro                     : Angular speed around Y axis (float)
                zgyro                     : Angular speed around Z axis (float)
                lat                       : Latitude (lower precision). Both this and the lat_int field should be set. (float)
                lon                       : Longitude (lower precision). Both this and the lon_int field should be set. (float)
                alt                       : Altitude (float)
                std_dev_horz              : Horizontal position standard deviation (float)
                std_dev_vert              : Vertical position standard deviation (float)
                vn                        : True velocity in north direction in earth-fixed NED frame (float)
                ve                        : True velocity in east direction in earth-fixed NED frame (float)
                vd                        : True velocity in down direction in earth-fixed NED frame (float)
                lat_int                   : Latitude (higher precision). If 0, recipients should use the lat field value (otherwise this field is preferred). (int32_t)
                lon_int                   : Longitude (higher precision). If 0, recipients should use the lon field value (otherwise this field is preferred). (int32_t)

*/
    mavlink20.messages.sim_state = function( ...moreargs ) {
    [ this.q1 , this.q2 , this.q3 , this.q4 , this.roll , this.pitch , this.yaw , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.lat , this.lon , this.alt , this.std_dev_horz , this.std_dev_vert , this.vn , this.ve , this.vd , this.lat_int , this.lon_int ] = moreargs;

    this._format = '<fffffffffffffffffffffii';
    this._id = mavlink20.MAVLINK_MSG_ID_SIM_STATE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 32;
    this._name = 'SIM_STATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['q1', 'q2', 'q3', 'q4', 'roll', 'pitch', 'yaw', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'lat', 'lon', 'alt', 'std_dev_horz', 'std_dev_vert', 'vn', 've', 'vd', 'lat_int', 'lon_int'];

}

mavlink20.messages.sim_state.prototype = new mavlink20.message;
mavlink20.messages.sim_state.prototype.pack = function(mav) {
    var orderedfields = [ this.q1, this.q2, this.q3, this.q4, this.roll, this.pitch, this.yaw, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.lat, this.lon, this.alt, this.std_dev_horz, this.std_dev_vert, this.vn, this.ve, this.vd, this.lat_int, this.lon_int];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Status generated by radio and injected into MAVLink stream.

                rssi                      : Local (message sender) received signal strength indication in device-dependent units/scale. Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)
                remrssi                   : Remote (message receiver) signal strength indication in device-dependent units/scale. Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)
                txbuf                     : Remaining free transmitter buffer space. (uint8_t)
                noise                     : Local background noise level. These are device dependent RSSI values (scale as approx 2x dB on SiK radios). Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)
                remnoise                  : Remote background noise level. These are device dependent RSSI values (scale as approx 2x dB on SiK radios). Values: [0-254], UINT8_MAX: invalid/unknown. (uint8_t)
                rxerrors                  : Count of radio packet receive errors (since boot). (uint16_t)
                fixed                     : Count of error corrected radio packets (since boot). (uint16_t)

*/
    mavlink20.messages.radio_status = function( ...moreargs ) {
    [ this.rssi , this.remrssi , this.txbuf , this.noise , this.remnoise , this.rxerrors , this.fixed ] = moreargs;

    this._format = '<HHBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_RADIO_STATUS;
    this.order_map = [2, 3, 4, 5, 6, 0, 1];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 185;
    this._name = 'RADIO_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['rssi', 'remrssi', 'txbuf', 'noise', 'remnoise', 'rxerrors', 'fixed'];

}

mavlink20.messages.radio_status.prototype = new mavlink20.message;
mavlink20.messages.radio_status.prototype.pack = function(mav) {
    var orderedfields = [ this.rxerrors, this.fixed, this.rssi, this.remrssi, this.txbuf, this.noise, this.remnoise];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
File transfer protocol message:
https://mavlink.io/en/services/ftp.html.

                target_network            : Network ID (0 for broadcast) (uint8_t)
                target_system             : System ID (0 for broadcast) (uint8_t)
                target_component          : Component ID (0 for broadcast) (uint8_t)
                payload                   : Variable length payload. The content/format of this block is defined in https://mavlink.io/en/services/ftp.html. The length is defined by the remaining message length when subtracting the header and other fields. See also MAV_FTP_OPCODE and MAV_FTP_ERR. (uint8_t)

*/
    mavlink20.messages.file_transfer_protocol = function( ...moreargs ) {
    [ this.target_network , this.target_system , this.target_component , this.payload ] = moreargs;

    this._format = '<BBB251s';
    this._id = mavlink20.MAVLINK_MSG_ID_FILE_TRANSFER_PROTOCOL;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 251];
    this.array_len_map = [0, 0, 0, 251];
    this.crc_extra = 84;
    this._name = 'FILE_TRANSFER_PROTOCOL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_network', 'target_system', 'target_component', 'payload'];

}

mavlink20.messages.file_transfer_protocol.prototype = new mavlink20.message;
mavlink20.messages.file_transfer_protocol.prototype.pack = function(mav) {
    var orderedfields = [ this.target_network, this.target_system, this.target_component, this.payload];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Time synchronization message.         The message is used for both
timesync requests and responses.         The request is sent with
`ts1=syncing component timestamp` and `tc1=0`, and may be broadcast or
targeted to a specific system/component.         The response is sent
with `ts1=syncing component timestamp` (mirror back unchanged), and
`tc1=responding component timestamp`, with the `target_system` and
`target_component` set to ids of the original request.         Systems
can determine if they are receiving a request or response based on the
value of `tc`.         If the response has
`target_system==target_component==0` the remote system has not been
updated to use the component IDs and cannot reliably timesync; the
requester may report an error.         Timestamps are UNIX Epoch time
or time since system boot in nanoseconds (the timestamp format can be
inferred by checking for the magnitude of the number; generally it
doesn't matter as only the offset is used).         The message
sequence is repeated numerous times with results being
filtered/averaged to estimate the offset.         See also:
https://mavlink.io/en/services/timesync.html.

                tc1                       : Time sync timestamp 1. Syncing: 0. Responding: Timestamp of responding component. (int64_t)
                ts1                       : Time sync timestamp 2. Timestamp of syncing component (mirrored in response). (int64_t)
                target_system             : Target system id. Request: 0 (broadcast) or id of specific system. Response must contain system id of the requesting component. (uint8_t)
                target_component          : Target component id. Request: 0 (broadcast) or id of specific component. Response must contain component id of the requesting component. (uint8_t)

*/
    mavlink20.messages.timesync = function( ...moreargs ) {
    [ this.tc1 , this.ts1 , this.target_system , this.target_component ] = moreargs;

    this._format = '<qqBB';
    this._id = mavlink20.MAVLINK_MSG_ID_TIMESYNC;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 34;
    this._name = 'TIMESYNC';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['tc1', 'ts1', 'target_system', 'target_component'];

}

mavlink20.messages.timesync.prototype = new mavlink20.message;
mavlink20.messages.timesync.prototype.pack = function(mav) {
    var orderedfields = [ this.tc1, this.ts1, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Camera-IMU triggering and synchronisation message.

                time_usec                 : Timestamp for image frame (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                seq                       : Image frame sequence (uint32_t)

*/
    mavlink20.messages.camera_trigger = function( ...moreargs ) {
    [ this.time_usec , this.seq ] = moreargs;

    this._format = '<QI';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_TRIGGER;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 174;
    this._name = 'CAMERA_TRIGGER';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'seq'];

}

mavlink20.messages.camera_trigger.prototype = new mavlink20.message;
mavlink20.messages.camera_trigger.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.seq];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The global position, as returned by the Global Positioning System
(GPS). This is                  NOT the global position estimate of
the system, but rather a RAW sensor value. See message
GLOBAL_POSITION_INT for the global position estimate.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                fix_type                  : 0-1: no fix, 2: 2D fix, 3: 3D fix. Some applications will not use the value of this field unless it is at least two, so always correctly fill in the fix. (uint8_t)
                lat                       : Latitude (WGS84) (int32_t)
                lon                       : Longitude (WGS84) (int32_t)
                alt                       : Altitude (MSL). Positive for up. (int32_t)
                eph                       : GPS HDOP horizontal dilution of position (unitless * 100). If unknown, set to: UINT16_MAX (uint16_t)
                epv                       : GPS VDOP vertical dilution of position (unitless * 100). If unknown, set to: UINT16_MAX (uint16_t)
                vel                       : GPS ground speed. If unknown, set to: UINT16_MAX (uint16_t)
                vn                        : GPS velocity in north direction in earth-fixed NED frame (int16_t)
                ve                        : GPS velocity in east direction in earth-fixed NED frame (int16_t)
                vd                        : GPS velocity in down direction in earth-fixed NED frame (int16_t)
                cog                       : Course over ground (NOT heading, but direction of movement), 0.0..359.99 degrees. If unknown, set to: UINT16_MAX (uint16_t)
                satellites_visible        : Number of satellites visible. If unknown, set to UINT8_MAX (uint8_t)
                id                        : GPS ID (zero indexed). Used for multiple GPS inputs (uint8_t)
                yaw                       : Yaw of vehicle relative to Earth's North, zero means not available, use 36000 for north (uint16_t)

*/
    mavlink20.messages.hil_gps = function( ...moreargs ) {
    [ this.time_usec , this.fix_type , this.lat , this.lon , this.alt , this.eph , this.epv , this.vel , this.vn , this.ve , this.vd , this.cog , this.satellites_visible , this.id , this.yaw ] = moreargs;

    this._format = '<QiiiHHHhhhHBBBH';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_GPS;
    this.order_map = [0, 11, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 124;
    this._name = 'HIL_GPS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'fix_type', 'lat', 'lon', 'alt', 'eph', 'epv', 'vel', 'vn', 've', 'vd', 'cog', 'satellites_visible', 'id', 'yaw'];

}

mavlink20.messages.hil_gps.prototype = new mavlink20.message;
mavlink20.messages.hil_gps.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.lat, this.lon, this.alt, this.eph, this.epv, this.vel, this.vn, this.ve, this.vd, this.cog, this.fix_type, this.satellites_visible, this.id, this.yaw];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Simulated optical flow from a flow sensor (e.g. PX4FLOW or optical
mouse sensor)

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                sensor_id                 : Sensor ID (uint8_t)
                integration_time_us        : Integration time. Divide integrated_x and integrated_y by the integration time to obtain average flow. The integration time also indicates the. (uint32_t)
                integrated_x              : Flow in radians around X axis (Sensor RH rotation about the X axis induces a positive flow. Sensor linear motion along the positive Y axis induces a negative flow.) (float)
                integrated_y              : Flow in radians around Y axis (Sensor RH rotation about the Y axis induces a positive flow. Sensor linear motion along the positive X axis induces a positive flow.) (float)
                integrated_xgyro          : RH rotation around X axis (float)
                integrated_ygyro          : RH rotation around Y axis (float)
                integrated_zgyro          : RH rotation around Z axis (float)
                temperature               : Temperature (int16_t)
                quality                   : Optical flow quality / confidence. 0: no valid flow, 255: maximum quality (uint8_t)
                time_delta_distance_us        : Time since the distance was sampled. (uint32_t)
                distance                  : Distance to the center of the flow field. Positive value (including zero): distance known. Negative value: Unknown distance. (float)

*/
    mavlink20.messages.hil_optical_flow = function( ...moreargs ) {
    [ this.time_usec , this.sensor_id , this.integration_time_us , this.integrated_x , this.integrated_y , this.integrated_xgyro , this.integrated_ygyro , this.integrated_zgyro , this.temperature , this.quality , this.time_delta_distance_us , this.distance ] = moreargs;

    this._format = '<QIfffffIfhBB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_OPTICAL_FLOW;
    this.order_map = [0, 10, 1, 2, 3, 4, 5, 6, 9, 11, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 237;
    this._name = 'HIL_OPTICAL_FLOW';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'sensor_id', 'integration_time_us', 'integrated_x', 'integrated_y', 'integrated_xgyro', 'integrated_ygyro', 'integrated_zgyro', 'temperature', 'quality', 'time_delta_distance_us', 'distance'];

}

mavlink20.messages.hil_optical_flow.prototype = new mavlink20.message;
mavlink20.messages.hil_optical_flow.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.integration_time_us, this.integrated_x, this.integrated_y, this.integrated_xgyro, this.integrated_ygyro, this.integrated_zgyro, this.time_delta_distance_us, this.distance, this.temperature, this.sensor_id, this.quality];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sent from simulation to autopilot, avoids in contrast to HIL_STATE
singularities. This packet is useful for high throughput applications
such as hardware in the loop simulations.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                attitude_quaternion        : Vehicle attitude expressed as normalized quaternion in w, x, y, z order (with 1 0 0 0 being the null-rotation) (float)
                rollspeed                 : Body frame roll / phi angular speed (float)
                pitchspeed                : Body frame pitch / theta angular speed (float)
                yawspeed                  : Body frame yaw / psi angular speed (float)
                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)
                alt                       : Altitude (int32_t)
                vx                        : Ground X Speed (Latitude) (int16_t)
                vy                        : Ground Y Speed (Longitude) (int16_t)
                vz                        : Ground Z Speed (Altitude) (int16_t)
                ind_airspeed              : Indicated airspeed (uint16_t)
                true_airspeed             : True airspeed (uint16_t)
                xacc                      : X acceleration (int16_t)
                yacc                      : Y acceleration (int16_t)
                zacc                      : Z acceleration (int16_t)

*/
    mavlink20.messages.hil_state_quaternion = function( ...moreargs ) {
    [ this.time_usec , this.attitude_quaternion , this.rollspeed , this.pitchspeed , this.yawspeed , this.lat , this.lon , this.alt , this.vx , this.vy , this.vz , this.ind_airspeed , this.true_airspeed , this.xacc , this.yacc , this.zacc ] = moreargs;

    this._format = '<Q4ffffiiihhhHHhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_HIL_STATE_QUATERNION;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    this.len_map = [1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 4;
    this._name = 'HIL_STATE_QUATERNION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'attitude_quaternion', 'rollspeed', 'pitchspeed', 'yawspeed', 'lat', 'lon', 'alt', 'vx', 'vy', 'vz', 'ind_airspeed', 'true_airspeed', 'xacc', 'yacc', 'zacc'];

}

mavlink20.messages.hil_state_quaternion.prototype = new mavlink20.message;
mavlink20.messages.hil_state_quaternion.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.attitude_quaternion, this.rollspeed, this.pitchspeed, this.yawspeed, this.lat, this.lon, this.alt, this.vx, this.vy, this.vz, this.ind_airspeed, this.true_airspeed, this.xacc, this.yacc, this.zacc];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW IMU readings for secondary 9DOF sensor setup. This message
should contain the scaled values to the described units

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                xacc                      : X acceleration (int16_t)
                yacc                      : Y acceleration (int16_t)
                zacc                      : Z acceleration (int16_t)
                xgyro                     : Angular speed around X axis (int16_t)
                ygyro                     : Angular speed around Y axis (int16_t)
                zgyro                     : Angular speed around Z axis (int16_t)
                xmag                      : X Magnetic field (int16_t)
                ymag                      : Y Magnetic field (int16_t)
                zmag                      : Z Magnetic field (int16_t)
                temperature               : Temperature, 0: IMU does not provide temperature values. If the IMU is at 0C it must send 1 (0.01C). (int16_t)

*/
    mavlink20.messages.scaled_imu2 = function( ...moreargs ) {
    [ this.time_boot_ms , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.xmag , this.ymag , this.zmag , this.temperature ] = moreargs;

    this._format = '<Ihhhhhhhhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_SCALED_IMU2;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 76;
    this._name = 'SCALED_IMU2';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'xmag', 'ymag', 'zmag', 'temperature'];

}

mavlink20.messages.scaled_imu2.prototype = new mavlink20.message;
mavlink20.messages.scaled_imu2.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.xmag, this.ymag, this.zmag, this.temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request a list of available logs.         On some systems calling this
may stop on-board logging until LOG_REQUEST_END is called.         If
there are no log files available this request shall be answered with
one LOG_ENTRY message with id = 0 and num_logs = 0.         LOG_ENTRY
messages can start with id 1 or 0.         The ground station needs to
be able to process either.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                start                     : First log id (0 for first available) (uint16_t)
                end                       : Last log id (0xffff for last available) (uint16_t)

*/
    mavlink20.messages.log_request_list = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.start , this.end ] = moreargs;

    this._format = '<HHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_LIST;
    this.order_map = [2, 3, 0, 1];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 128;
    this._name = 'LOG_REQUEST_LIST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'start', 'end'];

}

mavlink20.messages.log_request_list.prototype = new mavlink20.message;
mavlink20.messages.log_request_list.prototype.pack = function(mav) {
    var orderedfields = [ this.start, this.end, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reply to LOG_REQUEST_LIST

                id                        : Log id (uint16_t)
                num_logs                  : Total number of logs (uint16_t)
                last_log_num              : High log number (uint16_t)
                time_utc                  : UTC timestamp of log since 1970, or 0 if not available (uint32_t)
                size                      : Size of the log (may be approximate) (uint32_t)

*/
    mavlink20.messages.log_entry = function( ...moreargs ) {
    [ this.id , this.num_logs , this.last_log_num , this.time_utc , this.size ] = moreargs;

    this._format = '<IIHHH';
    this._id = mavlink20.MAVLINK_MSG_ID_LOG_ENTRY;
    this.order_map = [2, 3, 4, 0, 1];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 56;
    this._name = 'LOG_ENTRY';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['id', 'num_logs', 'last_log_num', 'time_utc', 'size'];

}

mavlink20.messages.log_entry.prototype = new mavlink20.message;
mavlink20.messages.log_entry.prototype.pack = function(mav) {
    var orderedfields = [ this.time_utc, this.size, this.id, this.num_logs, this.last_log_num];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request a chunk of a log

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                id                        : Log id (from LOG_ENTRY reply) (uint16_t)
                ofs                       : Offset into the log (uint32_t)
                count                     : Number of bytes (uint32_t)

*/
    mavlink20.messages.log_request_data = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id , this.ofs , this.count ] = moreargs;

    this._format = '<IIHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_DATA;
    this.order_map = [3, 4, 2, 0, 1];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 116;
    this._name = 'LOG_REQUEST_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id', 'ofs', 'count'];

}

mavlink20.messages.log_request_data.prototype = new mavlink20.message;
mavlink20.messages.log_request_data.prototype.pack = function(mav) {
    var orderedfields = [ this.ofs, this.count, this.id, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reply to LOG_REQUEST_DATA

                id                        : Log id (from LOG_ENTRY reply) (uint16_t)
                ofs                       : Offset into the log (uint32_t)
                count                     : Number of bytes (zero for end of log) (uint8_t)
                data                      : log data (uint8_t)

*/
    mavlink20.messages.log_data = function( ...moreargs ) {
    [ this.id , this.ofs , this.count , this.data ] = moreargs;

    this._format = '<IHB90s';
    this._id = mavlink20.MAVLINK_MSG_ID_LOG_DATA;
    this.order_map = [1, 0, 2, 3];
    this.len_map = [1, 1, 1, 90];
    this.array_len_map = [0, 0, 0, 90];
    this.crc_extra = 134;
    this._name = 'LOG_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['id', 'ofs', 'count', 'data'];

}

mavlink20.messages.log_data.prototype = new mavlink20.message;
mavlink20.messages.log_data.prototype.pack = function(mav) {
    var orderedfields = [ this.ofs, this.id, this.count, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Erase all logs

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)

*/
    mavlink20.messages.log_erase = function( ...moreargs ) {
    [ this.target_system , this.target_component ] = moreargs;

    this._format = '<BB';
    this._id = mavlink20.MAVLINK_MSG_ID_LOG_ERASE;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 237;
    this._name = 'LOG_ERASE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component'];

}

mavlink20.messages.log_erase.prototype = new mavlink20.message;
mavlink20.messages.log_erase.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Stop log transfer and resume normal logging

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)

*/
    mavlink20.messages.log_request_end = function( ...moreargs ) {
    [ this.target_system , this.target_component ] = moreargs;

    this._format = '<BB';
    this._id = mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_END;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 203;
    this._name = 'LOG_REQUEST_END';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component'];

}

mavlink20.messages.log_request_end.prototype = new mavlink20.message;
mavlink20.messages.log_request_end.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for injecting into the onboard GPS (used for DGPS)

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                len                       : Data length (uint8_t)
                data                      : Raw data (110 is enough for 12 satellites of RTCMv2) (uint8_t)

*/
    mavlink20.messages.gps_inject_data = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.len , this.data ] = moreargs;

    this._format = '<BBB110s';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_INJECT_DATA;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 110];
    this.array_len_map = [0, 0, 0, 110];
    this.crc_extra = 250;
    this._name = 'GPS_INJECT_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'len', 'data'];

}

mavlink20.messages.gps_inject_data.prototype = new mavlink20.message;
mavlink20.messages.gps_inject_data.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.len, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Second GPS data.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                fix_type                  : GPS fix type. (uint8_t)
                lat                       : Latitude (WGS84) (int32_t)
                lon                       : Longitude (WGS84) (int32_t)
                alt                       : Altitude (MSL). Positive for up. (int32_t)
                eph                       : GPS HDOP horizontal dilution of position (unitless * 100). If unknown, set to: UINT16_MAX (uint16_t)
                epv                       : GPS VDOP vertical dilution of position (unitless * 100). If unknown, set to: UINT16_MAX (uint16_t)
                vel                       : GPS ground speed. If unknown, set to: UINT16_MAX (uint16_t)
                cog                       : Course over ground (NOT heading, but direction of movement): 0.0..359.99 degrees. If unknown, set to: UINT16_MAX (uint16_t)
                satellites_visible        : Number of satellites visible. If unknown, set to UINT8_MAX (uint8_t)
                dgps_numch                : Number of DGPS satellites (uint8_t)
                dgps_age                  : Age of DGPS info (uint32_t)
                yaw                       : Yaw in earth frame from north. Use 0 if this GPS does not provide yaw. Use UINT16_MAX if this GPS is configured to provide yaw and is currently unable to provide it. Use 36000 for north. (uint16_t)
                alt_ellipsoid             : Altitude (above WGS84, EGM96 ellipsoid). Positive for up. (int32_t)
                h_acc                     : Position uncertainty. (uint32_t)
                v_acc                     : Altitude uncertainty. (uint32_t)
                vel_acc                   : Speed uncertainty. (uint32_t)
                hdg_acc                   : Heading / track uncertainty (uint32_t)

*/
    mavlink20.messages.gps2_raw = function( ...moreargs ) {
    [ this.time_usec , this.fix_type , this.lat , this.lon , this.alt , this.eph , this.epv , this.vel , this.cog , this.satellites_visible , this.dgps_numch , this.dgps_age , this.yaw , this.alt_ellipsoid , this.h_acc , this.v_acc , this.vel_acc , this.hdg_acc ] = moreargs;

    this._format = '<QiiiIHHHHBBBHiIIII';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS2_RAW;
    this.order_map = [0, 9, 1, 2, 3, 5, 6, 7, 8, 10, 11, 4, 12, 13, 14, 15, 16, 17];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 87;
    this._name = 'GPS2_RAW';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'fix_type', 'lat', 'lon', 'alt', 'eph', 'epv', 'vel', 'cog', 'satellites_visible', 'dgps_numch', 'dgps_age', 'yaw', 'alt_ellipsoid', 'h_acc', 'v_acc', 'vel_acc', 'hdg_acc'];

}

mavlink20.messages.gps2_raw.prototype = new mavlink20.message;
mavlink20.messages.gps2_raw.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.lat, this.lon, this.alt, this.dgps_age, this.eph, this.epv, this.vel, this.cog, this.fix_type, this.satellites_visible, this.dgps_numch, this.yaw, this.alt_ellipsoid, this.h_acc, this.v_acc, this.vel_acc, this.hdg_acc];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Power supply status

                Vcc                       : 5V rail voltage. (uint16_t)
                Vservo                    : Servo rail voltage. (uint16_t)
                flags                     : Bitmap of power supply status flags. (uint16_t)

*/
    mavlink20.messages.power_status = function( ...moreargs ) {
    [ this.Vcc , this.Vservo , this.flags ] = moreargs;

    this._format = '<HHH';
    this._id = mavlink20.MAVLINK_MSG_ID_POWER_STATUS;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 203;
    this._name = 'POWER_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['Vcc', 'Vservo', 'flags'];

}

mavlink20.messages.power_status.prototype = new mavlink20.message;
mavlink20.messages.power_status.prototype.pack = function(mav) {
    var orderedfields = [ this.Vcc, this.Vservo, this.flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Control a serial port. This can be used for raw access to an onboard
serial peripheral such as a GPS or telemetry radio. It is designed to
make it possible to update the devices firmware via MAVLink messages
or change the devices settings. A message with zero bytes can be used
to change just the baudrate.

                device                    : Serial control device type. (uint8_t)
                flags                     : Bitmap of serial control flags. (uint8_t)
                timeout                   : Timeout for reply data (uint16_t)
                baudrate                  : Baudrate of transfer. Zero means no change. (uint32_t)
                count                     : how many bytes in this transfer (uint8_t)
                data                      : serial data (uint8_t)
                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)

*/
    mavlink20.messages.serial_control = function( ...moreargs ) {
    [ this.device , this.flags , this.timeout , this.baudrate , this.count , this.data , this.target_system , this.target_component ] = moreargs;

    this._format = '<IHBBB70sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SERIAL_CONTROL;
    this.order_map = [2, 3, 1, 0, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 70, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 70, 0, 0];
    this.crc_extra = 220;
    this._name = 'SERIAL_CONTROL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['device', 'flags', 'timeout', 'baudrate', 'count', 'data', 'target_system', 'target_component'];

}

mavlink20.messages.serial_control.prototype = new mavlink20.message;
mavlink20.messages.serial_control.prototype.pack = function(mav) {
    var orderedfields = [ this.baudrate, this.timeout, this.device, this.flags, this.count, this.data, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
RTK GPS data. Gives information on the relative baseline calculation
the GPS is reporting

                time_last_baseline_ms        : Time since boot of last baseline message received. (uint32_t)
                rtk_receiver_id           : Identification of connected RTK receiver. (uint8_t)
                wn                        : GPS Week Number of last baseline (uint16_t)
                tow                       : GPS Time of Week of last baseline (uint32_t)
                rtk_health                : GPS-specific health report for RTK data. (uint8_t)
                rtk_rate                  : Rate of baseline messages being received by GPS (uint8_t)
                nsats                     : Current number of sats used for RTK calculation. (uint8_t)
                baseline_coords_type        : Coordinate system of baseline (uint8_t)
                baseline_a_mm             : Current baseline in ECEF x or NED north component. (int32_t)
                baseline_b_mm             : Current baseline in ECEF y or NED east component. (int32_t)
                baseline_c_mm             : Current baseline in ECEF z or NED down component. (int32_t)
                accuracy                  : Current estimate of baseline accuracy. (uint32_t)
                iar_num_hypotheses        : Current number of integer ambiguity hypotheses. (int32_t)

*/
    mavlink20.messages.gps_rtk = function( ...moreargs ) {
    [ this.time_last_baseline_ms , this.rtk_receiver_id , this.wn , this.tow , this.rtk_health , this.rtk_rate , this.nsats , this.baseline_coords_type , this.baseline_a_mm , this.baseline_b_mm , this.baseline_c_mm , this.accuracy , this.iar_num_hypotheses ] = moreargs;

    this._format = '<IIiiiIiHBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_RTK;
    this.order_map = [0, 8, 7, 1, 9, 10, 11, 12, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 25;
    this._name = 'GPS_RTK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_last_baseline_ms', 'rtk_receiver_id', 'wn', 'tow', 'rtk_health', 'rtk_rate', 'nsats', 'baseline_coords_type', 'baseline_a_mm', 'baseline_b_mm', 'baseline_c_mm', 'accuracy', 'iar_num_hypotheses'];

}

mavlink20.messages.gps_rtk.prototype = new mavlink20.message;
mavlink20.messages.gps_rtk.prototype.pack = function(mav) {
    var orderedfields = [ this.time_last_baseline_ms, this.tow, this.baseline_a_mm, this.baseline_b_mm, this.baseline_c_mm, this.accuracy, this.iar_num_hypotheses, this.wn, this.rtk_receiver_id, this.rtk_health, this.rtk_rate, this.nsats, this.baseline_coords_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
RTK GPS data. Gives information on the relative baseline calculation
the GPS is reporting

                time_last_baseline_ms        : Time since boot of last baseline message received. (uint32_t)
                rtk_receiver_id           : Identification of connected RTK receiver. (uint8_t)
                wn                        : GPS Week Number of last baseline (uint16_t)
                tow                       : GPS Time of Week of last baseline (uint32_t)
                rtk_health                : GPS-specific health report for RTK data. (uint8_t)
                rtk_rate                  : Rate of baseline messages being received by GPS (uint8_t)
                nsats                     : Current number of sats used for RTK calculation. (uint8_t)
                baseline_coords_type        : Coordinate system of baseline (uint8_t)
                baseline_a_mm             : Current baseline in ECEF x or NED north component. (int32_t)
                baseline_b_mm             : Current baseline in ECEF y or NED east component. (int32_t)
                baseline_c_mm             : Current baseline in ECEF z or NED down component. (int32_t)
                accuracy                  : Current estimate of baseline accuracy. (uint32_t)
                iar_num_hypotheses        : Current number of integer ambiguity hypotheses. (int32_t)

*/
    mavlink20.messages.gps2_rtk = function( ...moreargs ) {
    [ this.time_last_baseline_ms , this.rtk_receiver_id , this.wn , this.tow , this.rtk_health , this.rtk_rate , this.nsats , this.baseline_coords_type , this.baseline_a_mm , this.baseline_b_mm , this.baseline_c_mm , this.accuracy , this.iar_num_hypotheses ] = moreargs;

    this._format = '<IIiiiIiHBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS2_RTK;
    this.order_map = [0, 8, 7, 1, 9, 10, 11, 12, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 226;
    this._name = 'GPS2_RTK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_last_baseline_ms', 'rtk_receiver_id', 'wn', 'tow', 'rtk_health', 'rtk_rate', 'nsats', 'baseline_coords_type', 'baseline_a_mm', 'baseline_b_mm', 'baseline_c_mm', 'accuracy', 'iar_num_hypotheses'];

}

mavlink20.messages.gps2_rtk.prototype = new mavlink20.message;
mavlink20.messages.gps2_rtk.prototype.pack = function(mav) {
    var orderedfields = [ this.time_last_baseline_ms, this.tow, this.baseline_a_mm, this.baseline_b_mm, this.baseline_c_mm, this.accuracy, this.iar_num_hypotheses, this.wn, this.rtk_receiver_id, this.rtk_health, this.rtk_rate, this.nsats, this.baseline_coords_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The RAW IMU readings for 3rd 9DOF sensor setup. This message should
contain the scaled values to the described units

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                xacc                      : X acceleration (int16_t)
                yacc                      : Y acceleration (int16_t)
                zacc                      : Z acceleration (int16_t)
                xgyro                     : Angular speed around X axis (int16_t)
                ygyro                     : Angular speed around Y axis (int16_t)
                zgyro                     : Angular speed around Z axis (int16_t)
                xmag                      : X Magnetic field (int16_t)
                ymag                      : Y Magnetic field (int16_t)
                zmag                      : Z Magnetic field (int16_t)
                temperature               : Temperature, 0: IMU does not provide temperature values. If the IMU is at 0C it must send 1 (0.01C). (int16_t)

*/
    mavlink20.messages.scaled_imu3 = function( ...moreargs ) {
    [ this.time_boot_ms , this.xacc , this.yacc , this.zacc , this.xgyro , this.ygyro , this.zgyro , this.xmag , this.ymag , this.zmag , this.temperature ] = moreargs;

    this._format = '<Ihhhhhhhhhh';
    this._id = mavlink20.MAVLINK_MSG_ID_SCALED_IMU3;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 46;
    this._name = 'SCALED_IMU3';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'xacc', 'yacc', 'zacc', 'xgyro', 'ygyro', 'zgyro', 'xmag', 'ymag', 'zmag', 'temperature'];

}

mavlink20.messages.scaled_imu3.prototype = new mavlink20.message;
mavlink20.messages.scaled_imu3.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.xacc, this.yacc, this.zacc, this.xgyro, this.ygyro, this.zgyro, this.xmag, this.ymag, this.zmag, this.temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Handshake message to initiate, control and stop image streaming when
using the Image Transmission Protocol:
https://mavlink.io/en/services/image_transmission.html.

                type                      : Type of requested/acknowledged data. (uint8_t)
                size                      : total data size (set on ACK only). (uint32_t)
                width                     : Width of a matrix or image. (uint16_t)
                height                    : Height of a matrix or image. (uint16_t)
                packets                   : Number of packets being sent (set on ACK only). (uint16_t)
                payload                   : Payload size per packet (normally 253 byte, see DATA field size in message ENCAPSULATED_DATA) (set on ACK only). (uint8_t)
                jpg_quality               : JPEG quality. Values: [1-100]. (uint8_t)

*/
    mavlink20.messages.data_transmission_handshake = function( ...moreargs ) {
    [ this.type , this.size , this.width , this.height , this.packets , this.payload , this.jpg_quality ] = moreargs;

    this._format = '<IHHHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_DATA_TRANSMISSION_HANDSHAKE;
    this.order_map = [4, 0, 1, 2, 3, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 29;
    this._name = 'DATA_TRANSMISSION_HANDSHAKE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['type', 'size', 'width', 'height', 'packets', 'payload', 'jpg_quality'];

}

mavlink20.messages.data_transmission_handshake.prototype = new mavlink20.message;
mavlink20.messages.data_transmission_handshake.prototype.pack = function(mav) {
    var orderedfields = [ this.size, this.width, this.height, this.packets, this.type, this.payload, this.jpg_quality];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data packet for images sent using the Image Transmission Protocol:
https://mavlink.io/en/services/image_transmission.html.

                seqnr                     : sequence number (starting with 0 on every transmission) (uint16_t)
                data                      : image data bytes (uint8_t)

*/
    mavlink20.messages.encapsulated_data = function( ...moreargs ) {
    [ this.seqnr , this.data ] = moreargs;

    this._format = '<H253s';
    this._id = mavlink20.MAVLINK_MSG_ID_ENCAPSULATED_DATA;
    this.order_map = [0, 1];
    this.len_map = [1, 253];
    this.array_len_map = [0, 253];
    this.crc_extra = 223;
    this._name = 'ENCAPSULATED_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['seqnr', 'data'];

}

mavlink20.messages.encapsulated_data.prototype = new mavlink20.message;
mavlink20.messages.encapsulated_data.prototype.pack = function(mav) {
    var orderedfields = [ this.seqnr, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Distance sensor information for an onboard rangefinder.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                min_distance              : Minimum distance the sensor can measure (uint16_t)
                max_distance              : Maximum distance the sensor can measure (uint16_t)
                current_distance          : Current distance reading (uint16_t)
                type                      : Type of distance sensor. (uint8_t)
                id                        : Onboard ID of the sensor (uint8_t)
                orientation               : Direction the sensor faces. downward-facing: ROTATION_PITCH_270, upward-facing: ROTATION_PITCH_90, backward-facing: ROTATION_PITCH_180, forward-facing: ROTATION_NONE, left-facing: ROTATION_YAW_90, right-facing: ROTATION_YAW_270 (uint8_t)
                covariance                : Measurement variance. Max standard deviation is 6cm. UINT8_MAX if unknown. (uint8_t)
                horizontal_fov            : Horizontal Field of View (angle) where the distance measurement is valid and the field of view is known. Otherwise this is set to 0. (float)
                vertical_fov              : Vertical Field of View (angle) where the distance measurement is valid and the field of view is known. Otherwise this is set to 0. (float)
                quaternion                : Quaternion of the sensor orientation in vehicle body frame (w, x, y, z order, zero-rotation is 1, 0, 0, 0). Zero-rotation is along the vehicle body x-axis. This field is required if the orientation is set to MAV_SENSOR_ROTATION_CUSTOM. Set it to 0 if invalid." (float)
                signal_quality            : Signal quality of the sensor. Specific to each sensor type, representing the relation of the signal strength with the target reflectivity, distance, size or aspect, but normalised as a percentage. 0 = unknown/unset signal quality, 1 = invalid signal, 100 = perfect signal. (uint8_t)

*/
    mavlink20.messages.distance_sensor = function( ...moreargs ) {
    [ this.time_boot_ms , this.min_distance , this.max_distance , this.current_distance , this.type , this.id , this.orientation , this.covariance , this.horizontal_fov , this.vertical_fov , this.quaternion , this.signal_quality ] = moreargs;

    this._format = '<IHHHBBBBff4fB';
    this._id = mavlink20.MAVLINK_MSG_ID_DISTANCE_SENSOR;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0];
    this.crc_extra = 85;
    this._name = 'DISTANCE_SENSOR';

    this._instance_field = 'id';
    this._instance_offset = 11;

    this.fieldnames = ['time_boot_ms', 'min_distance', 'max_distance', 'current_distance', 'type', 'id', 'orientation', 'covariance', 'horizontal_fov', 'vertical_fov', 'quaternion', 'signal_quality'];

}

mavlink20.messages.distance_sensor.prototype = new mavlink20.message;
mavlink20.messages.distance_sensor.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.min_distance, this.max_distance, this.current_distance, this.type, this.id, this.orientation, this.covariance, this.horizontal_fov, this.vertical_fov, this.quaternion, this.signal_quality];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request for terrain data and terrain status. See terrain protocol
docs: https://mavlink.io/en/services/terrain.html

                lat                       : Latitude of SW corner of first grid (int32_t)
                lon                       : Longitude of SW corner of first grid (int32_t)
                grid_spacing              : Grid spacing (uint16_t)
                mask                      : Bitmask of requested 4x4 grids (row major 8x7 array of grids, 56 bits) (uint64_t)

*/
    mavlink20.messages.terrain_request = function( ...moreargs ) {
    [ this.lat , this.lon , this.grid_spacing , this.mask ] = moreargs;

    this._format = '<QiiH';
    this._id = mavlink20.MAVLINK_MSG_ID_TERRAIN_REQUEST;
    this.order_map = [1, 2, 3, 0];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 6;
    this._name = 'TERRAIN_REQUEST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['lat', 'lon', 'grid_spacing', 'mask'];

}

mavlink20.messages.terrain_request.prototype = new mavlink20.message;
mavlink20.messages.terrain_request.prototype.pack = function(mav) {
    var orderedfields = [ this.mask, this.lat, this.lon, this.grid_spacing];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Terrain data sent from GCS. The lat/lon and grid_spacing must be the
same as a lat/lon from a TERRAIN_REQUEST. See terrain protocol docs:
https://mavlink.io/en/services/terrain.html

                lat                       : Latitude of SW corner of first grid (int32_t)
                lon                       : Longitude of SW corner of first grid (int32_t)
                grid_spacing              : Grid spacing (uint16_t)
                gridbit                   : bit within the terrain request mask (uint8_t)
                data                      : Terrain data MSL (int16_t)

*/
    mavlink20.messages.terrain_data = function( ...moreargs ) {
    [ this.lat , this.lon , this.grid_spacing , this.gridbit , this.data ] = moreargs;

    this._format = '<iiH16hB';
    this._id = mavlink20.MAVLINK_MSG_ID_TERRAIN_DATA;
    this.order_map = [0, 1, 2, 4, 3];
    this.len_map = [1, 1, 1, 16, 1];
    this.array_len_map = [0, 0, 0, 16, 0];
    this.crc_extra = 229;
    this._name = 'TERRAIN_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['lat', 'lon', 'grid_spacing', 'gridbit', 'data'];

}

mavlink20.messages.terrain_data.prototype = new mavlink20.message;
mavlink20.messages.terrain_data.prototype.pack = function(mav) {
    var orderedfields = [ this.lat, this.lon, this.grid_spacing, this.data, this.gridbit];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request that the vehicle report terrain height at the given location
(expected response is a TERRAIN_REPORT). Used by GCS to check if
vehicle has all terrain data needed for a mission.

                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)

*/
    mavlink20.messages.terrain_check = function( ...moreargs ) {
    [ this.lat , this.lon ] = moreargs;

    this._format = '<ii';
    this._id = mavlink20.MAVLINK_MSG_ID_TERRAIN_CHECK;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 203;
    this._name = 'TERRAIN_CHECK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['lat', 'lon'];

}

mavlink20.messages.terrain_check.prototype = new mavlink20.message;
mavlink20.messages.terrain_check.prototype.pack = function(mav) {
    var orderedfields = [ this.lat, this.lon];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Streamed from drone to report progress of terrain map download
(initiated by TERRAIN_REQUEST), or sent as a response to a
TERRAIN_CHECK request. See terrain protocol docs:
https://mavlink.io/en/services/terrain.html

                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)
                spacing                   : grid spacing (zero if terrain at this location unavailable) (uint16_t)
                terrain_height            : Terrain height MSL (float)
                current_height            : Current vehicle height above lat/lon terrain height (float)
                pending                   : Number of 4x4 terrain blocks waiting to be received or read from disk (uint16_t)
                loaded                    : Number of 4x4 terrain blocks in memory (uint16_t)

*/
    mavlink20.messages.terrain_report = function( ...moreargs ) {
    [ this.lat , this.lon , this.spacing , this.terrain_height , this.current_height , this.pending , this.loaded ] = moreargs;

    this._format = '<iiffHHH';
    this._id = mavlink20.MAVLINK_MSG_ID_TERRAIN_REPORT;
    this.order_map = [0, 1, 4, 2, 3, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 1;
    this._name = 'TERRAIN_REPORT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['lat', 'lon', 'spacing', 'terrain_height', 'current_height', 'pending', 'loaded'];

}

mavlink20.messages.terrain_report.prototype = new mavlink20.message;
mavlink20.messages.terrain_report.prototype.pack = function(mav) {
    var orderedfields = [ this.lat, this.lon, this.terrain_height, this.current_height, this.spacing, this.pending, this.loaded];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Barometer readings for 2nd barometer

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                press_abs                 : Absolute pressure (float)
                press_diff                : Differential pressure (float)
                temperature               : Absolute pressure temperature (int16_t)
                temperature_press_diff        : Differential pressure temperature (0, if not available). Report values of 0 (or 1) as 1 cdegC. (int16_t)

*/
    mavlink20.messages.scaled_pressure2 = function( ...moreargs ) {
    [ this.time_boot_ms , this.press_abs , this.press_diff , this.temperature , this.temperature_press_diff ] = moreargs;

    this._format = '<Iffhh';
    this._id = mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE2;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 195;
    this._name = 'SCALED_PRESSURE2';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'press_abs', 'press_diff', 'temperature', 'temperature_press_diff'];

}

mavlink20.messages.scaled_pressure2.prototype = new mavlink20.message;
mavlink20.messages.scaled_pressure2.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.press_abs, this.press_diff, this.temperature, this.temperature_press_diff];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Motion capture attitude and position

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                q                         : Attitude quaternion (w, x, y, z order, zero-rotation is 1, 0, 0, 0) (float)
                x                         : X position (NED) (float)
                y                         : Y position (NED) (float)
                z                         : Z position (NED) (float)
                covariance                : Row-major representation of a pose 6x6 cross-covariance matrix upper right triangle (states: x, y, z, roll, pitch, yaw; first six entries are the first ROW, next five entries are the second ROW, etc.). If unknown, assign NaN value to first element in the array. (float)

*/
    mavlink20.messages.att_pos_mocap = function( ...moreargs ) {
    [ this.time_usec , this.q , this.x , this.y , this.z , this.covariance ] = moreargs;

    this._format = '<Q4ffff21f';
    this._id = mavlink20.MAVLINK_MSG_ID_ATT_POS_MOCAP;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 4, 1, 1, 1, 21];
    this.array_len_map = [0, 4, 0, 0, 0, 21];
    this.crc_extra = 109;
    this._name = 'ATT_POS_MOCAP';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'q', 'x', 'y', 'z', 'covariance'];

}

mavlink20.messages.att_pos_mocap.prototype = new mavlink20.message;
mavlink20.messages.att_pos_mocap.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.q, this.x, this.y, this.z, this.covariance];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set the vehicle attitude and body angular rates.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                group_mlx                 : Actuator group. The "_mlx" indicates this is a multi-instance message and a MAVLink parser should use this field to difference between instances. (uint8_t)
                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                controls                  : Actuator controls. Normed to -1..+1 where 0 is neutral position. Throttle for single rotation direction motors is 0..1, negative range for reverse direction. Standard mapping for attitude controls (group 0): (index 0-7): roll, pitch, yaw, throttle, flaps, spoilers, airbrakes, landing gear. Load a pass-through mixer to repurpose them as generic outputs. (float)

*/
    mavlink20.messages.set_actuator_control_target = function( ...moreargs ) {
    [ this.time_usec , this.group_mlx , this.target_system , this.target_component , this.controls ] = moreargs;

    this._format = '<Q8fBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_ACTUATOR_CONTROL_TARGET;
    this.order_map = [0, 2, 3, 4, 1];
    this.len_map = [1, 8, 1, 1, 1];
    this.array_len_map = [0, 8, 0, 0, 0];
    this.crc_extra = 168;
    this._name = 'SET_ACTUATOR_CONTROL_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'group_mlx', 'target_system', 'target_component', 'controls'];

}

mavlink20.messages.set_actuator_control_target.prototype = new mavlink20.message;
mavlink20.messages.set_actuator_control_target.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.controls, this.group_mlx, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set the vehicle attitude and body angular rates.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                group_mlx                 : Actuator group. The "_mlx" indicates this is a multi-instance message and a MAVLink parser should use this field to difference between instances. (uint8_t)
                controls                  : Actuator controls. Normed to -1..+1 where 0 is neutral position. Throttle for single rotation direction motors is 0..1, negative range for reverse direction. Standard mapping for attitude controls (group 0): (index 0-7): roll, pitch, yaw, throttle, flaps, spoilers, airbrakes, landing gear. Load a pass-through mixer to repurpose them as generic outputs. (float)

*/
    mavlink20.messages.actuator_control_target = function( ...moreargs ) {
    [ this.time_usec , this.group_mlx , this.controls ] = moreargs;

    this._format = '<Q8fB';
    this._id = mavlink20.MAVLINK_MSG_ID_ACTUATOR_CONTROL_TARGET;
    this.order_map = [0, 2, 1];
    this.len_map = [1, 8, 1];
    this.array_len_map = [0, 8, 0];
    this.crc_extra = 181;
    this._name = 'ACTUATOR_CONTROL_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'group_mlx', 'controls'];

}

mavlink20.messages.actuator_control_target.prototype = new mavlink20.message;
mavlink20.messages.actuator_control_target.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.controls, this.group_mlx];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The current system altitude.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                altitude_monotonic        : This altitude measure is initialized on system boot and monotonic (it is never reset, but represents the local altitude change). The only guarantee on this field is that it will never be reset and is consistent within a flight. The recommended value for this field is the uncorrected barometric altitude at boot time. This altitude will also drift and vary between flights. (float)
                altitude_amsl             : This altitude measure is strictly above mean sea level and might be non-monotonic (it might reset on events like GPS lock or when a new QNH value is set). It should be the altitude to which global altitude waypoints are compared to. Note that it is *not* the GPS altitude, however, most GPS modules already output MSL by default and not the WGS84 altitude. (float)
                altitude_local            : This is the local altitude in the local coordinate frame. It is not the altitude above home, but in reference to the coordinate origin (0, 0, 0). It is up-positive. (float)
                altitude_relative         : This is the altitude above the home position. It resets on each change of the current home position. (float)
                altitude_terrain          : This is the altitude above terrain. It might be fed by a terrain database or an altimeter. Values smaller than -1000 should be interpreted as unknown. (float)
                bottom_clearance          : This is not the altitude, but the clear space below the system according to the fused clearance estimate. It generally should max out at the maximum range of e.g. the laser altimeter. It is generally a moving target. A negative value indicates no measurement available. (float)

*/
    mavlink20.messages.altitude = function( ...moreargs ) {
    [ this.time_usec , this.altitude_monotonic , this.altitude_amsl , this.altitude_local , this.altitude_relative , this.altitude_terrain , this.bottom_clearance ] = moreargs;

    this._format = '<Qffffff';
    this._id = mavlink20.MAVLINK_MSG_ID_ALTITUDE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 47;
    this._name = 'ALTITUDE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'altitude_monotonic', 'altitude_amsl', 'altitude_local', 'altitude_relative', 'altitude_terrain', 'bottom_clearance'];

}

mavlink20.messages.altitude.prototype = new mavlink20.message;
mavlink20.messages.altitude.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.altitude_monotonic, this.altitude_amsl, this.altitude_local, this.altitude_relative, this.altitude_terrain, this.bottom_clearance];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The autopilot is requesting a resource (file, binary, other type of
data)

                request_id                : Request ID. This ID should be reused when sending back URI contents (uint8_t)
                uri_type                  : The type of requested URI. 0 = a file via URL. 1 = a UAVCAN binary (uint8_t)
                uri                       : The requested unique resource identifier (URI). It is not necessarily a straight domain name (depends on the URI type enum) (uint8_t)
                transfer_type             : The way the autopilot wants to receive the URI. 0 = MAVLink FTP. 1 = binary stream. (uint8_t)
                storage                   : The storage path the autopilot wants the URI to be stored in. Will only be valid if the transfer_type has a storage associated (e.g. MAVLink FTP). (uint8_t)

*/
    mavlink20.messages.resource_request = function( ...moreargs ) {
    [ this.request_id , this.uri_type , this.uri , this.transfer_type , this.storage ] = moreargs;

    this._format = '<BB120sB120s';
    this._id = mavlink20.MAVLINK_MSG_ID_RESOURCE_REQUEST;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 120, 1, 120];
    this.array_len_map = [0, 0, 120, 0, 120];
    this.crc_extra = 72;
    this._name = 'RESOURCE_REQUEST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['request_id', 'uri_type', 'uri', 'transfer_type', 'storage'];

}

mavlink20.messages.resource_request.prototype = new mavlink20.message;
mavlink20.messages.resource_request.prototype.pack = function(mav) {
    var orderedfields = [ this.request_id, this.uri_type, this.uri, this.transfer_type, this.storage];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Barometer readings for 3rd barometer

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                press_abs                 : Absolute pressure (float)
                press_diff                : Differential pressure (float)
                temperature               : Absolute pressure temperature (int16_t)
                temperature_press_diff        : Differential pressure temperature (0, if not available). Report values of 0 (or 1) as 1 cdegC. (int16_t)

*/
    mavlink20.messages.scaled_pressure3 = function( ...moreargs ) {
    [ this.time_boot_ms , this.press_abs , this.press_diff , this.temperature , this.temperature_press_diff ] = moreargs;

    this._format = '<Iffhh';
    this._id = mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE3;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 131;
    this._name = 'SCALED_PRESSURE3';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'press_abs', 'press_diff', 'temperature', 'temperature_press_diff'];

}

mavlink20.messages.scaled_pressure3.prototype = new mavlink20.message;
mavlink20.messages.scaled_pressure3.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.press_abs, this.press_diff, this.temperature, this.temperature_press_diff];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Current motion information from a designated system

                timestamp                 : Timestamp (time since system boot). (uint64_t)
                est_capabilities          : bit positions for tracker reporting capabilities (POS = 0, VEL = 1, ACCEL = 2, ATT + RATES = 3) (uint8_t)
                lat                       : Latitude (WGS84) (int32_t)
                lon                       : Longitude (WGS84) (int32_t)
                alt                       : Altitude (MSL) (float)
                vel                       : target velocity (0,0,0) for unknown (float)
                acc                       : linear target acceleration (0,0,0) for unknown (float)
                attitude_q                : (0 0 0 0 for unknown) (float)
                rates                     : (0 0 0 for unknown) (float)
                position_cov              : eph epv (float)
                custom_state              : button states or switches of a tracker device (uint64_t)

*/
    mavlink20.messages.follow_target = function( ...moreargs ) {
    [ this.timestamp , this.est_capabilities , this.lat , this.lon , this.alt , this.vel , this.acc , this.attitude_q , this.rates , this.position_cov , this.custom_state ] = moreargs;

    this._format = '<QQiif3f3f4f3f3fB';
    this._id = mavlink20.MAVLINK_MSG_ID_FOLLOW_TARGET;
    this.order_map = [0, 10, 2, 3, 4, 5, 6, 7, 8, 9, 1];
    this.len_map = [1, 1, 1, 1, 1, 3, 3, 4, 3, 3, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 3, 3, 4, 3, 3, 0];
    this.crc_extra = 127;
    this._name = 'FOLLOW_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['timestamp', 'est_capabilities', 'lat', 'lon', 'alt', 'vel', 'acc', 'attitude_q', 'rates', 'position_cov', 'custom_state'];

}

mavlink20.messages.follow_target.prototype = new mavlink20.message;
mavlink20.messages.follow_target.prototype.pack = function(mav) {
    var orderedfields = [ this.timestamp, this.custom_state, this.lat, this.lon, this.alt, this.vel, this.acc, this.attitude_q, this.rates, this.position_cov, this.est_capabilities];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The smoothed, monotonic system state used to feed the control loops of
the system.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                x_acc                     : X acceleration in body frame (float)
                y_acc                     : Y acceleration in body frame (float)
                z_acc                     : Z acceleration in body frame (float)
                x_vel                     : X velocity in body frame (float)
                y_vel                     : Y velocity in body frame (float)
                z_vel                     : Z velocity in body frame (float)
                x_pos                     : X position in local frame (float)
                y_pos                     : Y position in local frame (float)
                z_pos                     : Z position in local frame (float)
                airspeed                  : Airspeed, set to -1 if unknown (float)
                vel_variance              : Variance of body velocity estimate (float)
                pos_variance              : Variance in local position (float)
                q                         : The attitude, represented as Quaternion (float)
                roll_rate                 : Angular rate in roll axis (float)
                pitch_rate                : Angular rate in pitch axis (float)
                yaw_rate                  : Angular rate in yaw axis (float)

*/
    mavlink20.messages.control_system_state = function( ...moreargs ) {
    [ this.time_usec , this.x_acc , this.y_acc , this.z_acc , this.x_vel , this.y_vel , this.z_vel , this.x_pos , this.y_pos , this.z_pos , this.airspeed , this.vel_variance , this.pos_variance , this.q , this.roll_rate , this.pitch_rate , this.yaw_rate ] = moreargs;

    this._format = '<Qffffffffff3f3f4ffff';
    this._id = mavlink20.MAVLINK_MSG_ID_CONTROL_SYSTEM_STATE;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 4, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 4, 0, 0, 0];
    this.crc_extra = 103;
    this._name = 'CONTROL_SYSTEM_STATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'x_acc', 'y_acc', 'z_acc', 'x_vel', 'y_vel', 'z_vel', 'x_pos', 'y_pos', 'z_pos', 'airspeed', 'vel_variance', 'pos_variance', 'q', 'roll_rate', 'pitch_rate', 'yaw_rate'];

}

mavlink20.messages.control_system_state.prototype = new mavlink20.message;
mavlink20.messages.control_system_state.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.x_acc, this.y_acc, this.z_acc, this.x_vel, this.y_vel, this.z_vel, this.x_pos, this.y_pos, this.z_pos, this.airspeed, this.vel_variance, this.pos_variance, this.q, this.roll_rate, this.pitch_rate, this.yaw_rate];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Battery information. Updates GCS with flight controller battery
status. Smart batteries also use this message, but may additionally
send BATTERY_INFO.

                id                        : Battery ID (uint8_t)
                battery_function          : Function of the battery (uint8_t)
                type                      : Type (chemistry) of the battery (uint8_t)
                temperature               : Temperature of the battery. INT16_MAX for unknown temperature. (int16_t)
                voltages                  : Battery voltage of cells 1 to 10 (see voltages_ext for cells 11-14). Cells in this field above the valid cell count for this battery should have the UINT16_MAX value. If individual cell voltages are unknown or not measured for this battery, then the overall battery voltage should be filled in cell 0, with all others set to UINT16_MAX. If the voltage of the battery is greater than (UINT16_MAX - 1), then cell 0 should be set to (UINT16_MAX - 1), and cell 1 to the remaining voltage. This can be extended to multiple cells if the total voltage is greater than 2 * (UINT16_MAX - 1). (uint16_t)
                current_battery           : Battery current, -1: autopilot does not measure the current (int16_t)
                current_consumed          : Consumed charge, -1: autopilot does not provide consumption estimate (int32_t)
                energy_consumed           : Consumed energy, -1: autopilot does not provide energy consumption estimate (int32_t)
                battery_remaining         : Remaining battery energy. Values: [0-100], -1: autopilot does not estimate the remaining battery. (int8_t)
                time_remaining            : Remaining battery time, 0: autopilot does not provide remaining battery time estimate (int32_t)
                charge_state              : State for extent of discharge, provided by autopilot for warning or external reactions (uint8_t)
                voltages_ext              : Battery voltages for cells 11 to 14. Cells above the valid cell count for this battery should have a value of 0, where zero indicates not supported (note, this is different than for the voltages field and allows empty byte truncation). If the measured value is 0 then 1 should be sent instead. (uint16_t)
                mode                      : Battery mode. Default (0) is that battery mode reporting is not supported or battery is in normal-use mode. (uint8_t)
                fault_bitmask             : Fault/health indications. These should be set when charge_state is MAV_BATTERY_CHARGE_STATE_FAILED or MAV_BATTERY_CHARGE_STATE_UNHEALTHY (if not, fault reporting is not supported). (uint32_t)

*/
    mavlink20.messages.battery_status = function( ...moreargs ) {
    [ this.id , this.battery_function , this.type , this.temperature , this.voltages , this.current_battery , this.current_consumed , this.energy_consumed , this.battery_remaining , this.time_remaining , this.charge_state , this.voltages_ext , this.mode , this.fault_bitmask ] = moreargs;

    this._format = '<iih10HhBBBbiB4HBI';
    this._id = mavlink20.MAVLINK_MSG_ID_BATTERY_STATUS;
    this.order_map = [5, 6, 7, 2, 3, 4, 0, 1, 8, 9, 10, 11, 12, 13];
    this.len_map = [1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1];
    this.array_len_map = [0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0];
    this.crc_extra = 154;
    this._name = 'BATTERY_STATUS';

    this._instance_field = 'id';
    this._instance_offset = 32;

    this.fieldnames = ['id', 'battery_function', 'type', 'temperature', 'voltages', 'current_battery', 'current_consumed', 'energy_consumed', 'battery_remaining', 'time_remaining', 'charge_state', 'voltages_ext', 'mode', 'fault_bitmask'];

}

mavlink20.messages.battery_status.prototype = new mavlink20.message;
mavlink20.messages.battery_status.prototype.pack = function(mav) {
    var orderedfields = [ this.current_consumed, this.energy_consumed, this.temperature, this.voltages, this.current_battery, this.id, this.battery_function, this.type, this.battery_remaining, this.time_remaining, this.charge_state, this.voltages_ext, this.mode, this.fault_bitmask];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The location of a landing target. See:
https://mavlink.io/en/services/landing_target.html

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                target_num                : The ID of the target if multiple targets are present (uint8_t)
                frame                     : Coordinate frame used for following fields. (uint8_t)
                angle_x                   : X-axis angular offset of the target from the center of the image (float)
                angle_y                   : Y-axis angular offset of the target from the center of the image (float)
                distance                  : Distance to the target from the vehicle (float)
                size_x                    : Size of target along x-axis (float)
                size_y                    : Size of target along y-axis (float)
                x                         : X Position of the landing target in MAV_FRAME (float)
                y                         : Y Position of the landing target in MAV_FRAME (float)
                z                         : Z Position of the landing target in MAV_FRAME (float)
                q                         : Quaternion of landing target orientation (w, x, y, z order, zero-rotation is 1, 0, 0, 0) (float)
                type                      : Type of landing target (uint8_t)
                position_valid            : Position fields (x, y, z, q, type) contain valid target position information (MAV_BOOL_FALSE: invalid values). Values not equal to 0 or 1 are invalid. (uint8_t)

*/
    mavlink20.messages.landing_target = function( ...moreargs ) {
    [ this.time_usec , this.target_num , this.frame , this.angle_x , this.angle_y , this.distance , this.size_x , this.size_y , this.x , this.y , this.z , this.q , this.type , this.position_valid ] = moreargs;

    this._format = '<QfffffBBfff4fBB';
    this._id = mavlink20.MAVLINK_MSG_ID_LANDING_TARGET;
    this.order_map = [0, 6, 7, 1, 2, 3, 4, 5, 8, 9, 10, 11, 12, 13];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0];
    this.crc_extra = 200;
    this._name = 'LANDING_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'target_num', 'frame', 'angle_x', 'angle_y', 'distance', 'size_x', 'size_y', 'x', 'y', 'z', 'q', 'type', 'position_valid'];

}

mavlink20.messages.landing_target.prototype = new mavlink20.message;
mavlink20.messages.landing_target.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.angle_x, this.angle_y, this.distance, this.size_x, this.size_y, this.target_num, this.frame, this.x, this.y, this.z, this.q, this.type, this.position_valid];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Status of geo-fencing. Sent in extended status stream when fencing
enabled.

                breach_status             : Breach status (0 if currently inside fence, 1 if outside). (uint8_t)
                breach_count              : Number of fence breaches. (uint16_t)
                breach_type               : Last breach type. (uint8_t)
                breach_time               : Time (since boot) of last breach. (uint32_t)
                breach_mitigation         : Active action to prevent fence breach (uint8_t)

*/
    mavlink20.messages.fence_status = function( ...moreargs ) {
    [ this.breach_status , this.breach_count , this.breach_type , this.breach_time , this.breach_mitigation ] = moreargs;

    this._format = '<IHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_FENCE_STATUS;
    this.order_map = [2, 1, 3, 0, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 189;
    this._name = 'FENCE_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['breach_status', 'breach_count', 'breach_type', 'breach_time', 'breach_mitigation'];

}

mavlink20.messages.fence_status.prototype = new mavlink20.message;
mavlink20.messages.fence_status.prototype.pack = function(mav) {
    var orderedfields = [ this.breach_time, this.breach_count, this.breach_status, this.breach_type, this.breach_mitigation];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports progress of compass calibration.

                compass_id                : Compass being calibrated. (uint8_t)
                cal_mask                  : Bitmask of compasses being calibrated. (uint8_t)
                cal_status                : Calibration Status. (uint8_t)
                attempt                   : Attempt number. (uint8_t)
                completion_pct            : Completion percentage. (uint8_t)
                completion_mask           : Bitmask of sphere sections (10 bytes). (uint8_t)
                direction_x               : Body frame direction vector for display. (float)
                direction_y               : Body frame direction vector for display. (float)
                direction_z               : Body frame direction vector for display. (float)

*/
    mavlink20.messages.mag_cal_progress = function( ...moreargs ) {
    [ this.compass_id , this.cal_mask , this.cal_status , this.attempt , this.completion_pct , this.completion_mask , this.direction_x , this.direction_y , this.direction_z ] = moreargs;

    this._format = '<fffBBBBB10B';
    this._id = mavlink20.MAVLINK_MSG_ID_MAG_CAL_PROGRESS;
    this.order_map = [3, 4, 5, 6, 7, 8, 0, 1, 2];
    this.len_map = [1, 1, 1, 1, 1, 10, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 10, 0, 0, 0];
    this.crc_extra = 92;
    this._name = 'MAG_CAL_PROGRESS';

    this._instance_field = 'compass_id';
    this._instance_offset = 12;

    this.fieldnames = ['compass_id', 'cal_mask', 'cal_status', 'attempt', 'completion_pct', 'completion_mask', 'direction_x', 'direction_y', 'direction_z'];

}

mavlink20.messages.mag_cal_progress.prototype = new mavlink20.message;
mavlink20.messages.mag_cal_progress.prototype.pack = function(mav) {
    var orderedfields = [ this.direction_x, this.direction_y, this.direction_z, this.compass_id, this.cal_mask, this.cal_status, this.attempt, this.completion_pct, this.completion_mask];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports results of completed compass calibration. Sent until
MAG_CAL_ACK received.

                compass_id                : Compass being calibrated. (uint8_t)
                cal_mask                  : Bitmask of compasses being calibrated. (uint8_t)
                cal_status                : Calibration Status. (uint8_t)
                autosaved                 : 0=requires a MAV_CMD_DO_ACCEPT_MAG_CAL, 1=saved to parameters. (uint8_t)
                fitness                   : RMS milligauss residuals. (float)
                ofs_x                     : X offset. (float)
                ofs_y                     : Y offset. (float)
                ofs_z                     : Z offset. (float)
                diag_x                    : X diagonal (matrix 11). (float)
                diag_y                    : Y diagonal (matrix 22). (float)
                diag_z                    : Z diagonal (matrix 33). (float)
                offdiag_x                 : X off-diagonal (matrix 12 and 21). (float)
                offdiag_y                 : Y off-diagonal (matrix 13 and 31). (float)
                offdiag_z                 : Z off-diagonal (matrix 32 and 23). (float)
                orientation_confidence        : Confidence in orientation (higher is better). (float)
                old_orientation           : orientation before calibration. (uint8_t)
                new_orientation           : orientation after calibration. (uint8_t)
                scale_factor              : field radius correction factor (float)

*/
    mavlink20.messages.mag_cal_report = function( ...moreargs ) {
    [ this.compass_id , this.cal_mask , this.cal_status , this.autosaved , this.fitness , this.ofs_x , this.ofs_y , this.ofs_z , this.diag_x , this.diag_y , this.diag_z , this.offdiag_x , this.offdiag_y , this.offdiag_z , this.orientation_confidence , this.old_orientation , this.new_orientation , this.scale_factor ] = moreargs;

    this._format = '<ffffffffffBBBBfBBf';
    this._id = mavlink20.MAVLINK_MSG_ID_MAG_CAL_REPORT;
    this.order_map = [10, 11, 12, 13, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 14, 15, 16, 17];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 36;
    this._name = 'MAG_CAL_REPORT';

    this._instance_field = 'compass_id';
    this._instance_offset = 40;

    this.fieldnames = ['compass_id', 'cal_mask', 'cal_status', 'autosaved', 'fitness', 'ofs_x', 'ofs_y', 'ofs_z', 'diag_x', 'diag_y', 'diag_z', 'offdiag_x', 'offdiag_y', 'offdiag_z', 'orientation_confidence', 'old_orientation', 'new_orientation', 'scale_factor'];

}

mavlink20.messages.mag_cal_report.prototype = new mavlink20.message;
mavlink20.messages.mag_cal_report.prototype.pack = function(mav) {
    var orderedfields = [ this.fitness, this.ofs_x, this.ofs_y, this.ofs_z, this.diag_x, this.diag_y, this.diag_z, this.offdiag_x, this.offdiag_y, this.offdiag_z, this.compass_id, this.cal_mask, this.cal_status, this.autosaved, this.orientation_confidence, this.old_orientation, this.new_orientation, this.scale_factor];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
EFI status output

                health                    : EFI health status (uint8_t)
                ecu_index                 : ECU index (float)
                rpm                       : RPM (float)
                fuel_consumed             : Fuel consumed (float)
                fuel_flow                 : Fuel flow rate (float)
                engine_load               : Engine load (float)
                throttle_position         : Throttle position (float)
                spark_dwell_time          : Spark dwell time (float)
                barometric_pressure        : Barometric pressure (float)
                intake_manifold_pressure        : Intake manifold pressure( (float)
                intake_manifold_temperature        : Intake manifold temperature (float)
                cylinder_head_temperature        : Cylinder head temperature (float)
                ignition_timing           : Ignition timing (Crank angle degrees) (float)
                injection_time            : Injection time (float)
                exhaust_gas_temperature        : Exhaust gas temperature (float)
                throttle_out              : Output throttle (float)
                pt_compensation           : Pressure/temperature compensation (float)
                ignition_voltage          : Supply voltage to EFI sparking system.  Zero in this value means "unknown", so if the supply voltage really is zero volts use 0.0001 instead. (float)
                fuel_pressure             : Fuel pressure. Zero in this value means "unknown", so if the fuel pressure really is zero kPa use 0.0001 instead. (float)

*/
    mavlink20.messages.efi_status = function( ...moreargs ) {
    [ this.health , this.ecu_index , this.rpm , this.fuel_consumed , this.fuel_flow , this.engine_load , this.throttle_position , this.spark_dwell_time , this.barometric_pressure , this.intake_manifold_pressure , this.intake_manifold_temperature , this.cylinder_head_temperature , this.ignition_timing , this.injection_time , this.exhaust_gas_temperature , this.throttle_out , this.pt_compensation , this.ignition_voltage , this.fuel_pressure ] = moreargs;

    this._format = '<ffffffffffffffffBff';
    this._id = mavlink20.MAVLINK_MSG_ID_EFI_STATUS;
    this.order_map = [16, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17, 18];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 208;
    this._name = 'EFI_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['health', 'ecu_index', 'rpm', 'fuel_consumed', 'fuel_flow', 'engine_load', 'throttle_position', 'spark_dwell_time', 'barometric_pressure', 'intake_manifold_pressure', 'intake_manifold_temperature', 'cylinder_head_temperature', 'ignition_timing', 'injection_time', 'exhaust_gas_temperature', 'throttle_out', 'pt_compensation', 'ignition_voltage', 'fuel_pressure'];

}

mavlink20.messages.efi_status.prototype = new mavlink20.message;
mavlink20.messages.efi_status.prototype.pack = function(mav) {
    var orderedfields = [ this.ecu_index, this.rpm, this.fuel_consumed, this.fuel_flow, this.engine_load, this.throttle_position, this.spark_dwell_time, this.barometric_pressure, this.intake_manifold_pressure, this.intake_manifold_temperature, this.cylinder_head_temperature, this.ignition_timing, this.injection_time, this.exhaust_gas_temperature, this.throttle_out, this.pt_compensation, this.health, this.ignition_voltage, this.fuel_pressure];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Estimator status message including flags, innovation test ratios and
estimated accuracies. The flags message is an integer bitmask
containing information on which EKF outputs are valid. See the
ESTIMATOR_STATUS_FLAGS enum definition for further information. The
innovation test ratios show the magnitude of the sensor innovation
divided by the innovation check threshold. Under normal operation the
innovation test ratios should be below 0.5 with occasional values up
to 1.0. Values greater than 1.0 should be rare under normal operation
and indicate that a measurement has been rejected by the filter. The
user should be notified if an innovation test ratio greater than 1.0
is recorded. Notifications for values in the range between 0.5 and 1.0
should be optional and controllable by the user.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                flags                     : Bitmap indicating which EKF outputs are valid. (uint16_t)
                vel_ratio                 : Velocity innovation test ratio (float)
                pos_horiz_ratio           : Horizontal position innovation test ratio (float)
                pos_vert_ratio            : Vertical position innovation test ratio (float)
                mag_ratio                 : Magnetometer innovation test ratio (float)
                hagl_ratio                : Height above terrain innovation test ratio (float)
                tas_ratio                 : True airspeed innovation test ratio (float)
                pos_horiz_accuracy        : Horizontal position 1-STD accuracy relative to the EKF local origin (float)
                pos_vert_accuracy         : Vertical position 1-STD accuracy relative to the EKF local origin (float)

*/
    mavlink20.messages.estimator_status = function( ...moreargs ) {
    [ this.time_usec , this.flags , this.vel_ratio , this.pos_horiz_ratio , this.pos_vert_ratio , this.mag_ratio , this.hagl_ratio , this.tas_ratio , this.pos_horiz_accuracy , this.pos_vert_accuracy ] = moreargs;

    this._format = '<QffffffffH';
    this._id = mavlink20.MAVLINK_MSG_ID_ESTIMATOR_STATUS;
    this.order_map = [0, 9, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 163;
    this._name = 'ESTIMATOR_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'flags', 'vel_ratio', 'pos_horiz_ratio', 'pos_vert_ratio', 'mag_ratio', 'hagl_ratio', 'tas_ratio', 'pos_horiz_accuracy', 'pos_vert_accuracy'];

}

mavlink20.messages.estimator_status.prototype = new mavlink20.message;
mavlink20.messages.estimator_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.vel_ratio, this.pos_horiz_ratio, this.pos_vert_ratio, this.mag_ratio, this.hagl_ratio, this.tas_ratio, this.pos_horiz_accuracy, this.pos_vert_accuracy, this.flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Wind estimate from vehicle. Note that despite the name, this message
does not actually contain any covariances but instead variability and
accuracy fields in terms of standard deviation (1-STD).

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                wind_x                    : Wind in North (NED) direction (NAN if unknown) (float)
                wind_y                    : Wind in East (NED) direction (NAN if unknown) (float)
                wind_z                    : Wind in down (NED) direction (NAN if unknown) (float)
                var_horiz                 : Variability of wind in XY, 1-STD estimated from a 1 Hz lowpassed wind estimate (NAN if unknown) (float)
                var_vert                  : Variability of wind in Z, 1-STD estimated from a 1 Hz lowpassed wind estimate (NAN if unknown) (float)
                wind_alt                  : Altitude (MSL) that this measurement was taken at (NAN if unknown) (float)
                horiz_accuracy            : Horizontal speed 1-STD accuracy (0 if unknown) (float)
                vert_accuracy             : Vertical speed 1-STD accuracy (0 if unknown) (float)

*/
    mavlink20.messages.wind_cov = function( ...moreargs ) {
    [ this.time_usec , this.wind_x , this.wind_y , this.wind_z , this.var_horiz , this.var_vert , this.wind_alt , this.horiz_accuracy , this.vert_accuracy ] = moreargs;

    this._format = '<Qffffffff';
    this._id = mavlink20.MAVLINK_MSG_ID_WIND_COV;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 105;
    this._name = 'WIND_COV';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'wind_x', 'wind_y', 'wind_z', 'var_horiz', 'var_vert', 'wind_alt', 'horiz_accuracy', 'vert_accuracy'];

}

mavlink20.messages.wind_cov.prototype = new mavlink20.message;
mavlink20.messages.wind_cov.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.wind_x, this.wind_y, this.wind_z, this.var_horiz, this.var_vert, this.wind_alt, this.horiz_accuracy, this.vert_accuracy];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
GPS sensor input message.  This is a raw sensor value sent by the GPS.
This is NOT the global position estimate of the system.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                gps_id                    : ID of the GPS for multiple GPS inputs (uint8_t)
                ignore_flags              : Bitmap indicating which GPS input flags fields to ignore.  All other fields must be provided. (uint16_t)
                time_week_ms              : GPS time (from start of GPS week) (uint32_t)
                time_week                 : GPS week number (uint16_t)
                fix_type                  : 0-1: no fix, 2: 2D fix, 3: 3D fix. 4: 3D with DGPS. 5: 3D with RTK (uint8_t)
                lat                       : Latitude (WGS84) (int32_t)
                lon                       : Longitude (WGS84) (int32_t)
                alt                       : Altitude (MSL). Positive for up. (float)
                hdop                      : GPS HDOP horizontal dilution of position (unitless). If unknown, set to: UINT16_MAX (float)
                vdop                      : GPS VDOP vertical dilution of position (unitless). If unknown, set to: UINT16_MAX (float)
                vn                        : GPS velocity in north direction in earth-fixed NED frame (float)
                ve                        : GPS velocity in east direction in earth-fixed NED frame (float)
                vd                        : GPS velocity in down direction in earth-fixed NED frame (float)
                speed_accuracy            : GPS speed accuracy (float)
                horiz_accuracy            : GPS horizontal accuracy (float)
                vert_accuracy             : GPS vertical accuracy (float)
                satellites_visible        : Number of satellites visible. (uint8_t)
                yaw                       : Yaw of vehicle relative to Earth's North, zero means not available, use 36000 for north (uint16_t)

*/
    mavlink20.messages.gps_input = function( ...moreargs ) {
    [ this.time_usec , this.gps_id , this.ignore_flags , this.time_week_ms , this.time_week , this.fix_type , this.lat , this.lon , this.alt , this.hdop , this.vdop , this.vn , this.ve , this.vd , this.speed_accuracy , this.horiz_accuracy , this.vert_accuracy , this.satellites_visible , this.yaw ] = moreargs;

    this._format = '<QIiifffffffffHHBBBH';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_INPUT;
    this.order_map = [0, 15, 13, 1, 14, 16, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 17, 18];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 151;
    this._name = 'GPS_INPUT';

    this._instance_field = 'gps_id';
    this._instance_offset = 60;

    this.fieldnames = ['time_usec', 'gps_id', 'ignore_flags', 'time_week_ms', 'time_week', 'fix_type', 'lat', 'lon', 'alt', 'hdop', 'vdop', 'vn', 've', 'vd', 'speed_accuracy', 'horiz_accuracy', 'vert_accuracy', 'satellites_visible', 'yaw'];

}

mavlink20.messages.gps_input.prototype = new mavlink20.message;
mavlink20.messages.gps_input.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.time_week_ms, this.lat, this.lon, this.alt, this.hdop, this.vdop, this.vn, this.ve, this.vd, this.speed_accuracy, this.horiz_accuracy, this.vert_accuracy, this.ignore_flags, this.time_week, this.gps_id, this.fix_type, this.satellites_visible, this.yaw];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
RTCM message for injecting into the onboard GPS (used for DGPS)

                flags                     : LSB: 1 means message is fragmented, next 2 bits are the fragment ID, the remaining 5 bits are used for the sequence ID. Messages are only to be flushed to the GPS when the entire message has been reconstructed on the autopilot. The fragment ID specifies which order the fragments should be assembled into a buffer, while the sequence ID is used to detect a mismatch between different buffers. The buffer is considered fully reconstructed when either all 4 fragments are present, or all the fragments before the first fragment with a non full payload is received. This management is used to ensure that normal GPS operation doesn't corrupt RTCM data, and to recover from a unreliable transport delivery order. (uint8_t)
                len                       : data length (uint8_t)
                data                      : RTCM message (may be fragmented) (uint8_t)

*/
    mavlink20.messages.gps_rtcm_data = function( ...moreargs ) {
    [ this.flags , this.len , this.data ] = moreargs;

    this._format = '<BB180s';
    this._id = mavlink20.MAVLINK_MSG_ID_GPS_RTCM_DATA;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 180];
    this.array_len_map = [0, 0, 180];
    this.crc_extra = 35;
    this._name = 'GPS_RTCM_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['flags', 'len', 'data'];

}

mavlink20.messages.gps_rtcm_data.prototype = new mavlink20.message;
mavlink20.messages.gps_rtcm_data.prototype.pack = function(mav) {
    var orderedfields = [ this.flags, this.len, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message appropriate for high latency connections like Iridium

                base_mode                 : Bitmap of enabled system modes. (uint8_t)
                custom_mode               : A bitfield for use for autopilot-specific flags. (uint32_t)
                landed_state              : The landed state. Is set to MAV_LANDED_STATE_UNDEFINED if landed state is unknown. (uint8_t)
                roll                      : roll (int16_t)
                pitch                     : pitch (int16_t)
                heading                   : heading (uint16_t)
                throttle                  : throttle (percentage) (int8_t)
                heading_sp                : heading setpoint (int16_t)
                latitude                  : Latitude (int32_t)
                longitude                 : Longitude (int32_t)
                altitude_amsl             : Altitude above mean sea level (int16_t)
                altitude_sp               : Altitude setpoint relative to the home position (int16_t)
                airspeed                  : airspeed (uint8_t)
                airspeed_sp               : airspeed setpoint (uint8_t)
                groundspeed               : groundspeed (uint8_t)
                climb_rate                : climb rate (int8_t)
                gps_nsat                  : Number of satellites visible. If unknown, set to UINT8_MAX (uint8_t)
                gps_fix_type              : GPS Fix type. (uint8_t)
                battery_remaining         : Remaining battery (percentage) (uint8_t)
                temperature               : Autopilot temperature (degrees C) (int8_t)
                temperature_air           : Air temperature (degrees C) from airspeed sensor (int8_t)
                failsafe                  : failsafe (each bit represents a failsafe where 0=ok, 1=failsafe active (bit0:RC, bit1:batt, bit2:GPS, bit3:GCS, bit4:fence) (uint8_t)
                wp_num                    : current waypoint number (uint8_t)
                wp_distance               : distance to target (uint16_t)

*/
    mavlink20.messages.high_latency = function( ...moreargs ) {
    [ this.base_mode , this.custom_mode , this.landed_state , this.roll , this.pitch , this.heading , this.throttle , this.heading_sp , this.latitude , this.longitude , this.altitude_amsl , this.altitude_sp , this.airspeed , this.airspeed_sp , this.groundspeed , this.climb_rate , this.gps_nsat , this.gps_fix_type , this.battery_remaining , this.temperature , this.temperature_air , this.failsafe , this.wp_num , this.wp_distance ] = moreargs;

    this._format = '<IiihhHhhhHBBbBBBbBBBbbBB';
    this._id = mavlink20.MAVLINK_MSG_ID_HIGH_LATENCY;
    this.order_map = [10, 0, 11, 3, 4, 5, 12, 6, 1, 2, 7, 8, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 9];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 150;
    this._name = 'HIGH_LATENCY';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['base_mode', 'custom_mode', 'landed_state', 'roll', 'pitch', 'heading', 'throttle', 'heading_sp', 'latitude', 'longitude', 'altitude_amsl', 'altitude_sp', 'airspeed', 'airspeed_sp', 'groundspeed', 'climb_rate', 'gps_nsat', 'gps_fix_type', 'battery_remaining', 'temperature', 'temperature_air', 'failsafe', 'wp_num', 'wp_distance'];

}

mavlink20.messages.high_latency.prototype = new mavlink20.message;
mavlink20.messages.high_latency.prototype.pack = function(mav) {
    var orderedfields = [ this.custom_mode, this.latitude, this.longitude, this.roll, this.pitch, this.heading, this.heading_sp, this.altitude_amsl, this.altitude_sp, this.wp_distance, this.base_mode, this.landed_state, this.throttle, this.airspeed, this.airspeed_sp, this.groundspeed, this.climb_rate, this.gps_nsat, this.gps_fix_type, this.battery_remaining, this.temperature, this.temperature_air, this.failsafe, this.wp_num];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message appropriate for high latency connections like Iridium (version
2)

                timestamp                 : Timestamp (milliseconds since boot or Unix epoch) (uint32_t)
                type                      : Type of the MAV (quadrotor, helicopter, etc.) (uint8_t)
                autopilot                 : Autopilot type / class. Use MAV_AUTOPILOT_INVALID for components that are not flight controllers. (uint8_t)
                custom_mode               : A bitfield for use for autopilot-specific flags (2 byte version). (uint16_t)
                latitude                  : Latitude (int32_t)
                longitude                 : Longitude (int32_t)
                altitude                  : Altitude above mean sea level (int16_t)
                target_altitude           : Altitude setpoint (int16_t)
                heading                   : Heading (uint8_t)
                target_heading            : Heading setpoint (uint8_t)
                target_distance           : Distance to target waypoint or position (uint16_t)
                throttle                  : Throttle (uint8_t)
                airspeed                  : Airspeed (uint8_t)
                airspeed_sp               : Airspeed setpoint (uint8_t)
                groundspeed               : Groundspeed (uint8_t)
                windspeed                 : Windspeed (uint8_t)
                wind_heading              : Wind heading (uint8_t)
                eph                       : Maximum error horizontal position since last message (uint8_t)
                epv                       : Maximum error vertical position since last message (uint8_t)
                temperature_air           : Air temperature (int8_t)
                climb_rate                : Maximum climb rate magnitude since last message (int8_t)
                battery                   : Battery level (-1 if field not provided). (int8_t)
                wp_num                    : Current waypoint number (uint16_t)
                failure_flags             : Bitmap of failure flags. (uint16_t)
                custom0                   : Field for custom payload. (int8_t)
                custom1                   : Field for custom payload. (int8_t)
                custom2                   : Field for custom payload. (int8_t)

*/
    mavlink20.messages.high_latency2 = function( ...moreargs ) {
    [ this.timestamp , this.type , this.autopilot , this.custom_mode , this.latitude , this.longitude , this.altitude , this.target_altitude , this.heading , this.target_heading , this.target_distance , this.throttle , this.airspeed , this.airspeed_sp , this.groundspeed , this.windspeed , this.wind_heading , this.eph , this.epv , this.temperature_air , this.climb_rate , this.battery , this.wp_num , this.failure_flags , this.custom0 , this.custom1 , this.custom2 ] = moreargs;

    this._format = '<IiiHhhHHHBBBBBBBBBBBBbbbbbb';
    this._id = mavlink20.MAVLINK_MSG_ID_HIGH_LATENCY2;
    this.order_map = [0, 9, 10, 3, 1, 2, 4, 5, 11, 12, 6, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 7, 8, 24, 25, 26];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 179;
    this._name = 'HIGH_LATENCY2';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['timestamp', 'type', 'autopilot', 'custom_mode', 'latitude', 'longitude', 'altitude', 'target_altitude', 'heading', 'target_heading', 'target_distance', 'throttle', 'airspeed', 'airspeed_sp', 'groundspeed', 'windspeed', 'wind_heading', 'eph', 'epv', 'temperature_air', 'climb_rate', 'battery', 'wp_num', 'failure_flags', 'custom0', 'custom1', 'custom2'];

}

mavlink20.messages.high_latency2.prototype = new mavlink20.message;
mavlink20.messages.high_latency2.prototype.pack = function(mav) {
    var orderedfields = [ this.timestamp, this.latitude, this.longitude, this.custom_mode, this.altitude, this.target_altitude, this.target_distance, this.wp_num, this.failure_flags, this.type, this.autopilot, this.heading, this.target_heading, this.throttle, this.airspeed, this.airspeed_sp, this.groundspeed, this.windspeed, this.wind_heading, this.eph, this.epv, this.temperature_air, this.climb_rate, this.battery, this.custom0, this.custom1, this.custom2];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Vibration levels and accelerometer clipping

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                vibration_x               : Vibration levels on X-axis (float)
                vibration_y               : Vibration levels on Y-axis (float)
                vibration_z               : Vibration levels on Z-axis (float)
                clipping_0                : first accelerometer clipping count (uint32_t)
                clipping_1                : second accelerometer clipping count (uint32_t)
                clipping_2                : third accelerometer clipping count (uint32_t)

*/
    mavlink20.messages.vibration = function( ...moreargs ) {
    [ this.time_usec , this.vibration_x , this.vibration_y , this.vibration_z , this.clipping_0 , this.clipping_1 , this.clipping_2 ] = moreargs;

    this._format = '<QfffIII';
    this._id = mavlink20.MAVLINK_MSG_ID_VIBRATION;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 90;
    this._name = 'VIBRATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'vibration_x', 'vibration_y', 'vibration_z', 'clipping_0', 'clipping_1', 'clipping_2'];

}

mavlink20.messages.vibration.prototype = new mavlink20.message;
mavlink20.messages.vibration.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.vibration_x, this.vibration_y, this.vibration_z, this.clipping_0, this.clipping_1, this.clipping_2];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Contains the home position.         The home position is the default
position that the system will return to and land on.         The
position must be set automatically by the system during the takeoff,
and may also be explicitly set using MAV_CMD_DO_SET_HOME.         The
global and local positions encode the position in the respective
coordinate frames, while the q parameter encodes the orientation of
the surface.         Under normal conditions it describes the heading
and terrain slope, which can be used by the aircraft to adjust the
approach.         The approach 3D vector describes the point to which
the system should fly in normal flight mode and then perform a landing
sequence along the vector.         Note: this message can be requested
by sending the MAV_CMD_REQUEST_MESSAGE with param1=242.

                latitude                  : Latitude (WGS84) (int32_t)
                longitude                 : Longitude (WGS84) (int32_t)
                altitude                  : Altitude (MSL). Positive for up. (int32_t)
                x                         : Local X position of this position in the local coordinate frame (NED) (float)
                y                         : Local Y position of this position in the local coordinate frame (NED) (float)
                z                         : Local Z position of this position in the local coordinate frame (NED: positive "down") (float)
                q                         : Quaternion indicating world-to-surface-normal and heading transformation of the takeoff position.
        Used to indicate the heading and slope of the ground.
        All fields should be set to NaN if an accurate quaternion for both heading and surface slope cannot be supplied. (float)
                approach_x                : Local X position of the end of the approach vector. Multicopters should set this position based on their takeoff path. Grass-landing fixed wing aircraft should set it the same way as multicopters. Runway-landing fixed wing aircraft should set it to the opposite direction of the takeoff, assuming the takeoff happened from the threshold / touchdown zone. (float)
                approach_y                : Local Y position of the end of the approach vector. Multicopters should set this position based on their takeoff path. Grass-landing fixed wing aircraft should set it the same way as multicopters. Runway-landing fixed wing aircraft should set it to the opposite direction of the takeoff, assuming the takeoff happened from the threshold / touchdown zone. (float)
                approach_z                : Local Z position of the end of the approach vector. Multicopters should set this position based on their takeoff path. Grass-landing fixed wing aircraft should set it the same way as multicopters. Runway-landing fixed wing aircraft should set it to the opposite direction of the takeoff, assuming the takeoff happened from the threshold / touchdown zone. (float)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)

*/
    mavlink20.messages.home_position = function( ...moreargs ) {
    [ this.latitude , this.longitude , this.altitude , this.x , this.y , this.z , this.q , this.approach_x , this.approach_y , this.approach_z , this.time_usec ] = moreargs;

    this._format = '<iiifff4ffffQ';
    this._id = mavlink20.MAVLINK_MSG_ID_HOME_POSITION;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0];
    this.crc_extra = 104;
    this._name = 'HOME_POSITION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['latitude', 'longitude', 'altitude', 'x', 'y', 'z', 'q', 'approach_x', 'approach_y', 'approach_z', 'time_usec'];

}

mavlink20.messages.home_position.prototype = new mavlink20.message;
mavlink20.messages.home_position.prototype.pack = function(mav) {
    var orderedfields = [ this.latitude, this.longitude, this.altitude, this.x, this.y, this.z, this.q, this.approach_x, this.approach_y, this.approach_z, this.time_usec];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Sets the home position.         The home position is the default
position that the system will return to and land on.         The
position is set automatically by the system during the takeoff (and
may also be set using this message).         The global and local
positions encode the position in the respective coordinate frames,
while the q parameter encodes the orientation of the surface.
Under normal conditions it describes the heading and terrain slope,
which can be used by the aircraft to adjust the approach.         The
approach 3D vector describes the point to which the system should fly
in normal flight mode and then perform a landing sequence along the
vector.         Note: the current home position may be emitted in a
HOME_POSITION message on request (using MAV_CMD_REQUEST_MESSAGE with
param1=242).

                target_system             : System ID. (uint8_t)
                latitude                  : Latitude (WGS84) (int32_t)
                longitude                 : Longitude (WGS84) (int32_t)
                altitude                  : Altitude (MSL). Positive for up. (int32_t)
                x                         : Local X position of this position in the local coordinate frame (NED) (float)
                y                         : Local Y position of this position in the local coordinate frame (NED) (float)
                z                         : Local Z position of this position in the local coordinate frame (NED: positive "down") (float)
                q                         : World to surface normal and heading transformation of the takeoff position. Used to indicate the heading and slope of the ground (float)
                approach_x                : Local X position of the end of the approach vector. Multicopters should set this position based on their takeoff path. Grass-landing fixed wing aircraft should set it the same way as multicopters. Runway-landing fixed wing aircraft should set it to the opposite direction of the takeoff, assuming the takeoff happened from the threshold / touchdown zone. (float)
                approach_y                : Local Y position of the end of the approach vector. Multicopters should set this position based on their takeoff path. Grass-landing fixed wing aircraft should set it the same way as multicopters. Runway-landing fixed wing aircraft should set it to the opposite direction of the takeoff, assuming the takeoff happened from the threshold / touchdown zone. (float)
                approach_z                : Local Z position of the end of the approach vector. Multicopters should set this position based on their takeoff path. Grass-landing fixed wing aircraft should set it the same way as multicopters. Runway-landing fixed wing aircraft should set it to the opposite direction of the takeoff, assuming the takeoff happened from the threshold / touchdown zone. (float)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)

*/
    mavlink20.messages.set_home_position = function( ...moreargs ) {
    [ this.target_system , this.latitude , this.longitude , this.altitude , this.x , this.y , this.z , this.q , this.approach_x , this.approach_y , this.approach_z , this.time_usec ] = moreargs;

    this._format = '<iiifff4ffffBQ';
    this._id = mavlink20.MAVLINK_MSG_ID_SET_HOME_POSITION;
    this.order_map = [10, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0];
    this.crc_extra = 85;
    this._name = 'SET_HOME_POSITION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'latitude', 'longitude', 'altitude', 'x', 'y', 'z', 'q', 'approach_x', 'approach_y', 'approach_z', 'time_usec'];

}

mavlink20.messages.set_home_position.prototype = new mavlink20.message;
mavlink20.messages.set_home_position.prototype.pack = function(mav) {
    var orderedfields = [ this.latitude, this.longitude, this.altitude, this.x, this.y, this.z, this.q, this.approach_x, this.approach_y, this.approach_z, this.target_system, this.time_usec];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The interval between messages for a particular MAVLink message ID.
This message is sent in response to the MAV_CMD_REQUEST_MESSAGE
command with param1=244 (this message) and param2=message_id (the id
of the message for which the interval is required).         This
interface replaces DATA_STREAM.

                message_id                : The ID of the requested MAVLink message. v1.0 is limited to 254 messages. (uint16_t)
                interval_us               : The interval between two messages. A value of -1 indicates this stream is disabled, 0 indicates it is not available, > 0 indicates the interval at which it is sent. (int32_t)

*/
    mavlink20.messages.message_interval = function( ...moreargs ) {
    [ this.message_id , this.interval_us ] = moreargs;

    this._format = '<iH';
    this._id = mavlink20.MAVLINK_MSG_ID_MESSAGE_INTERVAL;
    this.order_map = [1, 0];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 95;
    this._name = 'MESSAGE_INTERVAL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['message_id', 'interval_us'];

}

mavlink20.messages.message_interval.prototype = new mavlink20.message;
mavlink20.messages.message_interval.prototype.pack = function(mav) {
    var orderedfields = [ this.interval_us, this.message_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Provides state for additional features

                vtol_state                : The VTOL state if applicable. Is set to MAV_VTOL_STATE_UNDEFINED if UAV is not in VTOL configuration. (uint8_t)
                landed_state              : The landed state. Is set to MAV_LANDED_STATE_UNDEFINED if landed state is unknown. (uint8_t)

*/
    mavlink20.messages.extended_sys_state = function( ...moreargs ) {
    [ this.vtol_state , this.landed_state ] = moreargs;

    this._format = '<BB';
    this._id = mavlink20.MAVLINK_MSG_ID_EXTENDED_SYS_STATE;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 130;
    this._name = 'EXTENDED_SYS_STATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['vtol_state', 'landed_state'];

}

mavlink20.messages.extended_sys_state.prototype = new mavlink20.message;
mavlink20.messages.extended_sys_state.prototype.pack = function(mav) {
    var orderedfields = [ this.vtol_state, this.landed_state];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The location and information of an ADSB vehicle

                ICAO_address              : ICAO address (uint32_t)
                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)
                altitude_type             : ADSB altitude type. (uint8_t)
                altitude                  : Altitude (ASL) (int32_t)
                heading                   : Course over ground (uint16_t)
                hor_velocity              : The horizontal velocity (uint16_t)
                ver_velocity              : The vertical velocity. Positive is up (int16_t)
                callsign                  : The callsign, 8+null (char)
                emitter_type              : ADSB emitter type. (uint8_t)
                tslc                      : Time since last communication from the remote vehicle, in seconds. (uint8_t)
                flags                     : Bitmap to indicate various statuses including valid data fields (uint16_t)
                squawk                    : Squawk code. Note that the code is in decimal: e.g. 7700 (general emergency) is encoded as binary 0b0001_1110_0001_0100, not(!) as 0b0000_111_111_000_000 (uint16_t)

*/
    mavlink20.messages.adsb_vehicle = function( ...moreargs ) {
    [ this.ICAO_address , this.lat , this.lon , this.altitude_type , this.altitude , this.heading , this.hor_velocity , this.ver_velocity , this.callsign , this.emitter_type , this.tslc , this.flags , this.squawk ] = moreargs;

    this._format = '<IiiiHHhHHB9sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_ADSB_VEHICLE;
    this.order_map = [0, 1, 2, 9, 3, 4, 5, 6, 10, 11, 12, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0];
    this.crc_extra = 184;
    this._name = 'ADSB_VEHICLE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['ICAO_address', 'lat', 'lon', 'altitude_type', 'altitude', 'heading', 'hor_velocity', 'ver_velocity', 'callsign', 'emitter_type', 'tslc', 'flags', 'squawk'];

}

mavlink20.messages.adsb_vehicle.prototype = new mavlink20.message;
mavlink20.messages.adsb_vehicle.prototype.pack = function(mav) {
    var orderedfields = [ this.ICAO_address, this.lat, this.lon, this.altitude, this.heading, this.hor_velocity, this.ver_velocity, this.flags, this.squawk, this.altitude_type, this.callsign, this.emitter_type, this.tslc];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a potential collision

                src                       : Collision data source (uint8_t)
                id                        : Unique identifier, domain based on src field (uint32_t)
                action                    : Action that is being taken to avoid this collision (uint8_t)
                threat_level              : How concerned the aircraft is about this collision (uint8_t)
                time_to_minimum_delta        : Estimated time until collision occurs (float)
                altitude_minimum_delta        : Closest vertical distance between vehicle and object (float)
                horizontal_minimum_delta        : Closest horizontal distance between vehicle and object (float)

*/
    mavlink20.messages.collision = function( ...moreargs ) {
    [ this.src , this.id , this.action , this.threat_level , this.time_to_minimum_delta , this.altitude_minimum_delta , this.horizontal_minimum_delta ] = moreargs;

    this._format = '<IfffBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_COLLISION;
    this.order_map = [4, 0, 5, 6, 1, 2, 3];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 81;
    this._name = 'COLLISION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['src', 'id', 'action', 'threat_level', 'time_to_minimum_delta', 'altitude_minimum_delta', 'horizontal_minimum_delta'];

}

mavlink20.messages.collision.prototype = new mavlink20.message;
mavlink20.messages.collision.prototype.pack = function(mav) {
    var orderedfields = [ this.id, this.time_to_minimum_delta, this.altitude_minimum_delta, this.horizontal_minimum_delta, this.src, this.action, this.threat_level];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message implementing parts of the V2 payload specs in V1 frames for
transitional support.

                target_network            : Network ID (0 for broadcast) (uint8_t)
                target_system             : System ID (0 for broadcast) (uint8_t)
                target_component          : Component ID (0 for broadcast) (uint8_t)
                message_type              : A code that identifies the software component that understands this message (analogous to USB device classes or mime type strings). If this code is less than 32768, it is considered a 'registered' protocol extension and the corresponding entry should be added to https://github.com/mavlink/mavlink/definition_files/extension_message_ids.xml. Software creators can register blocks of message IDs as needed (useful for GCS specific metadata, etc...). Message_types greater than 32767 are considered local experiments and should not be checked in to any widely distributed codebase. (uint16_t)
                payload                   : Variable length payload. The length must be encoded in the payload as part of the message_type protocol, e.g. by including the length as payload data, or by terminating the payload data with a non-zero marker. This is required in order to reconstruct zero-terminated payloads that are (or otherwise would be) trimmed by MAVLink 2 empty-byte truncation. The entire content of the payload block is opaque unless you understand the encoding message_type. The particular encoding used can be extension specific and might not always be documented as part of the MAVLink specification. (uint8_t)

*/
    mavlink20.messages.v2_extension = function( ...moreargs ) {
    [ this.target_network , this.target_system , this.target_component , this.message_type , this.payload ] = moreargs;

    this._format = '<HBBB249s';
    this._id = mavlink20.MAVLINK_MSG_ID_V2_EXTENSION;
    this.order_map = [1, 2, 3, 0, 4];
    this.len_map = [1, 1, 1, 1, 249];
    this.array_len_map = [0, 0, 0, 0, 249];
    this.crc_extra = 8;
    this._name = 'V2_EXTENSION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_network', 'target_system', 'target_component', 'message_type', 'payload'];

}

mavlink20.messages.v2_extension.prototype = new mavlink20.message;
mavlink20.messages.v2_extension.prototype.pack = function(mav) {
    var orderedfields = [ this.message_type, this.target_network, this.target_system, this.target_component, this.payload];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Send raw controller memory. The use of this message is discouraged for
normal packets, but a quite efficient way for testing new messages and
getting experimental debug output.

                address                   : Starting address of the debug variables (uint16_t)
                ver                       : Version code of the type variable. 0=unknown, type ignored and assumed int16_t. 1=as below (uint8_t)
                type                      : Type code of the memory variables. for ver = 1: 0=16 x int16_t, 1=16 x uint16_t, 2=16 x Q15, 3=16 x 1Q14 (uint8_t)
                value                     : Memory contents at specified address (int8_t)

*/
    mavlink20.messages.memory_vect = function( ...moreargs ) {
    [ this.address , this.ver , this.type , this.value ] = moreargs;

    this._format = '<HBB32s';
    this._id = mavlink20.MAVLINK_MSG_ID_MEMORY_VECT;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 32];
    this.array_len_map = [0, 0, 0, 32];
    this.crc_extra = 204;
    this._name = 'MEMORY_VECT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['address', 'ver', 'type', 'value'];

}

mavlink20.messages.memory_vect.prototype = new mavlink20.message;
mavlink20.messages.memory_vect.prototype.pack = function(mav) {
    var orderedfields = [ this.address, this.ver, this.type, this.value];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
To debug something using a named 3D vector.

                name                      : Name (char)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                x                         : x (float)
                y                         : y (float)
                z                         : z (float)

*/
    mavlink20.messages.debug_vect = function( ...moreargs ) {
    [ this.name , this.time_usec , this.x , this.y , this.z ] = moreargs;

    this._format = '<Qfff10s';
    this._id = mavlink20.MAVLINK_MSG_ID_DEBUG_VECT;
    this.order_map = [4, 0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 10];
    this.crc_extra = 49;
    this._name = 'DEBUG_VECT';

    this._instance_field = 'name';
    this._instance_offset = 20;

    this.fieldnames = ['name', 'time_usec', 'x', 'y', 'z'];

}

mavlink20.messages.debug_vect.prototype = new mavlink20.message;
mavlink20.messages.debug_vect.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.x, this.y, this.z, this.name];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Send a key-value pair as float. The use of this message is discouraged
for normal packets, but a quite efficient way for testing new messages
and getting experimental debug output.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                name                      : Name of the debug variable (char)
                value                     : Floating point value (float)

*/
    mavlink20.messages.named_value_float = function( ...moreargs ) {
    [ this.time_boot_ms , this.name , this.value ] = moreargs;

    this._format = '<If10s';
    this._id = mavlink20.MAVLINK_MSG_ID_NAMED_VALUE_FLOAT;
    this.order_map = [0, 2, 1];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 10];
    this.crc_extra = 170;
    this._name = 'NAMED_VALUE_FLOAT';

    this._instance_field = 'name';
    this._instance_offset = 8;

    this.fieldnames = ['time_boot_ms', 'name', 'value'];

}

mavlink20.messages.named_value_float.prototype = new mavlink20.message;
mavlink20.messages.named_value_float.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.value, this.name];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Send a key-value pair as integer. The use of this message is
discouraged for normal packets, but a quite efficient way for testing
new messages and getting experimental debug output.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                name                      : Name of the debug variable (char)
                value                     : Signed integer value (int32_t)

*/
    mavlink20.messages.named_value_int = function( ...moreargs ) {
    [ this.time_boot_ms , this.name , this.value ] = moreargs;

    this._format = '<Ii10s';
    this._id = mavlink20.MAVLINK_MSG_ID_NAMED_VALUE_INT;
    this.order_map = [0, 2, 1];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 10];
    this.crc_extra = 44;
    this._name = 'NAMED_VALUE_INT';

    this._instance_field = 'name';
    this._instance_offset = 8;

    this.fieldnames = ['time_boot_ms', 'name', 'value'];

}

mavlink20.messages.named_value_int.prototype = new mavlink20.message;
mavlink20.messages.named_value_int.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.value, this.name];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Status text message. These messages are printed in yellow in the COMM
console of QGroundControl. WARNING: They consume quite some bandwidth,
so use only for important status and error messages. If implemented
wisely, these messages are buffered on the MCU and sent only at a
limited rate (e.g. 10 Hz).

                severity                  : Severity of status. Relies on the definitions within RFC-5424. (uint8_t)
                text                      : Status text message, without null termination character. UTF-8 encoded. (char)
                id                        : Unique (opaque) identifier for this statustext message.  May be used to reassemble a logical long-statustext message from a sequence of chunks.  A value of zero indicates this is the only chunk in the sequence and the message can be emitted immediately. (uint16_t)
                chunk_seq                 : This chunk's sequence number; indexing is from zero.  Any null character in the text field is taken to mean this was the last chunk. (uint8_t)

*/
    mavlink20.messages.statustext = function( ...moreargs ) {
    [ this.severity , this.text , this.id , this.chunk_seq ] = moreargs;

    this._format = '<B50sHB';
    this._id = mavlink20.MAVLINK_MSG_ID_STATUSTEXT;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 50, 0, 0];
    this.crc_extra = 83;
    this._name = 'STATUSTEXT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['severity', 'text', 'id', 'chunk_seq'];

}

mavlink20.messages.statustext.prototype = new mavlink20.message;
mavlink20.messages.statustext.prototype.pack = function(mav) {
    var orderedfields = [ this.severity, this.text, this.id, this.chunk_seq];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Send a debug value. The index is used to discriminate between values.
These values show up in the plot of QGroundControl as DEBUG N.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                ind                       : index of debug variable (uint8_t)
                value                     : DEBUG value (float)

*/
    mavlink20.messages.debug = function( ...moreargs ) {
    [ this.time_boot_ms , this.ind , this.value ] = moreargs;

    this._format = '<IfB';
    this._id = mavlink20.MAVLINK_MSG_ID_DEBUG;
    this.order_map = [0, 2, 1];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 46;
    this._name = 'DEBUG';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'ind', 'value'];

}

mavlink20.messages.debug.prototype = new mavlink20.message;
mavlink20.messages.debug.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.value, this.ind];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Setup a MAVLink2 signing key. If called with secret_key of all zero
and zero initial_timestamp will disable signing

                target_system             : system id of the target (uint8_t)
                target_component          : component ID of the target (uint8_t)
                secret_key                : signing key (uint8_t)
                initial_timestamp         : initial timestamp (uint64_t)

*/
    mavlink20.messages.setup_signing = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.secret_key , this.initial_timestamp ] = moreargs;

    this._format = '<QBB32s';
    this._id = mavlink20.MAVLINK_MSG_ID_SETUP_SIGNING;
    this.order_map = [1, 2, 3, 0];
    this.len_map = [1, 1, 1, 32];
    this.array_len_map = [0, 0, 0, 32];
    this.crc_extra = 71;
    this._name = 'SETUP_SIGNING';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'secret_key', 'initial_timestamp'];

}

mavlink20.messages.setup_signing.prototype = new mavlink20.message;
mavlink20.messages.setup_signing.prototype.pack = function(mav) {
    var orderedfields = [ this.initial_timestamp, this.target_system, this.target_component, this.secret_key];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Report button state change.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                last_change_ms            : Time of last change of button state. (uint32_t)
                state                     : Bitmap for state of buttons. (uint8_t)

*/
    mavlink20.messages.button_change = function( ...moreargs ) {
    [ this.time_boot_ms , this.last_change_ms , this.state ] = moreargs;

    this._format = '<IIB';
    this._id = mavlink20.MAVLINK_MSG_ID_BUTTON_CHANGE;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 131;
    this._name = 'BUTTON_CHANGE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'last_change_ms', 'state'];

}

mavlink20.messages.button_change.prototype = new mavlink20.message;
mavlink20.messages.button_change.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.last_change_ms, this.state];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Control vehicle tone generation (buzzer).

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                tune                      : tune in board specific format (char)
                tune2                     : tune extension (appended to tune) (char)

*/
    mavlink20.messages.play_tune = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.tune , this.tune2 ] = moreargs;

    this._format = '<BB30s200s';
    this._id = mavlink20.MAVLINK_MSG_ID_PLAY_TUNE;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 30, 200];
    this.crc_extra = 187;
    this._name = 'PLAY_TUNE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'tune', 'tune2'];

}

mavlink20.messages.play_tune.prototype = new mavlink20.message;
mavlink20.messages.play_tune.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.tune, this.tune2];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a camera. Can be requested with a
MAV_CMD_REQUEST_MESSAGE command.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                vendor_name               : Name of the camera vendor (uint8_t)
                model_name                : Name of the camera model (uint8_t)
                firmware_version          : Version of the camera firmware, encoded as: `(Dev & 0xff) << 24 + (Patch & 0xff) << 16 + (Minor & 0xff) << 8 + (Major & 0xff)`. Use 0 if not known. (uint32_t)
                focal_length              : Focal length. Use NaN if not known. (float)
                sensor_size_h             : Image sensor size horizontal. Use NaN if not known. (float)
                sensor_size_v             : Image sensor size vertical. Use NaN if not known. (float)
                resolution_h              : Horizontal image resolution. Use 0 if not known. (uint16_t)
                resolution_v              : Vertical image resolution. Use 0 if not known. (uint16_t)
                lens_id                   : Reserved for a lens ID.  Use 0 if not known. (uint8_t)
                flags                     : Bitmap of camera capability flags. (uint32_t)
                cam_definition_version        : Camera definition version (iteration).  Use 0 if not known. (uint16_t)
                cam_definition_uri        : Camera definition URI (if any, otherwise only basic functions will be available). HTTP- (http://) and MAVLink FTP- (mavlinkftp://) formatted URIs are allowed (and both must be supported by any GCS that implements the Camera Protocol). The definition file may be xz compressed, which will be indicated by the file extension .xml.xz (a GCS that implements the protocol must support decompressing the file). The string needs to be zero terminated.  Use a zero-length string if not known. (char)
                gimbal_device_id          : Gimbal id of a gimbal associated with this camera. This is the component id of the gimbal device, or 1-6 for non mavlink gimbals. Use 0 if no gimbal is associated with the camera. (uint8_t)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.camera_information = function( ...moreargs ) {
    [ this.time_boot_ms , this.vendor_name , this.model_name , this.firmware_version , this.focal_length , this.sensor_size_h , this.sensor_size_v , this.resolution_h , this.resolution_v , this.lens_id , this.flags , this.cam_definition_version , this.cam_definition_uri , this.gimbal_device_id , this.camera_device_id ] = moreargs;

    this._format = '<IIfffIHHH32s32sB140sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_INFORMATION;
    this.order_map = [0, 9, 10, 1, 2, 3, 4, 6, 7, 11, 5, 8, 12, 13, 14];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 32, 32, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 0, 140, 0, 0];
    this.crc_extra = 92;
    this._name = 'CAMERA_INFORMATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'vendor_name', 'model_name', 'firmware_version', 'focal_length', 'sensor_size_h', 'sensor_size_v', 'resolution_h', 'resolution_v', 'lens_id', 'flags', 'cam_definition_version', 'cam_definition_uri', 'gimbal_device_id', 'camera_device_id'];

}

mavlink20.messages.camera_information.prototype = new mavlink20.message;
mavlink20.messages.camera_information.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.firmware_version, this.focal_length, this.sensor_size_h, this.sensor_size_v, this.flags, this.resolution_h, this.resolution_v, this.cam_definition_version, this.vendor_name, this.model_name, this.lens_id, this.cam_definition_uri, this.gimbal_device_id, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Settings of a camera. Can be requested with a MAV_CMD_REQUEST_MESSAGE
command.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                mode_id                   : Camera mode (uint8_t)
                zoomLevel                 : Current zoom level as a percentage of the full range (0.0 to 100.0, NaN if not known) (float)
                focusLevel                : Current focus level as a percentage of the full range (0.0 to 100.0, NaN if not known) (float)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.camera_settings = function( ...moreargs ) {
    [ this.time_boot_ms , this.mode_id , this.zoomLevel , this.focusLevel , this.camera_device_id ] = moreargs;

    this._format = '<IBffB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_SETTINGS;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 146;
    this._name = 'CAMERA_SETTINGS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'mode_id', 'zoomLevel', 'focusLevel', 'camera_device_id'];

}

mavlink20.messages.camera_settings.prototype = new mavlink20.message;
mavlink20.messages.camera_settings.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.mode_id, this.zoomLevel, this.focusLevel, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a storage medium. This message is sent in response
to a request with MAV_CMD_REQUEST_MESSAGE and whenever the status of
the storage changes (STORAGE_STATUS). Use
MAV_CMD_REQUEST_MESSAGE.param2 to indicate the index/id of requested
storage: 0 for all, 1 for first, 2 for second, etc.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                storage_id                : Storage ID (1 for first, 2 for second, etc.) (uint8_t)
                storage_count             : Number of storage devices (uint8_t)
                status                    : Status of storage (uint8_t)
                total_capacity            : Total capacity. If storage is not ready (STORAGE_STATUS_READY) value will be ignored. (float)
                used_capacity             : Used capacity. If storage is not ready (STORAGE_STATUS_READY) value will be ignored. (float)
                available_capacity        : Available storage capacity. If storage is not ready (STORAGE_STATUS_READY) value will be ignored. (float)
                read_speed                : Read speed. (float)
                write_speed               : Write speed. (float)
                type                      : Type of storage (uint8_t)
                name                      : Textual storage name to be used in UI (microSD 1, Internal Memory, etc.) This is a NULL terminated string. If it is exactly 32 characters long, add a terminating NULL. If this string is empty, the generic type is shown to the user. (char)
                storage_usage             : Flags indicating whether this instance is preferred storage for photos, videos, etc.
        Note: Implementations should initially set the flags on the system-default storage id used for saving media (if possible/supported).
        This setting can then be overridden using MAV_CMD_SET_STORAGE_USAGE.
        If the media usage flags are not set, a GCS may assume storage ID 1 is the default storage for all media types. (uint8_t)

*/
    mavlink20.messages.storage_information = function( ...moreargs ) {
    [ this.time_boot_ms , this.storage_id , this.storage_count , this.status , this.total_capacity , this.used_capacity , this.available_capacity , this.read_speed , this.write_speed , this.type , this.name , this.storage_usage ] = moreargs;

    this._format = '<IfffffBBBB32sB';
    this._id = mavlink20.MAVLINK_MSG_ID_STORAGE_INFORMATION;
    this.order_map = [0, 6, 7, 8, 1, 2, 3, 4, 5, 9, 10, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 0];
    this.crc_extra = 179;
    this._name = 'STORAGE_INFORMATION';

    this._instance_field = 'storage_id';
    this._instance_offset = 24;

    this.fieldnames = ['time_boot_ms', 'storage_id', 'storage_count', 'status', 'total_capacity', 'used_capacity', 'available_capacity', 'read_speed', 'write_speed', 'type', 'name', 'storage_usage'];

}

mavlink20.messages.storage_information.prototype = new mavlink20.message;
mavlink20.messages.storage_information.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.total_capacity, this.used_capacity, this.available_capacity, this.read_speed, this.write_speed, this.storage_id, this.storage_count, this.status, this.type, this.name, this.storage_usage];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about the status of a capture. Can be requested with a
MAV_CMD_REQUEST_MESSAGE command.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                image_status              : Current status of image capturing (0: idle, 1: capture in progress, 2: interval set but idle, 3: interval set and capture in progress) (uint8_t)
                video_status              : Current status of video capturing (0: idle, 1: capture in progress) (uint8_t)
                image_interval            : Image capture interval (float)
                recording_time_ms         : Elapsed time since recording started (0: Not supported/available). A GCS should compute recording time and use non-zero values of this field to correct any discrepancy. (uint32_t)
                available_capacity        : Available storage capacity. (float)
                image_count               : Total number of images captured ('forever', or until reset using MAV_CMD_STORAGE_FORMAT). (int32_t)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.camera_capture_status = function( ...moreargs ) {
    [ this.time_boot_ms , this.image_status , this.video_status , this.image_interval , this.recording_time_ms , this.available_capacity , this.image_count , this.camera_device_id ] = moreargs;

    this._format = '<IfIfBBiB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_CAPTURE_STATUS;
    this.order_map = [0, 4, 5, 1, 2, 3, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 12;
    this._name = 'CAMERA_CAPTURE_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'image_status', 'video_status', 'image_interval', 'recording_time_ms', 'available_capacity', 'image_count', 'camera_device_id'];

}

mavlink20.messages.camera_capture_status.prototype = new mavlink20.message;
mavlink20.messages.camera_capture_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.image_interval, this.recording_time_ms, this.available_capacity, this.image_status, this.video_status, this.image_count, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a captured image. This is emitted every time a
message is captured.         MAV_CMD_REQUEST_MESSAGE can be used to
(re)request this message for a specific sequence number or range of
sequence numbers:         MAV_CMD_REQUEST_MESSAGE.param2 indicates the
sequence number the first image to send, or set to -1 to send the
message for all sequence numbers.
MAV_CMD_REQUEST_MESSAGE.param3 is used to specify a range of messages
to send:         set to 0 (default) to send just the the message for
the sequence number in param 2,         set to -1 to send the message
for the sequence number in param 2 and all the following sequence
numbers,         set to the sequence number of the final message in
the range.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                time_utc                  : Timestamp (time since UNIX epoch) in UTC. 0 for unknown. (uint64_t)
                camera_id                 : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). Field name is usually camera_device_id. (uint8_t)
                lat                       : Latitude where image was taken (int32_t)
                lon                       : Longitude where capture was taken (int32_t)
                alt                       : Altitude (MSL) where image was taken (int32_t)
                relative_alt              : Altitude above ground (int32_t)
                q                         : Quaternion of camera orientation (w, x, y, z order, zero-rotation is 1, 0, 0, 0) (float)
                image_index               : Zero based index of this image (i.e. a new image will have index CAMERA_CAPTURE_STATUS.image count -1) (int32_t)
                capture_result            : Image was captured successfully (MAV_BOOL_TRUE). Values not equal to 0 or 1 are invalid. (int8_t)
                file_url                  : URL of image taken. Either local storage or http://foo.jpg if camera provides an HTTP interface. (char)

*/
    mavlink20.messages.camera_image_captured = function( ...moreargs ) {
    [ this.time_boot_ms , this.time_utc , this.camera_id , this.lat , this.lon , this.alt , this.relative_alt , this.q , this.image_index , this.capture_result , this.file_url ] = moreargs;

    this._format = '<QIiiii4fiBb205s';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_IMAGE_CAPTURED;
    this.order_map = [1, 0, 8, 2, 3, 4, 5, 6, 7, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 205];
    this.crc_extra = 133;
    this._name = 'CAMERA_IMAGE_CAPTURED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'time_utc', 'camera_id', 'lat', 'lon', 'alt', 'relative_alt', 'q', 'image_index', 'capture_result', 'file_url'];

}

mavlink20.messages.camera_image_captured.prototype = new mavlink20.message;
mavlink20.messages.camera_image_captured.prototype.pack = function(mav) {
    var orderedfields = [ this.time_utc, this.time_boot_ms, this.lat, this.lon, this.alt, this.relative_alt, this.q, this.image_index, this.camera_id, this.capture_result, this.file_url];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Flight information.         This includes time since boot for arm,
takeoff, and land, and a flight number.         Takeoff and landing
values reset to zero on arm.         This can be requested using
MAV_CMD_REQUEST_MESSAGE.         Note, some fields are misnamed -
timestamps are from boot (not UTC) and the flight_uuid is a sequence
number.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                arming_time_utc           : Timestamp at arming (since system boot). Set to 0 on boot. Set value on arming. Note, field is misnamed UTC. (uint64_t)
                takeoff_time_utc          : Timestamp at takeoff (since system boot). Set to 0 at boot and on arming. Note, field is misnamed UTC. (uint64_t)
                flight_uuid               : Flight number. Note, field is misnamed UUID. (uint64_t)
                landing_time              : Timestamp at landing (in ms since system boot). Set to 0 at boot and on arming. (uint32_t)

*/
    mavlink20.messages.flight_information = function( ...moreargs ) {
    [ this.time_boot_ms , this.arming_time_utc , this.takeoff_time_utc , this.flight_uuid , this.landing_time ] = moreargs;

    this._format = '<QQQII';
    this._id = mavlink20.MAVLINK_MSG_ID_FLIGHT_INFORMATION;
    this.order_map = [3, 0, 1, 2, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 49;
    this._name = 'FLIGHT_INFORMATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'arming_time_utc', 'takeoff_time_utc', 'flight_uuid', 'landing_time'];

}

mavlink20.messages.flight_information.prototype = new mavlink20.message;
mavlink20.messages.flight_information.prototype.pack = function(mav) {
    var orderedfields = [ this.arming_time_utc, this.takeoff_time_utc, this.flight_uuid, this.time_boot_ms, this.landing_time];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Orientation of a mount

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                roll                      : Roll in global frame (set to NaN for invalid). (float)
                pitch                     : Pitch in global frame (set to NaN for invalid). (float)
                yaw                       : Yaw relative to vehicle (set to NaN for invalid). (float)
                yaw_absolute              : Yaw in absolute frame relative to Earth's North, north is 0 (set to NaN for invalid). (float)

*/
    mavlink20.messages.mount_orientation = function( ...moreargs ) {
    [ this.time_boot_ms , this.roll , this.pitch , this.yaw , this.yaw_absolute ] = moreargs;

    this._format = '<Iffff';
    this._id = mavlink20.MAVLINK_MSG_ID_MOUNT_ORIENTATION;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 26;
    this._name = 'MOUNT_ORIENTATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'roll', 'pitch', 'yaw', 'yaw_absolute'];

}

mavlink20.messages.mount_orientation.prototype = new mavlink20.message;
mavlink20.messages.mount_orientation.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.roll, this.pitch, this.yaw, this.yaw_absolute];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A message containing logged data (see also MAV_CMD_LOGGING_START)

                target_system             : system ID of the target (uint8_t)
                target_component          : component ID of the target (uint8_t)
                sequence                  : sequence number (can wrap) (uint16_t)
                length                    : data length (uint8_t)
                first_message_offset        : offset into data where first message starts. This can be used for recovery, when a previous message got lost (set to UINT8_MAX if no start exists). (uint8_t)
                data                      : logged data (uint8_t)

*/
    mavlink20.messages.logging_data = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.sequence , this.length , this.first_message_offset , this.data ] = moreargs;

    this._format = '<HBBBB249s';
    this._id = mavlink20.MAVLINK_MSG_ID_LOGGING_DATA;
    this.order_map = [1, 2, 0, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 249];
    this.array_len_map = [0, 0, 0, 0, 0, 249];
    this.crc_extra = 193;
    this._name = 'LOGGING_DATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'sequence', 'length', 'first_message_offset', 'data'];

}

mavlink20.messages.logging_data.prototype = new mavlink20.message;
mavlink20.messages.logging_data.prototype.pack = function(mav) {
    var orderedfields = [ this.sequence, this.target_system, this.target_component, this.length, this.first_message_offset, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A message containing logged data which requires a LOGGING_ACK to be
sent back

                target_system             : system ID of the target (uint8_t)
                target_component          : component ID of the target (uint8_t)
                sequence                  : sequence number (can wrap) (uint16_t)
                length                    : data length (uint8_t)
                first_message_offset        : offset into data where first message starts. This can be used for recovery, when a previous message got lost (set to UINT8_MAX if no start exists). (uint8_t)
                data                      : logged data (uint8_t)

*/
    mavlink20.messages.logging_data_acked = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.sequence , this.length , this.first_message_offset , this.data ] = moreargs;

    this._format = '<HBBBB249s';
    this._id = mavlink20.MAVLINK_MSG_ID_LOGGING_DATA_ACKED;
    this.order_map = [1, 2, 0, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 249];
    this.array_len_map = [0, 0, 0, 0, 0, 249];
    this.crc_extra = 35;
    this._name = 'LOGGING_DATA_ACKED';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'sequence', 'length', 'first_message_offset', 'data'];

}

mavlink20.messages.logging_data_acked.prototype = new mavlink20.message;
mavlink20.messages.logging_data_acked.prototype.pack = function(mav) {
    var orderedfields = [ this.sequence, this.target_system, this.target_component, this.length, this.first_message_offset, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
An ack for a LOGGING_DATA_ACKED message

                target_system             : system ID of the target (uint8_t)
                target_component          : component ID of the target (uint8_t)
                sequence                  : sequence number (must match the one in LOGGING_DATA_ACKED) (uint16_t)

*/
    mavlink20.messages.logging_ack = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.sequence ] = moreargs;

    this._format = '<HBB';
    this._id = mavlink20.MAVLINK_MSG_ID_LOGGING_ACK;
    this.order_map = [1, 2, 0];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 14;
    this._name = 'LOGGING_ACK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'sequence'];

}

mavlink20.messages.logging_ack.prototype = new mavlink20.message;
mavlink20.messages.logging_ack.prototype.pack = function(mav) {
    var orderedfields = [ this.sequence, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about video stream. It may be requested using
MAV_CMD_REQUEST_MESSAGE, where param2 indicates the video stream id: 0
for all streams, 1 for first, 2 for second, etc.

                stream_id                 : Video Stream ID (1 for first, 2 for second, etc.) (uint8_t)
                count                     : Number of streams available. (uint8_t)
                type                      : Type of stream. (uint8_t)
                flags                     : Bitmap of stream status flags. (uint16_t)
                framerate                 : Frame rate. (float)
                resolution_h              : Horizontal resolution. (uint16_t)
                resolution_v              : Vertical resolution. (uint16_t)
                bitrate                   : Bit rate. (uint32_t)
                rotation                  : Video image rotation clockwise. (uint16_t)
                hfov                      : Horizontal Field of view. (uint16_t)
                name                      : Stream name. (char)
                uri                       : Video stream URI (TCP or RTSP URI ground station should connect to) or port number (UDP port ground station should listen to). (char)
                encoding                  : Encoding of stream. (uint8_t)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.video_stream_information = function( ...moreargs ) {
    [ this.stream_id , this.count , this.type , this.flags , this.framerate , this.resolution_h , this.resolution_v , this.bitrate , this.rotation , this.hfov , this.name , this.uri , this.encoding , this.camera_device_id ] = moreargs;

    this._format = '<fIHHHHHBBB32s160sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_VIDEO_STREAM_INFORMATION;
    this.order_map = [7, 8, 9, 2, 0, 3, 4, 1, 5, 6, 10, 11, 12, 13];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 160, 0, 0];
    this.crc_extra = 109;
    this._name = 'VIDEO_STREAM_INFORMATION';

    this._instance_field = 'stream_id';
    this._instance_offset = 18;

    this.fieldnames = ['stream_id', 'count', 'type', 'flags', 'framerate', 'resolution_h', 'resolution_v', 'bitrate', 'rotation', 'hfov', 'name', 'uri', 'encoding', 'camera_device_id'];

}

mavlink20.messages.video_stream_information.prototype = new mavlink20.message;
mavlink20.messages.video_stream_information.prototype.pack = function(mav) {
    var orderedfields = [ this.framerate, this.bitrate, this.flags, this.resolution_h, this.resolution_v, this.rotation, this.hfov, this.stream_id, this.count, this.type, this.name, this.uri, this.encoding, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about the status of a video stream. It may be requested
using MAV_CMD_REQUEST_MESSAGE.

                stream_id                 : Video Stream ID (1 for first, 2 for second, etc.) (uint8_t)
                flags                     : Bitmap of stream status flags (uint16_t)
                framerate                 : Frame rate (float)
                resolution_h              : Horizontal resolution (uint16_t)
                resolution_v              : Vertical resolution (uint16_t)
                bitrate                   : Bit rate (uint32_t)
                rotation                  : Video image rotation clockwise (uint16_t)
                hfov                      : Horizontal Field of view (uint16_t)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.video_stream_status = function( ...moreargs ) {
    [ this.stream_id , this.flags , this.framerate , this.resolution_h , this.resolution_v , this.bitrate , this.rotation , this.hfov , this.camera_device_id ] = moreargs;

    this._format = '<fIHHHHHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_VIDEO_STREAM_STATUS;
    this.order_map = [7, 2, 0, 3, 4, 1, 5, 6, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 59;
    this._name = 'VIDEO_STREAM_STATUS';

    this._instance_field = 'stream_id';
    this._instance_offset = 18;

    this.fieldnames = ['stream_id', 'flags', 'framerate', 'resolution_h', 'resolution_v', 'bitrate', 'rotation', 'hfov', 'camera_device_id'];

}

mavlink20.messages.video_stream_status.prototype = new mavlink20.message;
mavlink20.messages.video_stream_status.prototype.pack = function(mav) {
    var orderedfields = [ this.framerate, this.bitrate, this.flags, this.resolution_h, this.resolution_v, this.rotation, this.hfov, this.stream_id, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about the field of view of a camera. Can be requested with
a MAV_CMD_REQUEST_MESSAGE command.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                lat_camera                : Latitude of camera (INT32_MAX if unknown). (int32_t)
                lon_camera                : Longitude of camera (INT32_MAX if unknown). (int32_t)
                alt_camera                : Altitude (MSL) of camera (INT32_MAX if unknown). (int32_t)
                lat_image                 : Latitude of center of image (INT32_MAX if unknown, INT32_MIN if at infinity, not intersecting with horizon). (int32_t)
                lon_image                 : Longitude of center of image (INT32_MAX if unknown, INT32_MIN if at infinity, not intersecting with horizon). (int32_t)
                alt_image                 : Altitude (MSL) of center of image (INT32_MAX if unknown, INT32_MIN if at infinity, not intersecting with horizon). (int32_t)
                q                         : Quaternion of camera orientation (w, x, y, z order, zero-rotation is 1, 0, 0, 0) (float)
                hfov                      : Horizontal field of view (NaN if unknown). (float)
                vfov                      : Vertical field of view (NaN if unknown). (float)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.camera_fov_status = function( ...moreargs ) {
    [ this.time_boot_ms , this.lat_camera , this.lon_camera , this.alt_camera , this.lat_image , this.lon_image , this.alt_image , this.q , this.hfov , this.vfov , this.camera_device_id ] = moreargs;

    this._format = '<Iiiiiii4fffB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_FOV_STATUS;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0];
    this.crc_extra = 22;
    this._name = 'CAMERA_FOV_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'lat_camera', 'lon_camera', 'alt_camera', 'lat_image', 'lon_image', 'alt_image', 'q', 'hfov', 'vfov', 'camera_device_id'];

}

mavlink20.messages.camera_fov_status.prototype = new mavlink20.message;
mavlink20.messages.camera_fov_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.lat_camera, this.lon_camera, this.alt_camera, this.lat_image, this.lon_image, this.alt_image, this.q, this.hfov, this.vfov, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Camera tracking status, sent while in active tracking. Use
MAV_CMD_SET_MESSAGE_INTERVAL to define message interval.

                tracking_status           : Current tracking status (uint8_t)
                tracking_mode             : Current tracking mode (uint8_t)
                target_data               : Defines location of target data (uint8_t)
                point_x                   : Current tracked point x value if CAMERA_TRACKING_MODE_POINT (normalized 0..1, 0 is left, 1 is right), NAN if unknown (float)
                point_y                   : Current tracked point y value if CAMERA_TRACKING_MODE_POINT (normalized 0..1, 0 is top, 1 is bottom), NAN if unknown (float)
                radius                    : Current tracked radius if CAMERA_TRACKING_MODE_POINT (normalized 0..1, 0 is image left, 1 is image right), NAN if unknown (float)
                rec_top_x                 : Current tracked rectangle top x value if CAMERA_TRACKING_MODE_RECTANGLE (normalized 0..1, 0 is left, 1 is right), NAN if unknown (float)
                rec_top_y                 : Current tracked rectangle top y value if CAMERA_TRACKING_MODE_RECTANGLE (normalized 0..1, 0 is top, 1 is bottom), NAN if unknown (float)
                rec_bottom_x              : Current tracked rectangle bottom x value if CAMERA_TRACKING_MODE_RECTANGLE (normalized 0..1, 0 is left, 1 is right), NAN if unknown (float)
                rec_bottom_y              : Current tracked rectangle bottom y value if CAMERA_TRACKING_MODE_RECTANGLE (normalized 0..1, 0 is top, 1 is bottom), NAN if unknown (float)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.camera_tracking_image_status = function( ...moreargs ) {
    [ this.tracking_status , this.tracking_mode , this.target_data , this.point_x , this.point_y , this.radius , this.rec_top_x , this.rec_top_y , this.rec_bottom_x , this.rec_bottom_y , this.camera_device_id ] = moreargs;

    this._format = '<fffffffBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_TRACKING_IMAGE_STATUS;
    this.order_map = [7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 10];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 126;
    this._name = 'CAMERA_TRACKING_IMAGE_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['tracking_status', 'tracking_mode', 'target_data', 'point_x', 'point_y', 'radius', 'rec_top_x', 'rec_top_y', 'rec_bottom_x', 'rec_bottom_y', 'camera_device_id'];

}

mavlink20.messages.camera_tracking_image_status.prototype = new mavlink20.message;
mavlink20.messages.camera_tracking_image_status.prototype.pack = function(mav) {
    var orderedfields = [ this.point_x, this.point_y, this.radius, this.rec_top_x, this.rec_top_y, this.rec_bottom_x, this.rec_bottom_y, this.tracking_status, this.tracking_mode, this.target_data, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Camera tracking status, sent while in active tracking. Use
MAV_CMD_SET_MESSAGE_INTERVAL to define message interval.

                tracking_status           : Current tracking status (uint8_t)
                lat                       : Latitude of tracked object (int32_t)
                lon                       : Longitude of tracked object (int32_t)
                alt                       : Altitude of tracked object(AMSL, WGS84) (float)
                h_acc                     : Horizontal accuracy. NAN if unknown (float)
                v_acc                     : Vertical accuracy. NAN if unknown (float)
                vel_n                     : North velocity of tracked object. NAN if unknown (float)
                vel_e                     : East velocity of tracked object. NAN if unknown (float)
                vel_d                     : Down velocity of tracked object. NAN if unknown (float)
                vel_acc                   : Velocity accuracy. NAN if unknown (float)
                dist                      : Distance between camera and tracked object. NAN if unknown (float)
                hdg                       : Heading in radians, in NED. NAN if unknown (float)
                hdg_acc                   : Accuracy of heading, in NED. NAN if unknown (float)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)

*/
    mavlink20.messages.camera_tracking_geo_status = function( ...moreargs ) {
    [ this.tracking_status , this.lat , this.lon , this.alt , this.h_acc , this.v_acc , this.vel_n , this.vel_e , this.vel_d , this.vel_acc , this.dist , this.hdg , this.hdg_acc , this.camera_device_id ] = moreargs;

    this._format = '<iiffffffffffBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_TRACKING_GEO_STATUS;
    this.order_map = [12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 18;
    this._name = 'CAMERA_TRACKING_GEO_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['tracking_status', 'lat', 'lon', 'alt', 'h_acc', 'v_acc', 'vel_n', 'vel_e', 'vel_d', 'vel_acc', 'dist', 'hdg', 'hdg_acc', 'camera_device_id'];

}

mavlink20.messages.camera_tracking_geo_status.prototype = new mavlink20.message;
mavlink20.messages.camera_tracking_geo_status.prototype.pack = function(mav) {
    var orderedfields = [ this.lat, this.lon, this.alt, this.h_acc, this.v_acc, this.vel_n, this.vel_e, this.vel_d, this.vel_acc, this.dist, this.hdg, this.hdg_acc, this.tracking_status, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Camera absolute thermal range. This can be streamed when the
associated VIDEO_STREAM_STATUS `flag` field bit
VIDEO_STREAM_STATUS_FLAGS_THERMAL_RANGE_ENABLED is set, but a GCS may
choose to only request it for the current active stream. Use
MAV_CMD_SET_MESSAGE_INTERVAL to define message interval (param3
indicates the stream id of the current camera, or 0 for all streams,
param4 indicates the target camera_device_id for autopilot-attached
cameras or 0 for MAVLink cameras).

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                stream_id                 : Video Stream ID (1 for first, 2 for second, etc.) (uint8_t)
                camera_device_id          : Camera id of a non-MAVLink camera attached to an autopilot (1-6).  0 if the component is a MAVLink camera (with its own component id). (uint8_t)
                max                       : Temperature max. (float)
                max_point_x               : Temperature max point x value (normalized 0..1, 0 is left, 1 is right), NAN if unknown. (float)
                max_point_y               : Temperature max point y value (normalized 0..1, 0 is top, 1 is bottom), NAN if unknown. (float)
                min                       : Temperature min. (float)
                min_point_x               : Temperature min point x value (normalized 0..1, 0 is left, 1 is right), NAN if unknown. (float)
                min_point_y               : Temperature min point y value (normalized 0..1, 0 is top, 1 is bottom), NAN if unknown. (float)

*/
    mavlink20.messages.camera_thermal_range = function( ...moreargs ) {
    [ this.time_boot_ms , this.stream_id , this.camera_device_id , this.max , this.max_point_x , this.max_point_y , this.min , this.min_point_x , this.min_point_y ] = moreargs;

    this._format = '<IffffffBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAMERA_THERMAL_RANGE;
    this.order_map = [0, 7, 8, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 62;
    this._name = 'CAMERA_THERMAL_RANGE';

    this._instance_field = 'stream_id';
    this._instance_offset = 28;

    this.fieldnames = ['time_boot_ms', 'stream_id', 'camera_device_id', 'max', 'max_point_x', 'max_point_y', 'min', 'min_point_x', 'min_point_y'];

}

mavlink20.messages.camera_thermal_range.prototype = new mavlink20.message;
mavlink20.messages.camera_thermal_range.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.max, this.max_point_x, this.max_point_y, this.min, this.min_point_x, this.min_point_y, this.stream_id, this.camera_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a high level gimbal manager. This message should be
requested by a ground station using MAV_CMD_REQUEST_MESSAGE.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                cap_flags                 : Bitmap of gimbal capability flags. (uint32_t)
                gimbal_device_id          : Gimbal device ID that this gimbal manager is responsible for. Component ID of gimbal device (or 1-6 for non-MAVLink gimbal). (uint8_t)
                roll_min                  : Minimum hardware roll angle (positive: rolling to the right, negative: rolling to the left) (float)
                roll_max                  : Maximum hardware roll angle (positive: rolling to the right, negative: rolling to the left) (float)
                pitch_min                 : Minimum pitch angle (positive: up, negative: down) (float)
                pitch_max                 : Maximum pitch angle (positive: up, negative: down) (float)
                yaw_min                   : Minimum yaw angle (positive: to the right, negative: to the left) (float)
                yaw_max                   : Maximum yaw angle (positive: to the right, negative: to the left) (float)

*/
    mavlink20.messages.gimbal_manager_information = function( ...moreargs ) {
    [ this.time_boot_ms , this.cap_flags , this.gimbal_device_id , this.roll_min , this.roll_max , this.pitch_min , this.pitch_max , this.yaw_min , this.yaw_max ] = moreargs;

    this._format = '<IIffffffB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_INFORMATION;
    this.order_map = [0, 1, 8, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 70;
    this._name = 'GIMBAL_MANAGER_INFORMATION';

    this._instance_field = 'gimbal_device_id';
    this._instance_offset = 32;

    this.fieldnames = ['time_boot_ms', 'cap_flags', 'gimbal_device_id', 'roll_min', 'roll_max', 'pitch_min', 'pitch_max', 'yaw_min', 'yaw_max'];

}

mavlink20.messages.gimbal_manager_information.prototype = new mavlink20.message;
mavlink20.messages.gimbal_manager_information.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.cap_flags, this.roll_min, this.roll_max, this.pitch_min, this.pitch_max, this.yaw_min, this.yaw_max, this.gimbal_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Current status about a high level gimbal manager. This message should
be broadcast at a low regular rate (e.g. 5Hz).

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                flags                     : High level gimbal manager flags currently applied. (uint32_t)
                gimbal_device_id          : Gimbal device ID that this gimbal manager is responsible for. Component ID of gimbal device (or 1-6 for non-MAVLink gimbal). (uint8_t)
                primary_control_sysid        : System ID of MAVLink component with primary control, 0 for none. (uint8_t)
                primary_control_compid        : Component ID of MAVLink component with primary control, 0 for none. (uint8_t)
                secondary_control_sysid        : System ID of MAVLink component with secondary control, 0 for none. (uint8_t)
                secondary_control_compid        : Component ID of MAVLink component with secondary control, 0 for none. (uint8_t)

*/
    mavlink20.messages.gimbal_manager_status = function( ...moreargs ) {
    [ this.time_boot_ms , this.flags , this.gimbal_device_id , this.primary_control_sysid , this.primary_control_compid , this.secondary_control_sysid , this.secondary_control_compid ] = moreargs;

    this._format = '<IIBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_STATUS;
    this.order_map = [0, 1, 2, 3, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 48;
    this._name = 'GIMBAL_MANAGER_STATUS';

    this._instance_field = 'gimbal_device_id';
    this._instance_offset = 8;

    this.fieldnames = ['time_boot_ms', 'flags', 'gimbal_device_id', 'primary_control_sysid', 'primary_control_compid', 'secondary_control_sysid', 'secondary_control_compid'];

}

mavlink20.messages.gimbal_manager_status.prototype = new mavlink20.message;
mavlink20.messages.gimbal_manager_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.flags, this.gimbal_device_id, this.primary_control_sysid, this.primary_control_compid, this.secondary_control_sysid, this.secondary_control_compid];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
High level message to control a gimbal's attitude. This message is to
be sent to the gimbal manager (e.g. from a ground station). Angles and
rates can be set to NaN according to use case.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                flags                     : High level gimbal manager flags to use. (uint32_t)
                gimbal_device_id          : Component ID of gimbal device to address (or 1-6 for non-MAVLink gimbal), 0 for all gimbal device components. Send command multiple times for more than one gimbal (but not all gimbals). (uint8_t)
                q                         : Quaternion components, w, x, y, z (1 0 0 0 is the null-rotation, the frame is depends on whether the flag GIMBAL_MANAGER_FLAGS_YAW_LOCK is set) (float)
                angular_velocity_x        : X component of angular velocity, positive is rolling to the right, NaN to be ignored. (float)
                angular_velocity_y        : Y component of angular velocity, positive is pitching up, NaN to be ignored. (float)
                angular_velocity_z        : Z component of angular velocity, positive is yawing to the right, NaN to be ignored. (float)

*/
    mavlink20.messages.gimbal_manager_set_attitude = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.flags , this.gimbal_device_id , this.q , this.angular_velocity_x , this.angular_velocity_y , this.angular_velocity_z ] = moreargs;

    this._format = '<I4ffffBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_ATTITUDE;
    this.order_map = [5, 6, 0, 7, 1, 2, 3, 4];
    this.len_map = [1, 4, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 4, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 123;
    this._name = 'GIMBAL_MANAGER_SET_ATTITUDE';

    this._instance_field = 'gimbal_device_id';
    this._instance_offset = 34;

    this.fieldnames = ['target_system', 'target_component', 'flags', 'gimbal_device_id', 'q', 'angular_velocity_x', 'angular_velocity_y', 'angular_velocity_z'];

}

mavlink20.messages.gimbal_manager_set_attitude.prototype = new mavlink20.message;
mavlink20.messages.gimbal_manager_set_attitude.prototype.pack = function(mav) {
    var orderedfields = [ this.flags, this.q, this.angular_velocity_x, this.angular_velocity_y, this.angular_velocity_z, this.target_system, this.target_component, this.gimbal_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a low level gimbal. This message should be requested
by the gimbal manager or a ground station using
MAV_CMD_REQUEST_MESSAGE. The maximum angles and rates are the limits
by hardware. However, the limits by software used are likely
different/smaller and dependent on mode/settings/etc..

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                vendor_name               : Name of the gimbal vendor. (char)
                model_name                : Name of the gimbal model. (char)
                custom_name               : Custom name of the gimbal given to it by the user. (char)
                firmware_version          : Version of the gimbal firmware, encoded as: `(Dev & 0xff) << 24 + (Patch & 0xff) << 16 + (Minor & 0xff) << 8 + (Major & 0xff)`. (uint32_t)
                hardware_version          : Version of the gimbal hardware, encoded as: `(Dev & 0xff) << 24 + (Patch & 0xff) << 16 + (Minor & 0xff) << 8 + (Major & 0xff)`. (uint32_t)
                uid                       : UID of gimbal hardware (0 if unknown). (uint64_t)
                cap_flags                 : Bitmap of gimbal capability flags. (uint16_t)
                custom_cap_flags          : Bitmap for use for gimbal-specific capability flags. (uint16_t)
                roll_min                  : Minimum hardware roll angle (positive: rolling to the right, negative: rolling to the left). NAN if unknown. (float)
                roll_max                  : Maximum hardware roll angle (positive: rolling to the right, negative: rolling to the left). NAN if unknown. (float)
                pitch_min                 : Minimum hardware pitch angle (positive: up, negative: down). NAN if unknown. (float)
                pitch_max                 : Maximum hardware pitch angle (positive: up, negative: down). NAN if unknown. (float)
                yaw_min                   : Minimum hardware yaw angle (positive: to the right, negative: to the left). NAN if unknown. (float)
                yaw_max                   : Maximum hardware yaw angle (positive: to the right, negative: to the left). NAN if unknown. (float)
                gimbal_device_id          : This field is to be used if the gimbal manager and the gimbal device are the same component and hence have the same component ID. This field is then set to a number between 1-6. If the component ID is separate, this field is not required and must be set to 0. (uint8_t)
                cap_flags2                : Extended bitmap of gimbal capability flags (32 bit). For backwards compatibility, the lower 16 bits should also be set in cap_flags. Ground stations should prefer this field if non-zero. (uint32_t)

*/
    mavlink20.messages.gimbal_device_information = function( ...moreargs ) {
    [ this.time_boot_ms , this.vendor_name , this.model_name , this.custom_name , this.firmware_version , this.hardware_version , this.uid , this.cap_flags , this.custom_cap_flags , this.roll_min , this.roll_max , this.pitch_min , this.pitch_max , this.yaw_min , this.yaw_max , this.gimbal_device_id , this.cap_flags2 ] = moreargs;

    this._format = '<QIIIffffffHH32s32s32sBI';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_INFORMATION;
    this.order_map = [1, 12, 13, 14, 2, 3, 0, 10, 11, 4, 5, 6, 7, 8, 9, 15, 16];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 32, 0, 0];
    this.crc_extra = 74;
    this._name = 'GIMBAL_DEVICE_INFORMATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'vendor_name', 'model_name', 'custom_name', 'firmware_version', 'hardware_version', 'uid', 'cap_flags', 'custom_cap_flags', 'roll_min', 'roll_max', 'pitch_min', 'pitch_max', 'yaw_min', 'yaw_max', 'gimbal_device_id', 'cap_flags2'];

}

mavlink20.messages.gimbal_device_information.prototype = new mavlink20.message;
mavlink20.messages.gimbal_device_information.prototype.pack = function(mav) {
    var orderedfields = [ this.uid, this.time_boot_ms, this.firmware_version, this.hardware_version, this.roll_min, this.roll_max, this.pitch_min, this.pitch_max, this.yaw_min, this.yaw_max, this.cap_flags, this.custom_cap_flags, this.vendor_name, this.model_name, this.custom_name, this.gimbal_device_id, this.cap_flags2];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Low level message to control a gimbal device's attitude.
This message is to be sent from the gimbal manager to the gimbal
device component.           The quaternion and angular velocities can
be set to NaN according to use case.           For the angles encoded
in the quaternion and the angular velocities holds:           If the
flag GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME is set, then they are
relative to the vehicle heading (vehicle frame).           If the flag
GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME is set, then they are relative
to absolute North (earth frame).           If neither of these flags
are set, then (for backwards compatibility) it holds:           If the
flag GIMBAL_DEVICE_FLAGS_YAW_LOCK is set, then they are relative to
absolute North (earth frame),           else they are relative to the
vehicle heading (vehicle frame).           Setting both
GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME and
GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME is not allowed.           These
rules are to ensure backwards compatibility.           New
implementations should always set either
GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME or
GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                flags                     : Low level gimbal flags. (uint16_t)
                q                         : Quaternion components, w, x, y, z (1 0 0 0 is the null-rotation). The frame is described in the message description. Set fields to NaN to be ignored. (float)
                angular_velocity_x        : X component of angular velocity (positive: rolling to the right). The frame is described in the message description. NaN to be ignored. (float)
                angular_velocity_y        : Y component of angular velocity (positive: pitching up). The frame is described in the message description. NaN to be ignored. (float)
                angular_velocity_z        : Z component of angular velocity (positive: yawing to the right). The frame is described in the message description. NaN to be ignored. (float)

*/
    mavlink20.messages.gimbal_device_set_attitude = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.flags , this.q , this.angular_velocity_x , this.angular_velocity_y , this.angular_velocity_z ] = moreargs;

    this._format = '<4ffffHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_SET_ATTITUDE;
    this.order_map = [5, 6, 4, 0, 1, 2, 3];
    this.len_map = [4, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [4, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 99;
    this._name = 'GIMBAL_DEVICE_SET_ATTITUDE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'flags', 'q', 'angular_velocity_x', 'angular_velocity_y', 'angular_velocity_z'];

}

mavlink20.messages.gimbal_device_set_attitude.prototype = new mavlink20.message;
mavlink20.messages.gimbal_device_set_attitude.prototype.pack = function(mav) {
    var orderedfields = [ this.q, this.angular_velocity_x, this.angular_velocity_y, this.angular_velocity_z, this.flags, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message reporting the status of a gimbal device.           This
message should be broadcast by a gimbal device component at a low
regular rate (e.g. 5 Hz).           For the angles encoded in the
quaternion and the angular velocities holds:           If the flag
GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME is set, then they are
relative to the vehicle heading (vehicle frame).           If the flag
GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME is set, then they are relative
to absolute North (earth frame).           If neither of these flags
are set, then (for backwards compatibility) it holds:           If the
flag GIMBAL_DEVICE_FLAGS_YAW_LOCK is set, then they are relative to
absolute North (earth frame),           else they are relative to the
vehicle heading (vehicle frame).           Other conditions of the
flags are not allowed.           The quaternion and angular velocities
in the other frame can be calculated from delta_yaw and
delta_yaw_velocity as           q_earth = q_delta_yaw * q_vehicle and
w_earth = w_delta_yaw_velocity + w_vehicle (if not NaN).           If
neither the GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME nor the
GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME flag is set,           then
(for backwards compatibility) the data in the delta_yaw and
delta_yaw_velocity fields are to be ignored.           New
implementations should always set either
GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME or
GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME,           and always should
set delta_yaw and delta_yaw_velocity either to the proper value or
NaN.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                flags                     : Current gimbal flags set. (uint16_t)
                q                         : Quaternion components, w, x, y, z (1 0 0 0 is the null-rotation). The frame is described in the message description. (float)
                angular_velocity_x        : X component of angular velocity (positive: rolling to the right). The frame is described in the message description. NaN if unknown. (float)
                angular_velocity_y        : Y component of angular velocity (positive: pitching up). The frame is described in the message description. NaN if unknown. (float)
                angular_velocity_z        : Z component of angular velocity (positive: yawing to the right). The frame is described in the message description. NaN if unknown. (float)
                failure_flags             : Failure flags (0 for no failure) (uint32_t)
                delta_yaw                 : Yaw angle relating the quaternions in earth and body frames (see message description). NaN if unknown. (float)
                delta_yaw_velocity        : Yaw angular velocity relating the angular velocities in earth and body frames (see message description). NaN if unknown. (float)
                gimbal_device_id          : This field is to be used if the gimbal manager and the gimbal device are the same component and hence have the same component ID. This field is then set a number between 1-6. If the component ID is separate, this field is not required and must be set to 0. (uint8_t)

*/
    mavlink20.messages.gimbal_device_attitude_status = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.time_boot_ms , this.flags , this.q , this.angular_velocity_x , this.angular_velocity_y , this.angular_velocity_z , this.failure_flags , this.delta_yaw , this.delta_yaw_velocity , this.gimbal_device_id ] = moreargs;

    this._format = '<I4ffffIHBBffB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_ATTITUDE_STATUS;
    this.order_map = [7, 8, 0, 6, 1, 2, 3, 4, 5, 9, 10, 11];
    this.len_map = [1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 137;
    this._name = 'GIMBAL_DEVICE_ATTITUDE_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'time_boot_ms', 'flags', 'q', 'angular_velocity_x', 'angular_velocity_y', 'angular_velocity_z', 'failure_flags', 'delta_yaw', 'delta_yaw_velocity', 'gimbal_device_id'];

}

mavlink20.messages.gimbal_device_attitude_status.prototype = new mavlink20.message;
mavlink20.messages.gimbal_device_attitude_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.q, this.angular_velocity_x, this.angular_velocity_y, this.angular_velocity_z, this.failure_flags, this.flags, this.target_system, this.target_component, this.delta_yaw, this.delta_yaw_velocity, this.gimbal_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Low level message containing autopilot state relevant for a gimbal
device. This message is to be sent from the autopilot to the gimbal
device component. The data of this message are for the gimbal device's
estimator corrections, in particular horizon compensation, as well as
indicates autopilot control intentions, e.g. feed forward angular
control in the z-axis.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                time_boot_us              : Timestamp (time since system boot). (uint64_t)
                q                         : Quaternion components of autopilot attitude: w, x, y, z (1 0 0 0 is the null-rotation, Hamilton convention). (float)
                q_estimated_delay_us        : Estimated delay of the attitude data. 0 if unknown. (uint32_t)
                vx                        : X Speed in NED (North, East, Down). NAN if unknown. (float)
                vy                        : Y Speed in NED (North, East, Down). NAN if unknown. (float)
                vz                        : Z Speed in NED (North, East, Down). NAN if unknown. (float)
                v_estimated_delay_us        : Estimated delay of the speed data. 0 if unknown. (uint32_t)
                feed_forward_angular_velocity_z        : Feed forward Z component of angular velocity (positive: yawing to the right). NaN to be ignored. This is to indicate if the autopilot is actively yawing. (float)
                estimator_status          : Bitmap indicating which estimator outputs are valid. (uint16_t)
                landed_state              : The landed state. Is set to MAV_LANDED_STATE_UNDEFINED if landed state is unknown. (uint8_t)
                angular_velocity_z        : Z component of angular velocity in NED (North, East, Down). NaN if unknown. (float)

*/
    mavlink20.messages.autopilot_state_for_gimbal_device = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.time_boot_us , this.q , this.q_estimated_delay_us , this.vx , this.vy , this.vz , this.v_estimated_delay_us , this.feed_forward_angular_velocity_z , this.estimator_status , this.landed_state , this.angular_velocity_z ] = moreargs;

    this._format = '<Q4fIfffIfHBBBf';
    this._id = mavlink20.MAVLINK_MSG_ID_AUTOPILOT_STATE_FOR_GIMBAL_DEVICE;
    this.order_map = [9, 10, 0, 1, 2, 3, 4, 5, 6, 7, 8, 11, 12];
    this.len_map = [1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 210;
    this._name = 'AUTOPILOT_STATE_FOR_GIMBAL_DEVICE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'time_boot_us', 'q', 'q_estimated_delay_us', 'vx', 'vy', 'vz', 'v_estimated_delay_us', 'feed_forward_angular_velocity_z', 'estimator_status', 'landed_state', 'angular_velocity_z'];

}

mavlink20.messages.autopilot_state_for_gimbal_device.prototype = new mavlink20.message;
mavlink20.messages.autopilot_state_for_gimbal_device.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_us, this.q, this.q_estimated_delay_us, this.vx, this.vy, this.vz, this.v_estimated_delay_us, this.feed_forward_angular_velocity_z, this.estimator_status, this.target_system, this.target_component, this.landed_state, this.angular_velocity_z];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set gimbal manager pitch and yaw angles (high rate message). This
message is to be sent to the gimbal manager (e.g. from a ground
station) and will be ignored by gimbal devices. Angles and rates can
be set to NaN according to use case. Use
MAV_CMD_DO_GIMBAL_MANAGER_PITCHYAW for low-rate adjustments that
require confirmation.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                flags                     : High level gimbal manager flags to use. (uint32_t)
                gimbal_device_id          : Component ID of gimbal device to address (or 1-6 for non-MAVLink gimbal), 0 for all gimbal device components. Send command multiple times for more than one gimbal (but not all gimbals). (uint8_t)
                pitch                     : Pitch angle (positive: up, negative: down, NaN to be ignored). (float)
                yaw                       : Yaw angle (positive: to the right, negative: to the left, NaN to be ignored). (float)
                pitch_rate                : Pitch angular rate (positive: up, negative: down, NaN to be ignored). (float)
                yaw_rate                  : Yaw angular rate (positive: to the right, negative: to the left, NaN to be ignored). (float)

*/
    mavlink20.messages.gimbal_manager_set_pitchyaw = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.flags , this.gimbal_device_id , this.pitch , this.yaw , this.pitch_rate , this.yaw_rate ] = moreargs;

    this._format = '<IffffBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_PITCHYAW;
    this.order_map = [5, 6, 0, 7, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 1;
    this._name = 'GIMBAL_MANAGER_SET_PITCHYAW';

    this._instance_field = 'gimbal_device_id';
    this._instance_offset = 22;

    this.fieldnames = ['target_system', 'target_component', 'flags', 'gimbal_device_id', 'pitch', 'yaw', 'pitch_rate', 'yaw_rate'];

}

mavlink20.messages.gimbal_manager_set_pitchyaw.prototype = new mavlink20.message;
mavlink20.messages.gimbal_manager_set_pitchyaw.prototype.pack = function(mav) {
    var orderedfields = [ this.flags, this.pitch, this.yaw, this.pitch_rate, this.yaw_rate, this.target_system, this.target_component, this.gimbal_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
High level message to control a gimbal manually. The angles or angular
rates are unitless; the actual rates will depend on internal gimbal
manager settings/configuration (e.g. set by parameters). This message
is to be sent to the gimbal manager (e.g. from a ground station).
Angles and rates can be set to NaN according to use case.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                flags                     : High level gimbal manager flags. (uint32_t)
                gimbal_device_id          : Component ID of gimbal device to address (or 1-6 for non-MAVLink gimbal), 0 for all gimbal device components. Send command multiple times for more than one gimbal (but not all gimbals). (uint8_t)
                pitch                     : Pitch angle unitless (-1..1, positive: up, negative: down, NaN to be ignored). (float)
                yaw                       : Yaw angle unitless (-1..1, positive: to the right, negative: to the left, NaN to be ignored). (float)
                pitch_rate                : Pitch angular rate unitless (-1..1, positive: up, negative: down, NaN to be ignored). (float)
                yaw_rate                  : Yaw angular rate unitless (-1..1, positive: to the right, negative: to the left, NaN to be ignored). (float)

*/
    mavlink20.messages.gimbal_manager_set_manual_control = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.flags , this.gimbal_device_id , this.pitch , this.yaw , this.pitch_rate , this.yaw_rate ] = moreargs;

    this._format = '<IffffBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_MANUAL_CONTROL;
    this.order_map = [5, 6, 0, 7, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 20;
    this._name = 'GIMBAL_MANAGER_SET_MANUAL_CONTROL';

    this._instance_field = 'gimbal_device_id';
    this._instance_offset = 22;

    this.fieldnames = ['target_system', 'target_component', 'flags', 'gimbal_device_id', 'pitch', 'yaw', 'pitch_rate', 'yaw_rate'];

}

mavlink20.messages.gimbal_manager_set_manual_control.prototype = new mavlink20.message;
mavlink20.messages.gimbal_manager_set_manual_control.prototype.pack = function(mav) {
    var orderedfields = [ this.flags, this.pitch, this.yaw, this.pitch_rate, this.yaw_rate, this.target_system, this.target_component, this.gimbal_device_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
ESC information for lower rate streaming. Recommended streaming rate
1Hz. See ESC_STATUS for higher-rate ESC data.

                index                     : Index of the first ESC in this message (ESC are indexed in motor order). minValue = 0, maxValue = 60, increment = 4. (uint8_t)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude the number. (uint64_t)
                counter                   : Counter of data packets received. (uint16_t)
                count                     : Total number of ESCs in all messages of this type. Message fields with an index higher than this should be ignored because they contain invalid data. (uint8_t)
                connection_type           : Connection type protocol for all ESC. (uint8_t)
                info                      : Information regarding online/offline status of each ESC. (uint8_t)
                failure_flags             : Bitmap of ESC failure flags. (uint16_t)
                error_count               : Number of reported errors by each ESC since boot. (uint32_t)
                temperature               : Temperature of each ESC. INT16_MAX: if data not supplied by ESC. (int16_t)

*/
    mavlink20.messages.esc_info = function( ...moreargs ) {
    [ this.index , this.time_usec , this.counter , this.count , this.connection_type , this.info , this.failure_flags , this.error_count , this.temperature ] = moreargs;

    this._format = '<Q4IH4H4hBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_ESC_INFO;
    this.order_map = [5, 0, 2, 6, 7, 8, 3, 1, 4];
    this.len_map = [1, 4, 1, 4, 4, 1, 1, 1, 1];
    this.array_len_map = [0, 4, 0, 4, 4, 0, 0, 0, 0];
    this.crc_extra = 251;
    this._name = 'ESC_INFO';

    this._instance_field = 'index';
    this._instance_offset = 42;

    this.fieldnames = ['index', 'time_usec', 'counter', 'count', 'connection_type', 'info', 'failure_flags', 'error_count', 'temperature'];

}

mavlink20.messages.esc_info.prototype = new mavlink20.message;
mavlink20.messages.esc_info.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.error_count, this.counter, this.failure_flags, this.temperature, this.index, this.count, this.connection_type, this.info];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
ESC information for higher rate streaming. Recommended streaming rate
is ~10 Hz. Information that changes more slowly is sent in ESC_INFO.
It should typically only be streamed on high-bandwidth links (i.e. to
a companion computer).

                index                     : Index of the first ESC in this message (ESC are indexed in motor order). minValue = 0, maxValue = 60, increment = 4. (uint8_t)
                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude the number. (uint64_t)
                rpm                       : Reported motor RPM from each ESC (negative for reverse rotation). (int32_t)
                voltage                   : Voltage measured from each ESC. (float)
                current                   : Current measured from each ESC. (float)

*/
    mavlink20.messages.esc_status = function( ...moreargs ) {
    [ this.index , this.time_usec , this.rpm , this.voltage , this.current ] = moreargs;

    this._format = '<Q4i4f4fB';
    this._id = mavlink20.MAVLINK_MSG_ID_ESC_STATUS;
    this.order_map = [4, 0, 1, 2, 3];
    this.len_map = [1, 4, 4, 4, 1];
    this.array_len_map = [0, 4, 4, 4, 0];
    this.crc_extra = 10;
    this._name = 'ESC_STATUS';

    this._instance_field = 'index';
    this._instance_offset = 56;

    this.fieldnames = ['index', 'time_usec', 'rpm', 'voltage', 'current'];

}

mavlink20.messages.esc_status.prototype = new mavlink20.message;
mavlink20.messages.esc_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.rpm, this.voltage, this.current, this.index];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Airspeed information from a sensor.

                id                        : Sensor ID. (uint8_t)
                airspeed                  : Calibrated airspeed (CAS). (float)
                temperature               : Temperature. (int16_t)
                raw_press                 : Raw differential pressure. (float)
                flags                     : Airspeed sensor flags. (uint8_t)

*/
    mavlink20.messages.airspeed = function( ...moreargs ) {
    [ this.id , this.airspeed , this.temperature , this.raw_press , this.flags ] = moreargs;

    this._format = '<ffhBB';
    this._id = mavlink20.MAVLINK_MSG_ID_AIRSPEED;
    this.order_map = [3, 0, 2, 1, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 234;
    this._name = 'AIRSPEED';

    this._instance_field = 'id';
    this._instance_offset = 10;

    this.fieldnames = ['id', 'airspeed', 'temperature', 'raw_press', 'flags'];

}

mavlink20.messages.airspeed.prototype = new mavlink20.message;
mavlink20.messages.airspeed.prototype.pack = function(mav) {
    var orderedfields = [ this.airspeed, this.raw_press, this.temperature, this.id, this.flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports measurement/estimate from a global position sensor. Used as
navigation fusion source and optionally displayed in the UI.

                target_system             : System ID (ID of target system, normally autopilot and ground station). (uint8_t)
                target_component          : Component ID (normally 0 for broadcast). (uint8_t)
                id                        : Sensor ID (uint8_t)
                time_usec                 : Timestamp of message transmission (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                processing_time           : The time spent in processing the sensor data that is the basis for this position. The recipient can use this to improve time alignment of the data. This is the time between measurement (e.g. camera exposure time) and transmission of this message. Set to NaN if not known. (uint32_t)
                source                    : Source of position/estimate (such as GNSS, estimator, etc.) (uint8_t)
                flags                     : Status flags (uint8_t)
                lat                       : Latitude (WGS84) (int32_t)
                lon                       : Longitude (WGS84) (int32_t)
                alt_ellipsoid             : Altitude (WGS84 elipsoid), preferred if available (float)
                alt                       : Altitude (MSL - position-system specific value) use if no alt_ellipsoid available (float)
                eph                       : Standard deviation of horizontal position error (float)
                epv                       : Standard deviation of vertical position error (float)

*/
    mavlink20.messages.global_position_sensor = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id , this.time_usec , this.processing_time , this.source , this.flags , this.lat , this.lon , this.alt_ellipsoid , this.alt , this.eph , this.epv ] = moreargs;

    this._format = '<QIiiffffBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_SENSOR;
    this.order_map = [8, 9, 10, 0, 1, 11, 12, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 158;
    this._name = 'GLOBAL_POSITION_SENSOR';

    this._instance_field = 'id';
    this._instance_offset = 38;

    this.fieldnames = ['target_system', 'target_component', 'id', 'time_usec', 'processing_time', 'source', 'flags', 'lat', 'lon', 'alt_ellipsoid', 'alt', 'eph', 'epv'];

}

mavlink20.messages.global_position_sensor.prototype = new mavlink20.message;
mavlink20.messages.global_position_sensor.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.processing_time, this.lat, this.lon, this.alt_ellipsoid, this.alt, this.eph, this.epv, this.target_system, this.target_component, this.id, this.source, this.flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Configure WiFi AP SSID, password, and mode. This message is re-emitted
as an acknowledgement by the AP. The message may also be explicitly
requested using MAV_CMD_REQUEST_MESSAGE

                ssid                      : Name of Wi-Fi network (SSID). Blank to leave it unchanged when setting. Current SSID when sent back as a response. (char)
                password                  : Password. Blank for an open AP. MD5 hash when message is sent back as a response. (char)
                mode                      : WiFi Mode. (int8_t)
                response                  : Message acceptance response (sent back to GS). (int8_t)

*/
    mavlink20.messages.wifi_config_ap = function( ...moreargs ) {
    [ this.ssid , this.password , this.mode , this.response ] = moreargs;

    this._format = '<32s64sbb';
    this._id = mavlink20.MAVLINK_MSG_ID_WIFI_CONFIG_AP;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [32, 64, 0, 0];
    this.crc_extra = 19;
    this._name = 'WIFI_CONFIG_AP';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['ssid', 'password', 'mode', 'response'];

}

mavlink20.messages.wifi_config_ap.prototype = new mavlink20.message;
mavlink20.messages.wifi_config_ap.prototype.pack = function(mav) {
    var orderedfields = [ this.ssid, this.password, this.mode, this.response];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Version and capability of protocol version. This message can be
requested with MAV_CMD_REQUEST_MESSAGE and is used as part of the
handshaking to establish which MAVLink version should be used on the
network. Every node should respond to a request for PROTOCOL_VERSION
to enable the handshaking. Library implementers should consider adding
this into the default decoding state machine to allow the protocol
core to respond directly.

                version                   : Currently active MAVLink version number * 100: v1.0 is 100, v2.0 is 200, etc. (uint16_t)
                min_version               : Minimum MAVLink version supported (uint16_t)
                max_version               : Maximum MAVLink version supported (set to the same value as version by default) (uint16_t)
                spec_version_hash         : The first 8 bytes (not characters printed in hex!) of the git hash. (uint8_t)
                library_version_hash        : The first 8 bytes (not characters printed in hex!) of the git hash. (uint8_t)

*/
    mavlink20.messages.protocol_version = function( ...moreargs ) {
    [ this.version , this.min_version , this.max_version , this.spec_version_hash , this.library_version_hash ] = moreargs;

    this._format = '<HHH8s8s';
    this._id = mavlink20.MAVLINK_MSG_ID_PROTOCOL_VERSION;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 8, 8];
    this.array_len_map = [0, 0, 0, 8, 8];
    this.crc_extra = 217;
    this._name = 'PROTOCOL_VERSION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['version', 'min_version', 'max_version', 'spec_version_hash', 'library_version_hash'];

}

mavlink20.messages.protocol_version.prototype = new mavlink20.message;
mavlink20.messages.protocol_version.prototype.pack = function(mav) {
    var orderedfields = [ this.version, this.min_version, this.max_version, this.spec_version_hash, this.library_version_hash];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The location and information of an AIS vessel

                MMSI                      : Mobile Marine Service Identifier, 9 decimal digits (uint32_t)
                lat                       : Latitude (int32_t)
                lon                       : Longitude (int32_t)
                COG                       : Course over ground (uint16_t)
                heading                   : True heading (uint16_t)
                velocity                  : Speed over ground (uint16_t)
                turn_rate                 : Turn rate, 0.1 degrees per second (int8_t)
                navigational_status        : Navigational status (uint8_t)
                type                      : Type of vessels (uint8_t)
                dimension_bow             : Distance from lat/lon location to bow (uint16_t)
                dimension_stern           : Distance from lat/lon location to stern (uint16_t)
                dimension_port            : Distance from lat/lon location to port side (uint8_t)
                dimension_starboard        : Distance from lat/lon location to starboard side (uint8_t)
                callsign                  : The vessel callsign. Characters are encoded as 7-bit ASCII, but only characters in the [AIS 6-bit ASCII subset](https://en.wikipedia.org/wiki/Six-bit_character_code#AIS_SixBit_ASCII) are permitted. Also set AIS_FLAGS_VALID_CALLSIGN if valid. The string is NULL-terminated if it is shorter than the array length. (char)
                name                      : The vessel name. Characters are encoded as 7-bit ASCII, but only characters in the [AIS 6-bit ASCII subset](https://en.wikipedia.org/wiki/Six-bit_character_code#AIS_SixBit_ASCII) are permitted. Also set AIS_FLAGS_VALID_NAME if valid. The string is NULL-terminated if it is shorter than the array length. (char)
                tslc                      : Time since last communication from the vessel, in seconds (uint16_t)
                flags                     : Bitmask to indicate various statuses including valid data fields (uint16_t)

*/
    mavlink20.messages.ais_vessel = function( ...moreargs ) {
    [ this.MMSI , this.lat , this.lon , this.COG , this.heading , this.velocity , this.turn_rate , this.navigational_status , this.type , this.dimension_bow , this.dimension_stern , this.dimension_port , this.dimension_starboard , this.callsign , this.name , this.tslc , this.flags ] = moreargs;

    this._format = '<IiiHHHHHHHbBBBB7s20s';
    this._id = mavlink20.MAVLINK_MSG_ID_AIS_VESSEL;
    this.order_map = [0, 1, 2, 3, 4, 5, 10, 11, 12, 6, 7, 13, 14, 15, 16, 8, 9];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 20];
    this.crc_extra = 243;
    this._name = 'AIS_VESSEL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['MMSI', 'lat', 'lon', 'COG', 'heading', 'velocity', 'turn_rate', 'navigational_status', 'type', 'dimension_bow', 'dimension_stern', 'dimension_port', 'dimension_starboard', 'callsign', 'name', 'tslc', 'flags'];

}

mavlink20.messages.ais_vessel.prototype = new mavlink20.message;
mavlink20.messages.ais_vessel.prototype.pack = function(mav) {
    var orderedfields = [ this.MMSI, this.lat, this.lon, this.COG, this.heading, this.velocity, this.dimension_bow, this.dimension_stern, this.tslc, this.flags, this.turn_rate, this.navigational_status, this.type, this.dimension_port, this.dimension_starboard, this.callsign, this.name];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
General status information of an UAVCAN node. Please refer to the
definition of the UAVCAN message "uavcan.protocol.NodeStatus" for the
background information. The UAVCAN specification is available at
http://uavcan.org.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                uptime_sec                : Time since the start-up of the node. (uint32_t)
                health                    : Generalized node health status. (uint8_t)
                mode                      : Generalized operating mode. (uint8_t)
                sub_mode                  : Not used currently. (uint8_t)
                vendor_specific_status_code        : Vendor-specific status information. (uint16_t)

*/
    mavlink20.messages.uavcan_node_status = function( ...moreargs ) {
    [ this.time_usec , this.uptime_sec , this.health , this.mode , this.sub_mode , this.vendor_specific_status_code ] = moreargs;

    this._format = '<QIHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_UAVCAN_NODE_STATUS;
    this.order_map = [0, 1, 3, 4, 5, 2];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0];
    this.crc_extra = 28;
    this._name = 'UAVCAN_NODE_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'uptime_sec', 'health', 'mode', 'sub_mode', 'vendor_specific_status_code'];

}

mavlink20.messages.uavcan_node_status.prototype = new mavlink20.message;
mavlink20.messages.uavcan_node_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.uptime_sec, this.vendor_specific_status_code, this.health, this.mode, this.sub_mode];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
General information describing a particular UAVCAN node.
Please refer to the definition of the UAVCAN service
"uavcan.protocol.GetNodeInfo" for the background information.
This message should be emitted by the system whenever a new node
appears online, or an existing node reboots.         The message may
also be explicitly requested using MAV_CMD_REQUEST_MESSAGE.         It
is also not prohibited to emit this message unconditionally at a low
frequency.         The DroneCAN specification is available at
https://dronecan.github.io/Specification/1._Introduction/.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                uptime_sec                : Time since the start-up of the node. (uint32_t)
                name                      : Node name string. For example, "sapog.px4.io". (char)
                hw_version_major          : Hardware major version number. (uint8_t)
                hw_version_minor          : Hardware minor version number. (uint8_t)
                hw_unique_id              : Hardware unique 128-bit ID. (uint8_t)
                sw_version_major          : Software major version number. (uint8_t)
                sw_version_minor          : Software minor version number. (uint8_t)
                sw_vcs_commit             : Version control system (VCS) revision identifier (e.g. git short commit hash). 0 if unknown. (uint32_t)

*/
    mavlink20.messages.uavcan_node_info = function( ...moreargs ) {
    [ this.time_usec , this.uptime_sec , this.name , this.hw_version_major , this.hw_version_minor , this.hw_unique_id , this.sw_version_major , this.sw_version_minor , this.sw_vcs_commit ] = moreargs;

    this._format = '<QII80sBB16sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_UAVCAN_NODE_INFO;
    this.order_map = [0, 1, 3, 4, 5, 6, 7, 8, 2];
    this.len_map = [1, 1, 1, 1, 1, 1, 16, 1, 1];
    this.array_len_map = [0, 0, 0, 80, 0, 0, 16, 0, 0];
    this.crc_extra = 95;
    this._name = 'UAVCAN_NODE_INFO';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'uptime_sec', 'name', 'hw_version_major', 'hw_version_minor', 'hw_unique_id', 'sw_version_major', 'sw_version_minor', 'sw_vcs_commit'];

}

mavlink20.messages.uavcan_node_info.prototype = new mavlink20.message;
mavlink20.messages.uavcan_node_info.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.uptime_sec, this.sw_vcs_commit, this.name, this.hw_version_major, this.hw_version_minor, this.hw_unique_id, this.sw_version_major, this.sw_version_minor];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request to read the value of a parameter with either the param_id
string id or param_index. PARAM_EXT_VALUE should be emitted in
response.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                param_id                  : Parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_index               : Parameter index. Set to -1 to use the Parameter ID field as identifier (else param_id will be ignored) (int16_t)

*/
    mavlink20.messages.param_ext_request_read = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.param_id , this.param_index ] = moreargs;

    this._format = '<hBB16s';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_EXT_REQUEST_READ;
    this.order_map = [1, 2, 3, 0];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 16];
    this.crc_extra = 243;
    this._name = 'PARAM_EXT_REQUEST_READ';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'param_id', 'param_index'];

}

mavlink20.messages.param_ext_request_read.prototype = new mavlink20.message;
mavlink20.messages.param_ext_request_read.prototype.pack = function(mav) {
    var orderedfields = [ this.param_index, this.target_system, this.target_component, this.param_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request all parameters of this component. All parameters should be
emitted in response as PARAM_EXT_VALUE.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)

*/
    mavlink20.messages.param_ext_request_list = function( ...moreargs ) {
    [ this.target_system , this.target_component ] = moreargs;

    this._format = '<BB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_EXT_REQUEST_LIST;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 88;
    this._name = 'PARAM_EXT_REQUEST_LIST';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component'];

}

mavlink20.messages.param_ext_request_list.prototype = new mavlink20.message;
mavlink20.messages.param_ext_request_list.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Emit the value of a parameter. The inclusion of param_count and
param_index in the message allows the recipient to keep track of
received parameters and allows them to re-request missing parameters
after a loss or timeout.

                param_id                  : Parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_value               : Parameter value (char)
                param_type                : Parameter type. (uint8_t)
                param_count               : Total number of parameters (uint16_t)
                param_index               : Index of this parameter (uint16_t)

*/
    mavlink20.messages.param_ext_value = function( ...moreargs ) {
    [ this.param_id , this.param_value , this.param_type , this.param_count , this.param_index ] = moreargs;

    this._format = '<HH16s128sB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_EXT_VALUE;
    this.order_map = [2, 3, 4, 0, 1];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 16, 128, 0];
    this.crc_extra = 243;
    this._name = 'PARAM_EXT_VALUE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['param_id', 'param_value', 'param_type', 'param_count', 'param_index'];

}

mavlink20.messages.param_ext_value.prototype = new mavlink20.message;
mavlink20.messages.param_ext_value.prototype.pack = function(mav) {
    var orderedfields = [ this.param_count, this.param_index, this.param_id, this.param_value, this.param_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Set a parameter value. In order to deal with message loss (and
retransmission of PARAM_EXT_SET), when setting a parameter value and
the new value is the same as the current value, you will immediately
get a PARAM_ACK_ACCEPTED response. If the current state is
PARAM_ACK_IN_PROGRESS, you will accordingly receive a
PARAM_ACK_IN_PROGRESS in response.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                param_id                  : Parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_value               : Parameter value (char)
                param_type                : Parameter type. (uint8_t)

*/
    mavlink20.messages.param_ext_set = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.param_id , this.param_value , this.param_type ] = moreargs;

    this._format = '<BB16s128sB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_EXT_SET;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 16, 128, 0];
    this.crc_extra = 78;
    this._name = 'PARAM_EXT_SET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'param_id', 'param_value', 'param_type'];

}

mavlink20.messages.param_ext_set.prototype = new mavlink20.message;
mavlink20.messages.param_ext_set.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.param_id, this.param_value, this.param_type];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Response from a PARAM_EXT_SET message.

                param_id                  : Parameter id, terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_value               : Parameter value (new value if PARAM_ACK_ACCEPTED, current value otherwise) (char)
                param_type                : Parameter type. (uint8_t)
                param_result              : Result code. (uint8_t)

*/
    mavlink20.messages.param_ext_ack = function( ...moreargs ) {
    [ this.param_id , this.param_value , this.param_type , this.param_result ] = moreargs;

    this._format = '<16s128sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_EXT_ACK;
    this.order_map = [0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [16, 128, 0, 0];
    this.crc_extra = 132;
    this._name = 'PARAM_EXT_ACK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['param_id', 'param_value', 'param_type', 'param_result'];

}

mavlink20.messages.param_ext_ack.prototype = new mavlink20.message;
mavlink20.messages.param_ext_ack.prototype.pack = function(mav) {
    var orderedfields = [ this.param_id, this.param_value, this.param_type, this.param_result];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Obstacle distances in front of the sensor, starting from the left in
increment degrees to the right

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                sensor_type               : Class id of the distance sensor type. (uint8_t)
                distances                 : Distance of obstacles around the vehicle with index 0 corresponding to north + angle_offset, unless otherwise specified in the frame. A value of 0 is valid and means that the obstacle is practically touching the sensor. A value of max_distance +1 means no obstacle is present. A value of UINT16_MAX for unknown/not used. In a array element, one unit corresponds to 1cm. (uint16_t)
                increment                 : Angular width in degrees of each array element. Increment direction is clockwise. This field is ignored if increment_f is non-zero. (uint8_t)
                min_distance              : Minimum distance the sensor can measure. (uint16_t)
                max_distance              : Maximum distance the sensor can measure. (uint16_t)
                increment_f               : Angular width in degrees of each array element as a float. If non-zero then this value is used instead of the uint8_t increment field. Positive is clockwise direction, negative is counter-clockwise. (float)
                angle_offset              : Relative angle offset of the 0-index element in the distances array. Value of 0 corresponds to forward. Positive is clockwise direction, negative is counter-clockwise. (float)
                frame                     : Coordinate frame of reference for the yaw rotation and offset of the sensor data. Defaults to MAV_FRAME_GLOBAL, which is north aligned. For body-mounted sensors use MAV_FRAME_BODY_FRD, which is vehicle front aligned. (uint8_t)

*/
    mavlink20.messages.obstacle_distance = function( ...moreargs ) {
    [ this.time_usec , this.sensor_type , this.distances , this.increment , this.min_distance , this.max_distance , this.increment_f , this.angle_offset , this.frame ] = moreargs;

    this._format = '<Q72HHHBBffB';
    this._id = mavlink20.MAVLINK_MSG_ID_OBSTACLE_DISTANCE;
    this.order_map = [0, 4, 1, 5, 2, 3, 6, 7, 8];
    this.len_map = [1, 72, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 72, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 23;
    this._name = 'OBSTACLE_DISTANCE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'sensor_type', 'distances', 'increment', 'min_distance', 'max_distance', 'increment_f', 'angle_offset', 'frame'];

}

mavlink20.messages.obstacle_distance.prototype = new mavlink20.message;
mavlink20.messages.obstacle_distance.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.distances, this.min_distance, this.max_distance, this.sensor_type, this.increment, this.increment_f, this.angle_offset, this.frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Odometry message to communicate odometry information with an external
interface. Fits ROS REP 147 standard for aerial vehicles
(http://www.ros.org/reps/rep-0147.html).

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                frame_id                  : Coordinate frame of reference for the pose data. (uint8_t)
                child_frame_id            : Coordinate frame of reference for the velocity in free space (twist) data. (uint8_t)
                x                         : X Position (float)
                y                         : Y Position (float)
                z                         : Z Position (float)
                q                         : Quaternion components, w, x, y, z (1 0 0 0 is the null-rotation) (float)
                vx                        : X linear speed (float)
                vy                        : Y linear speed (float)
                vz                        : Z linear speed (float)
                rollspeed                 : Roll angular speed (float)
                pitchspeed                : Pitch angular speed (float)
                yawspeed                  : Yaw angular speed (float)
                pose_covariance           : Row-major representation of a 6x6 pose cross-covariance matrix upper right triangle (states: x, y, z, roll, pitch, yaw; first six entries are the first ROW, next five entries are the second ROW, etc.). If unknown, assign NaN value to first element in the array. (float)
                velocity_covariance        : Row-major representation of a 6x6 velocity cross-covariance matrix upper right triangle (states: vx, vy, vz, rollspeed, pitchspeed, yawspeed; first six entries are the first ROW, next five entries are the second ROW, etc.). If unknown, assign NaN value to first element in the array. (float)
                reset_counter             : Estimate reset counter. This should be incremented when the estimate resets in any of the dimensions (position, velocity, attitude, angular speed). This is designed to be used when e.g an external SLAM system detects a loop-closure and the estimate jumps. (uint8_t)
                estimator_type            : Type of estimator that is providing the odometry. (uint8_t)
                quality                   : Optional odometry quality metric as a percentage. -1 = odometry has failed, 0 = unknown/unset quality, 1 = worst quality, 100 = best quality (int8_t)

*/
    mavlink20.messages.odometry = function( ...moreargs ) {
    [ this.time_usec , this.frame_id , this.child_frame_id , this.x , this.y , this.z , this.q , this.vx , this.vy , this.vz , this.rollspeed , this.pitchspeed , this.yawspeed , this.pose_covariance , this.velocity_covariance , this.reset_counter , this.estimator_type , this.quality ] = moreargs;

    this._format = '<Qfff4fffffff21f21fBBBBb';
    this._id = mavlink20.MAVLINK_MSG_ID_ODOMETRY;
    this.order_map = [0, 13, 14, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17];
    this.len_map = [1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 21, 21, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 21, 21, 0, 0, 0, 0, 0];
    this.crc_extra = 91;
    this._name = 'ODOMETRY';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'frame_id', 'child_frame_id', 'x', 'y', 'z', 'q', 'vx', 'vy', 'vz', 'rollspeed', 'pitchspeed', 'yawspeed', 'pose_covariance', 'velocity_covariance', 'reset_counter', 'estimator_type', 'quality'];

}

mavlink20.messages.odometry.prototype = new mavlink20.message;
mavlink20.messages.odometry.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.x, this.y, this.z, this.q, this.vx, this.vy, this.vz, this.rollspeed, this.pitchspeed, this.yawspeed, this.pose_covariance, this.velocity_covariance, this.frame_id, this.child_frame_id, this.reset_counter, this.estimator_type, this.quality];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Describe a trajectory using an array of up-to 5 waypoints in the local
frame (MAV_FRAME_LOCAL_NED).

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                valid_points              : Number of valid points (up-to 5 waypoints are possible) (uint8_t)
                pos_x                     : X-coordinate of waypoint, set to NaN if not being used (float)
                pos_y                     : Y-coordinate of waypoint, set to NaN if not being used (float)
                pos_z                     : Z-coordinate of waypoint, set to NaN if not being used (float)
                vel_x                     : X-velocity of waypoint, set to NaN if not being used (float)
                vel_y                     : Y-velocity of waypoint, set to NaN if not being used (float)
                vel_z                     : Z-velocity of waypoint, set to NaN if not being used (float)
                acc_x                     : X-acceleration of waypoint, set to NaN if not being used (float)
                acc_y                     : Y-acceleration of waypoint, set to NaN if not being used (float)
                acc_z                     : Z-acceleration of waypoint, set to NaN if not being used (float)
                pos_yaw                   : Yaw angle, set to NaN if not being used (float)
                vel_yaw                   : Yaw rate, set to NaN if not being used (float)
                command                   : MAV_CMD command id of waypoint, set to UINT16_MAX if not being used. (uint16_t)

*/
    mavlink20.messages.trajectory_representation_waypoints = function( ...moreargs ) {
    [ this.time_usec , this.valid_points , this.pos_x , this.pos_y , this.pos_z , this.vel_x , this.vel_y , this.vel_z , this.acc_x , this.acc_y , this.acc_z , this.pos_yaw , this.vel_yaw , this.command ] = moreargs;

    this._format = '<Q5f5f5f5f5f5f5f5f5f5f5f5HB';
    this._id = mavlink20.MAVLINK_MSG_ID_TRAJECTORY_REPRESENTATION_WAYPOINTS;
    this.order_map = [0, 13, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    this.len_map = [1, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 1];
    this.array_len_map = [0, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 0];
    this.crc_extra = 236;
    this._name = 'TRAJECTORY_REPRESENTATION_WAYPOINTS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'valid_points', 'pos_x', 'pos_y', 'pos_z', 'vel_x', 'vel_y', 'vel_z', 'acc_x', 'acc_y', 'acc_z', 'pos_yaw', 'vel_yaw', 'command'];

}

mavlink20.messages.trajectory_representation_waypoints.prototype = new mavlink20.message;
mavlink20.messages.trajectory_representation_waypoints.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.pos_x, this.pos_y, this.pos_z, this.vel_x, this.vel_y, this.vel_z, this.acc_x, this.acc_y, this.acc_z, this.pos_yaw, this.vel_yaw, this.command, this.valid_points];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Describe a trajectory using an array of up-to 5 bezier control points
in the local frame (MAV_FRAME_LOCAL_NED).

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                valid_points              : Number of valid control points (up-to 5 points are possible) (uint8_t)
                pos_x                     : X-coordinate of bezier control points. Set to NaN if not being used (float)
                pos_y                     : Y-coordinate of bezier control points. Set to NaN if not being used (float)
                pos_z                     : Z-coordinate of bezier control points. Set to NaN if not being used (float)
                delta                     : Bezier time horizon. Set to NaN if velocity/acceleration should not be incorporated (float)
                pos_yaw                   : Yaw. Set to NaN for unchanged (float)

*/
    mavlink20.messages.trajectory_representation_bezier = function( ...moreargs ) {
    [ this.time_usec , this.valid_points , this.pos_x , this.pos_y , this.pos_z , this.delta , this.pos_yaw ] = moreargs;

    this._format = '<Q5f5f5f5f5fB';
    this._id = mavlink20.MAVLINK_MSG_ID_TRAJECTORY_REPRESENTATION_BEZIER;
    this.order_map = [0, 6, 1, 2, 3, 4, 5];
    this.len_map = [1, 5, 5, 5, 5, 5, 1];
    this.array_len_map = [0, 5, 5, 5, 5, 5, 0];
    this.crc_extra = 231;
    this._name = 'TRAJECTORY_REPRESENTATION_BEZIER';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'valid_points', 'pos_x', 'pos_y', 'pos_z', 'delta', 'pos_yaw'];

}

mavlink20.messages.trajectory_representation_bezier.prototype = new mavlink20.message;
mavlink20.messages.trajectory_representation_bezier.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.pos_x, this.pos_y, this.pos_z, this.delta, this.pos_yaw, this.valid_points];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Cellular network status as reported by a particular modem.
This is primarily intended for logging, but a GCS may choose to
display link_tx_rate and link_rx_rate.                  Note that a
value of 0 in the id field indicates that the sender does not support
reporting of multiple modems.         Message data should be from a
single modem, but that is not guaranteed.

                status                    : Cellular modem status (uint8_t)
                failure_reason            : Failure reason when status in in CELLULAR_STATUS_FLAG_FAILED (uint8_t)
                type                      : Cellular network radio type: gsm, cdma, lte... (uint8_t)
                quality                   : Signal quality in percent. If unknown, set to UINT8_MAX (uint8_t)
                mcc                       : Mobile country code. If unknown, set to UINT16_MAX (uint16_t)
                mnc                       : Mobile network code. If unknown, set to UINT16_MAX (uint16_t)
                lac                       : Location area code. If unknown, set to 0 (uint16_t)
                id                        : Cellular modem instance number. Indexed from 1. (uint8_t)
                link_tx_rate              : Download rate. (uint32_t)
                link_rx_rate              : Upload rate. (uint32_t)
                cell_tower_id             : ID of the currently connected cell tower. This must be NULL terminated if the length is less than 9 human-readable chars, and without the null termination (NULL) byte if the length is exactly 9 chars. (char)
                band_number               : LTE frequency band number. (uint8_t)
                band_frequency            : LTE radio frequency. (float)
                channel_number            : The channel number (CN). Absolute radio-frequency (ARFCN) / E-UTRA (EARFCN) / UTRA (UARFCN) / New radio (NR_CH). (uint32_t)
                rx_level                  : On 3G is Received Signal Code Power (RSCP). On LTE is Reference Signal Received Power (RSRP). On 5G is New Radio Reference Signal Received Power (NR_RSRP). (float)
                tx_level                  : Transmitter (modem) signal absolute power level. (float)
                rx_quality                : On 3G is Receiver Quality (RxQual). On LTE is Reference Signal Received Quality (RSRQ). On 5G is New Radio Reference Signal Received Quality (NR_RSRQ). (float)
                sinr                      : Signal to interference plus noise ratio (SINR). (float)

*/
    mavlink20.messages.cellular_status = function( ...moreargs ) {
    [ this.status , this.failure_reason , this.type , this.quality , this.mcc , this.mnc , this.lac , this.id , this.link_tx_rate , this.link_rx_rate , this.cell_tower_id , this.band_number , this.band_frequency , this.channel_number , this.rx_level , this.tx_level , this.rx_quality , this.sinr ] = moreargs;

    this._format = '<HHHBBBBBII9sBfIffff';
    this._id = mavlink20.MAVLINK_MSG_ID_CELLULAR_STATUS;
    this.order_map = [3, 4, 5, 6, 0, 1, 2, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 72;
    this._name = 'CELLULAR_STATUS';

    this._instance_field = 'id';
    this._instance_offset = 10;

    this.fieldnames = ['status', 'failure_reason', 'type', 'quality', 'mcc', 'mnc', 'lac', 'id', 'link_tx_rate', 'link_rx_rate', 'cell_tower_id', 'band_number', 'band_frequency', 'channel_number', 'rx_level', 'tx_level', 'rx_quality', 'sinr'];

}

mavlink20.messages.cellular_status.prototype = new mavlink20.message;
mavlink20.messages.cellular_status.prototype.pack = function(mav) {
    var orderedfields = [ this.mcc, this.mnc, this.lac, this.status, this.failure_reason, this.type, this.quality, this.id, this.link_tx_rate, this.link_rx_rate, this.cell_tower_id, this.band_number, this.band_frequency, this.channel_number, this.rx_level, this.tx_level, this.rx_quality, this.sinr];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Status of the Iridium SBD link.

                timestamp                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                last_heartbeat            : Timestamp of the last successful sbd session. The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                failed_sessions           : Number of failed SBD sessions. (uint16_t)
                successful_sessions        : Number of successful SBD sessions. (uint16_t)
                signal_quality            : Signal quality equal to the number of bars displayed on the ISU signal strength indicator. Range is 0 to 5, where 0 indicates no signal and 5 indicates maximum signal strength. (uint8_t)
                ring_pending              : 1: Ring call pending, 0: No call pending. (uint8_t)
                tx_session_pending        : 1: Transmission session pending, 0: No transmission session pending. (uint8_t)
                rx_session_pending        : 1: Receiving session pending, 0: No receiving session pending. (uint8_t)

*/
    mavlink20.messages.isbd_link_status = function( ...moreargs ) {
    [ this.timestamp , this.last_heartbeat , this.failed_sessions , this.successful_sessions , this.signal_quality , this.ring_pending , this.tx_session_pending , this.rx_session_pending ] = moreargs;

    this._format = '<QQHHBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_ISBD_LINK_STATUS;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 225;
    this._name = 'ISBD_LINK_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['timestamp', 'last_heartbeat', 'failed_sessions', 'successful_sessions', 'signal_quality', 'ring_pending', 'tx_session_pending', 'rx_session_pending'];

}

mavlink20.messages.isbd_link_status.prototype = new mavlink20.message;
mavlink20.messages.isbd_link_status.prototype.pack = function(mav) {
    var orderedfields = [ this.timestamp, this.last_heartbeat, this.failed_sessions, this.successful_sessions, this.signal_quality, this.ring_pending, this.tx_session_pending, this.rx_session_pending];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Configure cellular modems.         This message is re-emitted as an
acknowledgement by the modem.         The message may also be
explicitly requested using MAV_CMD_REQUEST_MESSAGE.

                enable_lte                : Enable/disable LTE. 0: setting unchanged, 1: disabled, 2: enabled. Current setting when sent back as a response. (uint8_t)
                enable_pin                : Enable/disable PIN on the SIM card. 0: setting unchanged, 1: disabled, 2: enabled. Current setting when sent back as a response. (uint8_t)
                pin                       : PIN sent to the SIM card. Blank when PIN is disabled. Empty when message is sent back as a response. (char)
                new_pin                   : New PIN when changing the PIN. Blank to leave it unchanged. Empty when message is sent back as a response. (char)
                apn                       : Name of the cellular APN. Blank to leave it unchanged. Current APN when sent back as a response. (char)
                puk                       : Required PUK code in case the user failed to authenticate 3 times with the PIN. Empty when message is sent back as a response. (char)
                roaming                   : Enable/disable roaming. 0: setting unchanged, 1: disabled, 2: enabled. Current setting when sent back as a response. (uint8_t)
                response                  : Message acceptance response (sent back to GS). (uint8_t)

*/
    mavlink20.messages.cellular_config = function( ...moreargs ) {
    [ this.enable_lte , this.enable_pin , this.pin , this.new_pin , this.apn , this.puk , this.roaming , this.response ] = moreargs;

    this._format = '<BB16s16s32s16sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CELLULAR_CONFIG;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 16, 16, 32, 16, 0, 0];
    this.crc_extra = 245;
    this._name = 'CELLULAR_CONFIG';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['enable_lte', 'enable_pin', 'pin', 'new_pin', 'apn', 'puk', 'roaming', 'response'];

}

mavlink20.messages.cellular_config.prototype = new mavlink20.message;
mavlink20.messages.cellular_config.prototype.pack = function(mav) {
    var orderedfields = [ this.enable_lte, this.enable_pin, this.pin, this.new_pin, this.apn, this.puk, this.roaming, this.response];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
RPM sensor data message.

                index                     : Index of this RPM sensor (0-indexed) (uint8_t)
                frequency                 : Indicated rate (float)

*/
    mavlink20.messages.raw_rpm = function( ...moreargs ) {
    [ this.index , this.frequency ] = moreargs;

    this._format = '<fB';
    this._id = mavlink20.MAVLINK_MSG_ID_RAW_RPM;
    this.order_map = [1, 0];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 199;
    this._name = 'RAW_RPM';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['index', 'frequency'];

}

mavlink20.messages.raw_rpm.prototype = new mavlink20.message;
mavlink20.messages.raw_rpm.prototype.pack = function(mav) {
    var orderedfields = [ this.frequency, this.index];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The global position resulting from GPS and sensor fusion.

                time                      : Time of applicability of position (microseconds since UNIX epoch). (uint64_t)
                uas_id                    : Unique UAS ID. (uint8_t)
                lat                       : Latitude (WGS84) (int32_t)
                lon                       : Longitude (WGS84) (int32_t)
                alt                       : Altitude (WGS84) (int32_t)
                relative_alt              : Altitude above ground (int32_t)
                vx                        : Ground X speed (latitude, positive north) (int16_t)
                vy                        : Ground Y speed (longitude, positive east) (int16_t)
                vz                        : Ground Z speed (altitude, positive down) (int16_t)
                h_acc                     : Horizontal position uncertainty (standard deviation) (uint16_t)
                v_acc                     : Altitude uncertainty (standard deviation) (uint16_t)
                vel_acc                   : Speed uncertainty (standard deviation) (uint16_t)
                next_lat                  : Next waypoint, latitude (WGS84) (int32_t)
                next_lon                  : Next waypoint, longitude (WGS84) (int32_t)
                next_alt                  : Next waypoint, altitude (WGS84) (int32_t)
                update_rate               : Time until next update. Set to 0 if unknown or in data driven mode. (uint16_t)
                flight_state              : Flight state (uint8_t)
                flags                     : Bitwise OR combination of the data available flags. (uint8_t)

*/
    mavlink20.messages.utm_global_position = function( ...moreargs ) {
    [ this.time , this.uas_id , this.lat , this.lon , this.alt , this.relative_alt , this.vx , this.vy , this.vz , this.h_acc , this.v_acc , this.vel_acc , this.next_lat , this.next_lon , this.next_alt , this.update_rate , this.flight_state , this.flags ] = moreargs;

    this._format = '<QiiiiiiihhhHHHH18sBB';
    this._id = mavlink20.MAVLINK_MSG_ID_UTM_GLOBAL_POSITION;
    this.order_map = [0, 15, 1, 2, 3, 4, 8, 9, 10, 11, 12, 13, 5, 6, 7, 14, 16, 17];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 18, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0];
    this.crc_extra = 99;
    this._name = 'UTM_GLOBAL_POSITION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time', 'uas_id', 'lat', 'lon', 'alt', 'relative_alt', 'vx', 'vy', 'vz', 'h_acc', 'v_acc', 'vel_acc', 'next_lat', 'next_lon', 'next_alt', 'update_rate', 'flight_state', 'flags'];

}

mavlink20.messages.utm_global_position.prototype = new mavlink20.message;
mavlink20.messages.utm_global_position.prototype.pack = function(mav) {
    var orderedfields = [ this.time, this.lat, this.lon, this.alt, this.relative_alt, this.next_lat, this.next_lon, this.next_alt, this.vx, this.vy, this.vz, this.h_acc, this.v_acc, this.vel_acc, this.update_rate, this.uas_id, this.flight_state, this.flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Parameter set/get error. Returned from a MAVLink node in response to
an error in the parameter protocol, for example failing to set a
parameter because it does not exist.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                param_id                  : Parameter id. Terminated by NULL if the length is less than 16 human-readable chars and WITHOUT null termination (NULL) byte if the length is exactly 16 chars - applications have to provide 16+1 bytes storage if the ID is stored as string (char)
                param_index               : Parameter index. Will be -1 if the param ID field should be used as an identifier (else the param id will be ignored) (int16_t)
                error                     : Error being returned to client. (uint8_t)

*/
    mavlink20.messages.param_error = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.param_id , this.param_index , this.error ] = moreargs;

    this._format = '<hBB16sB';
    this._id = mavlink20.MAVLINK_MSG_ID_PARAM_ERROR;
    this.order_map = [1, 2, 3, 0, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 16, 0];
    this.crc_extra = 209;
    this._name = 'PARAM_ERROR';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'param_id', 'param_index', 'error'];

}

mavlink20.messages.param_error.prototype = new mavlink20.message;
mavlink20.messages.param_error.prototype.pack = function(mav) {
    var orderedfields = [ this.param_index, this.target_system, this.target_component, this.param_id, this.error];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Large debug/prototyping array. The message uses the maximum available
payload for data. The array_id and name fields are used to
discriminate between messages in code and in user interfaces
(respectively). Do not use in production code.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                name                      : Name, for human-friendly display in a Ground Control Station (char)
                array_id                  : Unique ID used to discriminate between arrays (uint16_t)
                data                      : data (float)

*/
    mavlink20.messages.debug_float_array = function( ...moreargs ) {
    [ this.time_usec , this.name , this.array_id , this.data ] = moreargs;

    this._format = '<QH10s58f';
    this._id = mavlink20.MAVLINK_MSG_ID_DEBUG_FLOAT_ARRAY;
    this.order_map = [0, 2, 1, 3];
    this.len_map = [1, 1, 1, 58];
    this.array_len_map = [0, 0, 10, 58];
    this.crc_extra = 232;
    this._name = 'DEBUG_FLOAT_ARRAY';

    this._instance_field = 'array_id';
    this._instance_offset = 8;

    this.fieldnames = ['time_usec', 'name', 'array_id', 'data'];

}

mavlink20.messages.debug_float_array.prototype = new mavlink20.message;
mavlink20.messages.debug_float_array.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.array_id, this.name, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Vehicle status report that is sent out while orbit execution is in
progress (see MAV_CMD_DO_ORBIT).

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                radius                    : Radius of the orbit circle. Positive values orbit clockwise, negative values orbit counter-clockwise. (float)
                frame                     : The coordinate system of the fields: x, y, z. (uint8_t)
                x                         : X coordinate of center point. Coordinate system depends on frame field: local = x position in meters * 1e4, global = latitude in degrees * 1e7. (int32_t)
                y                         : Y coordinate of center point.  Coordinate system depends on frame field: local = x position in meters * 1e4, global = latitude in degrees * 1e7. (int32_t)
                z                         : Altitude of center point. Coordinate system depends on frame field. (float)

*/
    mavlink20.messages.orbit_execution_status = function( ...moreargs ) {
    [ this.time_usec , this.radius , this.frame , this.x , this.y , this.z ] = moreargs;

    this._format = '<QfiifB';
    this._id = mavlink20.MAVLINK_MSG_ID_ORBIT_EXECUTION_STATUS;
    this.order_map = [0, 1, 5, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0];
    this.crc_extra = 11;
    this._name = 'ORBIT_EXECUTION_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'radius', 'frame', 'x', 'y', 'z'];

}

mavlink20.messages.orbit_execution_status.prototype = new mavlink20.message;
mavlink20.messages.orbit_execution_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.radius, this.x, this.y, this.z, this.frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Smart Battery information (static/infrequent update). Use for updates
from: smart battery to flight stack, flight stack to GCS. Use
BATTERY_STATUS for the frequent battery updates.

                id                        : Battery ID (uint8_t)
                battery_function          : Function of the battery (uint8_t)
                type                      : Type (chemistry) of the battery (uint8_t)
                capacity_full_specification        : Capacity when full according to manufacturer, -1: field not provided. (int32_t)
                capacity_full             : Capacity when full (accounting for battery degradation), -1: field not provided. (int32_t)
                cycle_count               : Charge/discharge cycle count. UINT16_MAX: field not provided. (uint16_t)
                serial_number             : Serial number in ASCII characters, 0 terminated. All 0: field not provided. (char)
                device_name               : Static device name in ASCII characters, 0 terminated. All 0: field not provided. Encode as manufacturer name then product name separated using an underscore. (char)
                weight                    : Battery weight. 0: field not provided. (uint16_t)
                discharge_minimum_voltage        : Minimum per-cell voltage when discharging. If not supplied set to UINT16_MAX value. (uint16_t)
                charging_minimum_voltage        : Minimum per-cell voltage when charging. If not supplied set to UINT16_MAX value. (uint16_t)
                resting_minimum_voltage        : Minimum per-cell voltage when resting. If not supplied set to UINT16_MAX value. (uint16_t)
                charging_maximum_voltage        : Maximum per-cell voltage when charged. 0: field not provided. (uint16_t)
                cells_in_series           : Number of battery cells in series. 0: field not provided. (uint8_t)
                discharge_maximum_current        : Maximum pack discharge current. 0: field not provided. (uint32_t)
                discharge_maximum_burst_current        : Maximum pack discharge burst current. 0: field not provided. (uint32_t)
                manufacture_date          : Manufacture date (DD/MM/YYYY) in ASCII characters, 0 terminated. All 0: field not provided. (char)

*/
    mavlink20.messages.smart_battery_info = function( ...moreargs ) {
    [ this.id , this.battery_function , this.type , this.capacity_full_specification , this.capacity_full , this.cycle_count , this.serial_number , this.device_name , this.weight , this.discharge_minimum_voltage , this.charging_minimum_voltage , this.resting_minimum_voltage , this.charging_maximum_voltage , this.cells_in_series , this.discharge_maximum_current , this.discharge_maximum_burst_current , this.manufacture_date ] = moreargs;

    this._format = '<iiHHHHHBBB16s50sHBII11s';
    this._id = mavlink20.MAVLINK_MSG_ID_SMART_BATTERY_INFO;
    this.order_map = [7, 8, 9, 0, 1, 2, 10, 11, 3, 4, 5, 6, 12, 13, 14, 15, 16];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 50, 0, 0, 0, 0, 11];
    this.crc_extra = 75;
    this._name = 'SMART_BATTERY_INFO';

    this._instance_field = 'id';
    this._instance_offset = 18;

    this.fieldnames = ['id', 'battery_function', 'type', 'capacity_full_specification', 'capacity_full', 'cycle_count', 'serial_number', 'device_name', 'weight', 'discharge_minimum_voltage', 'charging_minimum_voltage', 'resting_minimum_voltage', 'charging_maximum_voltage', 'cells_in_series', 'discharge_maximum_current', 'discharge_maximum_burst_current', 'manufacture_date'];

}

mavlink20.messages.smart_battery_info.prototype = new mavlink20.message;
mavlink20.messages.smart_battery_info.prototype.pack = function(mav) {
    var orderedfields = [ this.capacity_full_specification, this.capacity_full, this.cycle_count, this.weight, this.discharge_minimum_voltage, this.charging_minimum_voltage, this.resting_minimum_voltage, this.id, this.battery_function, this.type, this.serial_number, this.device_name, this.charging_maximum_voltage, this.cells_in_series, this.discharge_maximum_current, this.discharge_maximum_burst_current, this.manufacture_date];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Vehicle status report that is sent out while figure eight execution is
in progress (see MAV_CMD_DO_FIGURE_EIGHT).         This may typically
send at low rates: of the order of 2Hz.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                major_radius              : Major axis radius of the figure eight. Positive: orbit the north circle clockwise. Negative: orbit the north circle counter-clockwise. (float)
                minor_radius              : Minor axis radius of the figure eight. Defines the radius of two circles that make up the figure. (float)
                orientation               : Orientation of the figure eight major axis with respect to true north in [-pi,pi). (float)
                frame                     : The coordinate system of the fields: x, y, z. (uint8_t)
                x                         : X coordinate of center point. Coordinate system depends on frame field. (int32_t)
                y                         : Y coordinate of center point. Coordinate system depends on frame field. (int32_t)
                z                         : Altitude of center point. Coordinate system depends on frame field. (float)

*/
    mavlink20.messages.figure_eight_execution_status = function( ...moreargs ) {
    [ this.time_usec , this.major_radius , this.minor_radius , this.orientation , this.frame , this.x , this.y , this.z ] = moreargs;

    this._format = '<QfffiifB';
    this._id = mavlink20.MAVLINK_MSG_ID_FIGURE_EIGHT_EXECUTION_STATUS;
    this.order_map = [0, 1, 2, 3, 7, 4, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 93;
    this._name = 'FIGURE_EIGHT_EXECUTION_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'major_radius', 'minor_radius', 'orientation', 'frame', 'x', 'y', 'z'];

}

mavlink20.messages.figure_eight_execution_status.prototype = new mavlink20.message;
mavlink20.messages.figure_eight_execution_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.major_radius, this.minor_radius, this.orientation, this.x, this.y, this.z, this.frame];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Fuel status.         This message provides "generic" fuel level
information for  in a GCS and for triggering failsafes in an
autopilot.         The fuel type and associated units for fields in
this message are defined in the enum MAV_FUEL_TYPE.          The
reported `consumed_fuel` and `remaining_fuel` must only be supplied if
measured: they must not be inferred from the `maximum_fuel` and the
other value.         A recipient can assume that if these fields are
supplied they are accurate.         If not provided, the recipient can
infer `remaining_fuel` from `maximum_fuel` and `consumed_fuel` on the
assumption that the fuel was initially at its maximum (this is what
battery monitors assume).         Note however that this is an
assumption, and the UI should prompt the user appropriately (i.e.
notify user that they should fill the tank before boot).          This
kind of information may also be sent in fuel-specific messages such as
BATTERY_STATUS_V2.         If both messages are sent for the same fuel
system, the ids and corresponding information must match.
This should be streamed (nominally at 0.1 Hz).

                id                        : Fuel ID. Must match ID of other messages for same fuel system, such as BATTERY_STATUS_V2. (uint8_t)
                maximum_fuel              : Capacity when full. Must be provided. (float)
                consumed_fuel             : Consumed fuel (measured). This value should not be inferred: if not measured set to NaN. NaN: field not provided. (float)
                remaining_fuel            : Remaining fuel until empty (measured). The value should not be inferred: if not measured set to NaN. NaN: field not provided. (float)
                percent_remaining         : Percentage of remaining fuel, relative to full. Values: [0-100], UINT8_MAX: field not provided. (uint8_t)
                flow_rate                 : Positive value when emptying/using, and negative if filling/replacing. NaN: field not provided. (float)
                temperature               : Fuel temperature. NaN: field not provided. (float)
                fuel_type                 : Fuel type. Defines units for fuel capacity and consumption fields above. (uint32_t)

*/
    mavlink20.messages.fuel_status = function( ...moreargs ) {
    [ this.id , this.maximum_fuel , this.consumed_fuel , this.remaining_fuel , this.percent_remaining , this.flow_rate , this.temperature , this.fuel_type ] = moreargs;

    this._format = '<fffffIBB';
    this._id = mavlink20.MAVLINK_MSG_ID_FUEL_STATUS;
    this.order_map = [6, 0, 1, 2, 7, 3, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 10;
    this._name = 'FUEL_STATUS';

    this._instance_field = 'id';
    this._instance_offset = 24;

    this.fieldnames = ['id', 'maximum_fuel', 'consumed_fuel', 'remaining_fuel', 'percent_remaining', 'flow_rate', 'temperature', 'fuel_type'];

}

mavlink20.messages.fuel_status.prototype = new mavlink20.message;
mavlink20.messages.fuel_status.prototype.pack = function(mav) {
    var orderedfields = [ this.maximum_fuel, this.consumed_fuel, this.remaining_fuel, this.flow_rate, this.temperature, this.fuel_type, this.id, this.percent_remaining];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Battery information that is static, or requires infrequent update.
This message should requested using MAV_CMD_REQUEST_MESSAGE and/or
streamed at very low rate.         BATTERY_STATUS_V2 is used for
higher-rate battery status information.

                id                        : Battery ID (uint8_t)
                battery_function          : Function of the battery. (uint8_t)
                type                      : Type (chemistry) of the battery. (uint8_t)
                state_of_health           : State of Health (SOH) estimate. Typically 100% at the time of manufacture and will decrease over time and use. -1: field not provided. (uint8_t)
                cells_in_series           : Number of battery cells in series. 0: field not provided. (uint8_t)
                cycle_count               : Lifetime count of the number of charge/discharge cycles (https://en.wikipedia.org/wiki/Charge_cycle). UINT16_MAX: field not provided. (uint16_t)
                weight                    : Battery weight. 0: field not provided. (uint16_t)
                discharge_minimum_voltage        : Minimum per-cell voltage when discharging. 0: field not provided. (float)
                charging_minimum_voltage        : Minimum per-cell voltage when charging. 0: field not provided. (float)
                resting_minimum_voltage        : Minimum per-cell voltage when resting. 0: field not provided. (float)
                charging_maximum_voltage        : Maximum per-cell voltage when charged. 0: field not provided. (float)
                charging_maximum_current        : Maximum pack continuous charge current. 0: field not provided. (float)
                nominal_voltage           : Battery nominal voltage. Used for conversion between Wh and Ah. 0: field not provided. (float)
                discharge_maximum_current        : Maximum pack discharge current. 0: field not provided. (float)
                discharge_maximum_burst_current        : Maximum pack discharge burst current. 0: field not provided. (float)
                design_capacity           : Fully charged design capacity. 0: field not provided. (float)
                full_charge_capacity        : Predicted battery capacity when fully charged (accounting for battery degradation). NAN: field not provided. (float)
                manufacture_date          : Manufacture date (DDMMYYYY) in ASCII characters, 0 terminated. All 0: field not provided. (char)
                serial_number             : Serial number in ASCII characters, 0 terminated. All 0: field not provided. (char)
                name                      : Battery device name. Formatted as manufacturer name then product name, separated with an underscore (in ASCII characters), 0 terminated. All 0: field not provided. (char)

*/
    mavlink20.messages.battery_info = function( ...moreargs ) {
    [ this.id , this.battery_function , this.type , this.state_of_health , this.cells_in_series , this.cycle_count , this.weight , this.discharge_minimum_voltage , this.charging_minimum_voltage , this.resting_minimum_voltage , this.charging_maximum_voltage , this.charging_maximum_current , this.nominal_voltage , this.discharge_maximum_current , this.discharge_maximum_burst_current , this.design_capacity , this.full_charge_capacity , this.manufacture_date , this.serial_number , this.name ] = moreargs;

    this._format = '<ffffffffffHHBBBBB9s32s50s';
    this._id = mavlink20.MAVLINK_MSG_ID_BATTERY_INFO;
    this.order_map = [12, 13, 14, 15, 16, 10, 11, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 17, 18, 19];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 32, 50];
    this.crc_extra = 26;
    this._name = 'BATTERY_INFO';

    this._instance_field = 'id';
    this._instance_offset = 44;

    this.fieldnames = ['id', 'battery_function', 'type', 'state_of_health', 'cells_in_series', 'cycle_count', 'weight', 'discharge_minimum_voltage', 'charging_minimum_voltage', 'resting_minimum_voltage', 'charging_maximum_voltage', 'charging_maximum_current', 'nominal_voltage', 'discharge_maximum_current', 'discharge_maximum_burst_current', 'design_capacity', 'full_charge_capacity', 'manufacture_date', 'serial_number', 'name'];

}

mavlink20.messages.battery_info.prototype = new mavlink20.message;
mavlink20.messages.battery_info.prototype.pack = function(mav) {
    var orderedfields = [ this.discharge_minimum_voltage, this.charging_minimum_voltage, this.resting_minimum_voltage, this.charging_maximum_voltage, this.charging_maximum_current, this.nominal_voltage, this.discharge_maximum_current, this.discharge_maximum_burst_current, this.design_capacity, this.full_charge_capacity, this.cycle_count, this.weight, this.id, this.battery_function, this.type, this.state_of_health, this.cells_in_series, this.manufacture_date, this.serial_number, this.name];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Telemetry of power generation system. Alternator or mechanical
generator.

                status                    : Status flags. (uint64_t)
                generator_speed           : Speed of electrical generator or alternator. UINT16_MAX: field not provided. (uint16_t)
                battery_current           : Current into/out of battery. Positive for out. Negative for in. NaN: field not provided. (float)
                load_current              : Current going to the UAV. If battery current not available this is the DC current from the generator. Positive for out. Negative for in. NaN: field not provided (float)
                power_generated           : The power being generated. NaN: field not provided (float)
                bus_voltage               : Voltage of the bus seen at the generator, or battery bus if battery bus is controlled by generator and at a different voltage to main bus. (float)
                rectifier_temperature        : The temperature of the rectifier or power converter. INT16_MAX: field not provided. (int16_t)
                bat_current_setpoint        : The target battery current. Positive for out. Negative for in. NaN: field not provided (float)
                generator_temperature        : The temperature of the mechanical motor, fuel cell core or generator. INT16_MAX: field not provided. (int16_t)
                runtime                   : Seconds this generator has run since it was rebooted. UINT32_MAX: field not provided. (uint32_t)
                time_until_maintenance        : Seconds until this generator requires maintenance.  A negative value indicates maintenance is past-due. INT32_MAX: field not provided. (int32_t)

*/
    mavlink20.messages.generator_status = function( ...moreargs ) {
    [ this.status , this.generator_speed , this.battery_current , this.load_current , this.power_generated , this.bus_voltage , this.rectifier_temperature , this.bat_current_setpoint , this.generator_temperature , this.runtime , this.time_until_maintenance ] = moreargs;

    this._format = '<QfffffIiHhh';
    this._id = mavlink20.MAVLINK_MSG_ID_GENERATOR_STATUS;
    this.order_map = [0, 8, 1, 2, 3, 4, 9, 5, 10, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 117;
    this._name = 'GENERATOR_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['status', 'generator_speed', 'battery_current', 'load_current', 'power_generated', 'bus_voltage', 'rectifier_temperature', 'bat_current_setpoint', 'generator_temperature', 'runtime', 'time_until_maintenance'];

}

mavlink20.messages.generator_status.prototype = new mavlink20.message;
mavlink20.messages.generator_status.prototype.pack = function(mav) {
    var orderedfields = [ this.status, this.battery_current, this.load_current, this.power_generated, this.bus_voltage, this.bat_current_setpoint, this.runtime, this.time_until_maintenance, this.generator_speed, this.rectifier_temperature, this.generator_temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The raw values of the actuator outputs (e.g. on Pixhawk, from MAIN,
AUX ports). This message supersedes SERVO_OUTPUT_RAW.

                time_usec                 : Timestamp (since system boot). (uint64_t)
                active                    : Active outputs (uint32_t)
                actuator                  : Servo / motor output array values. Zero values indicate unused channels. (float)

*/
    mavlink20.messages.actuator_output_status = function( ...moreargs ) {
    [ this.time_usec , this.active , this.actuator ] = moreargs;

    this._format = '<QI32f';
    this._id = mavlink20.MAVLINK_MSG_ID_ACTUATOR_OUTPUT_STATUS;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 32];
    this.array_len_map = [0, 0, 32];
    this.crc_extra = 251;
    this._name = 'ACTUATOR_OUTPUT_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'active', 'actuator'];

}

mavlink20.messages.actuator_output_status.prototype = new mavlink20.message;
mavlink20.messages.actuator_output_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.active, this.actuator];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Reports the on/off state of relays, as controlled by
MAV_CMD_DO_SET_RELAY.         Message streaming should be requested
using MAV_CMD_SET_MESSAGE_INTERVAL.         Note that it should not be
sent on every relay state change to avoid flooding the link.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                on                        : Relay states. Relay instance numbers are represented as individual bits in this mask by offset. (uint16_t)
                present                   : Relay present. Relay instance numbers are represented as individual bits in this mask by offset.  Bits will be true if a relay instance is configured. (uint16_t)

*/
    mavlink20.messages.relay_status = function( ...moreargs ) {
    [ this.time_boot_ms , this.on , this.present ] = moreargs;

    this._format = '<IHH';
    this._id = mavlink20.MAVLINK_MSG_ID_RELAY_STATUS;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 199;
    this._name = 'RELAY_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'on', 'present'];

}

mavlink20.messages.relay_status.prototype = new mavlink20.message;
mavlink20.messages.relay_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.on, this.present];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Time/duration estimates for various events and actions given the
current vehicle state and position.

                safe_return               : Estimated time to complete the vehicle's configured "safe return" action from its current position (e.g. RTL, Smart RTL, etc.). -1 indicates that the vehicle is landed, or that no time estimate available. (int32_t)
                land                      : Estimated time for vehicle to complete the LAND action from its current position. -1 indicates that the vehicle is landed, or that no time estimate available. (int32_t)
                mission_next_item         : Estimated time for reaching/completing the currently active mission item. -1 means no time estimate available. (int32_t)
                mission_end               : Estimated time for completing the current mission. -1 means no mission active and/or no estimate available. (int32_t)
                commanded_action          : Estimated time for completing the current commanded action (i.e. Go To, Takeoff, Land, etc.). -1 means no action active and/or no estimate available. (int32_t)

*/
    mavlink20.messages.time_estimate_to_target = function( ...moreargs ) {
    [ this.safe_return , this.land , this.mission_next_item , this.mission_end , this.commanded_action ] = moreargs;

    this._format = '<iiiii';
    this._id = mavlink20.MAVLINK_MSG_ID_TIME_ESTIMATE_TO_TARGET;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 232;
    this._name = 'TIME_ESTIMATE_TO_TARGET';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['safe_return', 'land', 'mission_next_item', 'mission_end', 'commanded_action'];

}

mavlink20.messages.time_estimate_to_target.prototype = new mavlink20.message;
mavlink20.messages.time_estimate_to_target.prototype.pack = function(mav) {
    var orderedfields = [ this.safe_return, this.land, this.mission_next_item, this.mission_end, this.commanded_action];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Message for transporting "arbitrary" variable-length data from one
component to another (broadcast is not forbidden, but discouraged).
The encoding of the data is usually extension specific, i.e.
determined by the source, and is usually not documented as part of the
MAVLink specification.

                target_system             : System ID (can be 0 for broadcast, but this is discouraged) (uint8_t)
                target_component          : Component ID (can be 0 for broadcast, but this is discouraged) (uint8_t)
                payload_type              : A code that identifies the content of the payload (0 for unknown, which is the default). If this code is less than 32768, it is a 'registered' payload type and the corresponding code should be added to the MAV_TUNNEL_PAYLOAD_TYPE enum. Software creators can register blocks of types as needed. Codes greater than 32767 are considered local experiments and should not be checked in to any widely distributed codebase. (uint16_t)
                payload_length            : Length of the data transported in payload (uint8_t)
                payload                   : Variable length payload. The payload length is defined by payload_length. The entire content of this block is opaque unless you understand the encoding specified by payload_type. (uint8_t)

*/
    mavlink20.messages.tunnel = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.payload_type , this.payload_length , this.payload ] = moreargs;

    this._format = '<HBBB128s';
    this._id = mavlink20.MAVLINK_MSG_ID_TUNNEL;
    this.order_map = [1, 2, 0, 3, 4];
    this.len_map = [1, 1, 1, 1, 128];
    this.array_len_map = [0, 0, 0, 0, 128];
    this.crc_extra = 147;
    this._name = 'TUNNEL';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'payload_type', 'payload_length', 'payload'];

}

mavlink20.messages.tunnel.prototype = new mavlink20.message;
mavlink20.messages.tunnel.prototype.pack = function(mav) {
    var orderedfields = [ this.payload_type, this.target_system, this.target_component, this.payload_length, this.payload];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A forwarded CAN frame as requested by MAV_CMD_CAN_FORWARD.

                target_system             : System ID. (uint8_t)
                target_component          : Component ID. (uint8_t)
                bus                       : Bus number (uint8_t)
                len                       : Frame length (uint8_t)
                id                        : Frame ID (uint32_t)
                data                      : Frame data (uint8_t)

*/
    mavlink20.messages.can_frame = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.bus , this.len , this.id , this.data ] = moreargs;

    this._format = '<IBBBB8s';
    this._id = mavlink20.MAVLINK_MSG_ID_CAN_FRAME;
    this.order_map = [1, 2, 3, 4, 0, 5];
    this.len_map = [1, 1, 1, 1, 1, 8];
    this.array_len_map = [0, 0, 0, 0, 0, 8];
    this.crc_extra = 132;
    this._name = 'CAN_FRAME';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'bus', 'len', 'id', 'data'];

}

mavlink20.messages.can_frame.prototype = new mavlink20.message;
mavlink20.messages.can_frame.prototype.pack = function(mav) {
    var orderedfields = [ this.id, this.target_system, this.target_component, this.bus, this.len, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A forwarded CANFD frame as requested by MAV_CMD_CAN_FORWARD. These are
separated from CAN_FRAME as they need different handling (eg. TAO
handling)

                target_system             : System ID. (uint8_t)
                target_component          : Component ID. (uint8_t)
                bus                       : bus number (uint8_t)
                len                       : Frame length (uint8_t)
                id                        : Frame ID (uint32_t)
                data                      : Frame data (uint8_t)

*/
    mavlink20.messages.canfd_frame = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.bus , this.len , this.id , this.data ] = moreargs;

    this._format = '<IBBBB64s';
    this._id = mavlink20.MAVLINK_MSG_ID_CANFD_FRAME;
    this.order_map = [1, 2, 3, 4, 0, 5];
    this.len_map = [1, 1, 1, 1, 1, 64];
    this.array_len_map = [0, 0, 0, 0, 0, 64];
    this.crc_extra = 4;
    this._name = 'CANFD_FRAME';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'bus', 'len', 'id', 'data'];

}

mavlink20.messages.canfd_frame.prototype = new mavlink20.message;
mavlink20.messages.canfd_frame.prototype.pack = function(mav) {
    var orderedfields = [ this.id, this.target_system, this.target_component, this.bus, this.len, this.data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Modify the filter of what CAN messages to forward over the mavlink.
This can be used to make CAN forwarding work well on low bandwidth
links. The filtering is applied on bits 8 to 24 of the CAN id (2nd and
3rd bytes) which corresponds to the DroneCAN message ID for DroneCAN.
Filters with more than 16 IDs can be constructed by sending multiple
CAN_FILTER_MODIFY messages.

                target_system             : System ID. (uint8_t)
                target_component          : Component ID. (uint8_t)
                bus                       : bus number (uint8_t)
                operation                 : what operation to perform on the filter list. See CAN_FILTER_OP enum. (uint8_t)
                num_ids                   : number of IDs in filter list (uint8_t)
                ids                       : filter IDs, length num_ids (uint16_t)

*/
    mavlink20.messages.can_filter_modify = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.bus , this.operation , this.num_ids , this.ids ] = moreargs;

    this._format = '<16HBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_CAN_FILTER_MODIFY;
    this.order_map = [1, 2, 3, 4, 5, 0];
    this.len_map = [16, 1, 1, 1, 1, 1];
    this.array_len_map = [16, 0, 0, 0, 0, 0];
    this.crc_extra = 8;
    this._name = 'CAN_FILTER_MODIFY';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'bus', 'operation', 'num_ids', 'ids'];

}

mavlink20.messages.can_filter_modify.prototype = new mavlink20.message;
mavlink20.messages.can_filter_modify.prototype.pack = function(mav) {
    var orderedfields = [ this.ids, this.target_system, this.target_component, this.bus, this.operation, this.num_ids];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Hardware status sent by an onboard computer.

                time_usec                 : Timestamp (UNIX Epoch time or time since system boot). The receiving end can infer timestamp format (since 1.1.1970 or since system boot) by checking for the magnitude of the number. (uint64_t)
                uptime                    : Time since system boot. (uint32_t)
                type                      : Type of the onboard computer: 0: Mission computer primary, 1: Mission computer backup 1, 2: Mission computer backup 2, 3: Compute node, 4-5: Compute spares, 6-9: Payload computers. (uint8_t)
                cpu_cores                 : CPU usage on the component in percent (100 - idle). A value of UINT8_MAX implies the field is unused. (uint8_t)
                cpu_combined              : Combined CPU usage as the last 10 slices of 100 MS (a histogram). This allows to identify spikes in load that max out the system, but only for a short amount of time. A value of UINT8_MAX implies the field is unused. (uint8_t)
                gpu_cores                 : GPU usage on the component in percent (100 - idle). A value of UINT8_MAX implies the field is unused. (uint8_t)
                gpu_combined              : Combined GPU usage as the last 10 slices of 100 MS (a histogram). This allows to identify spikes in load that max out the system, but only for a short amount of time. A value of UINT8_MAX implies the field is unused. (uint8_t)
                temperature_board         : Temperature of the board. A value of INT8_MAX implies the field is unused. (int8_t)
                temperature_core          : Temperature of the CPU core. A value of INT8_MAX implies the field is unused. (int8_t)
                fan_speed                 : Fan speeds. A value of INT16_MAX implies the field is unused. (int16_t)
                ram_usage                 : Amount of used RAM on the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                ram_total                 : Total amount of RAM on the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                storage_type              : Storage type: 0: HDD, 1: SSD, 2: EMMC, 3: SD card (non-removable), 4: SD card (removable). A value of UINT32_MAX implies the field is unused. (uint32_t)
                storage_usage             : Amount of used storage space on the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                storage_total             : Total amount of storage space on the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                link_type                 : Link type: 0-9: UART, 10-19: Wired network, 20-29: Wifi, 30-39: Point-to-point proprietary, 40-49: Mesh proprietary (uint32_t)
                link_tx_rate              : Network traffic from the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                link_rx_rate              : Network traffic to the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                link_tx_max               : Network capacity from the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                link_rx_max               : Network capacity to the component system. A value of UINT32_MAX implies the field is unused. (uint32_t)
                status_flags              : Bitmap of status flags. (uint16_t)

*/
    mavlink20.messages.onboard_computer_status = function( ...moreargs ) {
    [ this.time_usec , this.uptime , this.type , this.cpu_cores , this.cpu_combined , this.gpu_cores , this.gpu_combined , this.temperature_board , this.temperature_core , this.fan_speed , this.ram_usage , this.ram_total , this.storage_type , this.storage_usage , this.storage_total , this.link_type , this.link_tx_rate , this.link_rx_rate , this.link_tx_max , this.link_rx_max , this.status_flags ] = moreargs;

    this._format = '<QIII4I4I4I6I6I6I6I6I4hB8s10s4s10sb8sH';
    this._id = mavlink20.MAVLINK_MSG_ID_ONBOARD_COMPUTER_STATUS;
    this.order_map = [0, 1, 13, 14, 15, 16, 17, 18, 19, 12, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 20];
    this.len_map = [1, 1, 1, 1, 4, 4, 4, 6, 6, 6, 6, 6, 4, 1, 8, 10, 4, 10, 1, 8, 1];
    this.array_len_map = [0, 0, 0, 0, 4, 4, 4, 6, 6, 6, 6, 6, 4, 0, 8, 10, 4, 10, 0, 8, 0];
    this.crc_extra = 156;
    this._name = 'ONBOARD_COMPUTER_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'uptime', 'type', 'cpu_cores', 'cpu_combined', 'gpu_cores', 'gpu_combined', 'temperature_board', 'temperature_core', 'fan_speed', 'ram_usage', 'ram_total', 'storage_type', 'storage_usage', 'storage_total', 'link_type', 'link_tx_rate', 'link_rx_rate', 'link_tx_max', 'link_rx_max', 'status_flags'];

}

mavlink20.messages.onboard_computer_status.prototype = new mavlink20.message;
mavlink20.messages.onboard_computer_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.uptime, this.ram_usage, this.ram_total, this.storage_type, this.storage_usage, this.storage_total, this.link_type, this.link_tx_rate, this.link_rx_rate, this.link_tx_max, this.link_rx_max, this.fan_speed, this.type, this.cpu_cores, this.cpu_combined, this.gpu_cores, this.gpu_combined, this.temperature_board, this.temperature_core, this.status_flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Component information message, which may be requested using
MAV_CMD_REQUEST_MESSAGE.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                general_metadata_file_crc        : CRC32 of the general metadata file (general_metadata_uri). (uint32_t)
                general_metadata_uri        : MAVLink FTP URI for the general metadata file (COMP_METADATA_TYPE_GENERAL), which may be compressed with xz. The file contains general component metadata, and may contain URI links for additional metadata (see COMP_METADATA_TYPE). The information is static from boot, and may be generated at compile time. The string needs to be zero terminated. (char)
                peripherals_metadata_file_crc        : CRC32 of peripherals metadata file (peripherals_metadata_uri). (uint32_t)
                peripherals_metadata_uri        : (Optional) MAVLink FTP URI for the peripherals metadata file (COMP_METADATA_TYPE_PERIPHERALS), which may be compressed with xz. This contains data about "attached components" such as UAVCAN nodes. The peripherals are in a separate file because the information must be generated dynamically at runtime. The string needs to be zero terminated. (char)

*/
    mavlink20.messages.component_information = function( ...moreargs ) {
    [ this.time_boot_ms , this.general_metadata_file_crc , this.general_metadata_uri , this.peripherals_metadata_file_crc , this.peripherals_metadata_uri ] = moreargs;

    this._format = '<III100s100s';
    this._id = mavlink20.MAVLINK_MSG_ID_COMPONENT_INFORMATION;
    this.order_map = [0, 1, 3, 2, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 100, 100];
    this.crc_extra = 0;
    this._name = 'COMPONENT_INFORMATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'general_metadata_file_crc', 'general_metadata_uri', 'peripherals_metadata_file_crc', 'peripherals_metadata_uri'];

}

mavlink20.messages.component_information.prototype = new mavlink20.message;
mavlink20.messages.component_information.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.general_metadata_file_crc, this.peripherals_metadata_file_crc, this.general_metadata_uri, this.peripherals_metadata_uri];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Basic component information data. Should be requested using
MAV_CMD_REQUEST_MESSAGE on startup, or when required.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                capabilities              : Component capability flags (uint64_t)
                time_manufacture_s        : Date of manufacture as a UNIX Epoch time (since 1.1.1970) in seconds. (uint32_t)
                vendor_name               : Name of the component vendor. Needs to be zero terminated. The field is optional and can be empty/all zeros. (char)
                model_name                : Name of the component model. Needs to be zero terminated. The field is optional and can be empty/all zeros. (char)
                software_version          : Software version. The recommended format is SEMVER: 'major.minor.patch'  (any format may be used). The field must be zero terminated if it has a value. The field is optional and can be empty/all zeros. (char)
                hardware_version          : Hardware version. The recommended format is SEMVER: 'major.minor.patch'  (any format may be used). The field must be zero terminated if it has a value. The field is optional and can be empty/all zeros. (char)
                serial_number             : Hardware serial number. The field must be zero terminated if it has a value. The field is optional and can be empty/all zeros. (char)

*/
    mavlink20.messages.component_information_basic = function( ...moreargs ) {
    [ this.time_boot_ms , this.capabilities , this.time_manufacture_s , this.vendor_name , this.model_name , this.software_version , this.hardware_version , this.serial_number ] = moreargs;

    this._format = '<QII32s32s24s24s32s';
    this._id = mavlink20.MAVLINK_MSG_ID_COMPONENT_INFORMATION_BASIC;
    this.order_map = [1, 0, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 32, 32, 24, 24, 32];
    this.crc_extra = 50;
    this._name = 'COMPONENT_INFORMATION_BASIC';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'capabilities', 'time_manufacture_s', 'vendor_name', 'model_name', 'software_version', 'hardware_version', 'serial_number'];

}

mavlink20.messages.component_information_basic.prototype = new mavlink20.message;
mavlink20.messages.component_information_basic.prototype.pack = function(mav) {
    var orderedfields = [ this.capabilities, this.time_boot_ms, this.time_manufacture_s, this.vendor_name, this.model_name, this.software_version, this.hardware_version, this.serial_number];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Component metadata message, which may be requested using
MAV_CMD_REQUEST_MESSAGE.          This contains the MAVLink FTP URI
and CRC for the component's general metadata file.         The file
must be hosted on the component, and may be xz compressed.         The
file CRC can be used for file caching.          The general metadata
file can be read to get the locations of other metadata files
(COMP_METADATA_TYPE) and translations, which may be hosted either on
the vehicle or the internet.         For more information see:
https://mavlink.io/en/services/component_information.html.
Note: Camera components should use CAMERA_INFORMATION instead, and
autopilots may use both this message and AUTOPILOT_VERSION.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                file_crc                  : CRC32 of the general metadata file. (uint32_t)
                uri                       : MAVLink FTP URI for the general metadata file (COMP_METADATA_TYPE_GENERAL), which may be compressed with xz. The file contains general component metadata, and may contain URI links for additional metadata (see COMP_METADATA_TYPE). The information is static from boot, and may be generated at compile time. The string needs to be zero terminated. (char)

*/
    mavlink20.messages.component_metadata = function( ...moreargs ) {
    [ this.time_boot_ms , this.file_crc , this.uri ] = moreargs;

    this._format = '<II100s';
    this._id = mavlink20.MAVLINK_MSG_ID_COMPONENT_METADATA;
    this.order_map = [0, 1, 2];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 100];
    this.crc_extra = 182;
    this._name = 'COMPONENT_METADATA';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'file_crc', 'uri'];

}

mavlink20.messages.component_metadata.prototype = new mavlink20.message;
mavlink20.messages.component_metadata.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.file_crc, this.uri];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Play vehicle tone/tune (buzzer). Supersedes message PLAY_TUNE.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                format                    : Tune format (uint32_t)
                tune                      : Tune definition as a NULL-terminated string. (char)

*/
    mavlink20.messages.play_tune_v2 = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.format , this.tune ] = moreargs;

    this._format = '<IBB248s';
    this._id = mavlink20.MAVLINK_MSG_ID_PLAY_TUNE_V2;
    this.order_map = [1, 2, 0, 3];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 248];
    this.crc_extra = 110;
    this._name = 'PLAY_TUNE_V2';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'format', 'tune'];

}

mavlink20.messages.play_tune_v2.prototype = new mavlink20.message;
mavlink20.messages.play_tune_v2.prototype.pack = function(mav) {
    var orderedfields = [ this.format, this.target_system, this.target_component, this.tune];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Tune formats supported by vehicle. This should be emitted as response
to MAV_CMD_REQUEST_MESSAGE.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                format                    : Bitfield of supported tune formats. (uint32_t)

*/
    mavlink20.messages.supported_tunes = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.format ] = moreargs;

    this._format = '<IBB';
    this._id = mavlink20.MAVLINK_MSG_ID_SUPPORTED_TUNES;
    this.order_map = [1, 2, 0];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 183;
    this._name = 'SUPPORTED_TUNES';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'format'];

}

mavlink20.messages.supported_tunes.prototype = new mavlink20.message;
mavlink20.messages.supported_tunes.prototype.pack = function(mav) {
    var orderedfields = [ this.format, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Event message. Each new event from a particular component gets a new
sequence number. The same message might be sent multiple times if
(re-)requested. Most events are broadcast, some can be specific to a
target component (as receivers keep track of the sequence for missed
events, all events need to be broadcast. Thus we use
destination_component instead of target_component).

                destination_component        : Component ID (uint8_t)
                destination_system        : System ID (uint8_t)
                id                        : Event ID (as defined in the component metadata) (uint32_t)
                event_time_boot_ms        : Timestamp (time since system boot when the event happened). (uint32_t)
                sequence                  : Sequence number. (uint16_t)
                log_levels                : Log levels: 4 bits MSB: internal (for logging purposes), 4 bits LSB: external. Levels: Emergency = 0, Alert = 1, Critical = 2, Error = 3, Warning = 4, Notice = 5, Info = 6, Debug = 7, Protocol = 8, Disabled = 9 (uint8_t)
                arguments                 : Arguments (depend on event ID). (uint8_t)

*/
    mavlink20.messages.event = function( ...moreargs ) {
    [ this.destination_component , this.destination_system , this.id , this.event_time_boot_ms , this.sequence , this.log_levels , this.arguments ] = moreargs;

    this._format = '<IIHBBB40s';
    this._id = mavlink20.MAVLINK_MSG_ID_EVENT;
    this.order_map = [3, 4, 0, 1, 2, 5, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 40];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 40];
    this.crc_extra = 160;
    this._name = 'EVENT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['destination_component', 'destination_system', 'id', 'event_time_boot_ms', 'sequence', 'log_levels', 'arguments'];

}

mavlink20.messages.event.prototype = new mavlink20.message;
mavlink20.messages.event.prototype.pack = function(mav) {
    var orderedfields = [ this.id, this.event_time_boot_ms, this.sequence, this.destination_component, this.destination_system, this.log_levels, this.arguments];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Regular broadcast for the current latest event sequence number for a
component. This is used to check for dropped events.

                sequence                  : Sequence number. (uint16_t)
                flags                     : Flag bitset. (uint8_t)

*/
    mavlink20.messages.current_event_sequence = function( ...moreargs ) {
    [ this.sequence , this.flags ] = moreargs;

    this._format = '<HB';
    this._id = mavlink20.MAVLINK_MSG_ID_CURRENT_EVENT_SEQUENCE;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 0];
    this.crc_extra = 106;
    this._name = 'CURRENT_EVENT_SEQUENCE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['sequence', 'flags'];

}

mavlink20.messages.current_event_sequence.prototype = new mavlink20.message;
mavlink20.messages.current_event_sequence.prototype.pack = function(mav) {
    var orderedfields = [ this.sequence, this.flags];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Request one or more events to be (re-)sent. If
first_sequence==last_sequence, only a single event is requested. Note
that first_sequence can be larger than last_sequence (because the
sequence number can wrap). Each sequence will trigger an EVENT or
EVENT_ERROR response.

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                first_sequence            : First sequence number of the requested event. (uint16_t)
                last_sequence             : Last sequence number of the requested event. (uint16_t)

*/
    mavlink20.messages.request_event = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.first_sequence , this.last_sequence ] = moreargs;

    this._format = '<HHBB';
    this._id = mavlink20.MAVLINK_MSG_ID_REQUEST_EVENT;
    this.order_map = [2, 3, 0, 1];
    this.len_map = [1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0];
    this.crc_extra = 33;
    this._name = 'REQUEST_EVENT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'first_sequence', 'last_sequence'];

}

mavlink20.messages.request_event.prototype = new mavlink20.message;
mavlink20.messages.request_event.prototype.pack = function(mav) {
    var orderedfields = [ this.first_sequence, this.last_sequence, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Response to a REQUEST_EVENT in case of an error (e.g. the event is not
available anymore).

                target_system             : System ID (uint8_t)
                target_component          : Component ID (uint8_t)
                sequence                  : Sequence number. (uint16_t)
                sequence_oldest_available        : Oldest Sequence number that is still available after the sequence set in REQUEST_EVENT. (uint16_t)
                reason                    : Error reason. (uint8_t)

*/
    mavlink20.messages.response_event_error = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.sequence , this.sequence_oldest_available , this.reason ] = moreargs;

    this._format = '<HHBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_RESPONSE_EVENT_ERROR;
    this.order_map = [2, 3, 0, 1, 4];
    this.len_map = [1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0];
    this.crc_extra = 77;
    this._name = 'RESPONSE_EVENT_ERROR';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'sequence', 'sequence_oldest_available', 'reason'];

}

mavlink20.messages.response_event_error.prototype = new mavlink20.message;
mavlink20.messages.response_event_error.prototype.pack = function(mav) {
    var orderedfields = [ this.sequence, this.sequence_oldest_available, this.target_system, this.target_component, this.reason];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Information about a flight mode.          The message can be
enumerated to get information for all modes, or requested for a
particular mode, using MAV_CMD_REQUEST_MESSAGE.         Specify 0 in
param2 to request that the message is emitted for all available modes
or the specific index for just one mode.         The modes must be
available/settable for the current vehicle/frame type.         Each
mode should only be emitted once (even if it is both standard and
custom).         Note that the current mode should be emitted in
CURRENT_MODE, and that if the mode list can change then
AVAILABLE_MODES_MONITOR must be emitted on first change and
subsequently streamed.         See
https://mavlink.io/en/services/standard_modes.html

                number_modes              : The total number of available modes for the current vehicle type. (uint8_t)
                mode_index                : The current mode index within number_modes, indexed from 1. The index is not guaranteed to be persistent, and may change between reboots or if the set of modes change. (uint8_t)
                standard_mode             : Standard mode. (uint8_t)
                custom_mode               : A bitfield for use for autopilot-specific flags (uint32_t)
                properties                : Mode properties. (uint32_t)
                mode_name                 : Name of custom mode, with null termination character. Should be omitted for standard modes. (char)

*/
    mavlink20.messages.available_modes = function( ...moreargs ) {
    [ this.number_modes , this.mode_index , this.standard_mode , this.custom_mode , this.properties , this.mode_name ] = moreargs;

    this._format = '<IIBBB35s';
    this._id = mavlink20.MAVLINK_MSG_ID_AVAILABLE_MODES;
    this.order_map = [2, 3, 4, 0, 1, 5];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 35];
    this.crc_extra = 134;
    this._name = 'AVAILABLE_MODES';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['number_modes', 'mode_index', 'standard_mode', 'custom_mode', 'properties', 'mode_name'];

}

mavlink20.messages.available_modes.prototype = new mavlink20.message;
mavlink20.messages.available_modes.prototype.pack = function(mav) {
    var orderedfields = [ this.custom_mode, this.properties, this.number_modes, this.mode_index, this.standard_mode, this.mode_name];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Get the current mode.         This should be emitted on any mode
change, and broadcast at low rate (nominally 0.5 Hz).         It may
be requested using MAV_CMD_REQUEST_MESSAGE.         See
https://mavlink.io/en/services/standard_modes.html

                standard_mode             : Standard mode. (uint8_t)
                custom_mode               : A bitfield for use for autopilot-specific flags (uint32_t)
                intended_custom_mode        : The custom_mode of the mode that was last commanded by the user (for example, with MAV_CMD_DO_SET_STANDARD_MODE, MAV_CMD_DO_SET_MODE or via RC). This should usually be the same as custom_mode. It will be different if the vehicle is unable to enter the intended mode, or has left that mode due to a failsafe condition. 0 indicates the intended custom mode is unknown/not supplied (uint32_t)

*/
    mavlink20.messages.current_mode = function( ...moreargs ) {
    [ this.standard_mode , this.custom_mode , this.intended_custom_mode ] = moreargs;

    this._format = '<IIB';
    this._id = mavlink20.MAVLINK_MSG_ID_CURRENT_MODE;
    this.order_map = [2, 0, 1];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 193;
    this._name = 'CURRENT_MODE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['standard_mode', 'custom_mode', 'intended_custom_mode'];

}

mavlink20.messages.current_mode.prototype = new mavlink20.message;
mavlink20.messages.current_mode.prototype.pack = function(mav) {
    var orderedfields = [ this.custom_mode, this.intended_custom_mode, this.standard_mode];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
A change to the sequence number indicates that the set of
AVAILABLE_MODES has changed, and that the receiver should re-request
all available modes.          The message is optional, and is only
needed when the set of modes can change dynamically after boot.
It should be emitted whenever the set of modes change.         It
should be streamed at low rate (nominally 0.3 Hz).         See
https://mavlink.io/en/services/standard_modes.html

                seq                       : Sequence number. The value iterates sequentially whenever AVAILABLE_MODES changes (e.g. support for a new mode is added/removed dynamically). (uint8_t)

*/
    mavlink20.messages.available_modes_monitor = function( ...moreargs ) {
    [ this.seq ] = moreargs;

    this._format = '<B';
    this._id = mavlink20.MAVLINK_MSG_ID_AVAILABLE_MODES_MONITOR;
    this.order_map = [0];
    this.len_map = [1];
    this.array_len_map = [0];
    this.crc_extra = 30;
    this._name = 'AVAILABLE_MODES_MONITOR';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['seq'];

}

mavlink20.messages.available_modes_monitor.prototype = new mavlink20.message;
mavlink20.messages.available_modes_monitor.prototype.pack = function(mav) {
    var orderedfields = [ this.seq];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Illuminator status

                uptime_ms                 : Time since the start-up of the illuminator in ms (uint32_t)
                enable                    : 0: Illuminators OFF, 1: Illuminators ON (uint8_t)
                mode_bitmask              : Supported illuminator modes (uint8_t)
                error_status              : Errors (uint32_t)
                mode                      : Illuminator mode (uint8_t)
                brightness                : Illuminator brightness (float)
                strobe_period             : Illuminator strobing period in seconds (float)
                strobe_duty_cycle         : Illuminator strobing duty cycle (float)
                temp_c                    : Temperature in Celsius (float)
                min_strobe_period         : Minimum strobing period in seconds (float)
                max_strobe_period         : Maximum strobing period in seconds (float)

*/
    mavlink20.messages.illuminator_status = function( ...moreargs ) {
    [ this.uptime_ms , this.enable , this.mode_bitmask , this.error_status , this.mode , this.brightness , this.strobe_period , this.strobe_duty_cycle , this.temp_c , this.min_strobe_period , this.max_strobe_period ] = moreargs;

    this._format = '<IIffffffBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_ILLUMINATOR_STATUS;
    this.order_map = [0, 8, 9, 1, 10, 2, 3, 4, 5, 6, 7];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 66;
    this._name = 'ILLUMINATOR_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['uptime_ms', 'enable', 'mode_bitmask', 'error_status', 'mode', 'brightness', 'strobe_period', 'strobe_duty_cycle', 'temp_c', 'min_strobe_period', 'max_strobe_period'];

}

mavlink20.messages.illuminator_status.prototype = new mavlink20.message;
mavlink20.messages.illuminator_status.prototype.pack = function(mav) {
    var orderedfields = [ this.uptime_ms, this.error_status, this.brightness, this.strobe_period, this.strobe_duty_cycle, this.temp_c, this.min_strobe_period, this.max_strobe_period, this.enable, this.mode_bitmask, this.mode];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Cumulative distance traveled for each reported wheel.

                time_usec                 : Timestamp (synced to UNIX time or since system boot). (uint64_t)
                count                     : Number of wheels reported. (uint8_t)
                distance                  : Distance reported by individual wheel encoders. Forward rotations increase values, reverse rotations decrease them. Not all wheels will necessarily have wheel encoders; the mapping of encoders to wheel positions must be agreed/understood by the endpoints. (double)

*/
    mavlink20.messages.wheel_distance = function( ...moreargs ) {
    [ this.time_usec , this.count , this.distance ] = moreargs;

    this._format = '<Q16dB';
    this._id = mavlink20.MAVLINK_MSG_ID_WHEEL_DISTANCE;
    this.order_map = [0, 2, 1];
    this.len_map = [1, 16, 1];
    this.array_len_map = [0, 16, 0];
    this.crc_extra = 113;
    this._name = 'WHEEL_DISTANCE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'count', 'distance'];

}

mavlink20.messages.wheel_distance.prototype = new mavlink20.message;
mavlink20.messages.wheel_distance.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.distance, this.count];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Winch status.

                time_usec                 : Timestamp (synced to UNIX time or since system boot). (uint64_t)
                line_length               : Length of line released. NaN if unknown (float)
                speed                     : Speed line is being released or retracted. Positive values if being released, negative values if being retracted, NaN if unknown (float)
                tension                   : Tension on the line. NaN if unknown (float)
                voltage                   : Voltage of the battery supplying the winch. NaN if unknown (float)
                current                   : Current draw from the winch. NaN if unknown (float)
                temperature               : Temperature of the motor. INT16_MAX if unknown (int16_t)
                status                    : Status flags (uint32_t)

*/
    mavlink20.messages.winch_status = function( ...moreargs ) {
    [ this.time_usec , this.line_length , this.speed , this.tension , this.voltage , this.current , this.temperature , this.status ] = moreargs;

    this._format = '<QfffffIh';
    this._id = mavlink20.MAVLINK_MSG_ID_WINCH_STATUS;
    this.order_map = [0, 1, 2, 3, 4, 5, 7, 6];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 117;
    this._name = 'WINCH_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_usec', 'line_length', 'speed', 'tension', 'voltage', 'current', 'temperature', 'status'];

}

mavlink20.messages.winch_status.prototype = new mavlink20.message;
mavlink20.messages.winch_status.prototype.pack = function(mav) {
    var orderedfields = [ this.time_usec, this.line_length, this.speed, this.tension, this.voltage, this.current, this.status, this.temperature];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for filling the OpenDroneID Basic ID message. This and the below
messages are primarily meant for feeding data to/from an OpenDroneID
implementation. E.g. https://github.com/opendroneid/opendroneid-
core-c. These messages are compatible with the ASTM F3411 Remote ID
standard and the ASD-STAN prEN 4709-002 Direct Remote ID standard.
Additional information and usage of these messages is documented at
https://mavlink.io/en/services/opendroneid.html.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                id_type                   : Indicates the format for the uas_id field of this message. (uint8_t)
                ua_type                   : Indicates the type of UA (Unmanned Aircraft). (uint8_t)
                uas_id                    : UAS (Unmanned Aircraft System) ID following the format specified by id_type. Shall be filled with nulls in the unused portion of the field. (uint8_t)

*/
    mavlink20.messages.open_drone_id_basic_id = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.id_type , this.ua_type , this.uas_id ] = moreargs;

    this._format = '<BB20sBB20s';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_BASIC_ID;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 1, 20, 1, 1, 20];
    this.array_len_map = [0, 0, 20, 0, 0, 20];
    this.crc_extra = 114;
    this._name = 'OPEN_DRONE_ID_BASIC_ID';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'id_type', 'ua_type', 'uas_id'];

}

mavlink20.messages.open_drone_id_basic_id.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_basic_id.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.id_or_mac, this.id_type, this.ua_type, this.uas_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for filling the OpenDroneID Location message. The float data
types are 32-bit IEEE 754. The Location message provides the location,
altitude, direction and speed of the aircraft.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                status                    : Indicates whether the unmanned aircraft is on the ground or in the air. (uint8_t)
                direction                 : Direction over ground (not heading, but direction of movement) measured clockwise from true North: 0 - 35999 centi-degrees. If unknown: 36100 centi-degrees. (uint16_t)
                speed_horizontal          : Ground speed. Positive only. If unknown: 25500 cm/s. If speed is larger than 25425 cm/s, use 25425 cm/s. (uint16_t)
                speed_vertical            : The vertical speed. Up is positive. If unknown: 6300 cm/s. If speed is larger than 6200 cm/s, use 6200 cm/s. If lower than -6200 cm/s, use -6200 cm/s. (int16_t)
                latitude                  : Current latitude of the unmanned aircraft. If unknown: 0 (both Lat/Lon). (int32_t)
                longitude                 : Current longitude of the unmanned aircraft. If unknown: 0 (both Lat/Lon). (int32_t)
                altitude_barometric        : The altitude calculated from the barometric pressure. Reference is against 29.92inHg or 1013.2mb. If unknown: -1000 m. (float)
                altitude_geodetic         : The geodetic altitude as defined by WGS84. If unknown: -1000 m. (float)
                height_reference          : Indicates the reference point for the height field. (uint8_t)
                height                    : The current height of the unmanned aircraft above the take-off location or the ground as indicated by height_reference. If unknown: -1000 m. (float)
                horizontal_accuracy        : The accuracy of the horizontal position. (uint8_t)
                vertical_accuracy         : The accuracy of the vertical position. (uint8_t)
                barometer_accuracy        : The accuracy of the barometric altitude. (uint8_t)
                speed_accuracy            : The accuracy of the horizontal and vertical speed. (uint8_t)
                timestamp                 : Seconds after the full hour with reference to UTC time. Typically the GPS outputs a time-of-week value in milliseconds. First convert that to UTC and then convert for this field using ((float) (time_week_ms % (60*60*1000))) / 1000. If unknown: 0xFFFF. (float)
                timestamp_accuracy        : The accuracy of the timestamps. (uint8_t)

*/
    mavlink20.messages.open_drone_id_location = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.status , this.direction , this.speed_horizontal , this.speed_vertical , this.latitude , this.longitude , this.altitude_barometric , this.altitude_geodetic , this.height_reference , this.height , this.horizontal_accuracy , this.vertical_accuracy , this.barometer_accuracy , this.speed_accuracy , this.timestamp , this.timestamp_accuracy ] = moreargs;

    this._format = '<iiffffHHhBB20sBBBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_LOCATION;
    this.order_map = [9, 10, 11, 12, 6, 7, 8, 0, 1, 2, 3, 13, 4, 14, 15, 16, 17, 5, 18];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 254;
    this._name = 'OPEN_DRONE_ID_LOCATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'status', 'direction', 'speed_horizontal', 'speed_vertical', 'latitude', 'longitude', 'altitude_barometric', 'altitude_geodetic', 'height_reference', 'height', 'horizontal_accuracy', 'vertical_accuracy', 'barometer_accuracy', 'speed_accuracy', 'timestamp', 'timestamp_accuracy'];

}

mavlink20.messages.open_drone_id_location.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_location.prototype.pack = function(mav) {
    var orderedfields = [ this.latitude, this.longitude, this.altitude_barometric, this.altitude_geodetic, this.height, this.timestamp, this.direction, this.speed_horizontal, this.speed_vertical, this.target_system, this.target_component, this.id_or_mac, this.status, this.height_reference, this.horizontal_accuracy, this.vertical_accuracy, this.barometer_accuracy, this.speed_accuracy, this.timestamp_accuracy];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for filling the OpenDroneID Authentication message. The
Authentication Message defines a field that can provide a means of
authenticity for the identity of the UAS (Unmanned Aircraft System).
The Authentication message can have two different formats. For data
page 0, the fields PageCount, Length and TimeStamp are present and
AuthData is only 17 bytes. For data page 1 through 15, PageCount,
Length and TimeStamp are not present and the size of AuthData is 23
bytes.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                authentication_type        : Indicates the type of authentication. (uint8_t)
                data_page                 : Allowed range is 0 - 15. (uint8_t)
                last_page_index           : This field is only present for page 0. Allowed range is 0 - 15. See the description of struct ODID_Auth_data at https://github.com/opendroneid/opendroneid-core-c/blob/master/libopendroneid/opendroneid.h. (uint8_t)
                length                    : This field is only present for page 0. Total bytes of authentication_data from all data pages. See the description of struct ODID_Auth_data at https://github.com/opendroneid/opendroneid-core-c/blob/master/libopendroneid/opendroneid.h. (uint8_t)
                timestamp                 : This field is only present for page 0. 32 bit Unix Timestamp in seconds since 00:00:00 01/01/2019. (uint32_t)
                authentication_data        : Opaque authentication data. For page 0, the size is only 17 bytes. For other pages, the size is 23 bytes. Shall be filled with nulls in the unused portion of the field. (uint8_t)

*/
    mavlink20.messages.open_drone_id_authentication = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.authentication_type , this.data_page , this.last_page_index , this.length , this.timestamp , this.authentication_data ] = moreargs;

    this._format = '<IBB20sBBBB23s';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_AUTHENTICATION;
    this.order_map = [1, 2, 3, 4, 5, 6, 7, 0, 8];
    this.len_map = [1, 1, 1, 20, 1, 1, 1, 1, 23];
    this.array_len_map = [0, 0, 0, 20, 0, 0, 0, 0, 23];
    this.crc_extra = 140;
    this._name = 'OPEN_DRONE_ID_AUTHENTICATION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'authentication_type', 'data_page', 'last_page_index', 'length', 'timestamp', 'authentication_data'];

}

mavlink20.messages.open_drone_id_authentication.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_authentication.prototype.pack = function(mav) {
    var orderedfields = [ this.timestamp, this.target_system, this.target_component, this.id_or_mac, this.authentication_type, this.data_page, this.last_page_index, this.length, this.authentication_data];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for filling the OpenDroneID Self ID message. The Self ID Message
is an opportunity for the operator to (optionally) declare their
identity and purpose of the flight. This message can provide
additional information that could reduce the threat profile of a UA
(Unmanned Aircraft) flying in a particular area or manner. This
message can also be used to provide optional additional clarification
in an emergency/remote ID system failure situation.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                description_type          : Indicates the type of the description field. (uint8_t)
                description               : Text description or numeric value expressed as ASCII characters. Shall be filled with nulls in the unused portion of the field. (char)

*/
    mavlink20.messages.open_drone_id_self_id = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.description_type , this.description ] = moreargs;

    this._format = '<BB20sB23s';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SELF_ID;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 20, 1, 1];
    this.array_len_map = [0, 0, 20, 0, 23];
    this.crc_extra = 249;
    this._name = 'OPEN_DRONE_ID_SELF_ID';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'description_type', 'description'];

}

mavlink20.messages.open_drone_id_self_id.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_self_id.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.id_or_mac, this.description_type, this.description];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for filling the OpenDroneID System message. The System Message
contains general system information including the operator
location/altitude and possible aircraft group and/or category/class
information.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                operator_location_type        : Specifies the operator location type. (uint8_t)
                classification_type        : Specifies the classification type of the UA. (uint8_t)
                operator_latitude         : Latitude of the operator. If unknown: 0 (both Lat/Lon). (int32_t)
                operator_longitude        : Longitude of the operator. If unknown: 0 (both Lat/Lon). (int32_t)
                area_count                : Number of aircraft in the area, group or formation (default 1). Used only for swarms/multiple UA. (uint16_t)
                area_radius               : Radius of the cylindrical area of the group or formation (default 0). Used only for swarms/multiple UA. (uint16_t)
                area_ceiling              : Area Operations Ceiling relative to WGS84. If unknown: -1000 m. Used only for swarms/multiple UA. (float)
                area_floor                : Area Operations Floor relative to WGS84. If unknown: -1000 m. Used only for swarms/multiple UA. (float)
                category_eu               : When classification_type is MAV_ODID_CLASSIFICATION_TYPE_EU, specifies the category of the UA. (uint8_t)
                class_eu                  : When classification_type is MAV_ODID_CLASSIFICATION_TYPE_EU, specifies the class of the UA. (uint8_t)
                operator_altitude_geo        : Geodetic altitude of the operator relative to WGS84. If unknown: -1000 m. (float)
                timestamp                 : 32 bit Unix Timestamp in seconds since 00:00:00 01/01/2019. (uint32_t)

*/
    mavlink20.messages.open_drone_id_system = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.operator_location_type , this.classification_type , this.operator_latitude , this.operator_longitude , this.area_count , this.area_radius , this.area_ceiling , this.area_floor , this.category_eu , this.class_eu , this.operator_altitude_geo , this.timestamp ] = moreargs;

    this._format = '<iifffIHHBB20sBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SYSTEM;
    this.order_map = [8, 9, 10, 11, 12, 0, 1, 6, 7, 2, 3, 13, 14, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0];
    this.crc_extra = 77;
    this._name = 'OPEN_DRONE_ID_SYSTEM';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'operator_location_type', 'classification_type', 'operator_latitude', 'operator_longitude', 'area_count', 'area_radius', 'area_ceiling', 'area_floor', 'category_eu', 'class_eu', 'operator_altitude_geo', 'timestamp'];

}

mavlink20.messages.open_drone_id_system.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_system.prototype.pack = function(mav) {
    var orderedfields = [ this.operator_latitude, this.operator_longitude, this.area_ceiling, this.area_floor, this.operator_altitude_geo, this.timestamp, this.area_count, this.area_radius, this.target_system, this.target_component, this.id_or_mac, this.operator_location_type, this.classification_type, this.category_eu, this.class_eu];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Data for filling the OpenDroneID Operator ID message, which contains
the CAA (Civil Aviation Authority) issued operator ID.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                operator_id_type          : Indicates the type of the operator_id field. (uint8_t)
                operator_id               : Text description or numeric value expressed as ASCII characters. Shall be filled with nulls in the unused portion of the field. (char)

*/
    mavlink20.messages.open_drone_id_operator_id = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.operator_id_type , this.operator_id ] = moreargs;

    this._format = '<BB20sB20s';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_OPERATOR_ID;
    this.order_map = [0, 1, 2, 3, 4];
    this.len_map = [1, 1, 20, 1, 1];
    this.array_len_map = [0, 0, 20, 0, 20];
    this.crc_extra = 49;
    this._name = 'OPEN_DRONE_ID_OPERATOR_ID';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'operator_id_type', 'operator_id'];

}

mavlink20.messages.open_drone_id_operator_id.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_operator_id.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.id_or_mac, this.operator_id_type, this.operator_id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
An OpenDroneID message pack is a container for multiple encoded
OpenDroneID messages (i.e. not in the format given for the above
message descriptions but after encoding into the compressed
OpenDroneID byte format). Used e.g. when transmitting on Bluetooth 5.0
Long Range/Extended Advertising or on WiFi Neighbor Aware Networking
or on WiFi Beacon.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                id_or_mac                 : Only used for drone ID data received from other UAs. See detailed description at https://mavlink.io/en/services/opendroneid.html. (uint8_t)
                single_message_size        : This field must currently always be equal to 25 (bytes), since all encoded OpenDroneID messages are specified to have this length. (uint8_t)
                msg_pack_size             : Number of encoded messages in the pack (not the number of bytes). Allowed range is 1 - 9. (uint8_t)
                messages                  : Concatenation of encoded OpenDroneID messages. Shall be filled with nulls in the unused portion of the field. (uint8_t)

*/
    mavlink20.messages.open_drone_id_message_pack = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.id_or_mac , this.single_message_size , this.msg_pack_size , this.messages ] = moreargs;

    this._format = '<BB20sBB225s';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_MESSAGE_PACK;
    this.order_map = [0, 1, 2, 3, 4, 5];
    this.len_map = [1, 1, 20, 1, 1, 225];
    this.array_len_map = [0, 0, 20, 0, 0, 225];
    this.crc_extra = 94;
    this._name = 'OPEN_DRONE_ID_MESSAGE_PACK';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'id_or_mac', 'single_message_size', 'msg_pack_size', 'messages'];

}

mavlink20.messages.open_drone_id_message_pack.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_message_pack.prototype.pack = function(mav) {
    var orderedfields = [ this.target_system, this.target_component, this.id_or_mac, this.single_message_size, this.msg_pack_size, this.messages];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Transmitter (remote ID system) is enabled and ready to start sending
location and other required information. This is streamed by
transmitter. A flight controller uses it as a condition to arm.

                status                    : Status level indicating if arming is allowed. (uint8_t)
                error                     : Text error message, should be empty if status is good to arm. Fill with nulls in unused portion. (char)

*/
    mavlink20.messages.open_drone_id_arm_status = function( ...moreargs ) {
    [ this.status , this.error ] = moreargs;

    this._format = '<B50s';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_ARM_STATUS;
    this.order_map = [0, 1];
    this.len_map = [1, 1];
    this.array_len_map = [0, 50];
    this.crc_extra = 139;
    this._name = 'OPEN_DRONE_ID_ARM_STATUS';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['status', 'error'];

}

mavlink20.messages.open_drone_id_arm_status.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_arm_status.prototype.pack = function(mav) {
    var orderedfields = [ this.status, this.error];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Update the data in the OPEN_DRONE_ID_SYSTEM message with new location
information. This can be sent to update the location information for
the operator when no other information in the SYSTEM message has
changed. This message allows for efficient operation on radio links
which have limited uplink bandwidth while meeting requirements for
update frequency of the operator location.

                target_system             : System ID (0 for broadcast). (uint8_t)
                target_component          : Component ID (0 for broadcast). (uint8_t)
                operator_latitude         : Latitude of the operator. If unknown: 0 (both Lat/Lon). (int32_t)
                operator_longitude        : Longitude of the operator. If unknown: 0 (both Lat/Lon). (int32_t)
                operator_altitude_geo        : Geodetic altitude of the operator relative to WGS84. If unknown: -1000 m. (float)
                timestamp                 : 32 bit Unix Timestamp in seconds since 00:00:00 01/01/2019. (uint32_t)

*/
    mavlink20.messages.open_drone_id_system_update = function( ...moreargs ) {
    [ this.target_system , this.target_component , this.operator_latitude , this.operator_longitude , this.operator_altitude_geo , this.timestamp ] = moreargs;

    this._format = '<iifIBB';
    this._id = mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SYSTEM_UPDATE;
    this.order_map = [4, 5, 0, 1, 2, 3];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0];
    this.crc_extra = 7;
    this._name = 'OPEN_DRONE_ID_SYSTEM_UPDATE';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['target_system', 'target_component', 'operator_latitude', 'operator_longitude', 'operator_altitude_geo', 'timestamp'];

}

mavlink20.messages.open_drone_id_system_update.prototype = new mavlink20.message;
mavlink20.messages.open_drone_id_system_update.prototype.pack = function(mav) {
    var orderedfields = [ this.operator_latitude, this.operator_longitude, this.operator_altitude_geo, this.timestamp, this.target_system, this.target_component];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Temperature and humidity from hygrometer.

                id                        : Hygrometer ID (uint8_t)
                temperature               : Temperature (int16_t)
                humidity                  : Humidity (uint16_t)

*/
    mavlink20.messages.hygrometer_sensor = function( ...moreargs ) {
    [ this.id , this.temperature , this.humidity ] = moreargs;

    this._format = '<hHB';
    this._id = mavlink20.MAVLINK_MSG_ID_HYGROMETER_SENSOR;
    this.order_map = [2, 0, 1];
    this.len_map = [1, 1, 1];
    this.array_len_map = [0, 0, 0];
    this.crc_extra = 20;
    this._name = 'HYGROMETER_SENSOR';

    this._instance_field = 'id';
    this._instance_offset = 4;

    this.fieldnames = ['id', 'temperature', 'humidity'];

}

mavlink20.messages.hygrometer_sensor.prototype = new mavlink20.message;
mavlink20.messages.hygrometer_sensor.prototype.pack = function(mav) {
    var orderedfields = [ this.temperature, this.humidity, this.id];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The filtered global position (e.g. fused GPS and accelerometers). The
position is in GPS-frame (right-handed, Z-up). It is designed as
scaled integer message since the resolution of float is not
sufficient.

                time_boot_ms              : Timestamp (time since system boot). (uint32_t)
                lat                       : Latitude, expressed (int32_t)
                lon                       : Longitude, expressed (int32_t)
                alt                       : Altitude (MSL). Note that virtually all GPS modules provide both WGS84 and MSL. (int32_t)
                relative_alt              : Altitude above home (int32_t)
                vx                        : Ground X Speed (Latitude, positive north) (int16_t)
                vy                        : Ground Y Speed (Longitude, positive east) (int16_t)
                vz                        : Ground Z Speed (Altitude, positive down) (int16_t)
                hdg                       : Vehicle heading (yaw angle), 0.0..359.99 degrees. If unknown, set to: UINT16_MAX (uint16_t)

*/
    mavlink20.messages.global_position_int = function( ...moreargs ) {
    [ this.time_boot_ms , this.lat , this.lon , this.alt , this.relative_alt , this.vx , this.vy , this.vz , this.hdg ] = moreargs;

    this._format = '<IiiiihhhH';
    this._id = mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_INT;
    this.order_map = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.crc_extra = 104;
    this._name = 'GLOBAL_POSITION_INT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['time_boot_ms', 'lat', 'lon', 'alt', 'relative_alt', 'vx', 'vy', 'vz', 'hdg'];

}

mavlink20.messages.global_position_int.prototype = new mavlink20.message;
mavlink20.messages.global_position_int.prototype.pack = function(mav) {
    var orderedfields = [ this.time_boot_ms, this.lat, this.lon, this.alt, this.relative_alt, this.vx, this.vy, this.vz, this.hdg];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
Version and capability of autopilot software. This should be emitted
in response to a request with MAV_CMD_REQUEST_MESSAGE.

                capabilities              : Bitmap of capabilities (uint64_t)
                flight_sw_version         : Firmware version number.
        The field must be encoded as 4 bytes, where each byte (shown from MSB to LSB) is part of a semantic version: (major) (minor) (patch) (FIRMWARE_VERSION_TYPE). (uint32_t)
                middleware_sw_version        : Middleware version number (uint32_t)
                os_sw_version             : Operating system version number (uint32_t)
                board_version             : HW / board version (last 8 bits should be silicon ID, if any). The first 16 bits of this field specify a board type from an enumeration stored at https://github.com/PX4/PX4-Bootloader/blob/master/board_types.txt and with extensive additions at https://github.com/ArduPilot/ardupilot/blob/master/Tools/AP_Bootloader/board_types.txt (uint32_t)
                flight_custom_version        : Custom version field, commonly the first 8 bytes of the git hash. This is not an unique identifier, but should allow to identify the commit using the main version number even for very large code bases. (uint8_t)
                middleware_custom_version        : Custom version field, commonly the first 8 bytes of the git hash. This is not an unique identifier, but should allow to identify the commit using the main version number even for very large code bases. (uint8_t)
                os_custom_version         : Custom version field, commonly the first 8 bytes of the git hash. This is not an unique identifier, but should allow to identify the commit using the main version number even for very large code bases. (uint8_t)
                vendor_id                 : ID of the board vendor (uint16_t)
                product_id                : ID of the product (uint16_t)
                uid                       : UID if provided by hardware (see uid2) (uint64_t)
                uid2                      : UID if provided by hardware (supersedes the uid field. If this is non-zero, use this field, otherwise use uid) (uint8_t)

*/
    mavlink20.messages.autopilot_version = function( ...moreargs ) {
    [ this.capabilities , this.flight_sw_version , this.middleware_sw_version , this.os_sw_version , this.board_version , this.flight_custom_version , this.middleware_custom_version , this.os_custom_version , this.vendor_id , this.product_id , this.uid , this.uid2 ] = moreargs;

    this._format = '<QQIIIIHH8s8s8s18s';
    this._id = mavlink20.MAVLINK_MSG_ID_AUTOPILOT_VERSION;
    this.order_map = [0, 2, 3, 4, 5, 8, 9, 10, 6, 7, 1, 11];
    this.len_map = [1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 8, 18];
    this.array_len_map = [0, 0, 0, 0, 0, 0, 0, 0, 8, 8, 8, 18];
    this.crc_extra = 178;
    this._name = 'AUTOPILOT_VERSION';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['capabilities', 'flight_sw_version', 'middleware_sw_version', 'os_sw_version', 'board_version', 'flight_custom_version', 'middleware_custom_version', 'os_custom_version', 'vendor_id', 'product_id', 'uid', 'uid2'];

}

mavlink20.messages.autopilot_version.prototype = new mavlink20.message;
mavlink20.messages.autopilot_version.prototype.pack = function(mav) {
    var orderedfields = [ this.capabilities, this.uid, this.flight_sw_version, this.middleware_sw_version, this.os_sw_version, this.board_version, this.vendor_id, this.product_id, this.flight_custom_version, this.middleware_custom_version, this.os_custom_version, this.uid2];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


/* 
The heartbeat message shows that a system or component is present and
responding. The type and autopilot fields (along with the message
component id), allow the receiving system to treat further messages
from this system appropriately (e.g. by laying out the user interface
based on the autopilot). This microservice is documented at
https://mavlink.io/en/services/heartbeat.html

                type                      : Vehicle or component type. For a flight controller component the vehicle type (quadrotor, helicopter, etc.). For other components the component type (e.g. camera, gimbal, etc.). This should be used in preference to component id for identifying the component type. (uint8_t)
                autopilot                 : Autopilot type / class. Use MAV_AUTOPILOT_INVALID for components that are not flight controllers. (uint8_t)
                base_mode                 : System mode bitmap. (uint8_t)
                custom_mode               : A bitfield for use for autopilot-specific flags (uint32_t)
                system_status             : System status flag. (uint8_t)

*/
    mavlink20.messages.heartbeat = function( ...moreargs ) {
    [ this.type , this.autopilot , this.base_mode , this.custom_mode , this.system_status ] = moreargs;
    this.mavlink_version = 3;

    this._format = '<IBBBBB';
    this._id = mavlink20.MAVLINK_MSG_ID_HEARTBEAT;
    this.order_map = [1, 2, 3, 0, 4, 5];
    this.len_map = [1, 1, 1, 1, 1, 1];
    this.array_len_map = [0, 0, 0, 0, 0, 0];
    this.crc_extra = 50;
    this._name = 'HEARTBEAT';

    this._instance_field = undefined;
    this._instance_offset = -1;

    this.fieldnames = ['type', 'autopilot', 'base_mode', 'custom_mode', 'system_status', 'mavlink_version'];

}

mavlink20.messages.heartbeat.prototype = new mavlink20.message;
mavlink20.messages.heartbeat.prototype.pack = function(mav) {
    var orderedfields = [ this.custom_mode, this.type, this.autopilot, this.base_mode, this.system_status, this.mavlink_version];
    var j = jspack.Pack(this._format, orderedfields);
    if (j === false ) throw new Error("jspack unable to handle this packet");
    return mavlink20.message.prototype.pack.call(this, mav, this.crc_extra, j );
}


mavlink20.map = {
        1: { format: '<IIIHHhHHHHHHbIII', type: mavlink20.messages.sys_status, order_map: [0, 1, 2, 3, 4, 5, 12, 6, 7, 8, 9, 10, 11, 13, 14, 15], crc_extra: 124 },
        2: { format: '<QI', type: mavlink20.messages.system_time, order_map: [0, 1], crc_extra: 137 },
        4: { format: '<QIBB', type: mavlink20.messages.ping, order_map: [0, 1, 2, 3], crc_extra: 237 },
        5: { format: '<BBB25s', type: mavlink20.messages.change_operator_control, order_map: [0, 1, 2, 3], crc_extra: 217 },
        6: { format: '<BBB', type: mavlink20.messages.change_operator_control_ack, order_map: [0, 1, 2], crc_extra: 104 },
        7: { format: '<32s', type: mavlink20.messages.auth_key, order_map: [0], crc_extra: 119 },
        8: { format: '<QIIIIIHHHBB', type: mavlink20.messages.link_node_status, order_map: [0, 9, 10, 1, 2, 6, 7, 8, 3, 4, 5], crc_extra: 117 },
        11: { format: '<IBB', type: mavlink20.messages.set_mode, order_map: [1, 2, 0], crc_extra: 89 },
        20: { format: '<hBB16s', type: mavlink20.messages.param_request_read, order_map: [1, 2, 3, 0], crc_extra: 214 },
        21: { format: '<BB', type: mavlink20.messages.param_request_list, order_map: [0, 1], crc_extra: 159 },
        22: { format: '<fHH16sB', type: mavlink20.messages.param_value, order_map: [3, 0, 4, 1, 2], crc_extra: 220 },
        23: { format: '<fBB16sB', type: mavlink20.messages.param_set, order_map: [1, 2, 3, 0, 4], crc_extra: 168 },
        24: { format: '<QiiiHHHHBBiIIIIH', type: mavlink20.messages.gps_raw_int, order_map: [0, 8, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15], crc_extra: 24 },
        25: { format: '<B20s20s20s20s20s', type: mavlink20.messages.gps_status, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 23 },
        26: { format: '<Ihhhhhhhhhh', type: mavlink20.messages.scaled_imu, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 170 },
        27: { format: '<QhhhhhhhhhBh', type: mavlink20.messages.raw_imu, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], crc_extra: 144 },
        28: { format: '<Qhhhh', type: mavlink20.messages.raw_pressure, order_map: [0, 1, 2, 3, 4], crc_extra: 67 },
        29: { format: '<Iffhh', type: mavlink20.messages.scaled_pressure, order_map: [0, 1, 2, 3, 4], crc_extra: 115 },
        30: { format: '<Iffffff', type: mavlink20.messages.attitude, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 39 },
        31: { format: '<Ifffffff4f', type: mavlink20.messages.attitude_quaternion, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 246 },
        32: { format: '<Iffffff', type: mavlink20.messages.local_position_ned, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 185 },
        34: { format: '<IhhhhhhhhBB', type: mavlink20.messages.rc_channels_scaled, order_map: [0, 9, 1, 2, 3, 4, 5, 6, 7, 8, 10], crc_extra: 237 },
        35: { format: '<IHHHHHHHHBB', type: mavlink20.messages.rc_channels_raw, order_map: [0, 9, 1, 2, 3, 4, 5, 6, 7, 8, 10], crc_extra: 244 },
        36: { format: '<IHHHHHHHHBHHHHHHHH', type: mavlink20.messages.servo_output_raw, order_map: [0, 9, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17], crc_extra: 222 },
        37: { format: '<hhBBB', type: mavlink20.messages.mission_request_partial_list, order_map: [2, 3, 0, 1, 4], crc_extra: 212 },
        38: { format: '<hhBBB', type: mavlink20.messages.mission_write_partial_list, order_map: [2, 3, 0, 1, 4], crc_extra: 9 },
        39: { format: '<fffffffHHBBBBBB', type: mavlink20.messages.mission_item, order_map: [9, 10, 7, 11, 8, 12, 13, 0, 1, 2, 3, 4, 5, 6, 14], crc_extra: 254 },
        40: { format: '<HBBB', type: mavlink20.messages.mission_request, order_map: [1, 2, 0, 3], crc_extra: 230 },
        41: { format: '<HBB', type: mavlink20.messages.mission_set_current, order_map: [1, 2, 0], crc_extra: 28 },
        42: { format: '<HHBBIII', type: mavlink20.messages.mission_current, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 28 },
        43: { format: '<BBB', type: mavlink20.messages.mission_request_list, order_map: [0, 1, 2], crc_extra: 132 },
        44: { format: '<HBBBI', type: mavlink20.messages.mission_count, order_map: [1, 2, 0, 3, 4], crc_extra: 221 },
        45: { format: '<BBB', type: mavlink20.messages.mission_clear_all, order_map: [0, 1, 2], crc_extra: 232 },
        46: { format: '<H', type: mavlink20.messages.mission_item_reached, order_map: [0], crc_extra: 11 },
        47: { format: '<BBBBI', type: mavlink20.messages.mission_ack, order_map: [0, 1, 2, 3, 4], crc_extra: 153 },
        48: { format: '<iiiBQ', type: mavlink20.messages.set_gps_global_origin, order_map: [3, 0, 1, 2, 4], crc_extra: 41 },
        49: { format: '<iiiQ', type: mavlink20.messages.gps_global_origin, order_map: [0, 1, 2, 3], crc_extra: 39 },
        50: { format: '<ffffhBB16sB', type: mavlink20.messages.param_map_rc, order_map: [5, 6, 7, 4, 8, 0, 1, 2, 3], crc_extra: 78 },
        51: { format: '<HBBB', type: mavlink20.messages.mission_request_int, order_map: [1, 2, 0, 3], crc_extra: 196 },
        54: { format: '<ffffffBBB', type: mavlink20.messages.safety_set_allowed_area, order_map: [6, 7, 8, 0, 1, 2, 3, 4, 5], crc_extra: 15 },
        55: { format: '<ffffffB', type: mavlink20.messages.safety_allowed_area, order_map: [6, 0, 1, 2, 3, 4, 5], crc_extra: 3 },
        61: { format: '<Q4ffff9f', type: mavlink20.messages.attitude_quaternion_cov, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 167 },
        62: { format: '<fffffhhH', type: mavlink20.messages.nav_controller_output, order_map: [0, 1, 5, 6, 7, 2, 3, 4], crc_extra: 183 },
        63: { format: '<Qiiiifff36fB', type: mavlink20.messages.global_position_int_cov, order_map: [0, 9, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 119 },
        64: { format: '<Qfffffffff45fB', type: mavlink20.messages.local_position_ned_cov, order_map: [0, 11, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 191 },
        65: { format: '<IHHHHHHHHHHHHHHHHHHBB', type: mavlink20.messages.rc_channels, order_map: [0, 19, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20], crc_extra: 118 },
        66: { format: '<HBBBB', type: mavlink20.messages.request_data_stream, order_map: [1, 2, 3, 0, 4], crc_extra: 148 },
        67: { format: '<HBB', type: mavlink20.messages.data_stream, order_map: [1, 0, 2], crc_extra: 21 },
        69: { format: '<hhhhHBHBhhhhhhhh', type: mavlink20.messages.manual_control, order_map: [5, 0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], crc_extra: 243 },
        70: { format: '<HHHHHHHHBBHHHHHHHHHH', type: mavlink20.messages.rc_channels_override, order_map: [8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19], crc_extra: 124 },
        73: { format: '<ffffiifHHBBBBBB', type: mavlink20.messages.mission_item_int, order_map: [9, 10, 7, 11, 8, 12, 13, 0, 1, 2, 3, 4, 5, 6, 14], crc_extra: 38 },
        74: { format: '<ffffhH', type: mavlink20.messages.vfr_hud, order_map: [0, 1, 4, 5, 2, 3], crc_extra: 20 },
        75: { format: '<ffffiifHBBBBB', type: mavlink20.messages.command_int, order_map: [8, 9, 10, 7, 11, 12, 0, 1, 2, 3, 4, 5, 6], crc_extra: 158 },
        76: { format: '<fffffffHBBB', type: mavlink20.messages.command_long, order_map: [8, 9, 7, 10, 0, 1, 2, 3, 4, 5, 6], crc_extra: 152 },
        77: { format: '<HBBiBB', type: mavlink20.messages.command_ack, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 143 },
        80: { format: '<HBB', type: mavlink20.messages.command_cancel, order_map: [1, 2, 0], crc_extra: 14 },
        81: { format: '<IffffBB', type: mavlink20.messages.manual_setpoint, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 106 },
        82: { format: '<I4fffffBBB3f', type: mavlink20.messages.set_attitude_target, order_map: [0, 6, 7, 8, 1, 2, 3, 4, 5, 9], crc_extra: 49 },
        83: { format: '<I4fffffB', type: mavlink20.messages.attitude_target, order_map: [0, 6, 1, 2, 3, 4, 5], crc_extra: 22 },
        84: { format: '<IfffffffffffHBBB', type: mavlink20.messages.set_position_target_local_ned, order_map: [0, 13, 14, 15, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], crc_extra: 143 },
        85: { format: '<IfffffffffffHB', type: mavlink20.messages.position_target_local_ned, order_map: [0, 13, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], crc_extra: 140 },
        86: { format: '<IiifffffffffHBBB', type: mavlink20.messages.set_position_target_global_int, order_map: [0, 13, 14, 15, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], crc_extra: 5 },
        87: { format: '<IiifffffffffHB', type: mavlink20.messages.position_target_global_int, order_map: [0, 13, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], crc_extra: 150 },
        89: { format: '<Iffffff', type: mavlink20.messages.local_position_ned_system_global_offset, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 231 },
        90: { format: '<Qffffffiiihhhhhh', type: mavlink20.messages.hil_state, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], crc_extra: 183 },
        91: { format: '<QffffffffBB', type: mavlink20.messages.hil_controls, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 63 },
        92: { format: '<QHHHHHHHHHHHHB', type: mavlink20.messages.hil_rc_inputs_raw, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], crc_extra: 54 },
        93: { format: '<QQ16fB', type: mavlink20.messages.hil_actuator_controls, order_map: [0, 2, 3, 1], crc_extra: 47 },
        100: { format: '<QfffhhBBff', type: mavlink20.messages.optical_flow, order_map: [0, 6, 4, 5, 1, 2, 7, 3, 8, 9], crc_extra: 175 },
        101: { format: '<Qffffff21fB', type: mavlink20.messages.global_vision_position_estimate, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 102 },
        102: { format: '<Qffffff21fB', type: mavlink20.messages.vision_position_estimate, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 158 },
        103: { format: '<Qfff9fB', type: mavlink20.messages.vision_speed_estimate, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 208 },
        104: { format: '<Qffffff21f', type: mavlink20.messages.vicon_position_estimate, order_map: [0, 1, 2, 3, 4, 5, 6, 7], crc_extra: 56 },
        105: { format: '<QfffffffffffffHB', type: mavlink20.messages.highres_imu, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], crc_extra: 93 },
        106: { format: '<QIfffffIfhBB', type: mavlink20.messages.optical_flow_rad, order_map: [0, 10, 1, 2, 3, 4, 5, 6, 9, 11, 7, 8], crc_extra: 138 },
        107: { format: '<QfffffffffffffIB', type: mavlink20.messages.hil_sensor, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], crc_extra: 108 },
        108: { format: '<fffffffffffffffffffffii', type: mavlink20.messages.sim_state, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22], crc_extra: 32 },
        109: { format: '<HHBBBBB', type: mavlink20.messages.radio_status, order_map: [2, 3, 4, 5, 6, 0, 1], crc_extra: 185 },
        110: { format: '<BBB251s', type: mavlink20.messages.file_transfer_protocol, order_map: [0, 1, 2, 3], crc_extra: 84 },
        111: { format: '<qqBB', type: mavlink20.messages.timesync, order_map: [0, 1, 2, 3], crc_extra: 34 },
        112: { format: '<QI', type: mavlink20.messages.camera_trigger, order_map: [0, 1], crc_extra: 174 },
        113: { format: '<QiiiHHHhhhHBBBH', type: mavlink20.messages.hil_gps, order_map: [0, 11, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14], crc_extra: 124 },
        114: { format: '<QIfffffIfhBB', type: mavlink20.messages.hil_optical_flow, order_map: [0, 10, 1, 2, 3, 4, 5, 6, 9, 11, 7, 8], crc_extra: 237 },
        115: { format: '<Q4ffffiiihhhHHhhh', type: mavlink20.messages.hil_state_quaternion, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], crc_extra: 4 },
        116: { format: '<Ihhhhhhhhhh', type: mavlink20.messages.scaled_imu2, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 76 },
        117: { format: '<HHBB', type: mavlink20.messages.log_request_list, order_map: [2, 3, 0, 1], crc_extra: 128 },
        118: { format: '<IIHHH', type: mavlink20.messages.log_entry, order_map: [2, 3, 4, 0, 1], crc_extra: 56 },
        119: { format: '<IIHBB', type: mavlink20.messages.log_request_data, order_map: [3, 4, 2, 0, 1], crc_extra: 116 },
        120: { format: '<IHB90s', type: mavlink20.messages.log_data, order_map: [1, 0, 2, 3], crc_extra: 134 },
        121: { format: '<BB', type: mavlink20.messages.log_erase, order_map: [0, 1], crc_extra: 237 },
        122: { format: '<BB', type: mavlink20.messages.log_request_end, order_map: [0, 1], crc_extra: 203 },
        123: { format: '<BBB110s', type: mavlink20.messages.gps_inject_data, order_map: [0, 1, 2, 3], crc_extra: 250 },
        124: { format: '<QiiiIHHHHBBBHiIIII', type: mavlink20.messages.gps2_raw, order_map: [0, 9, 1, 2, 3, 5, 6, 7, 8, 10, 11, 4, 12, 13, 14, 15, 16, 17], crc_extra: 87 },
        125: { format: '<HHH', type: mavlink20.messages.power_status, order_map: [0, 1, 2], crc_extra: 203 },
        126: { format: '<IHBBB70sBB', type: mavlink20.messages.serial_control, order_map: [2, 3, 1, 0, 4, 5, 6, 7], crc_extra: 220 },
        127: { format: '<IIiiiIiHBBBBB', type: mavlink20.messages.gps_rtk, order_map: [0, 8, 7, 1, 9, 10, 11, 12, 2, 3, 4, 5, 6], crc_extra: 25 },
        128: { format: '<IIiiiIiHBBBBB', type: mavlink20.messages.gps2_rtk, order_map: [0, 8, 7, 1, 9, 10, 11, 12, 2, 3, 4, 5, 6], crc_extra: 226 },
        129: { format: '<Ihhhhhhhhhh', type: mavlink20.messages.scaled_imu3, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 46 },
        130: { format: '<IHHHBBB', type: mavlink20.messages.data_transmission_handshake, order_map: [4, 0, 1, 2, 3, 5, 6], crc_extra: 29 },
        131: { format: '<H253s', type: mavlink20.messages.encapsulated_data, order_map: [0, 1], crc_extra: 223 },
        132: { format: '<IHHHBBBBff4fB', type: mavlink20.messages.distance_sensor, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], crc_extra: 85 },
        133: { format: '<QiiH', type: mavlink20.messages.terrain_request, order_map: [1, 2, 3, 0], crc_extra: 6 },
        134: { format: '<iiH16hB', type: mavlink20.messages.terrain_data, order_map: [0, 1, 2, 4, 3], crc_extra: 229 },
        135: { format: '<ii', type: mavlink20.messages.terrain_check, order_map: [0, 1], crc_extra: 203 },
        136: { format: '<iiffHHH', type: mavlink20.messages.terrain_report, order_map: [0, 1, 4, 2, 3, 5, 6], crc_extra: 1 },
        137: { format: '<Iffhh', type: mavlink20.messages.scaled_pressure2, order_map: [0, 1, 2, 3, 4], crc_extra: 195 },
        138: { format: '<Q4ffff21f', type: mavlink20.messages.att_pos_mocap, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 109 },
        139: { format: '<Q8fBBB', type: mavlink20.messages.set_actuator_control_target, order_map: [0, 2, 3, 4, 1], crc_extra: 168 },
        140: { format: '<Q8fB', type: mavlink20.messages.actuator_control_target, order_map: [0, 2, 1], crc_extra: 181 },
        141: { format: '<Qffffff', type: mavlink20.messages.altitude, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 47 },
        142: { format: '<BB120sB120s', type: mavlink20.messages.resource_request, order_map: [0, 1, 2, 3, 4], crc_extra: 72 },
        143: { format: '<Iffhh', type: mavlink20.messages.scaled_pressure3, order_map: [0, 1, 2, 3, 4], crc_extra: 131 },
        144: { format: '<QQiif3f3f4f3f3fB', type: mavlink20.messages.follow_target, order_map: [0, 10, 2, 3, 4, 5, 6, 7, 8, 9, 1], crc_extra: 127 },
        146: { format: '<Qffffffffff3f3f4ffff', type: mavlink20.messages.control_system_state, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16], crc_extra: 103 },
        147: { format: '<iih10HhBBBbiB4HBI', type: mavlink20.messages.battery_status, order_map: [5, 6, 7, 2, 3, 4, 0, 1, 8, 9, 10, 11, 12, 13], crc_extra: 154 },
        149: { format: '<QfffffBBfff4fBB', type: mavlink20.messages.landing_target, order_map: [0, 6, 7, 1, 2, 3, 4, 5, 8, 9, 10, 11, 12, 13], crc_extra: 200 },
        162: { format: '<IHBBB', type: mavlink20.messages.fence_status, order_map: [2, 1, 3, 0, 4], crc_extra: 189 },
        191: { format: '<fffBBBBB10B', type: mavlink20.messages.mag_cal_progress, order_map: [3, 4, 5, 6, 7, 8, 0, 1, 2], crc_extra: 92 },
        192: { format: '<ffffffffffBBBBfBBf', type: mavlink20.messages.mag_cal_report, order_map: [10, 11, 12, 13, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 14, 15, 16, 17], crc_extra: 36 },
        225: { format: '<ffffffffffffffffBff', type: mavlink20.messages.efi_status, order_map: [16, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17, 18], crc_extra: 208 },
        230: { format: '<QffffffffH', type: mavlink20.messages.estimator_status, order_map: [0, 9, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 163 },
        231: { format: '<Qffffffff', type: mavlink20.messages.wind_cov, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 105 },
        232: { format: '<QIiifffffffffHHBBBH', type: mavlink20.messages.gps_input, order_map: [0, 15, 13, 1, 14, 16, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 17, 18], crc_extra: 151 },
        233: { format: '<BB180s', type: mavlink20.messages.gps_rtcm_data, order_map: [0, 1, 2], crc_extra: 35 },
        234: { format: '<IiihhHhhhHBBbBBBbBBBbbBB', type: mavlink20.messages.high_latency, order_map: [10, 0, 11, 3, 4, 5, 12, 6, 1, 2, 7, 8, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 9], crc_extra: 150 },
        235: { format: '<IiiHhhHHHBBBBBBBBBBBBbbbbbb', type: mavlink20.messages.high_latency2, order_map: [0, 9, 10, 3, 1, 2, 4, 5, 11, 12, 6, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 7, 8, 24, 25, 26], crc_extra: 179 },
        241: { format: '<QfffIII', type: mavlink20.messages.vibration, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 90 },
        242: { format: '<iiifff4ffffQ', type: mavlink20.messages.home_position, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 104 },
        243: { format: '<iiifff4ffffBQ', type: mavlink20.messages.set_home_position, order_map: [10, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11], crc_extra: 85 },
        244: { format: '<iH', type: mavlink20.messages.message_interval, order_map: [1, 0], crc_extra: 95 },
        245: { format: '<BB', type: mavlink20.messages.extended_sys_state, order_map: [0, 1], crc_extra: 130 },
        246: { format: '<IiiiHHhHHB9sBB', type: mavlink20.messages.adsb_vehicle, order_map: [0, 1, 2, 9, 3, 4, 5, 6, 10, 11, 12, 7, 8], crc_extra: 184 },
        247: { format: '<IfffBBB', type: mavlink20.messages.collision, order_map: [4, 0, 5, 6, 1, 2, 3], crc_extra: 81 },
        248: { format: '<HBBB249s', type: mavlink20.messages.v2_extension, order_map: [1, 2, 3, 0, 4], crc_extra: 8 },
        249: { format: '<HBB32s', type: mavlink20.messages.memory_vect, order_map: [0, 1, 2, 3], crc_extra: 204 },
        250: { format: '<Qfff10s', type: mavlink20.messages.debug_vect, order_map: [4, 0, 1, 2, 3], crc_extra: 49 },
        251: { format: '<If10s', type: mavlink20.messages.named_value_float, order_map: [0, 2, 1], crc_extra: 170 },
        252: { format: '<Ii10s', type: mavlink20.messages.named_value_int, order_map: [0, 2, 1], crc_extra: 44 },
        253: { format: '<B50sHB', type: mavlink20.messages.statustext, order_map: [0, 1, 2, 3], crc_extra: 83 },
        254: { format: '<IfB', type: mavlink20.messages.debug, order_map: [0, 2, 1], crc_extra: 46 },
        256: { format: '<QBB32s', type: mavlink20.messages.setup_signing, order_map: [1, 2, 3, 0], crc_extra: 71 },
        257: { format: '<IIB', type: mavlink20.messages.button_change, order_map: [0, 1, 2], crc_extra: 131 },
        258: { format: '<BB30s200s', type: mavlink20.messages.play_tune, order_map: [0, 1, 2, 3], crc_extra: 187 },
        259: { format: '<IIfffIHHH32s32sB140sBB', type: mavlink20.messages.camera_information, order_map: [0, 9, 10, 1, 2, 3, 4, 6, 7, 11, 5, 8, 12, 13, 14], crc_extra: 92 },
        260: { format: '<IBffB', type: mavlink20.messages.camera_settings, order_map: [0, 1, 2, 3, 4], crc_extra: 146 },
        261: { format: '<IfffffBBBB32sB', type: mavlink20.messages.storage_information, order_map: [0, 6, 7, 8, 1, 2, 3, 4, 5, 9, 10, 11], crc_extra: 179 },
        262: { format: '<IfIfBBiB', type: mavlink20.messages.camera_capture_status, order_map: [0, 4, 5, 1, 2, 3, 6, 7], crc_extra: 12 },
        263: { format: '<QIiiii4fiBb205s', type: mavlink20.messages.camera_image_captured, order_map: [1, 0, 8, 2, 3, 4, 5, 6, 7, 9, 10], crc_extra: 133 },
        264: { format: '<QQQII', type: mavlink20.messages.flight_information, order_map: [3, 0, 1, 2, 4], crc_extra: 49 },
        265: { format: '<Iffff', type: mavlink20.messages.mount_orientation, order_map: [0, 1, 2, 3, 4], crc_extra: 26 },
        266: { format: '<HBBBB249s', type: mavlink20.messages.logging_data, order_map: [1, 2, 0, 3, 4, 5], crc_extra: 193 },
        267: { format: '<HBBBB249s', type: mavlink20.messages.logging_data_acked, order_map: [1, 2, 0, 3, 4, 5], crc_extra: 35 },
        268: { format: '<HBB', type: mavlink20.messages.logging_ack, order_map: [1, 2, 0], crc_extra: 14 },
        269: { format: '<fIHHHHHBBB32s160sBB', type: mavlink20.messages.video_stream_information, order_map: [7, 8, 9, 2, 0, 3, 4, 1, 5, 6, 10, 11, 12, 13], crc_extra: 109 },
        270: { format: '<fIHHHHHBB', type: mavlink20.messages.video_stream_status, order_map: [7, 2, 0, 3, 4, 1, 5, 6, 8], crc_extra: 59 },
        271: { format: '<Iiiiiii4fffB', type: mavlink20.messages.camera_fov_status, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], crc_extra: 22 },
        275: { format: '<fffffffBBBB', type: mavlink20.messages.camera_tracking_image_status, order_map: [7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 10], crc_extra: 126 },
        276: { format: '<iiffffffffffBB', type: mavlink20.messages.camera_tracking_geo_status, order_map: [12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13], crc_extra: 18 },
        277: { format: '<IffffffBB', type: mavlink20.messages.camera_thermal_range, order_map: [0, 7, 8, 1, 2, 3, 4, 5, 6], crc_extra: 62 },
        280: { format: '<IIffffffB', type: mavlink20.messages.gimbal_manager_information, order_map: [0, 1, 8, 2, 3, 4, 5, 6, 7], crc_extra: 70 },
        281: { format: '<IIBBBBB', type: mavlink20.messages.gimbal_manager_status, order_map: [0, 1, 2, 3, 4, 5, 6], crc_extra: 48 },
        282: { format: '<I4ffffBBB', type: mavlink20.messages.gimbal_manager_set_attitude, order_map: [5, 6, 0, 7, 1, 2, 3, 4], crc_extra: 123 },
        283: { format: '<QIIIffffffHH32s32s32sBI', type: mavlink20.messages.gimbal_device_information, order_map: [1, 12, 13, 14, 2, 3, 0, 10, 11, 4, 5, 6, 7, 8, 9, 15, 16], crc_extra: 74 },
        284: { format: '<4ffffHBB', type: mavlink20.messages.gimbal_device_set_attitude, order_map: [5, 6, 4, 0, 1, 2, 3], crc_extra: 99 },
        285: { format: '<I4ffffIHBBffB', type: mavlink20.messages.gimbal_device_attitude_status, order_map: [7, 8, 0, 6, 1, 2, 3, 4, 5, 9, 10, 11], crc_extra: 137 },
        286: { format: '<Q4fIfffIfHBBBf', type: mavlink20.messages.autopilot_state_for_gimbal_device, order_map: [9, 10, 0, 1, 2, 3, 4, 5, 6, 7, 8, 11, 12], crc_extra: 210 },
        287: { format: '<IffffBBB', type: mavlink20.messages.gimbal_manager_set_pitchyaw, order_map: [5, 6, 0, 7, 1, 2, 3, 4], crc_extra: 1 },
        288: { format: '<IffffBBB', type: mavlink20.messages.gimbal_manager_set_manual_control, order_map: [5, 6, 0, 7, 1, 2, 3, 4], crc_extra: 20 },
        290: { format: '<Q4IH4H4hBBBB', type: mavlink20.messages.esc_info, order_map: [5, 0, 2, 6, 7, 8, 3, 1, 4], crc_extra: 251 },
        291: { format: '<Q4i4f4fB', type: mavlink20.messages.esc_status, order_map: [4, 0, 1, 2, 3], crc_extra: 10 },
        295: { format: '<ffhBB', type: mavlink20.messages.airspeed, order_map: [3, 0, 2, 1, 4], crc_extra: 234 },
        296: { format: '<QIiiffffBBBBB', type: mavlink20.messages.global_position_sensor, order_map: [8, 9, 10, 0, 1, 11, 12, 2, 3, 4, 5, 6, 7], crc_extra: 158 },
        299: { format: '<32s64sbb', type: mavlink20.messages.wifi_config_ap, order_map: [0, 1, 2, 3], crc_extra: 19 },
        300: { format: '<HHH8s8s', type: mavlink20.messages.protocol_version, order_map: [0, 1, 2, 3, 4], crc_extra: 217 },
        301: { format: '<IiiHHHHHHHbBBBB7s20s', type: mavlink20.messages.ais_vessel, order_map: [0, 1, 2, 3, 4, 5, 10, 11, 12, 6, 7, 13, 14, 15, 16, 8, 9], crc_extra: 243 },
        310: { format: '<QIHBBB', type: mavlink20.messages.uavcan_node_status, order_map: [0, 1, 3, 4, 5, 2], crc_extra: 28 },
        311: { format: '<QII80sBB16sBB', type: mavlink20.messages.uavcan_node_info, order_map: [0, 1, 3, 4, 5, 6, 7, 8, 2], crc_extra: 95 },
        320: { format: '<hBB16s', type: mavlink20.messages.param_ext_request_read, order_map: [1, 2, 3, 0], crc_extra: 243 },
        321: { format: '<BB', type: mavlink20.messages.param_ext_request_list, order_map: [0, 1], crc_extra: 88 },
        322: { format: '<HH16s128sB', type: mavlink20.messages.param_ext_value, order_map: [2, 3, 4, 0, 1], crc_extra: 243 },
        323: { format: '<BB16s128sB', type: mavlink20.messages.param_ext_set, order_map: [0, 1, 2, 3, 4], crc_extra: 78 },
        324: { format: '<16s128sBB', type: mavlink20.messages.param_ext_ack, order_map: [0, 1, 2, 3], crc_extra: 132 },
        330: { format: '<Q72HHHBBffB', type: mavlink20.messages.obstacle_distance, order_map: [0, 4, 1, 5, 2, 3, 6, 7, 8], crc_extra: 23 },
        331: { format: '<Qfff4fffffff21f21fBBBBb', type: mavlink20.messages.odometry, order_map: [0, 13, 14, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17], crc_extra: 91 },
        332: { format: '<Q5f5f5f5f5f5f5f5f5f5f5f5HB', type: mavlink20.messages.trajectory_representation_waypoints, order_map: [0, 13, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], crc_extra: 236 },
        333: { format: '<Q5f5f5f5f5fB', type: mavlink20.messages.trajectory_representation_bezier, order_map: [0, 6, 1, 2, 3, 4, 5], crc_extra: 231 },
        334: { format: '<HHHBBBBBII9sBfIffff', type: mavlink20.messages.cellular_status, order_map: [3, 4, 5, 6, 0, 1, 2, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], crc_extra: 72 },
        335: { format: '<QQHHBBBB', type: mavlink20.messages.isbd_link_status, order_map: [0, 1, 2, 3, 4, 5, 6, 7], crc_extra: 225 },
        336: { format: '<BB16s16s32s16sBB', type: mavlink20.messages.cellular_config, order_map: [0, 1, 2, 3, 4, 5, 6, 7], crc_extra: 245 },
        339: { format: '<fB', type: mavlink20.messages.raw_rpm, order_map: [1, 0], crc_extra: 199 },
        340: { format: '<QiiiiiiihhhHHHH18sBB', type: mavlink20.messages.utm_global_position, order_map: [0, 15, 1, 2, 3, 4, 8, 9, 10, 11, 12, 13, 5, 6, 7, 14, 16, 17], crc_extra: 99 },
        345: { format: '<hBB16sB', type: mavlink20.messages.param_error, order_map: [1, 2, 3, 0, 4], crc_extra: 209 },
        350: { format: '<QH10s58f', type: mavlink20.messages.debug_float_array, order_map: [0, 2, 1, 3], crc_extra: 232 },
        360: { format: '<QfiifB', type: mavlink20.messages.orbit_execution_status, order_map: [0, 1, 5, 2, 3, 4], crc_extra: 11 },
        370: { format: '<iiHHHHHBBB16s50sHBII11s', type: mavlink20.messages.smart_battery_info, order_map: [7, 8, 9, 0, 1, 2, 10, 11, 3, 4, 5, 6, 12, 13, 14, 15, 16], crc_extra: 75 },
        361: { format: '<QfffiifB', type: mavlink20.messages.figure_eight_execution_status, order_map: [0, 1, 2, 3, 7, 4, 5, 6], crc_extra: 93 },
        371: { format: '<fffffIBB', type: mavlink20.messages.fuel_status, order_map: [6, 0, 1, 2, 7, 3, 4, 5], crc_extra: 10 },
        372: { format: '<ffffffffffHHBBBBB9s32s50s', type: mavlink20.messages.battery_info, order_map: [12, 13, 14, 15, 16, 10, 11, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 17, 18, 19], crc_extra: 26 },
        373: { format: '<QfffffIiHhh', type: mavlink20.messages.generator_status, order_map: [0, 8, 1, 2, 3, 4, 9, 5, 10, 6, 7], crc_extra: 117 },
        375: { format: '<QI32f', type: mavlink20.messages.actuator_output_status, order_map: [0, 1, 2], crc_extra: 251 },
        376: { format: '<IHH', type: mavlink20.messages.relay_status, order_map: [0, 1, 2], crc_extra: 199 },
        380: { format: '<iiiii', type: mavlink20.messages.time_estimate_to_target, order_map: [0, 1, 2, 3, 4], crc_extra: 232 },
        385: { format: '<HBBB128s', type: mavlink20.messages.tunnel, order_map: [1, 2, 0, 3, 4], crc_extra: 147 },
        386: { format: '<IBBBB8s', type: mavlink20.messages.can_frame, order_map: [1, 2, 3, 4, 0, 5], crc_extra: 132 },
        387: { format: '<IBBBB64s', type: mavlink20.messages.canfd_frame, order_map: [1, 2, 3, 4, 0, 5], crc_extra: 4 },
        388: { format: '<16HBBBBB', type: mavlink20.messages.can_filter_modify, order_map: [1, 2, 3, 4, 5, 0], crc_extra: 8 },
        390: { format: '<QIII4I4I4I6I6I6I6I6I4hB8s10s4s10sb8sH', type: mavlink20.messages.onboard_computer_status, order_map: [0, 1, 13, 14, 15, 16, 17, 18, 19, 12, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 20], crc_extra: 156 },
        395: { format: '<III100s100s', type: mavlink20.messages.component_information, order_map: [0, 1, 3, 2, 4], crc_extra: 0 },
        396: { format: '<QII32s32s24s24s32s', type: mavlink20.messages.component_information_basic, order_map: [1, 0, 2, 3, 4, 5, 6, 7], crc_extra: 50 },
        397: { format: '<II100s', type: mavlink20.messages.component_metadata, order_map: [0, 1, 2], crc_extra: 182 },
        400: { format: '<IBB248s', type: mavlink20.messages.play_tune_v2, order_map: [1, 2, 0, 3], crc_extra: 110 },
        401: { format: '<IBB', type: mavlink20.messages.supported_tunes, order_map: [1, 2, 0], crc_extra: 183 },
        410: { format: '<IIHBBB40s', type: mavlink20.messages.event, order_map: [3, 4, 0, 1, 2, 5, 6], crc_extra: 160 },
        411: { format: '<HB', type: mavlink20.messages.current_event_sequence, order_map: [0, 1], crc_extra: 106 },
        412: { format: '<HHBB', type: mavlink20.messages.request_event, order_map: [2, 3, 0, 1], crc_extra: 33 },
        413: { format: '<HHBBB', type: mavlink20.messages.response_event_error, order_map: [2, 3, 0, 1, 4], crc_extra: 77 },
        435: { format: '<IIBBB35s', type: mavlink20.messages.available_modes, order_map: [2, 3, 4, 0, 1, 5], crc_extra: 134 },
        436: { format: '<IIB', type: mavlink20.messages.current_mode, order_map: [2, 0, 1], crc_extra: 193 },
        437: { format: '<B', type: mavlink20.messages.available_modes_monitor, order_map: [0], crc_extra: 30 },
        440: { format: '<IIffffffBBB', type: mavlink20.messages.illuminator_status, order_map: [0, 8, 9, 1, 10, 2, 3, 4, 5, 6, 7], crc_extra: 66 },
        9000: { format: '<Q16dB', type: mavlink20.messages.wheel_distance, order_map: [0, 2, 1], crc_extra: 113 },
        9005: { format: '<QfffffIh', type: mavlink20.messages.winch_status, order_map: [0, 1, 2, 3, 4, 5, 7, 6], crc_extra: 117 },
        12900: { format: '<BB20sBB20s', type: mavlink20.messages.open_drone_id_basic_id, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 114 },
        12901: { format: '<iiffffHHhBB20sBBBBBBB', type: mavlink20.messages.open_drone_id_location, order_map: [9, 10, 11, 12, 6, 7, 8, 0, 1, 2, 3, 13, 4, 14, 15, 16, 17, 5, 18], crc_extra: 254 },
        12902: { format: '<IBB20sBBBB23s', type: mavlink20.messages.open_drone_id_authentication, order_map: [1, 2, 3, 4, 5, 6, 7, 0, 8], crc_extra: 140 },
        12903: { format: '<BB20sB23s', type: mavlink20.messages.open_drone_id_self_id, order_map: [0, 1, 2, 3, 4], crc_extra: 249 },
        12904: { format: '<iifffIHHBB20sBBBB', type: mavlink20.messages.open_drone_id_system, order_map: [8, 9, 10, 11, 12, 0, 1, 6, 7, 2, 3, 13, 14, 4, 5], crc_extra: 77 },
        12905: { format: '<BB20sB20s', type: mavlink20.messages.open_drone_id_operator_id, order_map: [0, 1, 2, 3, 4], crc_extra: 49 },
        12915: { format: '<BB20sBB225s', type: mavlink20.messages.open_drone_id_message_pack, order_map: [0, 1, 2, 3, 4, 5], crc_extra: 94 },
        12918: { format: '<B50s', type: mavlink20.messages.open_drone_id_arm_status, order_map: [0, 1], crc_extra: 139 },
        12919: { format: '<iifIBB', type: mavlink20.messages.open_drone_id_system_update, order_map: [4, 5, 0, 1, 2, 3], crc_extra: 7 },
        12920: { format: '<hHB', type: mavlink20.messages.hygrometer_sensor, order_map: [2, 0, 1], crc_extra: 20 },
        33: { format: '<IiiiihhhH', type: mavlink20.messages.global_position_int, order_map: [0, 1, 2, 3, 4, 5, 6, 7, 8], crc_extra: 104 },
        148: { format: '<QQIIIIHH8s8s8s18s', type: mavlink20.messages.autopilot_version, order_map: [0, 2, 3, 4, 5, 8, 9, 10, 6, 7, 1, 11], crc_extra: 178 },
        0: { format: '<IBBBBB', type: mavlink20.messages.heartbeat, order_map: [1, 2, 3, 0, 4, 5], crc_extra: 50 },
}


// Special mavlink message to capture malformed data packets for debugging
mavlink20.messages.bad_data = function(data, reason) {
    this._id = mavlink20.MAVLINK_MSG_ID_BAD_DATA;
    this._data = data;
    this._reason = reason;
    this._msgbuf = data;
}
mavlink20.messages.bad_data.prototype = new mavlink20.message;

//  MAVLink signing state class
MAVLinkSigning = function MAVLinkSigning(object){
        this.secret_key = new Uint8Array();
        this.timestamp = 1;
        this.link_id = 0;
        this.sign_outgoing = false; // todo false this
        this.allow_unsigned_callback = undefined;
        this.stream_timestamps = {};
        this.sig_count = 0;
        this.badsig_count = 0;
        this.goodsig_count = 0;
        this.unsigned_count = 0;
        this.reject_count = 0;
}

/* MAVLink protocol handling class */
MAVLink20Processor = function(logger, srcSystem, srcComponent) {

    this.logger = logger;

    this.seq = 0;
    this.buf = new Uint8Array();
    this.bufInError = new Uint8Array();

    this.srcSystem = (typeof srcSystem === 'undefined') ? 0 : srcSystem;
    this.srcComponent =  (typeof srcComponent === 'undefined') ? 0 : srcComponent;

    this.have_prefix_error = false;

    // The first packet we expect is a valid header, 6 bytes.
    this.protocol_marker = 253;
    this.expected_length = mavlink20.HEADER_LEN;
    this.little_endian = true;

    this.crc_extra = true;
    this.sort_fields = true;
    this.total_packets_sent = 0;
    this.total_bytes_sent = 0;
    this.total_packets_received = 0;
    this.total_bytes_received = 0;
    this.total_receive_errors = 0;
    this.startup_time = Date.now();

    // optional , but when used we store signing state in this object:
    this.signing = new MAVLinkSigning();
}

if (!isNode) {
    // Browser-compatible util.inherits replacement
    MAVLink20Processor.prototype = Object.create(events.EventEmitter.prototype);
    MAVLink20Processor.prototype.constructor = MAVLink20Processor;
} else {
    // Implements EventEmitter
    util.inherits(MAVLink20Processor, events.EventEmitter);
}

// If the logger exists, this function will add a message to it.
// Assumes the logger is a winston object.
MAVLink20Processor.prototype.log = function(message) {
    if(this.logger) {
        this.logger.info(message);
    }
}

MAVLink20Processor.prototype.log = function(level, message) {
    if(this.logger) {
        this.logger.log(level, message);
    }
}

MAVLink20Processor.prototype.send = function(mavmsg) {
    buf = mavmsg.pack(this);
    this.file.write(buf);
    this.seq = (this.seq + 1) % 256;
    this.total_packets_sent +=1;
    this.total_bytes_sent += buf.length;
}

// return number of bytes needed for next parsing stage
MAVLink20Processor.prototype.bytes_needed = function() {
    ret = this.expected_length - this.buf.length;
    return ( ret <= 0 ) ? 1 : ret;
}

// Combine two buffers into one
MAVLink20Processor.prototype.concat_buffer = function(A, B) {
    const out = new Uint8Array(A.length + B.length)
    out.set(A, 0)
    out.set(B, A.length)
    return out
}

// add data to the local buffer
MAVLink20Processor.prototype.pushBuffer = function(data) {
    if (typeof data.length === 'undefined') {
       data = [data];
    }
    this.buf = this.concat_buffer(this.buf, data);
    this.total_bytes_received += data.length;
}

// Decode prefix.  Elides the prefix.
MAVLink20Processor.prototype.parsePrefix = function() {

    // Test for a message prefix.
    if( this.buf.length >= 1 &&
        this.buf[0] != mavlink20.PROTOCOL_MARKER_V2 &&
        this.buf[0] != mavlink20.PROTOCOL_MARKER_V1) {

        // Strip the offending initial bytes and throw an error.
        var badPrefix = this.buf[0];
        var idx1 = this.buf.indexOf(mavlink20.PROTOCOL_MARKER_V1);
        var idx2 = this.buf.indexOf(mavlink20.PROTOCOL_MARKER_V2);
        if (idx1 == -1) {
            idx1 = idx2;
        }
        if (idx1 == -1 && idx2 == -1) {
            this.bufInError = this.buf;
            this.buf = new Uint8Array();
        } else {
            this.bufInError = this.buf.slice(0,idx1);
            this.buf = this.buf.slice(idx1);
        }
        this.expected_length = mavlink20.HEADER_LEN; //initially we 'expect' at least the length of the header, later parseLength corrects for this. 
        throw new Error("Bad prefix ("+badPrefix+")");
    }

}

// Determine the length.  Leaves buffer untouched.
// Although the 'len' of a packet is available as of the second byte, the third byte with 'incompat_flags' lets
//  us know if we have signing enabled, which affects the real-world length by the signature-block length of 13 bytes.
// once successful, 'this.expected_length' is correctly set for the whole packet.
MAVLink20Processor.prototype.parseLength = function() {

    if( this.buf.length >= 3 ) {
        var unpacked = jspack.Unpack('BBB', this.buf.slice(0, 3));
        var magic = unpacked[0]; // stx ie fd or fe etc
        this.expected_length = unpacked[1] + mavlink20.HEADER_LEN + 2 // length of message + header + CRC (ie non-signed length)
        this.incompat_flags = unpacked[2];
        // mavlink2 only..  in mavlink1, incompat_flags var above is actually the 'seq', but for this test its ok.
        if ((magic == mavlink20.PROTOCOL_MARKER_V2 ) && ( this.incompat_flags & mavlink20.MAVLINK_IFLAG_SIGNED )){
            this.expected_length += mavlink20.MAVLINK_SIGNATURE_BLOCK_LEN;
        }
    }

}

// input some data bytes, possibly returning a new message - python equiv function is called parse_char / __parse_char_legacy
// c can be null to process any remaining data in the input buffer from a previous call
MAVLink20Processor.prototype.parseChar = function(c) {

    var m = null;

    try {
        if (c != null) {
            this.pushBuffer(c);
        }
        this.parsePrefix();
        this.parseLength();
        m = this.parsePayload();

    } catch(e) {
        this.log('error', e.message);
        this.total_receive_errors += 1;
        m = new mavlink20.messages.bad_data(this.bufInError, e.message);
        this.bufInError = new Uint8Array();

    }

    // emit a packet-specific message as well as a generic message, user/s can choose to use either or both of these.
    if (isNode && null != m) {
        this.emit(m._name, m);
        this.emit('message', m);
    }

    return m;

}

// continuation of python's  __parse_char_legacy 
MAVLink20Processor.prototype.parsePayload = function() {

    var m = null;

    // tip: this.expected_length and this.incompat_flags both already set correctly by parseLength(..) above 

    // If we have enough bytes to try and read it, read it.  
    //  shortest packet is header+checksum(2) with no payload, so we need at least that many 
    //  but once we have a longer 'expected length' we have to read all of it. 
    if(( this.expected_length >= mavlink20.HEADER_LEN+2) && (this.buf.length >= this.expected_length) ) { 

        // Slice off the expected packet length, reset expectation to be to find a header.
        var mbuf = this.buf.slice(0, this.expected_length);

        // TODO: slicing off the buffer should depend on the error produced by the decode() function
        // - if we find a well formed message, cut-off the expected_length 
        // - if the message is not well formed (correct prefix by accident), cut-off 1 char only
        this.buf = this.buf.slice(this.expected_length);
        this.expected_length = mavlink20.HEADER_LEN; // after attempting a parse, we'll next expect to find just a header. 

        try {
            m = this.decode(mbuf);
            this.total_packets_received += 1;
        }
        catch(e) {
            // Set buffer in question and re-throw to generic error handling
            this.bufInError = mbuf;
            throw e;
        }
    }

    return m;

}

// input some data bytes, possibly returning an array of new messages
MAVLink20Processor.prototype.parseBuffer = function(s) {

    // Get a message, if one is available in the stream.
    var m = this.parseChar(s);

    // No messages available, bail.
    if ( null === m ) {
        return null;
    }

    // While more valid messages can be read from the existing buffer, add
    // them to the array of new messages and return them.
    var ret = [];
    ret.push(m);
    while(true) {
        m = this.parseChar(null);
        if ( null === m ) {
            // No more messages left.
            return ret;
        }
        ret.push(m);
    }

}

//check signature on incoming message , many of the comments in this file come from the python impl
MAVLink20Processor.prototype.check_signature = function(msgbuf, srcSystem, srcComponent) {
    var timestamp_buf = msgbuf.slice(-12,-6);
 
    var link_id;
    if (isNode) {
        var link_id_buf = Buffer.from ? Buffer.from(msgbuf.slice(-13,-12)) : new Buffer(msgbuf.slice(-13,-12));
        link_id = link_id_buf[0]; // get the first byte.
    } else {
        // Browser-compatible buffer handling
        link_id = msgbuf.slice(-13,-12)[0];
    }

    function unpackUint48LE(bytes) {
        let value = 0n;
        for (let i = 5; i >= 0; i--) {
            value = (value << 8n) | BigInt(bytes[i]);
        }
        return value;
    }
    var timestamp = Number(unpackUint48LE(timestamp_buf));

    // see if the timestamp is acceptable

    // we'll use a STRING containing these three things in it as a unique key eg: '0,1,1'
    stream_key = new Array(link_id,srcSystem,srcComponent).toString();

    if (stream_key in this.signing.stream_timestamps){
        if (timestamp <= this.signing.stream_timestamps[stream_key]){
            //# reject old timestamp
            //console.log('old timestamp')
            return false
        }
    }else{
        //# a new stream has appeared. Accept the timestamp if it is at most
        //# one minute behind our current timestamp
    if (timestamp + 6000*1000 < this.signing.timestamp){
            //console.log('bad new stream ', timestamp/(100.0*1000*60*60*24*365), this.signing.timestamp/(100.0*1000*60*60*24*365))
            return false
        }
        this.signing.stream_timestamps[stream_key] = timestamp;
        //console.log('new stream',this.signing.stream_timestamps)
    }

    // just the last 6 of 13 available are the actual sig . ie excluding the linkid(1) and timestamp(6)
    var sigpart = msgbuf.slice(-6);
    sigpart = Uint8Array.from(sigpart);
    // not sig part 0- end-minus-6
    var notsigpart = msgbuf.slice(0,-6);
    notsigpart = Uint8Array.from(notsigpart);

    var sig1 = mavlink20.create_signature(this.signing.secret_key, notsigpart);

    // Browser-compatible buffer comparison
    var signaturesMatch;
    if (isNode) {
        signaturesMatch = Buffer.from(sig1).equals(Buffer.from(sigpart));
    } else {
        // Compare arrays element by element in browser
        signaturesMatch = sig1.length === sigpart.length && 
                         sig1.every((val, index) => val === sigpart[index]);
    }
    if (!signaturesMatch) {
        return false;
    }
    //# the timestamp we next send with is the max of the received timestamp and
    //# our current timestamp
    this.signing.timestamp = Math.max(this.signing.timestamp, timestamp+1);
    return true
}

/* decode a buffer as a MAVLink message */
MAVLink20Processor.prototype.decode = function(msgbuf) {

    var magic, incompat_flags, compat_flags, mlen, seq, srcSystem, srcComponent, unpacked, msgId, signature_len, header_len;

    // decode the header
    try {
        if (msgbuf[0] == 253) {
    var unpacked = jspack.Unpack('BBBBBBBHB', msgbuf.slice(0, 10));  // the H in here causes msgIDlow to takeup 2 bytes, the rest 1
        magic = unpacked[0];
        mlen = unpacked[1];
        incompat_flags = unpacked[2];
        compat_flags = unpacked[3];
        seq = unpacked[4];
        srcSystem = unpacked[5];
        srcComponent = unpacked[6];
        var msgIDlow = ((unpacked[7] & 0xFF) << 8) | ((unpacked[7] >> 8) & 0xFF); // first-two msgid bytes 
        var msgIDhigh = unpacked[8];   // the 3rd msgid byte 
        msgId = msgIDlow | (msgIDhigh<<16);  // combined result. 0 - 16777215  24bit number
        header_len = 10;
} else {
    var unpacked = jspack.Unpack('BBBBBB', msgbuf.slice(0, 6));
        magic = unpacked[0];
        mlen = unpacked[1];
        seq = unpacked[2];
        srcSystem = unpacked[3];
        srcComponent = unpacked[4];
        msgID = unpacked[5];
        incompat_flags = 0;
        compat_flags = 0;
        header_len = 6;
}
        }
    catch(e) {
        throw new Error('Unable to unpack MAVLink header: ' + e.message);
    }

    if (magic != this.protocol_marker) {
        throw new Error("Invalid MAVLink prefix ("+magic+")");
    }

    // is packet supposed to be signed?
    if ( incompat_flags & mavlink20.MAVLINK_IFLAG_SIGNED ){
        signature_len = mavlink20.MAVLINK_SIGNATURE_BLOCK_LEN;
    } else {
        signature_len = 0;
    }

    // header's declared len compared to packets actual len
    var actual_len = (msgbuf.length - (header_len + 2 + signature_len));
    var actual_len_nosign = (msgbuf.length - (header_len + 2 ));

    if ((mlen == actual_len) && (signature_len > 0)){
        var len_if_signed = mlen+signature_len;
        //console.log("Packet appears signed && labeled as signed, OK. msgId=" + msgId);

    } else  if ((mlen == actual_len_nosign) && (signature_len > 0)){

        var len_if_signed = mlen+signature_len;
        throw new Error("Packet appears unsigned when labeled as signed. Got actual_len "+actual_len_nosign+" expected " + len_if_signed + ", msgId=" + msgId);     

    } else if( mlen != actual_len) {
          throw new Error("Invalid MAVLink message length.  Got " + (msgbuf.length - (header_len + 2)) + " expected " + mlen + ", msgId=" + msgId);

    }

    if (!(msgId in mavlink20.map)) {
        throw new Error("Unknown MAVLink message ID (" + msgId + ")");
    }

    // here's the common chunks of packet we want to work with below..
    var payloadBuf = msgbuf.slice(mavlink20.HEADER_LEN, -(signature_len+2)); // the remaining bit between the header and the crc
    var crcCheckBuf = msgbuf.slice(1, -(signature_len+2)); // the part uses to calculate the crc - ie between the magic and signature,

    // decode the payload
    // refs: (fmt, type, order_map, crc_extra) = mavlink20.map[msgId]
    var decoder = mavlink20.map[msgId];

    // decode the checksum
    var receivedChecksum = undefined;
    if ( signature_len == 0 ) { // unsigned
        try {
            var crcBuf1 = msgbuf.slice(-2);
            receivedChecksum = jspack.Unpack('<H', crcBuf1);
        } catch (e) {
            throw new Error("Unable to unpack MAVLink unsigned CRC: " + e.message);
        }
    } else { // signed
        try {
            var crcBuf2 = msgbuf.slice(-15,-13);
            receivedChecksum = jspack.Unpack('<H', crcBuf2);
        } catch (e) {
            throw new Error("Unable to unpack MAVLink signed CRC: " + e.message);
        }
    }
    receivedChecksum = receivedChecksum[0];

    // make our own chksum of the relevant part of the packet...
    var messageChecksum = mavlink20.x25Crc(crcCheckBuf);
    var messageChecksum2 = mavlink20.x25Crc([decoder.crc_extra], messageChecksum);

    if ( receivedChecksum != messageChecksum2 ) {
        throw new Error('invalid MAVLink CRC in msgID ' +msgId+ ', got ' + receivedChecksum + ' checksum, calculated payload checksum as '+messageChecksum2 );
    }

    // now check the signature...
    var sig_ok = false 
    if (signature_len == mavlink20.MAVLINK_SIGNATURE_BLOCK_LEN){
        this.signing.sig_count += 1
    }

    // it's a Buffer, zero-length means unused
    if (this.signing.secret_key.length != 0 ){
        var accept_signature = false;
        if (signature_len == mavlink20.MAVLINK_SIGNATURE_BLOCK_LEN){
            sig_ok = this.check_signature(msgbuf, srcSystem, srcComponent);
            accept_signature = sig_ok;
            if (sig_ok){
                this.signing.goodsig_count += 1;
            }else{
                this.signing.badsig_count += 1;
            }
            if ( (! accept_signature) && (this.signing.allow_unsigned_callback != undefined) ){
                accept_signature = this.signing.allow_unsigned_callback(this, msgId);
                if (accept_signature){
                    this.signing.unsigned_count += 1;
                }else{
                    this.signing.reject_count += 1;
                }
            }
        }else if (this.signing.allow_unsigned_callback != undefined){
            accept_signature = this.signing.allow_unsigned_callback(this, msgId);
            if (accept_signature){
                this.signing.unsigned_count += 1;
            }else{
                this.signing.reject_count += 1;
            }
        }
        if (!accept_signature) throw new Error('Invalid signature');
    }

    // now look at the specifics of the payload...
    var paylen = jspack.CalcLength(decoder.format);

    //put any truncated 0's back in (ie zero-pad )
    if (paylen > payloadBuf.length) {
        payloadBuf = this.concat_buffer(payloadBuf, new Uint8Array(paylen - payloadBuf.length).fill(0));
    }
    // Decode the payload and reorder the fields to match the order map.
    try {
        var t = jspack.Unpack(decoder.format, payloadBuf); 
    }
    catch (e) {
        throw new Error('Unable to unpack MAVLink payload type='+decoder.type+' format='+decoder.format+' payloadLength='+ payloadBuf +': '+ e.message); 
    }

    // Need to check if the message contains arrays
    var args = {};
    const elementsInMsg = decoder.order_map.length;
    const actualElementsInMsg = JSON.parse(JSON.stringify(t)).length;

    if (elementsInMsg == actualElementsInMsg) {
        // Reorder the fields to match the order map
        t.forEach(function(e, i, l) {
            args[i] = t[decoder.order_map[i]]
        });
    } else {
        // This message contains arrays
        var typeIndex = 1;
        var orderIndex = 0;
        var memberIndex = 0;
        var tempArgs = {};

        // Walk through the fields 
        for(var i = 0, size = decoder.format.length-1; i <= size; ++i) {
            var order = decoder.order_map[orderIndex];
            var currentType =  decoder.format[typeIndex];

            if (isNaN(parseInt(currentType))) {
                // This field is not an array check the type and add it to the args
                tempArgs[orderIndex] = t[memberIndex];
                memberIndex++;
            } else {
                // This field is part of an array, need to find the length of the array
                var arraySize = ''
                var newArray = []
                while (!isNaN(decoder.format[typeIndex])) {
                    arraySize = arraySize + decoder.format[typeIndex];
                    typeIndex++;
                }

                // Now that we know how long the array is, create an array with the values
                for(var j = 0, size = parseInt(arraySize); j < size; ++j){
                    newArray.push(t[j+orderIndex]);
                    memberIndex++;
                }

                // Add the array to the args object
                arraySize = arraySize + decoder.format[typeIndex];
                currentType = arraySize;
                tempArgs[orderIndex] = newArray;
            }
            orderIndex++;
            typeIndex++;
        }

        // Finally reorder the fields to match the order map
        t.forEach(function(e, i, l) {
            args[i] = tempArgs[decoder.order_map[i]]
        });
    }

    // construct the message object
    try {
        // args at this point might look like:  { '0': 6, '1': 8, '2': 0, '3': 0, '4': 3, '5': 3 }
        var m = new decoder.type();   // make a new 'empty' instance of the right class,
        m.set(args,false); // associate ordered-field-numbers to names, after construction not during.
    }
    catch (e) {
        throw new Error('Unable to instantiate MAVLink message of type '+decoder.type+' : ' + e.message);
    }

    m._signed = sig_ok;
    if (m._signed) { m._link_id = msgbuf[-13]; }
 
    m._msgbuf = msgbuf;
    m._payload = payloadBuf;
    m.crc = receivedChecksum;
    m._header = new mavlink20.header(msgId, mlen, seq, srcSystem, srcComponent, incompat_flags, compat_flags);
    this.log(m);
    return m;
}


// Browser and Node.js compatible module exports
if (!isNode) {
    // For browsers, attach to window or use global namespace
    if (typeof window !== 'undefined') {
        window.mavlink20 = mavlink20;
        window.MAVLink20Processor = MAVLink20Processor;
    }
    // Also support global assignment
    if (typeof global !== 'undefined') {
        global.mavlink20 = mavlink20;
        global.MAVLink20Processor = MAVLink20Processor;
    }
}
// Always expose CommonJS exports so bundlers (webpack) can import the symbols
// regardless of the runtime detection above.
if (typeof module === "object" && module.exports) {
    module.exports = {mavlink20, MAVLink20Processor};
}

